import React, { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import ToasterWithMessage from "../../components/shared-components/toaster";
import styles from "./Userdetails.module.css";
import {
  User, Mail, Phone, Briefcase, MapPinned, TrendingUp, TrendingDown, CheckCircle,
  CreditCard, MessageCircle, FileText, Plus, Clock, Award, ChevronLeft, ChevronRight,
  Search, Edit, Delete, Pencil, Trash2, MoreVertical, X, Loader, Building, MapPin, CheckSquare,
  ChevronDown, AlertTriangle, AlertCircle, ArrowRight, Package, Download, CheckCheck, Lock, DollarSign, Lightbulb, Calendar, Filter,
  ExternalLink, Share2, RefreshCcw, ClipboardCheck, ScanBarcode, Eye, History, Ban,
} from "lucide-react";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useQuery, useMutation, useLazyQuery, useApolloClient } from '@apollo/client';
import { Square } from "lucide-react";
import {
  GET_USER_BY_ID, GET_SUPER_USER_BY_USER_ID, GET_USER_TICKETS, GET_USER_REP_AFFILIATE, GET_AFFILIATE_PEOPLE_BY_IDS,
  GET_USER_ANALYTICS,
  UPDATE_USER, DELETE_USER,
  GET_USER_NOTES, ADD_USER_NOTE, UPDATE_USER_NOTE, DELETE_USER_NOTE, VOID_USER_PAYOUTS,
  RESTORE_USER_PAYOUTS, UPDATE_USER_EMAIL_STATUS, GET_USER_EMAIL_STATUS, UPDATE_SUPER_USER_PERCENTAGE,
  GET_USER_PREFERENCE_TEAMS,
  GET_LEAGUE_CATEGORIES_BY_IDS, GET_USER_SAVED_SEAT_INFO, INSERT_USER_SAVED_SEAT_INFO,
  UPDATE_USER_SAVED_SEAT_INFO, GET_USER_TEAMS_WITH_SOLD_STATUS, GET_AVAILABLE_TEAMS_FOR_USER,
  ADD_USER_PREFERENCE_TEAM, REMOVE_USER_PREFERENCE_TEAM , ADMIN_REMOVE_USER_PREFERENCE_TEAM,
  GET_USER_TICKET_MARKETPLACES,UPDATE_TICKET_PLACEMENT,
  GET_USER_VICTORY_LIVE_SEAT_NOTES, INSERT_USER_VICTORY_LIVE_SEAT_NOTE,
  UPDATE_USER_VICTORY_LIVE_SEAT_NOTE, DELETE_USER_VICTORY_LIVE_SEAT_NOTE,
} from './api/UserdetailsQuery';
import SupportTicketsPage from '../SupportTickets/SupportTicketsPage';
import { affiliateIdsToLookUp, resolveRepAffiliate } from './userRepAffiliate';
import { useVlSupportCards } from '../ManageTickets/useVlSupportCards';
import { SeatModeBadge, useSeatModeDialog } from '../ManageTickets/SeatModeDialog';
import { deriveOwnerInitials as deriveVlSupportOwnerInitials, type VlSupportEventDetails } from '../ManageTickets/vlSupportEmail';
import { UPDATE_TICKET_BARCODE_STATUS, UPDATE_TICKET_COMMISSION_OVERRIDE } from '../ManageTickets/api/TicketsQuery';
import { GET_USERS_LIST, GET_ALL_LEAGUES } from '../Users/api/UsersQuery';
 import { CalendarDays, Check } from "lucide-react";
import {
  GET_MANAGE_TICKETS,
  EDIT_TICKET_PRICE_BY_SUPER_USER,
  UPDATE_TICKET_STATUS,
  DELETE_TICKET_STATUS,
  UPDATE_TICKET_PAYMENT_STATUS,
  UPDATE_TICKETS_PAYMENT_STATUS,
  RESTORE_DELETED_TO_VERIFICATION,
  RESTORE_CANCELLED_LISTING_TO_VERIFICATION,
  GET_PLACEMENT_VL_PRODUCTION_IDS,
  PUBLISH_NON_VL_LISTING,
} from '../ManageTickets/api/TicketsQuery';
import { GET_MARKETPLACES_FOR_TICKETS } from '../ManageTickets/api/TicketsQuery';
import { isFailToTransferTicketLike } from '../ManageTickets/utils/failToTransfer';
import { fetchUserFeePercentages } from '../ManageTickets/api/userFeePercentages';
import {
  submitListingsToVl,
  syncVlListingStatus,
  startVlAccountCrawl,
  getVlAccountCrawlStatus,
  recommendBarcodeSyncAccounts,
  checkVlBarcodes,
  syncConciergeVlPrices,
  shareVlListings,
  markWrongPid,
  searchVlProductions,
  confirmVlProduction,
  verifyTicketPlacements,
  delistTicketsRequest,
  delistTicketByAdminRequest,
  DelistJobError,
  VL_MARKETPLACE_OPTIONS,
  type ProductionMismatchDetails,
  type BarcodeSyncRecommendResult,
  type CheckBarcodesResult,
} from '../ManageTickets/api/vlListing.api';
import {
  formatVlUnknownMessage,
  isVlUnknownStatus,
  summarizeVlActionToast,
  successfulVlTpIds,
  toastForVlCaughtError,
  type VlActionToast,
} from '../ManageTickets/vlActionOutcome';
import BarcodeSyncConfirmModal from '../ManageTickets/components/BarcodeSyncConfirmModal';
import CheckBarcodesModal from '../ManageTickets/components/CheckBarcodesModal';
import SyncFromVlScopeModal, {
  type SyncFromVlScope,
} from '../ManageTickets/components/SyncFromVlScopeModal';
import { EventMarketplaceDeepLinks, MarketplaceBrandMark } from '../ManageTickets/EventMarketplaceDeepLinks';
import { ListedVlRowControls } from '../ManageTickets/ListedVlRowControls';
import { ListedSharedToggle } from '../ManageTickets/ListedSharedToggle';
import { WrongPidRetryButton } from '../ManageTickets/WrongPidRetryButton';
import { ListedShareConfirmModal } from '../ManageTickets/ListedShareConfirmModal';
import { ListedDelistConfirmModal } from '../ManageTickets/ListedDelistConfirmModal';
import type { DelistJobProgress, DelistUiStep } from '../ManageTickets/delistStepStatus';
import { SelfPricingPriceConfirmModal } from '../ManageTickets/SelfPricingPriceConfirmModal';
import { NonVlStatusConfirmModal } from '../ManageTickets/NonVlStatusConfirmModal';
import {
  isNonVlStatusChange,
  buildNonVlStatusConfirmSummary,
} from '../ManageTickets/nonVlStatusChange';
import {
  getEnabledMarketplaceIdsForTicket,
  getCachedEnabledMarketplaceIds,
  setCachedEnabledMarketplaceIds,
  setCachedEnabledMarketplaceIdsForMany,
  getVlSharedStatusForTicket,
  setCachedVlSharedStatus,
  setCachedVlSharedStatusForMany,
  ticketHasVlListingMarkers,
  isVlListedTicketStatus,
  LISTED_DELIST_BUSY_MESSAGE,
  formatUnshareDelistSuccessMessage,
  formatDelistCleanupFailureMessage,
} from '../ManageTickets/vlMarketplaceSelection';
import PriceChangeLogsPanel from '../PriceChangeLogs/PriceChangeLogsPanel';
import { globalContext } from "../../Provider/AppProvider";
import { getStoredEmailFromIdToken } from '../../authToken';
import { GET_USER_PROFILE } from "../Auth/api/SignInQuery";
import { roles, roundToFixed, formatNumberWithCommas } from "../../helper";
import { formatDbEventDate, formatDbEventTime } from "../../utils/eventDbDateTime";
import { getStatusIcon } from '../ManageTickets/getStatusIcon';
import { renderEventStatusBadge, isEventDateTbdForVerification } from '../ManageTickets/eventStatusBadge';
import {
  parseFilterCalendarDate,
  ticketMatchesEventDateRange,
  toLocalDateYmd,
} from './ticketEventDateFilter';
import { config } from '../../config/config';
import { sortUserDetailTickets, sortUserDetailsDelistedTickets, getUserDetailsDelistedGroupRank, MANAGE_TICKETS_ORDER_BY, parseAndSortSeatNumbers } from '../ManageTickets/manageTicketSort';
import {
  isManageTicketTableSortEnabled,
  sortManageTicketRowsByValues,
  type ManageTicketSortColumn,
  type ManageTicketTableSort,
} from '../ManageTickets/manageTicketTableSort';
import { GET_NOTIFICATIONS } from '../../components/shared-components/notification/api/NotificationQuery';
import { getNotificationQueryVariables } from '../../utils/notification-query-variables';
import ListingNoteCombobox from './ListingNoteCombobox';
import { composeListingNoteDraft, expandListingSeatNumbers, findMatchingSeatLevelNote, findSeatLevelNoteForListing, formatListingPopupNotes, isParkingPassNoteGroup, isParkingPassRow, listingNoteChoices, profileNoteChoices, PARKING_EXTERNAL_NOTE, PARKING_INTERNAL_NOTE, seedListingNoteFields, withListingAmenityNotes, withSeatNoteTeamNames } from './seatLevelNotes';
import {
  getLastPricedBadge,
  getLastPricedDisplayValue,
  describeLastPricedBucket,
  LAST_PRICED_BUCKET_OPTIONS,
  getLastPricedCustomRange,
  getLastPricedRange,
  matchesLastPricedRange,
  matchesLastPricedBucketFilter,
} from '../ManageTickets/staleness';
import { isVictoryLivePriceUpdateSuccess, priceUpdateFailureMessage, VL_ID_MISMATCH_PRICE_ERROR } from '../ManageTickets/priceUpdateResult';
import {
  useConciergePriceSocket,
  type TicketHoldsUpdatedPayload,
} from '../ManageTickets/hooks/useConciergePriceSocket';
import { matchesPidStatusFilter, type PidStatusFilter } from '../ManageTickets/pidStatusFilter';
import BarcodeStatusDropdown, { type BarcodeStatusValue } from '../ManageTickets/BarcodeStatusDropdown';
import { BARCODE_STATUS_OPTIONS } from '../../utils/noBarcodeRules';

import {
  getUserDetailsBarcodeStatus,
  normalizePricingMethod,
  pricingMethodMatches,
  resolvePricingMethodSelection,
  toManageTicketGroupingRecord,
} from './userdetailsTicketTransform';
import {
  buildManageTicketDisplayGroups,
  expandTicketsToSameDisplayGroup,
  getGroupedPageSeatFetchSize,
  getGroupedSeatWindowIndex,
  getGroupedWindowLocalOffset,
  getNextGroupedPageOffset,
  hasAnotherGroupedPage,
  resolveLoadedGroupedRowTotal,
} from '../ManageTickets/manageTicketGrouping';
import { buildUserTicketListQueryFilters } from './userTicketListQuery';

/** Don't paint the seat dropdown until confirm/API commits — Delist can fail or be cancelled. */
const DEFERRED_SEAT_STATUS_PAINT = new Set([
  'Verified',
  'Verified_NonVL',
  'Delist',
  'Delist_NonVL',
  'Sold',
  'Deleted',
  'List',
  'List_NonVL',
  'DelistInProgress',
  'DelistInProgress_NonVL',
  'DelistRequested',
  'Return',
  'Return_NonVL',
  'Unsold',
  'Unsold_NonVL',
  'ListingRequestCancelled',
]);

const shouldDeferSeatStatusPaint = (nextStatus: string): boolean =>
  DEFERRED_SEAT_STATUS_PAINT.has(nextStatus);

const readDelistSuccessTpIds = (data: any): string[] => {
  if (!Array.isArray(data?.successTpIds)) return [];
  return data.successTpIds
    .map((id: unknown) => String(id || '').trim())
    .filter(Boolean);
};

// ------------------- Interfaces -------------------
interface UserData {
  id: string; name: string; initials: string; type: string; tier: string;
  business: string; email: string; phone: string; address1: string; address2: string;
  address3: string; lastActive: string; annualSales: string; teams: string[];
  assignedTeams?: string[]; userFee: string; status: string; createdAt: string;
  city: string; state: string; zip: string; country: string; payoutsVoided: boolean;
  voidReason?: string; voidDate?: string; emailEnabled: boolean; hearAboutUs?: string;
   stripeAccountId?: string | null;
  stripeTransfersStatus?: string | null;
  stripeAccountIsDue?: boolean | null;
  payoutInfoAccountLabel?: string;
  payoutInfoStatusText?: string;
  payoutInfoIsComplete?: boolean;
}
interface Ticket {
  id: string; tpId: string; rawStatus: string; event: string; date: string;
  section: string; row: string; seatNo: string; seatMode?: 'odd' | 'even' | null; status: string; price: string;
  tp_delist_requested_email?: string | null;
  e_status?: string | null;
  lc_id?: string | null;
  soldPrice: string;
  paymentStatus?: string | null;
  payoutStatus?: string | null;
  updatedAt?: string;
  tp_updated_at?: string;
  last_priced_at?: string | null;
  eventDateRaw?: string;
  eventTime?: string;
  /** IANA venue timezone (e.g. America/New_York) — same as ManageTickets e_time_zone. */
  eventTimeZone?: string | null;
  eventId?: string;
  eventStatus?: string | null;
  marketplace?: string | null;
  qaProfit?: number;
  venue?: string | null;
  league?: string | null;
  email?: string | null;
  vlListingId?: string | null;
  vlItemId?: string | null;
  tpWrongPid?: boolean;
  confirmationMessage?: string | null;
  confirmedVlProductionId?: string | null;
  stubhubId?: string | null;
  seatgeekId?: string | null;
  pidConfirmedAt?: string | null;
  barcode?: string | null;
  barcodeAttached?: boolean;
  barcodeStatus?: BarcodeStatusValue;
  on_hold?: boolean | null;
  tp_vl_share?: boolean;
  internalNotes?: string;
  externalNotes?: string;
  tp_pricing_method?: 'MANUAL' | 'FOLLOW_MARKET' | null;
  tp_sales_rep_commission_override?: number | string | null;
}

type BarcodeSyncSummary = {
  phase: 'crawling' | 'verifying' | 'success' | 'failure';
  accountIds: string[];
  crawlMessage?: string;
  crawlResults: Array<{
    accountId: string;
    status: 'pending' | 'processing' | 'completed' | 'failed';
    crawlStatus?: string | null;
    message?: string;
    username?: string | null;
    marketplaceName?: string | null;
  }>;
  verificationResult?: CheckBarcodesResult | null;
  failures?: string[];
  verificationMessage?: string;
};

interface Note {
  id: string; type: 'qa' | 'internal' | 'external'; content: string;
  createdAt: string; createdBy: string; updatedAt?: string;
}

interface SeatLevelNoteEntry {
  id: string;
  userId: string;
  teamId: string;
  teamName?: string;
  section: string;
  row: string;
  seatStart: number;
  seatEnd: number;
  internalNote: string;
  externalNote: string;
  createdAt: string;
  updatedAt: string;
}

interface LeagueCategoryPreference {
  lc_id: string; lc_abbrev?: string | null; lc_name?: string | null; lc_colour_code?: string | null; l_id?: string;
}

interface SeatInfoRow {
  id: string; 
  event: string; 
  date: string; 
  eventTime?: string;  // Added for time display
  section: string; 
  row: string;
  seatNo: string; 
  source: 'saved' | 'ticket'; 
  ussiId?: string; 
  ticketId?: string;
  status?: string;     // Added for ticket status
  price?: string;      // Added for ticket price
}

type MarketplaceOption = {
  id: string; name: string; vl_fee_percentage: number; active?: boolean;
};

type SoldFeeConfig = {
  feeMode: 'super' | 'default';
  superClientPercent: number | null;
};

const DEFAULT_SOLD_FEE_CONFIG: SoldFeeConfig = { feeMode: 'default', superClientPercent: null };

/** VL production names often include extras after `;` — show only the short name. */
function displayVlEventName(name?: string | null): string {
  const full = String(name || '').trim();
  if (!full) return '';
  const cut = full.indexOf(';');
  return (cut >= 0 ? full.slice(0, cut) : full).trim();
}

/** Venue-local YYYY-MM-DD from event date + timezone (same as Manage Tickets). */
const formatVenueEventDateYmd = (
  eDate?: string | null,
  eTimeZone?: string | null,
): string => {
  if (!eDate) return '';
  try {
    return new Date(eDate).toLocaleDateString('en-CA', {
      timeZone: eTimeZone || 'America/Chicago',
    });
  } catch {
    return String(eDate).slice(0, 10);
  }
};

const getUserTicketVlProductionId = (ticket: {
  confirmedVlProductionId?: string | null;
  rawStatus?: string | null;
  status?: string | null;
}) => String(ticket?.confirmedVlProductionId || '').trim();

const isUserTicketAwaitingVlPid = (ticket: {
  rawStatus?: string | null;
  status?: string | null;
}) =>
  String(ticket?.rawStatus || ticket?.status || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '') === 'tobeverified';

const USER_EVENT_MISSING_VALUE = '–';

function getUserTicketBarcodeValue(ticket: Ticket | null | undefined): string {
  if (!ticket) return '';
  return String(ticket.barcode || '').trim();
}

function userTicketHasBarcodeAttached(ticket: Ticket | null | undefined): boolean {
  if (!ticket) return false;
  if (ticket.barcodeAttached === true) return true;
  return Boolean(getUserTicketBarcodeValue(ticket));
}

function getUserTicketBarcodeStatus(ticket: Ticket | null | undefined): BarcodeStatusValue {
  return getUserDetailsBarcodeStatus(ticket);
}

function getUserTicketsBarcodeStatus(tickets: Array<Ticket | null | undefined>): {
  allAttached: boolean;
  missingCount: number;
  noBarcodeCount: number;
  total: number;
} {
  const list = tickets.filter((candidate): candidate is Ticket => Boolean(candidate));
  const missingCount = list.filter((ticket) => getUserTicketBarcodeStatus(ticket) === 'Barcode Pending').length;
  const noBarcodeCount = list.filter((ticket) => getUserTicketBarcodeStatus(ticket) === 'Null').length;
  return {
    allAttached: list.length > 0 && list.every((ticket) => getUserTicketBarcodeStatus(ticket) === 'Barcode Available'),
    missingCount,
    noBarcodeCount,
    total: list.length,
  };
}

function getUserBarcodeMissingSummary(tickets: Array<Ticket | null | undefined>): string {
  const { allAttached, missingCount, noBarcodeCount, total } = getUserTicketsBarcodeStatus(tickets);
  if (allAttached) return 'Attached for every seat';
  if (total > 0 && noBarcodeCount === total) return 'No barcode for every seat';
  if (total === 0 || missingCount === total) return 'Missing for all seats';
  return `Missing for ${missingCount} of ${total} seats${noBarcodeCount ? `; No barcode for ${noBarcodeCount}` : ''}`;
}

function getUserGroupBarcodeStatus(tickets: Array<Ticket | null | undefined>): BarcodeStatusValue | 'Mixed' {
  const statuses = new Set(tickets.map(getUserTicketBarcodeStatus));
  return statuses.size === 1 ? [...statuses][0] : 'Mixed';
}

function renderUserSeatBarcodeStatus(ticket: Ticket | null | undefined) {
  const barcode = getUserTicketBarcodeValue(ticket);
  const status = getUserTicketBarcodeStatus(ticket);
  if (status === 'Null') {
    return (
      <div className={`${styles.seatBarcodeStatus} ${styles.barcodeStatusNull}`}>
        <Ban size={12} aria-hidden />
        <span>No Barcode</span>
      </div>
    );
  }
  if (status === 'Barcode Available') {
    return (
      <div className={`${styles.seatBarcodeStatus} ${styles.barcodeStatusOk}`}>
        <CheckCircle size={12} aria-hidden />
        {barcode ? (
          <span className={styles.seatBarcodeValue} title={barcode}>
            Barcode: {barcode}
          </span>
        ) : null}
      </div>
    );
  }
  return (
    <div className={`${styles.seatBarcodeStatus} ${styles.barcodeStatusMissing}`}>
      <AlertCircle size={12} aria-hidden />
      <span>Missing</span>
    </div>
  );
}

function renderUserDetailsEventCell(options: {
  ticket: Ticket;
  eventName: string;
  dateLabel: string;
  timeLabel?: string;
  datePrefix?: React.ReactNode;
  showBarcodeStatusIcon?: boolean;
  groupTickets?: Ticket[];
  onBarcodeStatusSelect?: (tickets: Ticket[], status: BarcodeStatusValue) => void;
  /** Victory Live support controls (mail icon, open-ticket badge), same spot as on Manage Tickets. */
  extraContent?: React.ReactNode;
}) {
  const seats = options.groupTickets?.length ? options.groupTickets : [options.ticket];
  const pid =
    seats.map((seat) => getUserTicketVlProductionId(seat)).find(Boolean) || '';
  const stubhubId =
    seats.map((seat) => String(seat.stubhubId || '').trim()).find(Boolean) || null;
  const seatgeekId =
    seats.map((seat) => String(seat.seatgeekId || '').trim()).find(Boolean) || null;
  const timeLabel = options.timeLabel ? String(options.timeLabel).trim() : '';
  const barcodeTickets = options.groupTickets?.length ? options.groupTickets : [options.ticket];

  return (
    <td className={`${styles.tdEvent} ${styles.stickyEvent}`}>
      <div className={styles.eventName}>
       
        <span className={styles.eventNameText}>{options.eventName || USER_EVENT_MISSING_VALUE}</span> 
      </div>
      <div className={styles.eventDate}>
        {options.datePrefix}
        <Calendar size={10} />
        {options.dateLabel || 'TBD'}
        {timeLabel ? ` • ${timeLabel}` : ''}
      </div>
      <div className={styles.eventPidBarcode}>
        {options.showBarcodeStatusIcon ? (
          <>
            PID: {pid || USER_EVENT_MISSING_VALUE} and Barcode:{' '}
            <BarcodeStatusDropdown
              value={getUserGroupBarcodeStatus(barcodeTickets)}
              onSelect={(status) => options.onBarcodeStatusSelect?.(barcodeTickets, status)}
            />
          </>
        ) : (
          <>PID: {pid || USER_EVENT_MISSING_VALUE}</>
        )}
      </div>
      TM Status : {renderEventStatusBadge(options.ticket)}
      <EventMarketplaceDeepLinks
        stubhubId={stubhubId}
        seatgeekId={seatgeekId}
        ticketmasterId={undefined}
        vividSeatsId={undefined}
        eventName={options.eventName}
        eventDate={formatVenueEventDateYmd(options.ticket.eventDateRaw, options.ticket.eventTimeZone)}
        venue={options.ticket.venue}
        className={styles.marketplaceDeepLinks}
        linkClassName={styles.marketplaceDeepLink}
        disabledClassName={styles.marketplaceDeepLinkDisabled}
        stubhubClassName={styles.marketplaceDeepLinkStubhub}
        seatgeekClassName={styles.marketplaceDeepLinkSeatgeek}
        ticketmasterClassName={styles.marketplaceDeepLinkTicketmaster}
        vividseatsClassName={styles.marketplaceDeepLinkVivid}
      />
      {options.extraContent}
    </td>
  );
}

type VlProgressStep = 'confirm' | 'submit' | 'share';

const VL_PROGRESS_BY_STATUS: Record<
  string,
  { step: VlProgressStep; label: string; title: string; busyMessage: string }
> = {
  PidPending: {
    step: 'confirm',
    label: 'Confirm Production ID',
    title: 'Review and confirm the Victory Live event before submitting inventory',
    busyMessage: 'Searching Victory Live productions…',
  },
  PidConfirmed: {
    step: 'submit',
    label: 'Submit to VL',
    title: 'Create Victory Live inventory using the confirmed Production ID',
    busyMessage: 'Submitting to Victory Live…',
  },
  Verified: {
    step: 'share',
    label: 'List on Marketplace',
    title: 'Choose VL marketplaces and mark Listed',
    busyMessage: 'Sharing listings on Victory Live…',
  },
};

function normalizeVlProgressStatus(value: string): string {
  const key = String(value || '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
  if (key === 'tobeverified') return 'ToBeVerified';
  if (key === 'verified') return 'Verified';
  if (key === 'list' || key === 'listed') return 'List';
  return String(value || '');
}

function getVlProgressForUserTickets(
  tickets: Array<{
    rawStatus?: string | null;
    status?: string | null;
    vlListingId?: string | null;
    vlItemId?: string | null;
    confirmedVlProductionId?: string | null;
  }>,
) {
  if (!tickets.length) return null;
  const statuses = tickets.map((t) => normalizeVlProgressStatus(String(t.rawStatus || t.status || '')));
  const unique = [...new Set(statuses)];
  if (unique.length !== 1) return null;
  const status = unique[0];
  if (status === 'ToBeVerified') return null;
  // Verified stays Verified through PID confirmation and ingestion.
  const allMissingVlIds = tickets.every((t) => !t.vlListingId && !t.vlItemId);
  if (allMissingVlIds && status === 'Verified') {
    const allPidConfirmed = tickets.every((ticket) => {
      const pid = String(getUserTicketVlProductionId(ticket) || '').trim();
      return Boolean(pid && /^\d+$/.test(pid));
    });
    return allPidConfirmed
      ? VL_PROGRESS_BY_STATUS.PidConfirmed
      : VL_PROGRESS_BY_STATUS.PidPending;
  }
  // Orphan after failed split: Listed but no VL ids → legacy submit recovery.
  if (allMissingVlIds && status === 'List') {
    return VL_PROGRESS_BY_STATUS.PidConfirmed;
  }
  return VL_PROGRESS_BY_STATUS[status] ?? null;
}

type SelectedTeam = {
  id: string; abbreviation: string; name: string; color: string; hasSoldTicket?: boolean; leagueId?: string; leagueName?: string;
};

const SearchableTeamSelect = ({
  teams,
  value,
  onChange,
  disabled = false,
  placeholder = 'Select Team',
}: {
  teams: SelectedTeam[];
  value: SelectedTeam | null;
  onChange: (team: SelectedTeam | null) => void;
  disabled?: boolean;
  placeholder?: string;
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const filteredTeams = teams.filter((team) => {
    const query = search.trim().toLowerCase();
    return !query || team.name.toLowerCase().includes(query) || team.abbreviation.toLowerCase().includes(query);
  });

  return (
    <div className={styles.vlTeamSelect}>
      <button
        type="button"
        className={styles.vlTeamSelectButton}
        onClick={() => !disabled && setOpen((current) => !current)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{value?.name || placeholder}</span>
        <ChevronDown size={16} />
      </button>
      {open && !disabled && (
        <div className={styles.vlTeamSelectMenu} role="listbox">
          <input
            autoFocus
            type="search"
            className={styles.vlTeamSearchInput}
            placeholder="Search Team..."
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            onClick={(event) => event.stopPropagation()}
          />
          <div className={styles.vlTeamOptions}>
            {filteredTeams.length > 0 ? filteredTeams.map((team) => (
              <button
                type="button"
                className={styles.vlTeamOption}
                key={team.id}
                onClick={() => {
                  onChange(team);
                  setSearch('');
                  setOpen(false);
                }}
                role="option"
                aria-selected={team.id === value?.id}
              >
                {team.name}
              </button>
            )) : <div className={styles.vlTeamEmpty}>No teams found</div>}
          </div>
        </div>
      )}
    </div>
  );
};

const SearchableValueSelect = ({
  options,
  value,
  onChange,
  disabled = false,
  placeholder,
  searchPlaceholder,
}: {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder: string;
  searchPlaceholder: string;
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const query = search.trim().toLowerCase();
  const filteredOptions = options.filter((option) => !query || option.toLowerCase().includes(query));

  return (
    <div className={styles.vlTeamSelect}>
      <button
        type="button"
        className={styles.vlTeamSelectButton}
        onClick={() => !disabled && setOpen((current) => !current)}
        disabled={disabled}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span>{value || placeholder}</span>
        <ChevronDown size={16} />
      </button>
      {open && !disabled && (
        <div className={styles.vlTeamSelectMenu} role="listbox">
          <input
            autoFocus
            type="search"
            className={styles.vlTeamSearchInput}
            placeholder={searchPlaceholder}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
            onClick={(event) => event.stopPropagation()}
          />
          <div className={styles.vlTeamOptions}>
            {filteredOptions.length > 0 ? filteredOptions.map((option) => (
              <button
                type="button"
                className={styles.vlTeamOption}
                key={option}
                onClick={() => {
                  onChange(option);
                  setSearch('');
                  setOpen(false);
                }}
                role="option"
                aria-selected={option === value}
              >
                {option}
              </button>
            )) : <div className={styles.vlTeamEmpty}>No options found</div>}
          </div>
        </div>
      )}
    </div>
  );
};

// ------------------- Helpers -------------------
const DEFAULT_CONCIERGE_PERCENT = 20;

function effectiveSoldQuickCutPercent(
  marketplaceFeePercent: number, feeMode: 'super' | 'default', superClientPercent: number | null
): number {
  const clientPercent = feeMode === 'super' && superClientPercent != null ? superClientPercent : DEFAULT_CONCIERGE_PERCENT;
  return Math.max(0, clientPercent - marketplaceFeePercent);
}

const formatCurrency = (value: number) => {
  if (!Number.isFinite(value)) return '$0.00';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

/** Sales rep commission = QuickAsyst quick-cut × rep commission rate %. */
const getSalesRepCommissionAmount = (quickCutAmount: number, commissionRate: number): number => {
  if (!Number.isFinite(quickCutAmount) || quickCutAmount <= 0) return 0;
  if (!Number.isFinite(commissionRate) || commissionRate <= 0) return 0;
  return Math.round(((quickCutAmount * commissionRate) / 100) * 100) / 100;
};

const formatOptionalCurrency = (value: unknown): string => {
  if (value == null || String(value).trim() === '') return '-';
  const num = Number(value);
  if (!Number.isFinite(num)) return '-';
  return formatCurrency(num);
};

const pickTicketValue = (...values: Array<unknown>) => {
  for (const value of values) {
    if (value == null) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    return value;
  }
  return null;
};

const formatPercent = (value: number) => {
  if (!Number.isFinite(value)) return '0%';
  return `${value.toFixed(1)}%`;
};

export const getPayoutInfoStatus = (
  stripeAccountId?: string | null,
  stripeTransfersStatus?: string | null,
  stripeAccountIsDue?: boolean | null,
) => {
  const normalizedAccountId = typeof stripeAccountId === 'string' ? stripeAccountId.trim() : '';
  const hasStripeAccount = Boolean(normalizedAccountId);
  const normalizedStatus =
    typeof stripeTransfersStatus === 'string' ? stripeTransfersStatus.trim().toLowerCase() : '';
  const isComplete = hasStripeAccount && (stripeAccountIsDue === false || normalizedStatus === 'active');

  return {
    accountLabel: hasStripeAccount ? normalizedAccountId : 'Not Connected',
    statusText: isComplete ? 'Payout Info Added' : 'Payout Info Not Added',
    isComplete,
    statusTone: isComplete ? 'success' : 'warning',
  };
};

const formatDate = (
  dateString: string,
  timeZone?: string | null,
  dateTimeZone?: string | null,
  eTime?: string | null,
): string => {
  if (!dateString && !dateTimeZone) return 'N/A';
  const formatted = formatDbEventDate({
    e_date: dateString,
    e_time_zone: timeZone,
    e_date_time_zone: dateTimeZone,
    e_time: eTime,
  }, 'short');
  return formatted === 'TBD' ? 'N/A' : formatted;
};
const getStatusLabel = (status: string): string => {
  if (!status) return 'Unknown';
  const normalizedStatus = status.toLowerCase();
    if (normalizedStatus === 'voidedpayout') return 'Voided Payout';
  if (normalizedStatus === 'list') return 'Listed';
  if (normalizedStatus === 'list_nonvl') return 'Listed (Non-VL)';
  if (normalizedStatus === 'delistinprogress_nonvl') return 'Delist Requested (Non-VL)';
  if (normalizedStatus === 'delistinprogress' || normalizedStatus === 'delistrequested') return 'Delist Requested';
  if (normalizedStatus === 'listingrequestcancelled') return 'Listing Request Cancelled';
  if (normalizedStatus === 'closed') return 'Listing Request Expired';
  if (normalizedStatus === 'underreview') return 'Under Review';
  if (normalizedStatus === 'paidmanuallyviaqa') return 'Paid Manually via QA';
  if (normalizedStatus === 'qadeniedpayout') return 'QA Denied Payout';
  if (normalizedStatus === 'settled') return 'Settled';
  if (normalizedStatus === 'settlementinprogress') return 'Settlement In Progress';
  if (normalizedStatus === 'return_nonvl') return 'Returned (Non-VL)';
  if (normalizedStatus === 'return') return 'Returned';
  if (normalizedStatus === 'tobeverified') return 'To Be Verified';
  if (normalizedStatus === 'verified_nonvl') return 'Verified (Non-VL)';
  if (normalizedStatus === 'verified') return 'Verified';
  if (normalizedStatus === 'invalid') return 'Invalid';
  if (normalizedStatus === 'sold') return 'Sold';
  if (normalizedStatus === 'unsold_nonvl') return 'Unsold (Non-VL)';
  if (normalizedStatus === 'unsold') return 'Unsold';
  if (normalizedStatus === 'delist_nonvl') return 'Delisted (Non-VL)';
  if (normalizedStatus === 'delist') return 'Delisted';
  return status;
};
const getTicketStatusPresentation = (ticket: Ticket): { label: string; iconStatus: string } => {
  const placementStatus = mapStatusForMutation(ticket.rawStatus || ticket.status);
  if (placementStatus.toLowerCase() !== 'sold') {
    const label = getStatusLabel(ticket.rawStatus || ticket.status);
    return { label, iconStatus: placementStatus };
  }
  if (String(ticket.payoutStatus || '').trim() === 'Voided_Payout') {
    return { label: 'Voided Payout', iconStatus: 'sold' };
  }
  const pay = (ticket.paymentStatus || '').trim();
  if (pay === 'Success') {
    return { label: 'Settled', iconStatus: 'settled' };
  }
  if (pay === 'Inprogress') {
    return { label: 'Settlement In Progress', iconStatus: 'settlementinprogress' };
  }
  if (pay === 'Failed') {
    return { label: 'Failed', iconStatus: 'failed' };
  }
  if (!pay) {
    const payoutStatusRaw = String(ticket.payoutStatus || '').trim();
    if (payoutStatusRaw && payoutStatusRaw !== 'Unvoided_Payout') {
      return { label: payoutStatusRaw.replace(/_/g, ' '), iconStatus: 'sold' };
    }
    return { label: 'Sold', iconStatus: 'sold' };
  }
  return { label: pay, iconStatus: 'sold' };
};

const defaultStatusForUserTab = (tab: string) => {
  switch (tab) {
    case 'Verification': return 'All Verification';
    case 'Listed': return 'All Listed';
    case 'Sold': return 'All Sold';
    case 'Delisted': return 'All Delisted';
    case 'Deleted': return 'All Deleted';
    case 'Listing Request Cancelled': return 'All Listing Request Cancelled';
    case 'Expired': return 'All Expired';
    case 'Unsold': return 'All Unsold';
    default: return 'All';
  }
};

const soldSubFilterFromStatus = (
  status: string,
): 'all' | 'sold' | 'settled' | 'settlementinprogress' | 'failed' | 'voidedpayout' | 'paidmanuallyviaqa' | 'qadeniedpayout' | 'underreview' => {
  const map: Record<string, 'sold' | 'settled' | 'settlementinprogress' | 'failed' | 'voidedpayout' | 'paidmanuallyviaqa' | 'qadeniedpayout' | 'underreview'> = {
    Sold: 'sold',
    Settled: 'settled',
    SettlementInProgress: 'settlementinprogress',
    Failed: 'failed',
    Voided_Payout: 'voidedpayout',
    PaidManuallyViaQA: 'paidmanuallyviaqa',
    QADeniedPayout: 'qadeniedpayout',
    UnderReview: 'underreview',
  };
  return map[status] || 'all';
};

const matchesUserStatusDropdown = (ticket: Ticket, tab: string, status: string) => {
  if (tab === 'Sold') return true;
  if (!status || status === 'All' || status.startsWith('All ')) return true;
  const raw = normalizeStatusToken(ticket.rawStatus || ticket.status);
  const soldKey = soldSubFilterFromStatus(status);
  if (soldKey !== 'all') {
    const isSale = ['sold', 'settled', 'settlementinprogress', 'underreview', 'paidmanuallyviaqa', 'qadeniedpayout'].includes(raw);
    return isSale && getSoldPresentationFilterKey(ticket) === soldKey;
  }
  if (status === 'ToBeVerified') return raw === 'tobeverified';
  if (status === 'Verified') return raw === 'verified' || raw === 'verification';
  if (status === 'Invalid') return raw === 'invalid';
  if (status === 'List') return raw === 'list' || raw === 'listed';
  if (status === 'DelistInProgress') return raw === 'delistinprogress' || raw === 'delistrequested';
  if (status === 'Delist') return raw === 'delist' || raw === 'delisted';
  if (status === 'Return') return raw === 'return';
  if (status === 'Deleted') return raw === 'deleted';
  if (status === 'ListingRequestCancelled') return raw === 'listingrequestcancelled';
  if (status === 'Closed') return raw === 'closed' || raw === 'listingrequestexpired';
  if (status === 'Unsold') return raw === 'unsold';
  return true;
};

const getSoldPresentationFilterKey = (
  ticket: Ticket,
): 'sold' | 'settled' | 'settlementinprogress' | 'failed' | 'voidedpayout' | 'paidmanuallyviaqa' | 'qadeniedpayout' | 'underreview' => {
  const statusKey = normalizeStatusToken(ticket.rawStatus || ticket.status);

  // 1) QA-only statuses (tp_status) — payment-driven filters ki leak avvakoodadu.
  if (statusKey === 'paidmanuallyviaqa') return 'paidmanuallyviaqa';
  if (statusKey === 'qadeniedpayout') return 'qadeniedpayout';
  if (statusKey === 'underreview') return 'underreview';

  // 2) Payment-driven filters ki tp_status='Sold' unna rows matrame.
  //    (PaidManuallyViaQA/UnderReview/QADeniedPayout lantivi ikkada ki reach avvavu.)
  if (statusKey !== 'sold') return 'sold';

  // 3) Voided_Payout — paymentStatus='Inprogress' unna kuda Voided gelavali.
  const payout = String(ticket.payoutStatus || '').trim();
  if (payout === 'Voided_Payout') return 'voidedpayout';

  // 4) Payment status nunchi derive cheyyandi (getTicketStatusPresentation meeda depend avvakunda).
  const pay = String(ticket.paymentStatus || '').trim();
  if (pay === 'Success') return 'settled';
  if (pay === 'Inprogress') return 'settlementinprogress';
  if (pay === 'Failed') return 'failed';
  return 'sold';
};

const getStatusColorClass = (status: string): string => {
  if (!status) return 'statusDefault';
  const s = status.toLowerCase().replace(/\s+/g, '');
  
  if (s === 'voidedpayout') return 'voidedpayout';
  if (s === 'verified') return 'verified';
  if (s === 'list' || s === 'listed') return 'listed';
  if (s === 'tobeverified' || s === 'tobeeverified') return 'tobeverified';
  if (s === 'invalid') return 'invalid';
  if (s === 'sold') return 'sold';
  if (s === 'underreview') return 'underreview';
  if (s === 'paidmanuallyviaqa') return 'paidmanuallyviaqa';
  if (s === 'qadeniedpayout') return 'qadeniedpayout';
  if (s === 'return' || s === 'returned') return 'return';
  if (
    s === 'delist' ||
    s === 'delistinprogress' ||
    s === 'delistrequested' ||
    s === 'listingrequestcancelled'
  ) {
    return 'delist';
  }
  if (s === 'deleted') return 'deleted';
  if (s === 'unsold') return 'unsold';
  if (s === 'closed' || s === 'listingrequestexpired') return 'closed';
  if (s === 'settled') return 'settled';
  if (s === 'settlementinprogress') return 'settlementinprogress';
  return '';
};

const displayPrice = (priceStr: string): string => {
  if (!priceStr || priceStr === '-' || priceStr.trim() === '') return '-';
  const numeric = parseCurrency(priceStr);
  if (!Number.isFinite(numeric)) return '-';
  return formatCurrency(numeric);
};

/** Map raw network errors to user-facing copy (no localhost:4000 on deployed admin). */
const formatUserDetailsError = (error: any, fallback: string): string => {
  const candidateMessages = [
    error?.graphQLErrors?.[0]?.message,
    error?.networkError?.result?.errors?.[0]?.message,
    error?.networkError?.result?.errors?.[0]?.extensions?.internal?.error?.message,
    error?.networkError?.result?.error,
    error?.networkError?.result?.message,
    error?.networkError?.message,
    typeof error === 'string' ? error : error?.message,
  ];
  const presentMessages = candidateMessages
    .filter((msg): msg is string => typeof msg === 'string' && String(msg).trim().length > 0)
    .map((msg) => String(msg).trim());
  if (presentMessages.some((msg) => /vl ids are not matched|vl id'?s? are mismatch/i.test(msg))) {
    return VL_ID_MISMATCH_PRICE_ERROR;
  }
  const raw = (presentMessages[0] || fallback || '').toString().trim();
  if (!raw) return fallback;

  const normalized = raw.toLowerCase();
  const isLocalDevHost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

  if (
    normalized.includes('failed to fetch') ||
    normalized.includes('networkerror') ||
    normalized.includes('load failed')
  ) {
    if (isLocalDevHost) {
      return 'Backend API unreachable (Failed to fetch). Ensure Node is running on port 4000 (npm run start:local) and REACT_APP_NODE_API_URL=http://localhost:4000.';
    }
    return 'Unable to reach the server. Please wait a moment and try again, then refresh if the change did not apply.';
  }
  if (/vl ids are not matched|vl id'?s? are mismatch/i.test(normalized)) {
    return VL_ID_MISMATCH_PRICE_ERROR;
  }
  if (
    normalized.includes('timed out') ||
    normalized.includes('result is unknown') ||
    normalized.includes('http exception when calling webhook')
  ) {
    if (isLocalDevHost && normalized.includes('http exception')) {
      return formatVlUnknownMessage(
        'this action',
        'Backend action timed out (Hasura → Node). The change may still have completed.',
      );
    }
    return formatVlUnknownMessage('this action');
  }
  return raw;
};

const isBackendActionTimeoutError = (error: unknown): boolean => {
  const msg = formatUserDetailsError(error, '').toLowerCase();
  return (
    msg.includes('timed out') ||
    msg.includes('result is unknown') ||
    msg.includes('http exception when calling webhook') ||
    msg.includes('took too long') ||
    msg.includes('do not retry yet')
  );
};

const mapStatusForMutation = (status: string): string => {
  const s = status.toLowerCase();
  // UI-only Non-VL sentinels (never written to DB)
  if (s === 'verified_nonvl') return 'Verified_NonVL';
  if (s === 'list_nonvl') return 'List_NonVL';
  if (s === 'delist_nonvl') return 'Delist_NonVL';
  if (s === 'delistinprogress_nonvl') return 'DelistInProgress_NonVL';
  if (s === 'unsold_nonvl') return 'Unsold_NonVL';
  if (s === 'return_nonvl') return 'Return_NonVL';
  if (s === 'listed' || s === 'list') return 'List';
  if (s === 'sold') return 'Sold';
  if (s === 'settled') return 'Settled';
  if (s === 'settlement in progress' || s === 'settlementinprogress') return 'SettlementInProgress';
  if (s === 'unsold') return 'Unsold';
  if (s === 'verified') return 'Verified';
  if (s === 'to be verified' || s === 'tobeverified') return 'ToBeVerified';
  if (s === 'delisted') return 'Delist';
  if (s === 'delist requested') return 'DelistInProgress';
  if (s === 'delistrequested') return 'DelistInProgress';
  if (s === 'delistinprogress') return 'DelistInProgress';
  if (s === 'listing request expired') return 'Closed';
  if (s === 'listing request cancelled') return 'ListingRequestCancelled';
  if (s === 'listingrequestcancelled') return 'ListingRequestCancelled';
  if (s === 'invalid') return 'ListingRequestCancelled';
  if (s === 'return' || s === 'returned') return 'Return';
  if (s === 'under review' || s === 'underreview') return 'UnderReview';
  if (s === 'paid manually via qa' || s === 'paidmanuallyviaqa') return 'PaidManuallyViaQA';
  if (s === 'qa denied payout' || s === 'qadeniedpayout') return 'QADeniedPayout';
  if (s === 'move to listed') return 'List';
  return status;
};

/** Add PID writes the production id on every seat in the same display group. */
const expandUserTicketsToSameGroup = (selected: Ticket[], pool: Ticket[]): Ticket[] => {
  if (!selected.length) return [];
  const byId = new Map<string, Ticket>();
  [...pool, ...selected].forEach((ticket) => {
    const tpId = String(ticket.tpId || '').trim();
    if (tpId) byId.set(tpId, ticket);
  });
  const expanded = expandTicketsToSameDisplayGroup(
    selected.map((ticket) => toManageTicketGroupingRecord(ticket)),
    pool.map((ticket) => toManageTicketGroupingRecord(ticket)),
  );
  const restored = expanded
    .map((ticket) => byId.get(String(ticket.tp_id || '').trim()))
    .filter((ticket): ticket is Ticket => Boolean(ticket));
  return restored.length ? restored : selected;
};

const isUserDetailFailToTransferTicket = (ticket: {
  rawStatus?: string;
  status?: string;
  updatedAt?: string;
}): boolean => {
  const rawToken = normalizeStatusToken(ticket.rawStatus || ticket.status || '');
  if (rawToken !== 'tobeverified') return false;
  return isFailToTransferTicketLike(
    mapStatusForMutation(ticket.rawStatus || ticket.status || ''),
    ticket.updatedAt,
  );
};

const emailRegexPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const getStatusTransitions = (currentStatus: string) => {
  const normalizedStatus = currentStatus 
    ? ((currentStatus || '').toLowerCase().replace(/\s/g, ''))
    : '';
  
  const statusCanonicalMapLocal: Record<string, string> = {
    closed: 'Closed',
    delist: 'Delist',
    delistinprogress: 'DelistInProgress',
    delistrequested: 'DelistInProgress',
    invalid: 'Invalid',
    list: 'List',
    listed: 'List',
    listingrequestcancelled: 'ListingRequestCancelled',
    paidmanuallyviaqa: 'PaidManuallyViaQA',
    qadeniedpayout: 'QADeniedPayout',
    underreview: 'UnderReview',
    return: 'Return',
    sold: 'Sold',
    voidedpayout: 'Voided_Payout',
    settled: 'Settled',
    settlementinprogress: 'SettlementInProgress',
    tobeverified: 'ToBeVerified',
    unsold: 'Unsold',
    verified: 'Verified'
  };
  
  const canonicalStatus = statusCanonicalMapLocal[normalizedStatus] || currentStatus;
  
  const statusTransitions: { [key: string]: { value: string, label: string }[] } = {
    ToBeVerified: [
      { value: 'Verified', label: 'Verified' },
      { value: 'Verified_NonVL', label: 'Verified (Non-VL)' },
      { value: 'ListingRequestCancelled', label: 'Listing Request Cancelled' },
      { value: 'Deleted', label: 'Delete' },
    ],
    Verified: [
      { value: 'List', label: 'Listed' },
      { value: 'List_NonVL', label: 'Listed (Non-VL)' },
      { value: 'DelistInProgress', label: 'Delist Requested' },
      { value: 'DelistInProgress_NonVL', label: 'Delist Requested (Non-VL)' },
      { value: 'Deleted', label: 'Delete' },
    ],
    List: [
      { value: 'Delist', label: 'Delisted' },
      { value: 'Delist_NonVL', label: 'Delisted (Non-VL)' },
      { value: 'Sold', label: 'Sold' },
      { value: 'Unsold', label: 'Unsold' },
      { value: 'Unsold_NonVL', label: 'Unsold (Non-VL)' },
      { value: 'Deleted', label: 'Delete' },
    ],
    DelistInProgress: [
      { value: 'Delist', label: 'Delist' },
      { value: 'Delist_NonVL', label: 'Delisted (Non-VL)' },
      { value: 'List', label: 'Listed (Undo)' },
      { value: 'List_NonVL', label: 'Listed (Non-VL Undo)' },
      { value: 'Return', label: 'Returned' },
      { value: 'Return_NonVL', label: 'Returned (Non-VL)' },
    ],
    Delist: [
      { value: 'List', label: 'Listed (Undo)' },
      { value: 'List_NonVL', label: 'Listed (Non-VL Undo)' },
      { value: 'DelistInProgress', label: 'Delist Requested' },
      { value: 'DelistInProgress_NonVL', label: 'Delist Requested (Non-VL)' },
      { value: 'Return', label: 'Returned' },
      { value: 'Return_NonVL', label: 'Returned (Non-VL)' },
      { value: 'Deleted', label: 'Delete' },
    ],
    Sold: [
      { value: 'Settled', label: 'Settled' },
      { value: 'SettlementInProgress', label: 'Settlement In Progress' },
      { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
      { value: 'QADeniedPayout', label: 'QA Denied Payout' },
      { value: 'UnderReview', label: 'Under Review' },
    ],
    Settled: [
      { value: 'Sold', label: 'Sold' },
      { value: 'SettlementInProgress', label: 'Settlement In Progress' },
    ],
    SettlementInProgress: [
      { value: 'Sold', label: 'Sold' },
      { value: 'Settled', label: 'Settled' },
      { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
    ],
    Voided_Payout: [
      { value: 'Sold', label: 'Sold' },
      { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
      { value: 'Settled', label: 'Settled' },
      { value: 'SettlementInProgress', label: 'Settlement In Progress' },
    ],
    Unsold: [
      { value: 'Sold', label: 'Sold' },
    ],
    UnderReview: [
      { value: 'Sold', label: 'Sold' },
    ],
    PaidManuallyViaQA: [],
    QADeniedPayout: [
      { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
    ],
    Invalid: [
      { value: 'ToBeVerified', label: 'To Be Verified' },
    ],
    ListingRequestCancelled: [
      { value: 'ToBeVerified', label: 'To Be Verified' },
    ],
    Return: [],
    Closed: [],
    Deleted: [
      { value: 'ToBeVerified', label: 'To Be Verified' },
      { value: 'List', label: 'Listed' },
    ],
  };
  return statusTransitions[canonicalStatus] || [];
};

const normalizeStatusToken = (status: string) => {
  return (status || '').toLowerCase().replace(/[^a-z0-9]/g, '');
};

const parseCurrency = (value: string): number => {
  const normalized = value.replace(/[^0-9.]/g, '');
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
};

const requiresPriceChangeConfirmation = (currentPrice: unknown, proposedPrice: number): boolean => {
  const current = Number(currentPrice);
  return current > 0 && Math.abs(proposedPrice - current) > current * 0.2;
};

const getLargePriceChangeDirection = (
  currentPrice: unknown,
  proposedPrice: number,
): 'increase' | 'decrease' | null => {
  if (!requiresPriceChangeConfirmation(currentPrice, proposedPrice)) return null;
  return Number(proposedPrice) > Number(currentPrice) ? 'increase' : 'decrease';
};

const getPriceChangeWarningNote = (
  changes: Array<{ currentPrice: unknown; proposedPrice: number }>,
): string => {
  const directions = new Set(
    changes
      .map(({ currentPrice, proposedPrice }) => getLargePriceChangeDirection(currentPrice, proposedPrice))
      .filter((direction): direction is 'increase' | 'decrease' => direction != null),
  );
  if (directions.has('increase') && directions.has('decrease')) {
    return 'You are changing the price for one or more tickets by more than 20% and more than 20% less. Review the details before proceeding.';
  }
  if (directions.has('decrease')) {
    return 'You are changing the price for one or more tickets by less than 20% . Review the details before proceeding.';
  }
  return 'You are changing the price for one or more tickets by more than 20%. Review the details before proceeding.';
};

const sanitizePriceInput = (value: string): string => {
  let sanitized = value.replace(/[^0-9.]/g, '');
  const firstDecimal = sanitized.indexOf('.');
  if (firstDecimal !== -1) {
    sanitized = sanitized.slice(0, firstDecimal + 1) + sanitized.slice(firstDecimal + 1).replace(/\./g, '');
  }
  return sanitized;
};

const formatListPrice = (listPrice: unknown): string => {
  if (listPrice == null || String(listPrice).trim() === '') return '-';
  const num = Number(listPrice);
  if (!Number.isFinite(num) || num <= 0) return '-';
  return formatCurrency(num);
};

const normalizeSeatRangeInput = (input: string | number): string => {
  const raw = String(input ?? '').trim();
  if (!raw) return '';
  return raw
    .replace(/–/g, '-')
    .replace(/—/g, '-')
    .replace(/\s+/g, '')
    .replace(/(^|-)\s*(\d)/g, '$1$2');
};

const parseSeatNumbersFromRange = (seatRange: string | number | null | undefined): number[] => {
  const normalized = normalizeSeatRangeInput(seatRange ?? '');
  if (!normalized) return [];

  if (/^\d+$/.test(normalized)) {
    const seat = Number(normalized);
    return Number.isFinite(seat) && seat > 0 ? [seat] : [];
  }

  const match = normalized.match(/^(\d+)\s*-\s*(\d+)$/);
  if (!match) return [];

  const start = Number(match[1]);
  const end = Number(match[2]);
  if (!Number.isFinite(start) || !Number.isFinite(end) || start <= 0 || end <= 0) return [];

  const rangeStart = Math.min(start, end);
  const rangeEnd = Math.max(start, end);
  const values: number[] = [];
  for (let i = rangeStart; i <= rangeEnd; i += 1) values.push(i);
  return values;
};

const seatRangeContainsSeat = (savedSeatRange: string | number | null | undefined, requestedSeat: string | number | null | undefined): boolean => {
  const saved = parseSeatNumbersFromRange(savedSeatRange);
  const requested = parseSeatNumbersFromRange(requestedSeat ?? '');
  if (!saved.length || !requested.length) return false;
  return requested.every((seat) => saved.includes(seat));
};

const isMissingVerifyRequiredFields = (ticket: Ticket): boolean =>
  !ticket.event ||
  (!ticket.eventDateRaw && !isEventDateTbdForVerification(ticket)) ||
  !ticket.section ||
  ticket.section === '-' ||
  !ticket.row ||
  ticket.row === '-' ||
  !ticket.seatNo ||
  ticket.seatNo === '-';

const isValidUuid = (value?: string) => Boolean(value && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value));

const USER_DETAILS_TICKET_FILTER_TABS = [
  'All',
  'Verification',
  'Listed',
  'Sold',
  'Delisted',
  'Deleted',
  'Listing Request Cancelled',
  'Unsold',
  'Expired',
] as const;

// ------------------- Main Component -------------------
const UserDetailsPage = () => {
  const { userId } = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { globalState, handleGlobalState } = useContext<any>(globalContext);
  const { data: authenticatedProfileData } = useQuery(GET_USER_PROFILE, {
    fetchPolicy: 'network-only',
  });
  const authenticatedProfileEmail = String(
    authenticatedProfileData?.get_user_profile?.[0]?.u_email_id ||
      getStoredEmailFromIdToken() ||
      globalState?.profile?.mailId ||
      '',
  ).trim().toLowerCase();
  const apolloClient = useApolloClient();
  
  const activeHasuraRole = (localStorage.getItem('x-hasura-user-role') || '').toLowerCase().trim();
  const profileRole = (globalState?.profile?.userRole || '').toLowerCase().trim();
  const normalizedPortalRole = activeHasuraRole || profileRole;
  const isAffiliateAdmin = normalizedPortalRole === roles.AFFILIATER_ADMIN;
  // Live-safe: keep existing admin/sub-admin/affiliate-admin behavior; only add sales rep (marketing_user).
  const canEditPricing = [roles.ADMIN, roles.SUB_ADMIN, roles.AFFILIATER_ADMIN, roles.MARKETING_USER].includes(normalizedPortalRole);
  const canOverrideSettlementStatus = [roles.ADMIN, roles.SUB_ADMIN, roles.AFFILIATER_ADMIN].includes(normalizedPortalRole);
  const canEditSoldCommission = normalizedPortalRole === roles.ADMIN;
  
  // UI State
  const [showQANote, setShowQANote] = useState(false);
  const [showInternalNote, setShowInternalNote] = useState(false);
  const [showExternalNote, setShowExternalNote] = useState(false);
  const [editingNote, setEditingNote] = useState<{ id: string; type: 'qa' | 'internal' | 'external'; content: string } | null>(null);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) return saved === 'dark';
    return document.documentElement.getAttribute('data-theme') === 'dark';
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedTicketSearch, setDebouncedTicketSearch] = useState('');
  const [ticketPageOffset, setTicketPageOffset] = useState(0);
  const [ticketPageSize, setTicketPageSize] = useState(10);
  const [ticketSeatTotal, setTicketSeatTotal] = useState(0);
  const [ticketGroupsPerFullWindow, setTicketGroupsPerFullWindow] = useState<number | null>(null);
  const [ticketLoadedSeatWindowIndex, setTicketLoadedSeatWindowIndex] = useState(0);
  const pendingTicketSeatWindowIndexRef = useRef(0);
  const appliedUserTicketsPayloadRef = useRef<any>(null);
  const appliedUserTicketMarketplacesRef = useRef<any>(null);
  const visiblePageTicketsRef = useRef<Ticket[]>([]);
  const [teamSearchQuery, setTeamSearchQuery] = useState("");
  const userDetailsTabs = ['profile', 'tickets', 'analytics', 'teams', 'support-tickets'] as const;
  const savedTab = userId ? localStorage.getItem(`userdetails-active-tab-${userId}`) : null;
  const initialTab = searchParams.get('tab') || (savedTab && userDetailsTabs.includes(savedTab as typeof userDetailsTabs[number]) ? savedTab : 'profile');
  const [activeTab, setActiveTab] = useState(initialTab);
  const handleActiveTabChange = (tab: typeof userDetailsTabs[number]) => {
    setActiveTab(tab);
    if (userId) localStorage.setItem(`userdetails-active-tab-${userId}`, tab);
  };
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showTicketDeleteConfirm, setShowTicketDeleteConfirm] = useState(false);
  const [seatLevelNotePendingDeleteId, setSeatLevelNotePendingDeleteId] = useState<string | null>(null);
  const [seatLevelNoteDeleteLoading, setSeatLevelNoteDeleteLoading] = useState(false);
  const [ticketPendingDelete, setTicketPendingDelete] = useState<Ticket | null>(null);
  const [ticketDeleteLoading, setTicketDeleteLoading] = useState(false);
  const [openActionTicketId, setOpenActionTicketId] = useState<string | null>(null);
  const [showTicketViewModal, setShowTicketViewModal] = useState(false);
  const [ticketForView, setTicketForView] = useState<Ticket | null>(null);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [selectedTicketForCommission, setSelectedTicketForCommission] = useState<Ticket | null>(null);
  const [commissionOverrideInput, setCommissionOverrideInput] = useState('');
  const [commissionOverrideLoading, setCommissionOverrideLoading] = useState(false);
  function openCommissionModal(ticket: Ticket): void {
    if (!canEditSoldCommission) return;
    setSelectedTicketForCommission(ticket);
    setCommissionOverrideInput(
      ticket.tp_sales_rep_commission_override == null
        ? getTicketSalesRepCommission(ticket).toFixed(2)
        : Number(ticket.tp_sales_rep_commission_override).toFixed(2),
    );
    setShowCommissionModal(true);
  }
  const [showPriceLogsModal, setShowPriceLogsModal] = useState(false);
  const [ticketForPriceLogs, setTicketForPriceLogs] = useState<Ticket | null>(null);
  const [priceLogsTpIds, setPriceLogsTpIds] = useState<string[]>([]);
  const [localTickets, setLocalTickets] = useState<Ticket[]>([]);
  const [ticketTableSort, setTicketTableSort] = useState<ManageTicketTableSort | null>(null);
  const localStatusOverridesRef = useRef<Record<string, string>>({});
  const [tabSwitchLoading, setTabSwitchLoading] = useState(false);
  const previousTicketTabRef = useRef<string | null>(null);
  const [activeFilterTab, setActiveFilterTab] = useState<string>(() => {
    const storedTab = userId ? localStorage.getItem(`userdetails-ticket-filter-tab-${userId}`) : null;
    return storedTab && USER_DETAILS_TICKET_FILTER_TABS.includes(
      storedTab as (typeof USER_DETAILS_TICKET_FILTER_TABS)[number],
    )
      ? storedTab
      : 'All';
  });
  const [soldSubFilter, setSoldSubFilter] = useState<
    | 'all'
    | 'sold'
    | 'settled'
    | 'settlementinprogress'
    | 'failed'
    | 'voidedpayout'
    | 'paidmanuallyviaqa'
    | 'qadeniedpayout'
    | 'underreview'
  >('all');
  const [filterStatus, setFilterStatus] = useState('All');
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showBarcodeFilterDropdown, setShowBarcodeFilterDropdown] = useState(false);
  const [showStripeAccountFilterDropdown, setShowStripeAccountFilterDropdown] = useState(false);
  const [showPidStatusFilterDropdown, setShowPidStatusFilterDropdown] = useState(false);
  const [showPricingMethodFilterDropdown, setShowPricingMethodFilterDropdown] = useState(false);
  const [showLastPricedFilterDropdown, setShowLastPricedFilterDropdown] = useState(false);
  const [barcodeFilter, setBarcodeFilter] = useState<'all' | 'attached' | 'missing' | 'none'>('all');
  const [pidStatusFilter, setPidStatusFilter] = useState<PidStatusFilter>('all');
  const [vlShareFilter, setVlShareFilter] = useState<'all' | 'shared' | 'unshared'>('all');
  const [showVlShareFilterDropdown, setShowVlShareFilterDropdown] = useState(false);
  const [pricingMethodFilter, setPricingMethodFilter] = useState<'all' | 'MANUAL' | 'FOLLOW_MARKET' | 'NONE'>('all');
  const [lastPricedFilter, setLastPricedFilter] = useState<string[]>([]);
  const [lastPricedFrom, setLastPricedFrom] = useState('');
  const [lastPricedTo, setLastPricedTo] = useState('');
  const [lastPricedCustomValue, setLastPricedCustomValue] = useState('');
  const [lastPricedCustomUnit, setLastPricedCustomUnit] = useState<'Hours' | 'Minutes' | 'Days'>('Hours');
  const [lastPricedCustomWindow, setLastPricedCustomWindow] = useState<'within' | 'outside'>('within');
  const [lastPricedCustomRange, setLastPricedCustomRange] = useState<{ from: string; to: string } | null>(null);
  const [lastPricedQueryNow, setLastPricedQueryNow] = useState(() => Date.now());
  const [lastPricedCustomError, setLastPricedCustomError] = useState('');
  const [onHoldFilter, setOnHoldFilter] = useState(false);

    type StripeAccountFilter = 'all' | 'due' | 'connected';
  const [stripeAccountFilter, setStripeAccountFilter] = useState<StripeAccountFilter>('all');

  const STRIPE_ACCOUNT_FILTER_OPTIONS: Array<{ value: StripeAccountFilter; label: string }> = [
    { value: 'due', label: 'Stripe Due' },
    { value: 'connected', label: 'Stripe Connected' },
    { value: 'all', label: 'All' },
  ];

  const getStripeAccountFilterButtonLabel = (filter: StripeAccountFilter): string =>
    STRIPE_ACCOUNT_FILTER_OPTIONS.find((o) => o.value === filter)?.label || 'Stripe';

  const getStripeAccountFilterForQuery = (filter: StripeAccountFilter) => {
    if (filter === 'due') {
      return {
        _or: [
          { u_stripe_account_is_due: { _eq: true } },
          { u_stripe_account_id: { _is_null: true } },
        ],
      };
    }
    if (filter === 'connected') {
      return {
        u_stripe_account_id: { _is_null: false },
        u_stripe_account_is_due: { _eq: false },
        u_stripe_transfers_status: { _eq: 'active' },
      };
    }
    return {};
  };

  const userMatchesStripeFilter = (filter: StripeAccountFilter): boolean => {
    if (filter === 'all') return true;
    const isConnected =
      !!currentUser?.stripeAccountId &&
      currentUser?.stripeAccountIsDue === false &&
      currentUser?.stripeTransfersStatus === 'active';
    const isDue =
      currentUser?.stripeAccountIsDue === true || !currentUser?.stripeAccountId;
    return filter === 'connected' ? isConnected : isDue;
  };
  const applySocketHoldUpdates = useCallback((payload: TicketHoldsUpdatedPayload) => {
    const updates = payload?.updates || [];
    if (!updates.length) return;
    const byTpId = new Map(
      updates
        .filter((row) => row?.tpId && typeof row.onHold === 'boolean')
        .map((row) => [row.tpId, row.onHold === true]),
    );
    if (!byTpId.size) return;
    setLocalTickets((prev) => {
      let changed = false;
      const next = prev.map((ticket) => {
        if (!byTpId.has(ticket.tpId)) return ticket;
        const nextHold = byTpId.get(ticket.tpId) === true;
        if (ticket.on_hold === nextHold) return ticket;
        changed = true;
        return { ...ticket, on_hold: nextHold };
      });
      return changed ? next : prev;
    });
  }, []);
  useConciergePriceSocket(null, true, applySocketHoldUpdates);
  const [notes, setNotes] = useState<Note[]>([]);
  const [seatLevelNotes, setSeatLevelNotes] = useState<SeatLevelNoteEntry[]>([]);
  const [matchedSeatLevelNote, setMatchedSeatLevelNote] = useState<SeatLevelNoteEntry | null>(null);
  const [seatLevelTeam, setSeatLevelTeam] = useState<SelectedTeam | null>(null);
  const [seatLevelSection, setSeatLevelSection] = useState('');
  const [seatLevelRow, setSeatLevelRow] = useState('');
  const [seatLevelRange, setSeatLevelRange] = useState('');
  const [showSeatLevelNoteForm, setShowSeatLevelNoteForm] = useState(false);
  const [seatLevelNoteForm, setSeatLevelNoteForm] = useState({
    id: '',
    team: '',
    section: '',
    row: '',
    startSeat: '',
    endSeat: '',
    internalNote: '',
    externalNote: '',
  });
  const [newNoteContentByType, setNewNoteContentByType] = useState<Record<'qa' | 'internal' | 'external', string>>({ qa: '', internal: '', external: '' });
  const [showDelistEmailModal, setShowDelistEmailModal] = useState(false);
  const [pendingDelistTpIds, setPendingDelistTpIds] = useState<string[]>([]);
  const [delistEmail, setDelistEmail] = useState('');
   const [delistConfirmEmail, setDelistConfirmEmail] = useState('');
  const [delistRequestLoading, setDelistRequestLoading] = useState(false);
  const [selectedTeamForSeats, setSelectedTeamForSeats] = useState<SelectedTeam | null>(null);
  const [editingSeatTicketId, setEditingSeatTicketId] = useState<string | null>(null);
  const [seatEditForm, setSeatEditForm] = useState({ section: '', row: '', seatNo: '' });
  const [savingSeatTicketId, setSavingSeatTicketId] = useState<string | null>(null);
  const [localSeatInfoOverrides, setLocalSeatInfoOverrides] = useState<Record<string, SeatInfoRow[]>>({});
  const [showVoidPayoutsModal, setShowVoidPayoutsModal] = useState(false);
  const [voidReason, setVoidReason] = useState('');
  const [isVoidingPayouts, setIsVoidingPayouts] = useState(false);
  const [openStatusDropdown, setOpenStatusDropdown] = useState<string | null>(null);
  const [seatCardStatusDropdownOpen, setSeatCardStatusDropdownOpen] = useState<Record<string, boolean>>({});
  const [seatCardStatusBySeatId, setSeatCardStatusBySeatId] = useState<Record<string, string>>({});
const [dateFilter, setDateFilter] = useState<'today' | 'yesterday' | 'thisWeek' | 'thisMonth' | 'custom' | 'all'>('all');
const [customFromDate, setCustomFromDate] = useState<string>('');
const [customToDate, setCustomToDate] = useState<string>('');
const [showDatePicker, setShowDatePicker] = useState(false);
  // Team Management State
  const [showAddTeamModal, setShowAddTeamModal] = useState(false);
  const [availableTeamsForUser, setAvailableTeamsForUser] = useState<Array<{lc_id: string; lc_abbrev: string; lc_name: string; lc_colour_code: string; l_id?: string}>>([]);
  const [teamsWithSoldStatus, setTeamsWithSoldStatus] = useState<Record<string, boolean>>({});
  const [addingTeamId, setAddingTeamId] = useState<string | null>(null);
  const [removingTeamId, setRemovingTeamId] = useState<string | null>(null);
  const [adminRemovingTeamId, setAdminRemovingTeamId] = useState<string | null>(null);
  const [selectedLeagueFilter, setSelectedLeagueFilter] = useState<string>('all');
  
  // Modal states for ticket status transitions
  const [showListedModal, setShowListedModal] = useState(false);
  const [listedModalLoading, setListedModalLoading] = useState(false);
  const [listedModalTicket, setListedModalTicket] = useState<Ticket | null>(null);
  const [listedPrice, setListedPrice] = useState('');
  const [showSoldModal, setShowSoldModal] = useState(false);
  const [soldModalTicket, setSoldModalTicket] = useState<Ticket | null>(null);
  const [soldMarketplaceId, setSoldMarketplaceId] = useState('');
  const [soldLogitixAmount, setSoldLogitixAmount] = useState('0');
  const [soldFeeMode, setSoldFeeMode] = useState<'super' | 'default'>('default');
  const [soldSuperClientPercent, setSoldSuperClientPercent] = useState<number | null>(null);
  const [soldFeeConfigReady, setSoldFeeConfigReady] = useState(false);
  const [soldModalLoading, setSoldModalLoading] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [priceModalTicket, setPriceModalTicket] = useState<Ticket | null>(null);
  const [newPrice, setNewPrice] = useState('');
  const [priceModalLoading, setPriceModalLoading] = useState(false);
  const [priceUpdatePendingIds, setPriceUpdatePendingIds] = useState<ReadonlySet<string>>(() => new Set());
  const markPriceUpdatePending = (ids: string[], pending: boolean) => {
    if (!ids.length) return;
    setPriceUpdatePendingIds((current) => {
      const next = new Set(current);
      ids.forEach((id) => {
        if (!id) return;
        if (pending) next.add(id);
        else next.delete(id);
      });
      return next;
    });
  };
  const [showChangeStatusModal, setShowChangeStatusModal] = useState(false);
  const [changeStatusTicket, setChangeStatusTicket] = useState<Ticket | null>(null);
  const [selectedNewStatus, setSelectedNewStatus] = useState('');
  const [changeStatusLoading, setChangeStatusLoading] = useState(false);
  const [showEditTicketModal, setShowEditTicketModal] = useState(false);
  const [editTicket, setEditTicket] = useState<Ticket | null>(null);
  const [editTicketGroup, setEditTicketGroup] = useState<Ticket[]>([]);
  const [editTicketForm, setEditTicketForm] = useState({
    section: '',
    row: '',
    seatStart: '', 
  seatEnd: '', 
    isGroupEdit: false,
    price: '',
    internalNotes: '',
    externalNotes: '',
  });
  const [editInternalNoteChoices, setEditInternalNoteChoices] = useState<string[]>([]);
  const [editExternalNoteChoices, setEditExternalNoteChoices] = useState<string[]>([]);

  // Dedicated pricing-method modal state (Userdetails parity with Manage Tickets)
  const [showPricingMethodModal, setShowPricingMethodModal] = useState(false);
  const [selectedTicketForPricingMethod, setSelectedTicketForPricingMethod] = useState<Ticket | null>(null);
  const [pricingMethodTpIds, setPricingMethodTpIds] = useState<string[]>([]);
  const [pricingMethodLoading, setPricingMethodLoading] = useState(false);
  const [pricingMethodFormData, setPricingMethodFormData] = useState<'MANUAL' | 'FOLLOW_MARKET' | 'NONE' | ''>('');
  const [editTicketInitialNotes, setEditTicketInitialNotes] = useState({
    internal: '',
    external: '',
  });
  const [editTicketLoading, setEditTicketLoading] = useState(false);
  const [bulkSelectedTicketIds, setBulkSelectedTicketIds] = useState<Set<string>>(new Set());
  const [expandedTicketGroupKeys, setExpandedTicketGroupKeys] = useState<Record<string, boolean>>({});
  const [showBulkStatusModal, setShowBulkStatusModal] = useState(false);
  const [bulkSelectedTickets, setBulkSelectedTickets] = useState<Ticket[]>([]);
  const [bulkNewStatus, setBulkNewStatus] = useState('');
  const [bulkStatusListingPrices, setBulkStatusListingPrices] = useState<Record<string, string>>({});
  const [bulkStatusListingCommonPrice, setBulkStatusListingCommonPrice] = useState('');
  const [bulkStatusChangeLoading, setBulkStatusChangeLoading] = useState(false);
  const [bulkSoldMarketplaceId, setBulkSoldMarketplaceId] = useState('');
  const [bulkSoldLogitixAmounts, setBulkSoldLogitixAmounts] = useState<Record<string, string>>({});
  const [bulkSoldCommonLogitixAmount, setBulkSoldCommonLogitixAmount] = useState('');
  const [bulkSoldFeeConfigByTicketId, setBulkSoldFeeConfigByTicketId] = useState<Record<string, SoldFeeConfig>>({});
  const [bulkSoldFeeConfigReady, setBulkSoldFeeConfigReady] = useState(false);
  const [bulkSoldLoading, setBulkSoldLoading] = useState(false);
  const [bulkPriceTpIds, setBulkPriceTpIds] = useState<string[]>([]);
  
  // Bulk pricing modal state
  const [showBulkPriceModal, setShowBulkPriceModal] = useState(false);
  const [bulkPriceModalTickets, setBulkPriceModalTickets] = useState<Ticket[]>([]);
  const [bulkPrices, setBulkPrices] = useState<Record<string, string>>({});
  const [bulkCommonPrice, setBulkCommonPrice] = useState('');
  const [bulkPriceLoading, setBulkPriceLoading] = useState(false);
  const [priceConfirmationFlow, setPriceConfirmationFlow] = useState<
    'single' | 'bulkPrice' | null
  >(null);

  const [showVlShareModal, setShowVlShareModal] = useState(false);
  const [vlShareLoading, setVlShareLoading] = useState(false);
  const [vlEnabledMarketplaces, setVlEnabledMarketplaces] = useState<string[]>(
    () => VL_MARKETPLACE_OPTIONS.map((m) => m.id),
  );
  const [vlSharePrices, setVlSharePrices] = useState<Record<string, string>>({});
  const [vlShareSections, setVlShareSections] = useState<Record<string, string>>({});
  const [vlShareRows, setVlShareRows] = useState<Record<string, string>>({});
  const [vlShareSeats, setVlShareSeats] = useState<Record<string, string>>({});
  const [vlShareInternalNotes, setVlShareInternalNotes] = useState('');
  const [vlShareExternalNotes, setVlShareExternalNotes] = useState('');
  const [vlShareQaNotes, setVlShareQaNotes] = useState('');
  const [vlShareInternalNoteQuery, setVlShareInternalNoteQuery] = useState('');
  const [vlShareExternalNoteQuery, setVlShareExternalNoteQuery] = useState('');
  const [vlShareInternalNoteChoices, setVlShareInternalNoteChoices] = useState<string[]>([]);
  const [vlShareExternalNoteChoices, setVlShareExternalNoteChoices] = useState<string[]>([]);
  const [vlShareListingCustom, setVlShareListingCustom] = useState('');
  const vlShareWasParkingRef = useRef(false);
  useEffect(() => {
    const parking = isParkingPassNoteGroup(Object.values(vlShareRows));
    if (parking && !vlShareWasParkingRef.current) {
      setVlShareInternalNoteQuery(PARKING_INTERNAL_NOTE);
      setVlShareExternalNoteQuery(PARKING_EXTERNAL_NOTE);
      setVlShareInternalNotes(PARKING_INTERNAL_NOTE);
      setVlShareExternalNotes(PARKING_EXTERNAL_NOTE);
    }
    vlShareWasParkingRef.current = parking;
  }, [vlShareRows]);
  const [vlSharePricingMethod, setVlSharePricingMethod] = useState<'MANUAL' | 'FOLLOW_MARKET' | 'NONE' | ''>('');
  const [showListedDelistConfirm, setShowListedDelistConfirm] = useState(false);
  const [listedDelistTpIds, setListedDelistTpIds] = useState<string[]>([]);
  const [listedDelistStoredEmail, setListedDelistStoredEmail] = useState('');
  const [listedDelistProgress, setListedDelistProgress] = useState<DelistJobProgress | null>(null);
  const [showListedMarketplaceEdit, setShowListedMarketplaceEdit] = useState(false);
  const [listedMarketplaceEditTpIds, setListedMarketplaceEditTpIds] = useState<string[]>([]);
  const [listedMarketplaceEditTickets, setListedMarketplaceEditTickets] = useState<Ticket[]>([]);
  const [listedEditMarketplaces, setListedEditMarketplaces] = useState<string[]>(() =>
    VL_MARKETPLACE_OPTIONS.map((m) => m.id),
  );
  const [listedMarketplaceEditLoading, setListedMarketplaceEditLoading] = useState(false);
  const [listedSharedToggleLoading, setListedSharedToggleLoading] = useState(false);
  const [wrongPidConfirm, setWrongPidConfirm] = useState<{ tpIds: string[]; tickets: Ticket[] } | null>(null);
  const [wrongPidLoading, setWrongPidLoading] = useState(false);
  const wrongPidFlowRef = useRef<'resubmit' | 'relist' | null>(null);
  const [listedShareConfirm, setListedShareConfirm] = useState<{
    tpIds: string[];
    tickets: Ticket[];
    targetShared: boolean;
  } | null>(null);
  const [showSelfPricingPriceConfirm, setShowSelfPricingPriceConfirm] = useState(false);
  const [selfPricingPriceConfirmSummary, setSelfPricingPriceConfirmSummary] = useState('');
  const [selfPricingPriceConfirmCount, setSelfPricingPriceConfirmCount] = useState(1);
  const selfPricingPriceConfirmActionRef = useRef<(() => Promise<void>) | null>(null);
  const [showNonVlStatusConfirm, setShowNonVlStatusConfirm] = useState(false);
  const [nonVlStatusConfirmSummary, setNonVlStatusConfirmSummary] = useState('');
  const nonVlStatusConfirmActionRef = useRef<(() => Promise<void>) | null>(null);
  const skipNonVlStatusConfirmRef = useRef(false);
  const [showVlProductionMapModal, setShowVlProductionMapModal] = useState(false);
  const [vlProductionMapLoading, setVlProductionMapLoading] = useState(false);
  const [vlProductionSearchLoading, setVlProductionSearchLoading] = useState(false);
  const [vlProductionMismatch, setVlProductionMismatch] = useState<ProductionMismatchDetails | null>(null);
  const [vlProductionSearchQuery, setVlProductionSearchQuery] = useState('');
  const [vlProductionSearchResults, setVlProductionSearchResults] = useState<
    Array<{
      productionId: string;
      eventName: string;
      venueName: string;
      eventDate: string;
      eventTime?: string;
      stubhubId?: string | null;
      seatgeekId?: string | null;
      score: number;
      acceptable?: boolean;
      isSuggested?: boolean;
    }>
  >([]);
  const [vlSelectedProductionId, setVlSelectedProductionId] = useState('');
  const [vlEnteredProductionId, setVlEnteredProductionId] = useState('');
  const [vlAddPidTab, setVlAddPidTab] = useState<'search' | 'enter'>('search');
  const [vlPendingSubmitTpIds, setVlPendingSubmitTpIds] = useState<string[]>([]);
  const [vlProductionModalMode, setVlProductionModalMode] = useState<
    'confirm' | 'retry-submit' | 'add-pid'
  >('retry-submit');
  const [showSyncFromVlScopeModal, setShowSyncFromVlScopeModal] = useState(false);
  const [syncFromVlScopeTpIds, setSyncFromVlScopeTpIds] = useState<string[]>([]);
  const [syncFromVlConfirming, setSyncFromVlConfirming] = useState(false);
  const [barcodeSyncSummary, setBarcodeSyncSummary] = useState<BarcodeSyncSummary | null>(null);
  const [showBarcodeSyncSummaryModal, setShowBarcodeSyncSummaryModal] = useState(false);
  const [barcodeSyncTargetTpIds, setBarcodeSyncTargetTpIds] = useState<string[]>([]);
  const [showBarcodeSyncConfirmModal, setShowBarcodeSyncConfirmModal] = useState(false);
  const [barcodeSyncRecommendLoading, setBarcodeSyncRecommendLoading] = useState(false);
  const [barcodeSyncConfirming, setBarcodeSyncConfirming] = useState(false);
  const [barcodeSyncRecommendation, setBarcodeSyncRecommendation] =
    useState<BarcodeSyncRecommendResult | null>(null);
  const [barcodeSyncRecommendError, setBarcodeSyncRecommendError] = useState<string | null>(null);
  const [showCheckBarcodesModal, setShowCheckBarcodesModal] = useState(false);
  const [checkBarcodesLoading, setCheckBarcodesLoading] = useState(false);
  const [checkBarcodesError, setCheckBarcodesError] = useState<string | null>(null);
  const [checkBarcodesResult, setCheckBarcodesResult] = useState<CheckBarcodesResult | null>(null);
  const [showConciergePriceModal, setShowConciergePriceModal] = useState(false);
  const [conciergePriceResults, setConciergePriceResults] = useState<
    Array<{
      tpId: string;
      status: string;
      message?: string;
      oldPrice?: number | null;
      newPrice?: number | null;
      direction?: string;
      section?: string | null;
      row?: string | null;
      seat?: string | number | null;
      eventName?: string | null;
    }>
  >([]);
  const [conciergeRecentChanges, setConciergeRecentChanges] = useState<
    Array<{
      lpId: string;
      tpId: string;
      oldPrice: number | null;
      newPrice: number | null;
      direction: string;
      editType: string | null;
      createdAt: string | null;
      section?: string | null;
      row?: string | null;
      seat?: string | number | null;
      eventName?: string | null;
    }>
  >([]);
  const [vlBusyCount, setVlBusyCount] = useState(0);
  const [vlBusyMessage, setVlBusyMessage] = useState('Working…');
  const [ticketActionBusyCount, setTicketActionBusyCount] = useState(0);
  const [ticketTableBusyMessage, setTicketTableBusyMessage] = useState('Updating…');
  const vlActionLoading = vlBusyCount > 0;
  const isTicketTableBusy = vlBusyCount > 0 || ticketActionBusyCount > 0;

  const beginVlBusy = (message = 'Working…') => {
    setVlBusyMessage(message);
    setTicketTableBusyMessage(message);
    setVlBusyCount((count) => count + 1);
  };
  const endVlBusy = () => {
    setVlBusyCount((count) => Math.max(0, count - 1));
  };
  const beginTicketActionBusy = (message = 'Updating…') => {
    setTicketTableBusyMessage(message);
    setTicketActionBusyCount((count) => count + 1);
  };
  const endTicketActionBusy = () => {
    setTicketActionBusyCount((count) => Math.max(0, count - 1));
  };
  const runStatusMutation = async (message: string, operation: () => Promise<void>) => {
    beginTicketActionBusy(message);
    try {
      await operation();
    } finally {
      endTicketActionBusy();
    }
  };

  // GraphQL Queries & Mutations
  const bulkSoldActiveInStatusModal =
    showBulkStatusModal && mapStatusForMutation(bulkNewStatus) === 'Sold';

  const { data: marketplacesData, refetch: refetchMarketplaces } = useQuery(GET_MARKETPLACES_FOR_TICKETS, {
    fetchPolicy: 'network-only',
    skip: !showSoldModal && !bulkSoldActiveInStatusModal,
  });
  const marketplacesList: MarketplaceOption[] = React.useMemo(() => {
    const dbList: MarketplaceOption[] = Array.isArray(marketplacesData?.marketplaces) ? marketplacesData.marketplaces : [];
    return dbList.filter((mp) => mp.active ?? true).sort((a, b) => a.name.localeCompare(b.name));
  }, [marketplacesData]);

  useEffect(() => {
    if (!bulkSoldActiveInStatusModal || !bulkSoldMarketplaceId || !bulkSoldFeeConfigReady) return;
    const mp = marketplacesList.find((m) => m.id === bulkSoldMarketplaceId);
    if (!mp || bulkSelectedTickets.length === 0) return;
    setBulkSoldLogitixAmounts((prev) => {
      const next = { ...prev };
      bulkSelectedTickets.forEach((ticket) => {
        const list = getTicketListPrice(ticket);
        const expected = Math.round(list * (100 - mp.vl_fee_percentage)) / 100;
        next[ticket.tpId] = String(Number(roundToFixed(expected, 2)));
      });
      return next;
    });
  }, [
    bulkSoldActiveInStatusModal,
    bulkSoldMarketplaceId,
    bulkSoldFeeConfigReady,
    bulkSelectedTickets,
    marketplacesList,
  ]);
  
  const [getSuperUserForSold] = useLazyQuery(GET_SUPER_USER_BY_USER_ID, { fetchPolicy: 'no-cache' });
  
  const { loading: userLoading, error: userError, data: userData, refetch: refetchUser } = useQuery(GET_USER_BY_ID, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only'
  });
  const isGetUserByIdAllowlistError = (userError?.message || '').toLowerCase().includes('query is not allowed');
  const { loading: fallbackUserLoading, data: fallbackUsersData } = useQuery(GET_USERS_LIST, {
    variables: { pageSize: 1000, pageOffset: 0, searchText: '%', order_by: [{ u_created_at: 'desc' }] },
    skip: !userId || (!isGetUserByIdAllowlistError && !isAffiliateAdmin), fetchPolicy: 'network-only'
  });
  const fallbackUserRecord = Array.isArray(fallbackUsersData?.user) ? fallbackUsersData.user.find((u: { u_id: string }) => u.u_id === userId) : null;
  const affiliateManagedUserIds = new Set(Array.isArray(fallbackUsersData?.user) ? fallbackUsersData.user.map((u: { u_id: string }) => u.u_id) : []);
  const isAffiliateScopeResolved = !isAffiliateAdmin || Boolean(fallbackUsersData?.user);
  const isAffiliateAllowedUser = !isAffiliateAdmin || !userId || affiliateManagedUserIds.has(userId);
  const effectiveUserRecord = userData?.user?.[0] || fallbackUserRecord || null;

  // Sales rep and affiliates for the profile's User Information card (same people the Users table shows).
  const { data: repAffiliateData } = useQuery(GET_USER_REP_AFFILIATE, {
    variables: { userId },
    skip: !userId,
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  });
  const repAffiliateInfo = repAffiliateData?.user?.[0] ?? null;
  const affiliatePeopleIds = affiliateIdsToLookUp(repAffiliateInfo);
  const { data: affiliatePeopleData } = useQuery(GET_AFFILIATE_PEOPLE_BY_IDS, {
    variables: { ids: affiliatePeopleIds },
    skip: !affiliatePeopleIds.length,
    errorPolicy: 'all',
  });
  const repAffiliate = resolveRepAffiliate(repAffiliateInfo, affiliatePeopleData);
  const isUserLoading = userLoading || (isGetUserByIdAllowlistError && fallbackUserLoading);
  
  const { data: superUserData, refetch: refetchSuperUser } = useQuery(GET_SUPER_USER_BY_USER_ID, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only'
  });
  
  const userTicketListFilters = useMemo(() => {
    const stripeAccountId = String(effectiveUserRecord?.u_stripe_account_id || '').trim();
    const stripeDue = effectiveUserRecord?.u_stripe_account_is_due;
    const stripeTransfers = effectiveUserRecord?.u_stripe_transfers_status;
    const stripeMatches = stripeAccountFilter === 'all' || (
      stripeAccountFilter === 'connected'
        ? Boolean(stripeAccountId) && stripeDue === false && stripeTransfers === 'active'
        : stripeDue === true || !stripeAccountId
    );
    return buildUserTicketListQueryFilters({
      userId: userId || '',
      tab: activeFilterTab,
      soldSubFilter,
      search: debouncedTicketSearch,
      dateFilter,
      customFromDate,
      customToDate,
      barcodeFilter,
      pidStatusFilter,
      vlShareFilter,
      pricingMethodFilter,
      onHoldOnly: onHoldFilter,
      lastPricedRange: getLastPricedRange(lastPricedFrom, lastPricedTo),
      lastPricedCustomRange,
      lastPricedBuckets: lastPricedFilter,
      now: new Date(lastPricedQueryNow),
      statusFilter: filterStatus,
      stripeMatches,
      sort: ticketTableSort,
    });
  }, [
    effectiveUserRecord,
    stripeAccountFilter,
    userId,
    activeFilterTab,
    soldSubFilter,
    debouncedTicketSearch,
    dateFilter,
    customFromDate,
    customToDate,
    barcodeFilter,
    pidStatusFilter,
    vlShareFilter,
    pricingMethodFilter,
    onHoldFilter,
    lastPricedFrom,
    lastPricedTo,
    lastPricedCustomRange,
    lastPricedFilter,
    lastPricedQueryNow,
    filterStatus,
    ticketTableSort,
  ]);
  const ticketGroupedFetchSize = getGroupedPageSeatFetchSize(ticketPageSize);
  const ticketSeatsFitOneFetch = ticketSeatTotal > 0 && ticketSeatTotal <= ticketGroupedFetchSize;
  const ticketSeatWindowIndex = ticketSeatsFitOneFetch
    ? 0
    : getGroupedSeatWindowIndex(ticketPageOffset, ticketGroupsPerFullWindow);
  pendingTicketSeatWindowIndexRef.current = ticketSeatWindowIndex;
  const { loading: ticketsLoading, error: ticketsError, data: ticketsData, refetch: refetchTickets } = useQuery(GET_USER_TICKETS, {
    variables: {
      userId,
      limit: ticketGroupedFetchSize,
      offset: ticketSeatsFitOneFetch ? 0 : ticketSeatWindowIndex * ticketGroupedFetchSize,
      where: userTicketListFilters.where,
      orderBy: userTicketListFilters.orderBy,
      verificationCutoff: userTicketListFilters.verificationCutoff,
      barcodeAttachedWhere: userTicketListFilters.barcodeAttachedWhere,
      barcodeMissingWhere: userTicketListFilters.barcodeMissingWhere,
    },
    skip: !userId,
    fetchPolicy: 'network-only',
  });
  const isGetUserTicketsAllowlistError =
    (ticketsError?.message || '').toLowerCase().includes('query is not allowed') ||
    (ticketsError?.message || '').toLowerCase().includes("field 'filterlisttickets'") ||
    (ticketsError?.message || '').toLowerCase().includes('filterlisttickets');
  const { loading: userTicketMarketplacesLoading, data: userTicketMarketplacesData, refetch: refetchUserTicketMarketplaces } = useQuery(GET_USER_TICKET_MARKETPLACES, {
    variables: { userId },
    skip: !userId,
    fetchPolicy: 'network-only',
  });
  const { loading: fallbackTicketsLoading, data: fallbackManageTicketsData } = useQuery(GET_MANAGE_TICKETS, {
    variables: { enddate: null, leagueId: null, startdate: null, ticketStatus: null, ticketId: null, tpId: null, pageSize: 5000, pageOffset: 0, day: null, search_event: '%', array_tpid: null, pricingMode: '%', order_by: MANAGE_TICKETS_ORDER_BY },
    skip: !userId || !isGetUserTicketsAllowlistError, fetchPolicy: 'network-only'
  });
  
  const { loading: analyticsLoading, data: analyticsData, refetch: refetchAnalytics } = useQuery(GET_USER_ANALYTICS, {
    variables: { userId }, skip: !userId || activeTab !== 'analytics', fetchPolicy: 'network-only'
  });

  const hearAboutUsLoading = false;
  const hearAboutUsData: any = null;
  
  const { data: userPreferenceData, loading: userPreferenceLoading, refetch: refetchUserPreferences } = useQuery(GET_USER_PREFERENCE_TEAMS, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only'
  });
  const preferredCategoryIds: string[] = Array.isArray(userPreferenceData?.user_preference)
    ? userPreferenceData.user_preference.map((p: { lc_id?: string }) => p?.lc_id).filter(Boolean) : [];
  
  const { data: availableTeamsData, loading: availableTeamsLoading } = useQuery(GET_AVAILABLE_TEAMS_FOR_USER, {
    fetchPolicy: 'cache-first'
  });
  const { data: allLeaguesData, loading: allLeaguesLoading } = useQuery(GET_ALL_LEAGUES, {
    fetchPolicy: 'cache-first'
  });
  const leagueNameById = new Map<string, string>(
    (allLeaguesData?.leagues || []).map((league: any) => [league.l_id, league.l_name || league.l_id]),
  );
  
  const { data: teamsWithSoldData, loading: teamsWithSoldLoading, refetch: refetchTeamsWithSoldStatus } = useQuery(GET_USER_TEAMS_WITH_SOLD_STATUS, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only'
  });
  
  const { data: preferredLeagueCategoriesData, loading: preferredLeagueCategoriesLoading } = useQuery(GET_LEAGUE_CATEGORIES_BY_IDS, {
    variables: { categoryIds: preferredCategoryIds }, skip: preferredCategoryIds.length === 0, fetchPolicy: 'network-only'
  });
  
  const selectedTeamHasCategoryId = selectedTeamForSeats ? isValidUuid(selectedTeamForSeats.id) : false;
  const { data: userSavedSeatInfoData, loading: userSavedSeatInfoLoading, refetch: refetchUserSavedSeatInfo } = useQuery(GET_USER_SAVED_SEAT_INFO, {
    variables: { userId, lcId: selectedTeamForSeats?.id },
    skip: !userId || !selectedTeamForSeats || !selectedTeamHasCategoryId, fetchPolicy: 'network-only'
  });
  
  const { loading: notesLoading, data: notesData, refetch: refetchNotes } = useQuery(GET_USER_NOTES, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only',
    onCompleted: (data) => { if (data?.user_notes) setNotes(transformNotesData(data.user_notes)); }
  });

  const [fetchLeagueCategoryNames] = useLazyQuery(GET_LEAGUE_CATEGORIES_BY_IDS, { fetchPolicy: 'network-only' });
  const { loading: seatLevelNotesLoading, error: seatLevelNotesError, refetch: refetchSeatLevelNotes } = useQuery(GET_USER_VICTORY_LIVE_SEAT_NOTES, {
    variables: { userId },
    skip: !userId,
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const rows = Array.isArray(data?.user_victory_live_seat_notes) ? data.user_victory_live_seat_notes : [];
      const notes = rows.map((note: any) => ({
        id: note.vlsn_id,
        userId: note.u_id,
        teamId: note.lc_id,
        teamName: '',
        section: String(note.section || ''),
        row: String(note.seat_row || ''),
        seatStart: Number(note.seat_start),
        seatEnd: Number(note.seat_end),
        internalNote: String(note.internal_note || ''),
        externalNote: String(note.external_note || ''),
        createdAt: note.created_at,
        updatedAt: note.updated_at,
      }));
      const teamIds = [...new Set(notes.map((note: SeatLevelNoteEntry) => note.teamId).filter(Boolean))];
      if (!teamIds.length) {
        setSeatLevelNotes(notes);
        return;
      }
      fetchLeagueCategoryNames({ variables: { categoryIds: teamIds } })
        .then((result) => {
          setSeatLevelNotes(withSeatNoteTeamNames(
            notes,
            (result.data?.league_categories || []).map((team: { lc_id?: string; lc_name?: string | null }) => ({
              id: team.lc_id,
              name: team.lc_name,
            })),
          ) as SeatLevelNoteEntry[]);
        })
        .catch(() => setSeatLevelNotes(notes));
    },
  });

  const seatNotesWithTeamNames = async (): Promise<SeatLevelNoteEntry[]> => {
    if (!seatLevelNotes.some((note) => note.teamId && !String(note.teamName || '').trim())) {
      return seatLevelNotes;
    }
    const teamIds = [...new Set(seatLevelNotes.map((note) => note.teamId).filter(Boolean))];
    if (!teamIds.length) return seatLevelNotes;
    try {
      const result = await fetchLeagueCategoryNames({ variables: { categoryIds: teamIds } });
      const named = withSeatNoteTeamNames(
        seatLevelNotes,
        (result.data?.league_categories || []).map((team: { lc_id?: string; lc_name?: string | null }) => ({
          id: team.lc_id,
          name: team.lc_name,
        })),
      ) as SeatLevelNoteEntry[];
      setSeatLevelNotes(named);
      return named;
    } catch (error) {
      console.warn('Failed to load seat-note team names', error);
      return seatLevelNotes;
    }
  };

  const ticketNoteLocations = (tickets: Ticket[]) => tickets.map((ticket) => {
    const clean = (value: string | null | undefined) => {
      const text = String(value || '').trim();
      return text === '-' ? '' : text;
    };
    return {
      userId: String(userId || '').trim(),
      teamId: String(ticket.lc_id || '').trim(),
      eventName: String(ticket.event || '').trim(),
      section: clean(ticket.section),
      row: clean(ticket.row),
    };
  });

  const { data: emailStatusData } = useQuery(GET_USER_EMAIL_STATUS, {
    variables: { userId }, skip: !userId, fetchPolicy: 'network-only',
  });

  const [voidPayoutNote, setVoidPayoutNote] = useState('');
  const [addNoteOnVoid, setAddNoteOnVoid] = useState(false);
  
  const { error: showErrorRaw, success: showSuccess, info: showInfo } = ToasterWithMessage();
  const showError = (message: any) => {
    showErrorRaw(formatUserDetailsError(message, typeof message === 'string' ? message : 'Something went wrong'));
  };
  const showVlToast = (toast: VlActionToast) => {
    if (toast.type === 'success') showSuccess(toast.message);
    else if (toast.type === 'info') showInfo(toast.message);
    else showError(toast.message);
  };

  const [refreshNotifications] = useLazyQuery(GET_NOTIFICATIONS, {
    fetchPolicy: 'network-only',
    onCompleted: (notificationData) => {
      if (notificationData && globalState?.profile?.id) {
        handleGlobalState((prev: typeof globalState) => ({
          ...prev,
          notifications: notificationData.notifications || prev?.notifications || [],
        }));
      }
    },
  });

  const syncDashboardNotifications = () => {
    if (!globalState?.profile?.id) return;
    const adminId = globalState.profile.id;
    const runSync = () => {
      refreshNotifications({
        variables: getNotificationQueryVariables(adminId),
      });
    };
    runSync();
  };

  const refreshTicketsAndNotifications = async () => {
    await Promise.all([
      refetchTickets(),
      refetchUserTicketMarketplaces().catch(() => undefined),
    ]);
    syncDashboardNotifications();
  };
  
  const escapeCSV = (value: string | number | null | undefined) => {
    const safeValue = value == null ? '' : String(value);
    return `"${safeValue.replace(/"/g, '""')}"`;
  };
const getDateRange = (filter: typeof dateFilter): { from: Date | null; to: Date | null } => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  switch (filter) {
    case 'today':
      return { from: new Date(today), to: new Date(today) };
    case 'yesterday': {
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return { from: new Date(yesterday), to: new Date(yesterday) };
    }
    case 'thisWeek': {
      const weekStart = new Date(today);
      const dayOfWeek = today.getDay(); // 0 = Sunday
      weekStart.setDate(today.getDate() - dayOfWeek);
      const weekEnd = new Date(weekStart);
      weekEnd.setDate(weekStart.getDate() + 6);
      return { from: weekStart, to: weekEnd };
    }
    case 'thisMonth': {
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
      const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      return { from: monthStart, to: monthEnd };
    }
    case 'custom': {
      if (!customFromDate || !customToDate) return { from: null, to: null };
      return {
        from: parseFilterCalendarDate(customFromDate),
        to: parseFilterCalendarDate(customToDate),
      };
    }
    default:
      return { from: null, to: null };
  }
};


const filterTicketsByDate = (tickets: Ticket[]): Ticket[] => {
  if (dateFilter === 'all') return tickets;

  const { from, to } = getDateRange(dateFilter);
  if (!from || !to || Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return tickets;

  const fromYmd = toLocalDateYmd(from);
  const toYmd = toLocalDateYmd(to);
  return tickets.filter((ticket) => ticketMatchesEventDateRange(ticket, fromYmd, toYmd));
};


const isCustomDateRangeValid = (): boolean => {
  if (!customFromDate || !customToDate) return false;
  const from = new Date(customFromDate);
  const to = new Date(customToDate);
  return !isNaN(from.getTime()) && !isNaN(to.getTime()) && from <= to;
};

const clearAllFilters = () => {
  setDateFilter('all');
  setCustomFromDate('');
  setCustomToDate('');
  setSearchQuery('');
  setActiveFilterTab('All');
  setSoldSubFilter('all');
  setBarcodeFilter('all');
  setPidStatusFilter('all');
  setVlShareFilter('all');
  setShowVlShareFilterDropdown(false);
   setStripeAccountFilter('all');
};

const [updateTicketPlacement] = useMutation(UPDATE_TICKET_PLACEMENT, { fetchPolicy: 'network-only' });

const formatDateDisplay = (date: Date): string => {
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
};

const getDateFilterLabel = (): string => {
  switch (dateFilter) {
    case 'today': return 'Today';
    case 'yesterday': return 'Yesterday';
    case 'thisWeek': return 'This Week';
    case 'thisMonth': return 'This Month';
    case 'custom': {
      if (customFromDate && customToDate) {
        return `${formatDateDisplay(new Date(customFromDate))} - ${formatDateDisplay(new Date(customToDate))}`;
      }
      return 'Custom Range';
    }
    default: return 'All Dates';
  }
};

  const formatTime = (
    dateString: string,
    timeZone?: string | null,
    dateTimeZone?: string | null,
    eTime?: string | null,
  ): string => {
  if (!dateString && !dateTimeZone && !eTime) return '';
  return formatDbEventTime({
    e_date: dateString,
    e_time_zone: timeZone,
    e_date_time_zone: dateTimeZone,
    e_time: eTime,
  }, 'short');
};
const formatTicketTime = (dateString?: string, timeZone?: string | null): string => {
  if (!dateString) return '';
  return formatTime(dateString, timeZone);
};

  const sanitizePriceInput = (value: string): string => {
    let sanitized = value.replace(/[^0-9.]/g, '');
    const firstDecimalIndex = sanitized.indexOf('.');
    if (firstDecimalIndex !== -1) {
      sanitized =
        sanitized.slice(0, firstDecimalIndex + 1) +
        sanitized.slice(firstDecimalIndex + 1).replace(/\./g, '');
    }
    return sanitized;
  };

  const getUserDetailCsvClientType = () => {
    const pricingMode = String(effectiveUserRecord?.u_pricing_mode || '').trim().toLowerCase();
    if (pricingMode === 'self-pricing') return 'Self Pricing';
    if (pricingMode === 'concierge') return 'Concierge';
    return '';
  };

  /** Default VL internal notes when the client has none — same Custom:N rules as CSV listing. */
  const buildDefaultInternalNotes = (quantity: number): string => {
    if (!Number.isInteger(quantity) || quantity <= 0) return '';
    const start = quantity % 2 === 0 ? 2 : 1;
    const values: number[] = [];
    for (let value = start; value <= quantity; value += 2) values.push(value);
    return values.length ? `Custom:${values.join(',')}` : '';
  };
  const getEventTimeForExport = (ticket: Ticket): string => {
  if (ticket.eventTime && ticket.eventTime.trim()) return ticket.eventTime;
  if (ticket.eventDateRaw) {
    return formatTime(ticket.eventDateRaw, ticket.eventTimeZone);
  }
  return '';
};

 const exportTicketsCsv = (tickets: Ticket[], filterName: string) => {
  if (!tickets || tickets.length === 0) {
    showError('No tickets to export');
    return;
  }

  const normalizedFilter = filterName ? filterName.toLowerCase().replace(/[^a-z0-9]+/g, '_') : 'all';
  const filename = `user_tickets_${normalizedFilter}`;
  const includeCommission = filterName === 'Sold';
  const commissionRate = Number(effectiveUserRecord?.sales_reps?.sr_commission_rate ?? 0);
  const headers = [
    'Ticket ID', 'Event', 'Date', 'Event Time', 'Section', 'Row', 'Seat #', 'Status', 'Price', 'Sold Price',
    ...(includeCommission ? ['Commission'] as const : []),
    'Client Type', 'Internal Notes', 'External Notes'
  ];
  const rows = [headers.map(escapeCSV).join(',')];
  const clientTypeLabel = getUserDetailCsvClientType();

  tickets.forEach((ticket) => {
    const quickCut = qaProfitByTicketPlacementId.get(ticket.tpId) ?? ticket.qaProfit ?? 0;
    const commission = getSalesRepCommissionAmount(quickCut, commissionRate);
    rows.push([
      escapeCSV(ticket.tpId),
      escapeCSV(ticket.event),
      escapeCSV(ticket.date),
      escapeCSV(getEventTimeForExport(ticket)),
      escapeCSV(ticket.section),
      escapeCSV(ticket.row),
      escapeCSV(ticket.seatNo),
      escapeCSV(ticket.status),
      escapeCSV(ticket.price),
      escapeCSV(ticket.soldPrice),
      ...(includeCommission
        ? [escapeCSV(commission > 0 ? formatCurrency(commission) : '—')]
        : []),
      escapeCSV(clientTypeLabel),
      escapeCSV(ticket.internalNotes || ''),
      escapeCSV(ticket.externalNotes || ''),
    ].join(','));
  });

    const blob = new Blob([rows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}_${new Date().toISOString().slice(0,10)}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  
  // Mutations
  const [updateUser, { loading: updateLoading }] = useMutation(UPDATE_USER);
  const [emailUpdateLoading, setEmailUpdateLoading] = useState(false);
  const [deleteUser, { loading: deleteLoading }] = useMutation(DELETE_USER);
  const [voidUserPayouts, { loading: voidLoading }] = useMutation(VOID_USER_PAYOUTS);
  const [updateEmailStatus, { loading: emailStatusLoading }] = useMutation(UPDATE_USER_EMAIL_STATUS);
  const [restoreUserPayouts, { loading: restoreLoading }] = useMutation(RESTORE_USER_PAYOUTS);
  const [updateSuperUserPercentage] = useMutation(UPDATE_SUPER_USER_PERCENTAGE);
  const [addNote, { loading: addNoteLoading }] = useMutation(ADD_USER_NOTE);
  const [updateNote, { loading: updateNoteLoading }] = useMutation(UPDATE_USER_NOTE);
  const [deleteNote, { loading: deleteNoteLoading }] = useMutation(DELETE_USER_NOTE);
  const [editTicketPriceBySuperUser] = useMutation(EDIT_TICKET_PRICE_BY_SUPER_USER, { fetchPolicy: 'network-only' });
  const [updateTicketStatus] = useMutation(UPDATE_TICKET_STATUS, { fetchPolicy: 'network-only' });
  const [deleteTicketStatus] = useMutation(DELETE_TICKET_STATUS, { fetchPolicy: 'network-only' });
  const [publishNonVlListingMutation] = useMutation(PUBLISH_NON_VL_LISTING, { fetchPolicy: 'network-only' });
  const [restoreDeletedToVerification] = useMutation(RESTORE_DELETED_TO_VERIFICATION, { fetchPolicy: 'network-only' });
  const [updateTicketPaymentStatus] = useMutation(UPDATE_TICKET_PAYMENT_STATUS, { fetchPolicy: 'network-only' });
  const [updateTicketsPaymentStatus] = useMutation(UPDATE_TICKETS_PAYMENT_STATUS, { fetchPolicy: 'network-only' });
  const [updateTicketCommissionOverride] = useMutation(UPDATE_TICKET_COMMISSION_OVERRIDE, { fetchPolicy: 'network-only' });
  const [updateTicketBarcodeStatus] = useMutation(UPDATE_TICKET_BARCODE_STATUS, { fetchPolicy: 'network-only' });
  const [restoreCancelledListingToVerification] = useMutation(RESTORE_CANCELLED_LISTING_TO_VERIFICATION, { fetchPolicy: 'network-only' });
  const [insertUserSavedSeatInfo] = useMutation(INSERT_USER_SAVED_SEAT_INFO);
  const [updateUserSavedSeatInfo] = useMutation(UPDATE_USER_SAVED_SEAT_INFO);
  const [insertSeatLevelNote] = useMutation(INSERT_USER_VICTORY_LIVE_SEAT_NOTE);
  const [updateSeatLevelNote] = useMutation(UPDATE_USER_VICTORY_LIVE_SEAT_NOTE);
  const [deleteSeatLevelNote] = useMutation(DELETE_USER_VICTORY_LIVE_SEAT_NOTE);
  const [addUserTeam] = useMutation(ADD_USER_PREFERENCE_TEAM);
  const [removeUserTeam] = useMutation(REMOVE_USER_PREFERENCE_TEAM);
  const [adminRemoveUserTeam] = useMutation(ADMIN_REMOVE_USER_PREFERENCE_TEAM);

  const handleUserBarcodeStatusUpdate = async (tickets: Ticket[], status: BarcodeStatusValue) => {
    const tpIds = [...new Set(tickets.map((ticket) => ticket.tpId).filter(Boolean))];
    if (!tpIds.length) return;
    try {
      const result = await updateTicketBarcodeStatus({ variables: { tpIds, status } });
      if (result.data?.update_ticket_placement?.affected_rows !== tpIds.length) {
        throw new Error('Not all ticket barcode statuses were updated.');
      }
      const label = BARCODE_STATUS_OPTIONS.find((option) => option.value === status)?.label || status;
      showSuccess(`Barcode status set to ${label}.`);
      await refetchTickets();
    } catch (error) {
      showError(error);
    }
  };
  
  const [editFormData, setEditFormData] = useState<UserData | null>(null);
  
  useEffect(() => {
    if (effectiveUserRecord) {
      setEditFormData(transformUserData(effectiveUserRecord, superUserData?.super_user?.[0]?.percentage));
    }
  }, [effectiveUserRecord, superUserData]);
  
  useEffect(() => {
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
    if (isDarkMode) {
      document.documentElement.classList.add('dark-mode');
      document.body.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
      document.body.classList.remove('dark-mode');
    }
  }, [isDarkMode]);
  
  useEffect(() => {
    if (!openStatusDropdown) return undefined;
    const ignoreUntil = Date.now() + 75;
    const handleClick = (event: MouseEvent) => {
      if (Date.now() < ignoreUntil) return;
      const target = event.target as HTMLElement | null;
      if (target?.closest(`.${styles.statusDropdownWrapper}`)) return;
      setOpenStatusDropdown(null);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [openStatusDropdown, styles.statusDropdownWrapper]);

  const toggleTicketActionMenu = (ticketId: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setOpenActionTicketId((current) => (current === ticketId ? null : ticketId));
  };

  useEffect(() => {
    const hasOpenSeatCardDropdown = Object.values(seatCardStatusDropdownOpen).some(Boolean);
    if (!hasOpenSeatCardDropdown) return undefined;

    const handleSeatCardDropdownClick = () => setSeatCardStatusDropdownOpen({});
    window.addEventListener('click', handleSeatCardDropdownClick);
    return () => window.removeEventListener('click', handleSeatCardDropdownClick);
  }, [seatCardStatusDropdownOpen]);
  
  useEffect(() => {
    if (Array.isArray(availableTeamsData?.league_categories)) {
      setAvailableTeamsForUser(availableTeamsData.league_categories);
    }
  }, [availableTeamsData]);
  

  // Data Transformations
  function transformUserData(data: any, superUserPercentage?: number): UserData {
    const fullName = data.u_full_name || `${data.u_first_name || ''} ${data.u_last_name || ''}`.trim() || 'Unknown User';
    const initials = fullName.split(' ').map((n: string) => n[0]).join('').toUpperCase().substring(0, 2);
    const pricingMode = data.u_pricing_mode;
    const isSelfPricing = pricingMode === 'self-pricing';
    const persistedUserFee = Number(data.u_fee_percentage);
    const superUserFee = Number(superUserPercentage);
    const derivedUserFee = isSelfPricing
      ? (Number.isFinite(superUserFee) && superUserFee > 0 ? superUserFee : (Number.isFinite(persistedUserFee) && persistedUserFee > 0 && persistedUserFee !== 20 ? persistedUserFee : 15))
      : (Number.isFinite(persistedUserFee) && persistedUserFee > 0 ? persistedUserFee : 20);
    const payoutInfoStatus = getPayoutInfoStatus(
      data.u_stripe_account_id,
      data.u_stripe_transfers_status,
      data.u_stripe_account_is_due,
    );
    return {
      id: data.u_id, name: fullName, initials, type: isSelfPricing ? 'Self Pricing' : 'Concierge',
      tier: data.u_seller_tier || 'No Status', business: data.u_stripe_business_name || '',
      email: data.u_email_id || '', phone: data.u_phone_number || '',
      address1: data.u_address_line1 || '', address2: data.u_address_line2 || '', address3: data.u_address_line3 || 'USA',
      city: data.u_city || '', state: data.u_state || '', zip: data.u_zip || '', country: data.u_country || 'USA',
      lastActive: data.u_last_online ? new Date(data.u_last_online).toLocaleString() : 'N/A',
      annualSales: `${formatCurrency(data.tickets_sold_amount || 0)}/yr`,
      teams: data.teams?.map((team: any) => team.team_name).filter(Boolean) || [],
      assignedTeams: Array.isArray(data.u_teams) ? data.u_teams : [],
      userFee: derivedUserFee.toString(), status: data.u_status || 'active', createdAt: data.u_created_at || '',
      payoutsVoided: data.u_payouts_voided || false, voidReason: data.u_void_reason, voidDate: data.u_void_date,
      emailEnabled: data.u_email_enabled !== false, hearAboutUs: data.u_hear_about_us || undefined,
      stripeAccountId: data.u_stripe_account_id || null,
      stripeTransfersStatus: data.u_stripe_transfers_status || null,
      stripeAccountIsDue: data.u_stripe_account_is_due ?? null,
      payoutInfoAccountLabel: payoutInfoStatus.accountLabel,
      payoutInfoStatusText: payoutInfoStatus.statusText,
      payoutInfoIsComplete: payoutInfoStatus.isComplete,
    };
  }

  const currentUser = effectiveUserRecord ? transformUserData(effectiveUserRecord, superUserData?.super_user?.[0]?.percentage) : null;

  // ========== TIMING ANALYTICS HELPERS ==========
const parseDateAnalytics = (value?: string | null): Date | null => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const getDaysBetweenDates = (date1: Date, date2: Date): number => {
  return (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24);
};

const formatCurrencyForAnalytics = (value: number): string => {
  if (!Number.isFinite(value)) return '$0.00';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(value);
};

  
const transformTicketsData = (data: any, targetUserId?: string): Ticket[] => {
  if (!data?.tickets) return [];
  return sortUserDetailTickets(data.tickets.map((ticket: any): Ticket => {
    const listPriceValue = pickTicketValue(
      ticket.t_list_price,
      ticket.tp_list_price,
      ticket.list_price,
      ticket.listPrice,
      ticket.price,
      ticket.t_price,
      ticket.tp_price,
    );
    const soldAmount = pickTicketValue(
      ticket.t_sold_price,
      ticket.t_sold_amount,
      ticket.tp_sold_amount,
      ticket.tp_sold_price,
      ticket.sold_price,
      ticket.soldAmount,
      ticket.sold_amount,
      ticket.sale_amount,
      ticket.settlement_amount,
    );

    const marketplaceFields = [
      'tp_marketplace_name',
      't_marketplace_name',
      'marketplace_name',
      'marketplace',
      'mp_name',
    ];
    
    let { isValid: mpIsValid, value: marketplace, source: mpSource } = validateTicketMarketplaceData(ticket, marketplaceFields);
    
    const tpId = ticket.tp_id || ticket.t_id;
    if (!mpIsValid && !marketplace && targetUserId) {
      const cachedMarketplace = restoreMarketplaceFromCache(targetUserId, tpId);
      if (cachedMarketplace) {
        marketplace = cachedMarketplace;
        mpIsValid = true;
        console.log(`✅ RESTORED marketplace from cache for ${tpId}: ${cachedMarketplace}`);
      }
    }
    
    if ((ticket.t_status?.toLowerCase() === 'sold' || ticket.tp_status?.toLowerCase() === 'sold') && !mpIsValid) {
      console.warn('⚠️ PRIMARY DATA - SOLD ticket missing marketplace:', {
        tpId: tpId,
        status: ticket.t_status || ticket.tp_status,
        availableFields: marketplaceFields.map(f => ({ field: f, value: ticket[f] }))
      });
    }

   const eventTimeZone =
     ticket.e_time_zone ||
     ticket.event?.e_time_zone ||
     ticket.t_event_time_zone ||
     null;
   const eventDateTimeZone =
     ticket.e_date_time_zone ||
     ticket.event?.e_date_time_zone ||
     ticket.t_event_date_time_zone ||
     null;
   const eventWallTime =
     ticket.e_time ||
     ticket.event?.e_time ||
     null;
   // Prefer e_date instant + venue TZ (same as ManageTickets); fall back to timezone label field.
   const eventDateRawValue =
     ticket.e_date ||
     ticket.t_event_date ||
     ticket.event?.e_date ||
     ticket.t_event_date_time_zone ||
     ticket.e_date_time_zone ||
     ticket.t_date ||
     ticket.date;
    
    const eventDateTime = eventDateRawValue || '';
    const eventTime = formatTime(eventDateTime, eventTimeZone, eventDateTimeZone, eventWallTime);
    const formattedDate = eventDateRawValue
      ? formatDate(eventDateRawValue, eventTimeZone, eventDateTimeZone, eventWallTime)
      : 'TBD';
    
    // Debug log to check date data
    if (eventDateTime) {
      console.log('Event date debug:', {
        tpId: ticket.tp_id || ticket.t_id,
        eventDateRaw: eventDateRawValue,
        eventTimeZone,
        formattedDate: formattedDate,
        eventDateTime: eventDateTime
      });
    }

    const rawStatusValue = ticket.t_status || ticket.tp_status || ticket.status || 'Unknown';
    const statusLabel = getStatusLabel(ticket.t_status || ticket.tp_status || ticket.status || '') || rawStatusValue;

    const venue = ticket.e_address || ticket.event?.e_address || '';
    const league = ticket.l_name || ticket.league?.l_name || '';
    const email = ticket.u_email_id || ticket.u_original_email || ticket.user?.u_email_id || '';

    const ticketRow: Ticket = {
      id: ticket.t_id, 
      tpId: tpId, 
      lc_id: ticket.lc_id || undefined,
      rawStatus: rawStatusValue,
      updatedAt: ticket.t_updated_at || ticket.tp_updated_at || undefined,
      tp_updated_at: ticket.tp_updated_at || ticket.t_updated_at || undefined,
      tp_delist_requested_email: ticket.tp_delist_requested_email ?? null,
      last_priced_at: ticket.last_priced_at ?? undefined,
      event: ticket.event?.e_name || ticket.e_name || 'Unknown Event',
      seatMode: ticket.tp_seat_mode ?? null,
      eventId: ticket.e_id || ticket.event?.e_id || undefined,
      eventStatus: ticket.e_status || ticket.event?.e_status || null,
      eventDateRaw: eventDateRawValue || undefined, // Make sure this is set
      eventTime: eventTime,
      eventTimeZone: eventTimeZone || null,
      date: formattedDate,
      section: ticket.t_section || ticket.tp_section || '-', 
      row: ticket.t_row || ticket.tp_row || '-',       seatNo:
        ticket.t_seat_no != null && String(ticket.t_seat_no).trim() !== ''
          ? String(ticket.t_seat_no)
          : ticket.tp_seat_no != null && String(ticket.tp_seat_no).trim() !== ''
            ? String(ticket.tp_seat_no)
            : '-',
      status: statusLabel,
      paymentStatus: ticket.t_payment_status ?? ticket.tp_payment_status ?? null,
      payoutStatus: ticket.t_payout_status ?? ticket.tp_payout_status ?? null,
      price: formatListPrice(listPriceValue),
      soldPrice: formatOptionalCurrency(soldAmount),
      marketplace: marketplace,
      qaProfit: Math.max(0, Number(ticket.tp_quick_cut_amount) || 0),
      venue,
      league,
      email,
      vlListingId: ticket.tp_vl_listing_id ?? null,
      vlItemId: ticket.tp_vl_item_id ?? null,
      tpWrongPid: ticket.tp_wrong_pid === true,
      confirmedVlProductionId: String(ticket.tp_vl_production_id || '').trim() || null,
      barcode: String(ticket.tp_barcode || ticket.barcode || ticket.vl_barcode || '').trim() || null,
      barcodeStatus: ticket.tp_barcode_status as BarcodeStatusValue | undefined,
      barcodeAttached:
        ticket.tp_barcode_attached === true ||
        Boolean(String(ticket.tp_barcode || ticket.barcode || ticket.vl_barcode || '').trim()),
      on_hold: ticket.on_hold === true,
      tp_vl_share: ticket.tp_vl_share === true,
      internalNotes: String(ticket.tp_internal_notes || ''),
      externalNotes: String(ticket.tp_external_notes || ''),
      tp_sales_rep_commission_override: ticket.tp_sales_rep_commission_override ?? null,
    };
    const pres = getTicketStatusPresentation(ticketRow);
    return { ...ticketRow, status: pres.label };
  }));
};

  
  // ========== MARKETPLACE & LEAGUE DATA VALIDATION UTILITIES ==========
const KNOWN_MARKETPLACES = [
  'StubHub', 'Ticketmaster', 'SeatGeek', 'Vivid Seats', 'Gametime', 
  'TickPick', 'Logitix', 'AXS', 'Eventbrite', 'Viagogo', 'Live Nation',
  'StudHub', 'Facebook', 'Craigslist', 'Other'
];

const normalizeMarketplaceName = (raw: string | null | undefined): string | null => {
  if (!raw || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  
  const exactMatch = KNOWN_MARKETPLACES.find(m => m.toLowerCase() === trimmed.toLowerCase());
  if (exactMatch) return exactMatch;
  
  const lower = trimmed.toLowerCase();
  if (lower.includes('stub')) return 'StubHub';
  if (lower.includes('ticketmaster')) return 'Ticketmaster';
  if (lower.includes('seatgeek')) return 'SeatGeek';
  if (lower.includes('vivid')) return 'Vivid Seats';
  if (lower.includes('game')) return 'Gametime';
  if (lower.includes('tickpick')) return 'TickPick';
  if (lower.includes('logitix')) return 'Logitix';
  if (lower.includes('axs')) return 'AXS';
  if (lower.includes('eventbrite')) return 'Eventbrite';
  if (lower.includes('viagogo')) return 'Viagogo';
  
  return trimmed.length > 0 ? trimmed : null;
};

const validateTicketMarketplaceData = (ticket: any, fieldNames: string[]): { isValid: boolean; value: string | null; source: string } => {
  for (const field of fieldNames) {
    const value = ticket[field];
    if (value && typeof value === 'string' && value.trim()) {
      const normalized = normalizeMarketplaceName(value);
      if (normalized) {
        return { isValid: true, value: normalized, source: field };
      }
    }
  }
  return { isValid: false, value: null, source: 'none' };
};

const getMarketplaceCache = (userId: string): Record<string, string> => {
  try {
    const cached = localStorage.getItem(`marketplace_cache_${userId}`);
    return cached ? JSON.parse(cached) : {};
  } catch {
    return {};
  }
};

const saveMarketplaceCache = (userId: string, tpId: string, marketplace: string) => {
  try {
    const cache = getMarketplaceCache(userId);
    cache[tpId] = marketplace;
    localStorage.setItem(`marketplace_cache_${userId}`, JSON.stringify(cache));
    console.log(`✅ CACHED marketplace for ${tpId}: ${marketplace}`);
  } catch (err) {
    console.warn('Failed to cache marketplace:', err);
  }
};

const restoreMarketplaceFromCache = (userId: string, tpId: string): string | null => {
  const cache = getMarketplaceCache(userId);
  return cache[tpId] || null;
};

const marketplaceByTicketPlacementId = useMemo(() => {
  const map = new Map<string, string>();
  const rows = Array.isArray(userTicketMarketplacesData?.ticket_placement)
    ? userTicketMarketplacesData.ticket_placement
    : [];

  rows.forEach((row: any) => {
    const tpId = String(row?.tp_id ?? '').trim();
    const marketplace = typeof row?.tp_marketplace_name === 'string' ? row.tp_marketplace_name.trim() : '';
    if (tpId && marketplace && marketplace !== 'Other' && marketplace !== 'Unknown') {
      map.set(tpId, marketplace);
    }
  });

  return map;
}, [userTicketMarketplacesData]);

const vlIdsByTicketPlacementId = useMemo(() => {
  const map = new Map<string, { vlListingId: string | null; vlItemId: string | null }>();
  const rows = Array.isArray(userTicketMarketplacesData?.ticket_placement)
    ? userTicketMarketplacesData.ticket_placement
    : [];

  rows.forEach((row: any) => {
    const tpId = String(row?.tp_id ?? '').trim();
    if (!tpId) return;
    map.set(tpId, {
      vlListingId: row?.tp_vl_listing_id != null ? String(row.tp_vl_listing_id) : null,
      vlItemId: row?.tp_vl_item_id != null ? String(row.tp_vl_item_id) : null,
    });
  });

  return map;
}, [userTicketMarketplacesData]);

const qaProfitByTicketPlacementId = useMemo(() => {
  const map = new Map<string, number>();
  const rows = Array.isArray(userTicketMarketplacesData?.ticket_placement)
    ? userTicketMarketplacesData.ticket_placement
    : [];

  rows.forEach((row: any) => {
    const tpId = String(row?.tp_id ?? '').trim();
    const status = String(row?.tp_status ?? '').toLowerCase();
    if (!tpId || status !== 'sold') return;
    const amount = Number(row?.tp_quick_cut_amount);
    if (Number.isFinite(amount) && amount >= 0) {
      map.set(tpId, amount);
    }
  });

  return map;
}, [userTicketMarketplacesData]);

const salesRepCommissionOverrideByTicketPlacementId = useMemo(() => {
  const map = new Map<string, number | string | null>();
  const rows = Array.isArray(userTicketMarketplacesData?.ticket_placement)
    ? userTicketMarketplacesData.ticket_placement
    : [];

  rows.forEach((row: any) => {
    const tpId = String(row?.tp_id ?? '').trim();
    if (tpId) map.set(tpId, row?.tp_sales_rep_commission_override ?? null);
  });

  return map;
}, [userTicketMarketplacesData]);


const pricingMethodByTicketPlacementId = useMemo(() => {
  const map = new Map<string, 'MANUAL' | 'FOLLOW_MARKET'>();
  const rows = Array.isArray(userTicketMarketplacesData?.ticket_placement)
    ? userTicketMarketplacesData.ticket_placement
    : [];

  rows.forEach((row: any) => {
    const tpId = String(row?.tp_id ?? '').trim();
    const pricingMethod = normalizePricingMethod(row?.tp_pricing_method);
    if (tpId && pricingMethod) map.set(tpId, pricingMethod);
  });

  return map;
}, [userTicketMarketplacesData]);
const applyMarketplaceLookupToTickets = React.useCallback((tickets: Ticket[]): Ticket[] => {
  return tickets.map((ticket) => {
    let next = ticket;
    if (!(ticket.marketplace && ticket.marketplace.trim() && ticket.marketplace !== 'Other' && ticket.marketplace !== 'Unknown')) {
      const marketplace = marketplaceByTicketPlacementId.get(ticket.tpId);
      if (marketplace) next = { ...next, marketplace };
    }
    const vlIds = vlIdsByTicketPlacementId.get(ticket.tpId);
    if (vlIds) {
      next = {
        ...next,
        vlListingId: vlIds.vlListingId ?? next.vlListingId ?? null,
        vlItemId: vlIds.vlItemId ?? next.vlItemId ?? null,
      };
    }
    const pricingMethod = pricingMethodByTicketPlacementId.get(ticket.tpId);
    if (pricingMethod) {
      next = { ...next, tp_pricing_method: pricingMethod };
    }
    const commissionOverride = salesRepCommissionOverrideByTicketPlacementId.get(ticket.tpId);
    if (commissionOverride !== undefined) {
      next = { ...next, tp_sales_rep_commission_override: commissionOverride };
    }
    return next;
  });
}, [
  marketplaceByTicketPlacementId,
  pricingMethodByTicketPlacementId,
  salesRepCommissionOverrideByTicketPlacementId,
  vlIdsByTicketPlacementId,
]);
const transformFallbackManageTicketsData = (data: any, targetUserId?: string): Ticket[] => {
  if (!data?.filtermanagetickets || !targetUserId) return [];
  return sortUserDetailTickets(
    data.filtermanagetickets.filter((ticket: any) => ticket.u_id === targetUserId).map((ticket: any): Ticket => {
      const listPriceValue = pickTicketValue(
        ticket.tp_list_price,
        ticket.t_list_price,
        ticket.list_price,
        ticket.listPrice,
        ticket.price,
        ticket.tp_price,
        ticket.t_price,
      );
      const soldAmount = pickTicketValue(
        ticket.tp_sold_amount,
        ticket.tp_sold_price,
        ticket.t_sold_amount,
        ticket.t_sold_price,
        ticket.sold_amount,
        ticket.soldAmount,
        ticket.sale_amount,
        ticket.settlement_amount,
      );

      const marketplaceFields = [
        'tp_marketplace_name',
        't_marketplace_name',
        'marketplace_name',
        'marketplace',
        'mp_name',
        'vl_marketplace_name',
      ];
      
      let { isValid: mpIsValid, value: marketplace, source: mpSource } = validateTicketMarketplaceData(ticket, marketplaceFields);
      
      const tpId = ticket.tp_id;
      if (!mpIsValid && !marketplace && targetUserId) {
        const cachedMarketplace = restoreMarketplaceFromCache(targetUserId, tpId);
        if (cachedMarketplace) {
          marketplace = cachedMarketplace;
          mpIsValid = true;
          console.log(`✅ RESTORED marketplace from cache for ${tpId}: ${cachedMarketplace}`);
        }
      }
      
      if (ticket.tp_status?.toLowerCase() === 'sold' && !mpIsValid) {
        console.warn('⚠️ SOLD ticket missing marketplace:', {
          tpId: tpId,
          status: ticket.tp_status,
          availableFields: marketplaceFields.map(f => ({ field: f, value: ticket[f] }))
        });
      }

      const rawStatusValue = ticket.tp_status || ticket.t_status || ticket.status || 'Unknown';
      const statusLabel = getStatusLabel(ticket.tp_status || ticket.t_status || ticket.status || '') || rawStatusValue;

      // Prefer e_date + e_time_zone (venue-local), same as ManageTickets.
      const eventTimeZone = ticket.e_time_zone || ticket.event?.e_time_zone || null;
      const eventDateTimeZone = ticket.e_date_time_zone || ticket.event?.e_date_time_zone || null;
      const eventWallTime = ticket.e_time || ticket.event?.e_time || null;
      const eventDateRawValue =
        ticket.e_date ||
        ticket.t_event_date ||
        ticket.e_date_time_zone ||
        ticket.date ||
        '';
      const eventTime = formatTime(eventDateRawValue, eventTimeZone, eventDateTimeZone, eventWallTime);
      const venue = ticket.e_address || '';
      const league = ticket.l_name || '';
      const email = ticket.u_email_id || ticket.u_original_email || '';

      const ticketRow: Ticket = {
        id: ticket.t_id, 
        tpId: ticket.tp_id || ticket.t_id, 
        lc_id: ticket.lc_id || undefined,
        rawStatus: rawStatusValue,
        updatedAt: ticket.tp_updated_at || undefined,
        tp_updated_at: ticket.tp_updated_at || undefined,
        tp_delist_requested_email: ticket.tp_delist_requested_email ?? null,
        last_priced_at: ticket.last_priced_at ?? undefined,
        event: ticket.e_name || 'Unknown Event',
        seatMode: ticket.tp_seat_mode ?? null,
        eventId: ticket.e_id || ticket.event?.e_id || undefined,
        eventDateRaw: eventDateRawValue || undefined,
        eventTime: eventTime,
        eventTimeZone: eventTimeZone || null,
        date: eventDateRawValue ? formatDate(eventDateRawValue, eventTimeZone, eventDateTimeZone, eventWallTime) : 'TBD',
        section: ticket.tp_section || '-', 
        row: ticket.tp_row || '-',         seatNo: ticket.tp_seat_no != null && String(ticket.tp_seat_no).trim() !== '' ? String(ticket.tp_seat_no) : '-',
        status: statusLabel,
        paymentStatus: ticket.tp_payment_status ?? null,
        payoutStatus: ticket.tp_payout_status ?? null,
        price: formatListPrice(listPriceValue),
        tp_pricing_method: normalizePricingMethod(ticket.tp_pricing_method),
        soldPrice: formatOptionalCurrency(soldAmount),
        marketplace: marketplace,
        qaProfit: Math.max(0, Number(ticket.tp_quick_cut_amount) || 0),
        venue,
        league,
        email,
        confirmedVlProductionId: String(ticket.tp_vl_production_id || '').trim() || null,
        barcode: String(ticket.tp_barcode || ticket.barcode || ticket.vl_barcode || '').trim() || null,
        barcodeStatus: ticket.tp_barcode_status as BarcodeStatusValue | undefined,
        barcodeAttached:
        ticket.tp_barcode_attached === true ||
        Boolean(String(ticket.tp_barcode || ticket.barcode || ticket.vl_barcode || '').trim()),
        on_hold: ticket.on_hold === true,
        tp_vl_share: ticket.tp_vl_share === true,
        tp_sales_rep_commission_override: ticket.tp_sales_rep_commission_override ?? null,
      };
      const pres = getTicketStatusPresentation(ticketRow);
      return { ...ticketRow, status: pres.label };
    }),
  );
};
  
  const transformNotesData = (data: any[]): Note[] => {
    if (!data) return [];
    return data.map((note: any) => ({
      id: note.n_id, type: note.n_type, content: note.n_content,
      createdAt: note.n_created_at, createdBy: note.n_created_by, updatedAt: note.n_updated_at
    }));
  };
  
  // Handlers
  const handleUserClick = () => navigate(`/users`);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const handleRefresh = async () => {
    if (isRefreshing) return;
    setIsRefreshing(true);
    try {
      await apolloClient.refetchQueries({
        include: [
          GET_USER_PROFILE,
          GET_USER_BY_ID,
          GET_SUPER_USER_BY_USER_ID,
          GET_USERS_LIST,
          GET_USER_TICKETS,
          GET_USER_TICKET_MARKETPLACES,
          GET_MANAGE_TICKETS,
          GET_USER_ANALYTICS,
          GET_USER_PREFERENCE_TEAMS,
          GET_AVAILABLE_TEAMS_FOR_USER,
          GET_ALL_LEAGUES,
          GET_USER_TEAMS_WITH_SOLD_STATUS,
          GET_LEAGUE_CATEGORIES_BY_IDS,
          GET_USER_SAVED_SEAT_INFO,
          GET_USER_NOTES,
          GET_USER_VICTORY_LIVE_SEAT_NOTES,
          GET_USER_EMAIL_STATUS,
          GET_MARKETPLACES_FOR_TICKETS,
        ],
      });
    } catch (err: any) {
      showError(err?.message || 'Failed to refresh user details');
    } finally {
      setIsRefreshing(false);
    }
  };
  const handleSearch = (query: string) => setSearchQuery(query);
  
  const handleEditClick = () => {
    if (effectiveUserRecord) {
      setEditFormData(transformUserData(effectiveUserRecord, superUserData?.super_user?.[0]?.percentage));
      setIsEditing(true);
    }
  };
  const handleCancelEdit = () => { setIsEditing(false); setEditFormData(null); };

  const isDuplicateEmailUpdateError = (error: any): boolean => {
    const graphQlMessage = error?.graphQLErrors?.[0]?.message || '';
    const message = (error?.message || graphQlMessage || '').toLowerCase();
    return (
      message.includes('user_u_email_id_key') ||
      message.includes('duplicate key value violates unique constraint') ||
      message.includes('duplicate key') ||
      message.includes('already exists') ||
      message.includes('already belongs') ||
      message.includes('already in use')
    );
  };

  const updateUserEmail = async (email: string) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');

    const response = await fetch(`${nodeApiBaseUrl}/api/updateUserEmail`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ input: { userId, email } }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(responseData?.message || responseData?.error || 'Failed to synchronize user email');
    }
    return responseData;
  };

  const callDeactivateSuperUserApi = async (emailId: string) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/deactivateSuperUser`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: { deactivateSuperUserInput: { emailId } },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(responseData?.message || 'Failed to deactivate super user');
    }
    return responseData;
  };
  

  
  const handleSaveEdit = async () => {
    if (!editFormData || !userId || updateLoading || emailUpdateLoading) return;
    setEmailUpdateLoading(true);
    try {
      if (!canEditPricing) {
        const currentPricingMode = String(effectiveUserRecord?.u_pricing_mode || '').trim().toLowerCase();
        const originalType = currentPricingMode === 'self-pricing' ? 'Self Pricing' : 'Concierge';
        const originalPercentage = Number(effectiveUserRecord?.u_fee_percentage);
        const hasPricingTypeChanged = editFormData.type !== originalType;
        const hasPercentageChanged = Number.isFinite(originalPercentage)
          ? Number(editFormData.userFee) !== originalPercentage
          : Number(editFormData.userFee) !== (originalType === 'Self Pricing' ? 15 : 20);
        if (hasPricingTypeChanged || hasPercentageChanged) {
          showError('Only admin, sub-admin, or sales rep can update pricing mode or percentage.');
          return;
        }
      }
      const isSelfPricing = editFormData.type === 'Self Pricing';
      const feePercentage = Number(editFormData.userFee);
      if (!Number.isFinite(feePercentage) || feePercentage <= 0 || feePercentage > 100) {
        showError('Percentage must be greater than 0 and at most 100.');
        return;
      }
      const currentEmail = String(effectiveUserRecord?.u_email_id || '').trim().toLowerCase();
      const requestedEmail = String(editFormData.email || '').trim().toLowerCase();
      if (requestedEmail !== currentEmail) {
        await updateUserEmail(requestedEmail);
      }
      await updateUser({
        variables: {
          userId: userId,
          input: {
            u_phone_number: editFormData.phone || null,
            u_stripe_business_name: editFormData.business || null,
            u_pricing_mode: isSelfPricing ? 'self-pricing' : 'concierge',
            u_fee_percentage: feePercentage,
          }
        }
      });
      // Sync fee to active super_user row only (insert stays on Users tab toggle).
      const activeSuperUser = superUserData?.super_user?.[0];
      if (isSelfPricing && activeSuperUser?.su_id) {
        await updateSuperUserPercentage({
          variables: { su_id: activeSuperUser.su_id, percentage: feePercentage },
        });
      } else if (!isSelfPricing && activeSuperUser?.su_id) {
        const emailId = editFormData.email || effectiveUserRecord?.u_email_id;
        if (emailId) {
          await callDeactivateSuperUserApi(emailId);
        }
      }
      await Promise.all([refetchUser(), refetchSuperUser()]);
      setIsEditing(false);
      setEditFormData(null);
      showSuccess('User updated successfully!');
    } catch (error: any) {
      if (isDuplicateEmailUpdateError(error)) {
        showError('This email is already in use. Please use a different email address.');
        return;
      }
      const gqlMsgs = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: { message?: string }) => e.message).filter(Boolean) : [];
      const detail = gqlMsgs.length ? gqlMsgs.join(' ') : error?.message;
      showError(detail?.trim() || 'Failed to update user. Please try again.');
    } finally {
      setEmailUpdateLoading(false);
    }
  };
  
  const handleDeleteUser = async () => {
    if (!userId) return;
    try {
      await updateUser({ variables: { userId: userId, input: { u_delete_requested: true } } });
      showSuccess('User deleted successfully!');
      navigate('/users');
    } catch (error: any) {
      showError(`Error: ${error?.message || 'Failed to delete user'}`);
    }
  };

  const openTicketDeleteConfirm = (ticket: Ticket) => {
    setTicketPendingDelete(ticket);
    setShowTicketDeleteConfirm(true);
    setOpenActionTicketId(null);
  };

  const handleConfirmDeleteTicket = async () => {
    if (!ticketPendingDelete || ticketDeleteLoading) return;
    setTicketDeleteLoading(true);
    try {
      await deleteTicketStatus({
        variables: {
          tp_id: ticketPendingDelete.tpId
        }
      });
      showSuccess('Ticket deleted successfully');
      updateLocalTicket([ticketPendingDelete.tpId], { rawStatus: 'Deleted', status: 'Deleted' });
      setShowTicketDeleteConfirm(false);
      setTicketPendingDelete(null);
      setActiveFilterTab('Deleted');
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showError(error?.message || 'Failed to delete ticket');
    } finally {
      setTicketDeleteLoading(false);
    }
  };

  const handleConfirmDeleteSeatLevelNote = async () => {
    if (!seatLevelNotePendingDeleteId || seatLevelNoteDeleteLoading) return;
    setSeatLevelNoteDeleteLoading(true);
    try {
      await deleteSeatLevelNote({
        variables: { vlsn_id: seatLevelNotePendingDeleteId },
      });
      setSeatLevelNotes((previous) => previous.filter((note) => note.id !== seatLevelNotePendingDeleteId));
      setSeatLevelNotePendingDeleteId(null);
      await refetchSeatLevelNotes();
    } catch (error: any) {
      showError(error?.message || 'Unable to delete notes. Please try again.');
    } finally {
      setSeatLevelNoteDeleteLoading(false);
    }
  };
  
  const handleVoidPayouts = async () => {
    if (!userId) return;
    setIsVoidingPayouts(true);
    try {
      await voidUserPayouts({
        variables: {
          userId: userId,
          reason: voidReason || null,
          date: new Date().toISOString()
        }
      });
      if (addNoteOnVoid && voidPayoutNote && voidPayoutNote.trim()) {
        try {
          await addNote({ variables: { userId: userId, type: 'internal', content: `Void Payouts: ${voidReason || ''}\n\n${voidPayoutNote.trim()}` } });
          await refetchNotes();
        } catch (e) { console.error(e); }
      }
      await refetchUser();
      showSuccess('Payouts voided successfully');
      setShowVoidPayoutsModal(false);
      setVoidReason('');
      setVoidPayoutNote('');
      setAddNoteOnVoid(false);
    } catch (error) {
      showError('Failed to void payouts');
    } finally {
      setIsVoidingPayouts(false);
    }
  };
  
  const handleRestorePayouts = async () => {
    if (!userId) return;
    try {
      await restoreUserPayouts({ variables: { userId: userId } });
      await refetchUser();
      showSuccess('Payouts restored successfully');
    } catch (error) {
      showError('Failed to restore payouts');
    }
  };
  
  const handleToggleEmail = async () => {
    if (!userId) return;
    const currentEmailEnabled = (emailStatusData?.user?.[0]?.u_email_enabled) ?? (currentUser?.emailEnabled ?? true);
    try {
      await updateEmailStatus({ variables: { userId: userId, u_email_enabled: !currentEmailEnabled } });
      await refetchUser();
      showSuccess(`${!currentEmailEnabled ? 'Enabled' : 'Disabled'} emails successfully`);
    } catch (error) {
      showError('Failed to update email status');
    }
  };

  const handleAddNote = async (type: 'qa' | 'internal' | 'external') => {
    const content = newNoteContentByType[type]?.trim() || '';
    if (!userId || !content) {
      showError('Please enter note content');
      return;
    }
    try {
      const result = await addNote({ variables: { userId: userId, type, content } });
      const inserted = result?.data?.insert_user_notes_one;
      if (inserted) {
        setNotes((prev) => [{
          id: inserted.n_id,
          type: inserted.n_type,
          content: inserted.n_content,
          createdAt: inserted.n_created_at || new Date().toISOString(),
          createdBy: inserted.n_created_by || 'admin',
          updatedAt: inserted.n_updated_at || inserted.n_created_at || new Date().toISOString(),
        }, ...prev]);
      }
      await refetchNotes();
      setNewNoteContentByType((prev) => ({ ...prev, [type]: '' }));
      if (type === 'qa') setShowQANote(false);
      if (type === 'internal') setShowInternalNote(false);
      if (type === 'external') setShowExternalNote(false);
      showSuccess('Note added successfully');
    } catch (error: any) {
      const detail = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: any) => e.message).join(' ')
        : error?.message;
      showError(detail || 'Failed to add note');
    }
  };
  
  const handleUpdateNote = async () => {
    if (!editingNote || (editingNote.type === 'qa' && !editingNote.content.trim())) {
      showError('Please enter note content');
      return;
    }
    try {
      await updateNote({ variables: { noteId: editingNote.id, content: editingNote.content.trim(), updatedAt: new Date().toISOString() } });
      await refetchNotes();
      setEditingNote(null);
      showSuccess('Note updated successfully');
    } catch (error: any) {
      const detail = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: any) => e.message).join(' ')
        : error?.message;
      showError(detail || 'Failed to update note');
    }
  };
  
  const handleDeleteNote = async (note: Note) => {
   
      try {
        await deleteNote({ variables: { noteId: note.id } });
        setNotes((prev) => prev.filter((currentNote) => currentNote.id !== note.id));
        await refetchNotes();
        showSuccess('Note deleted successfully');
      } catch (error: any) {
        const detail = Array.isArray(error?.graphQLErrors)
          ? error.graphQLErrors.map((e: any) => e.message).join(' ')
          : error?.message;
        showError(detail || 'Failed to delete note');
      }
    
  };
  
  // Team Management Handlers
  const handleOpenAddTeamModal = () => {
    setShowAddTeamModal(true);
    setSelectedLeagueFilter('all');
    setTeamSearchQuery('');
    refetchUserPreferences().catch((error) => {
      console.error('Failed to refetch user preferences:', error);
    });
  };
  
  const handleAddTeam = async (teamId: string) => {
    if (!userId) {
      showError('User ID is required');
      return;
    }
    setAddingTeamId(teamId);
    try {
      await addUserTeam({ variables: { userId, teamId } });
      showSuccess('Team added successfully!');
      await Promise.all([
        refetchUser(),
        refetchUserPreferences(),
        refetchTeamsWithSoldStatus(),
      ]);
      setShowAddTeamModal(false);
    } catch (error: any) {
      const detail = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: any) => e.message).join(' ')
        : error?.message;
      showError(detail || 'Failed to add team');
    } finally {
      setAddingTeamId(null);
    }
  };
  
  const handleRemoveTeam = async (teamId: string) => {
    if (!userId) {
      showError('User ID is required');
      return;
    }
    
    if (teamsWithSoldStatus[teamId]) {
      showError('Cannot remove team with sold tickets');
      return;
    }
    
    setRemovingTeamId(teamId);
    try {
      await removeUserTeam({ variables: { userId, teamId } });
      showSuccess('Team removed successfully!');
      console.log('🗑️ Team deleted. Refetching user preferences immediately...');
      await refetchUserPreferences();
      await Promise.all([
        refetchUser(),
        refetchTeamsWithSoldStatus(),
      ]);
    } catch (error: any) {
      const detail = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: any) => e.message).join(' ')
        : error?.message;
      showError(detail || 'Failed to remove team');
    } finally {
      setRemovingTeamId(null);
    }
  };
  
  const handleAdminRemoveTeam = async (teamId: string) => {
    if (!userId) {
      showError('User ID is required');
      return;
    }
    
   const team = selectedTeams.find(t => t.id === teamId);
  if (team && hasSoldTicketsForTeam(teamId, team.name, team.abbreviation)) {
    showError('Cannot remove team with sold tickets. User has active sales for this team.');
    return;
  }
    setAdminRemovingTeamId(teamId);
    try {
      await adminRemoveUserTeam({ variables: { userId, teamId } });
      showSuccess('Team removed from user successfully!');
      console.log('🗑️ Team deleted. Refetching user preferences immediately...');
      await refetchUserPreferences();
      console.log('✅ User preferences refetched. UI should update now.');
      await Promise.all([
        refetchUser(),
        refetchTeamsWithSoldStatus(),
      ]);
    } catch (error: any) {
      const detail = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: any) => e.message).join(' ')
        : error?.message;
      showError(detail || 'Failed to remove team');
    } finally {
      setAdminRemovingTeamId(null);
    }
  };
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    if (!editFormData) return;
    setEditFormData(prev => {
      if (!prev) return prev;
      if (name === 'type') {
        const isSwitchingToSelfPricing = value === 'Self Pricing';
        const shouldResetToSelfPricingDefault = isSwitchingToSelfPricing && (!prev.userFee || Number(prev.userFee) === 20);
        return { ...prev, [name]: value, ...(shouldResetToSelfPricingDefault ? { userFee: '15' } : {}) };
      }
      return { ...prev, [name]: value };
    });
  };
  
  const matchesTicketSearchQuery = (ticket: Ticket, query: string) => {
    const token = query.trim().toLowerCase();
    if (!token) return true;
    const haystack = [
      ticket.event,
      ticket.date,
      ticket.section,
      ticket.row,
      ticket.seatNo,
      ticket.status,
      ticket.price,
      ticket.soldPrice,
    ]
      .filter((v) => v != null && String(v).trim() !== '' && String(v) !== '-')
      .join(' ')
      .toLowerCase();
    return haystack.includes(token);
  };

  const matchesFilterTab = (ticket: Ticket, tab: string, soldFilter: typeof soldSubFilter = 'all') => {
    // All tab must show every ticket — including 48h+ ToBeVerified (fail to transfer).
    // Fail-to-transfer rows are only excluded from the Verification tab.
    if (tab !== 'All' && isUserDetailFailToTransferTicket(ticket)) return false;

    const rawToken = normalizeStatusToken(ticket.rawStatus || ticket.status);
    if (tab === 'All') return true;
    if (tab === 'Verification') {
      return ['tobeverified', 'verified', 'verification', 'invalid'].includes(rawToken);
    }
    if (tab === 'Listed') return ['list', 'listed'].includes(rawToken);
    if (tab === 'Sold') {
      if (!isCompletedSaleTicket(ticket)) return false;
      if (soldFilter === 'all') return true;
      return getSoldPresentationFilterKey(ticket) === soldFilter;
    }
    if (tab === 'Delisted') {
      return ['delist', 'delisted', 'delistinprogress', 'delistrequested', 'return'].includes(rawToken);
    }
    if (tab === 'Deleted') {
      return rawToken === 'deleted';
    }
    if (tab === 'Listing Request Cancelled') {
      return rawToken === 'listingrequestcancelled';
    }
    if (tab === 'Unsold') return rawToken === 'unsold';
    if (tab === 'Expired') return rawToken === 'closed' || rawToken === 'listingrequestexpired';
    return true;
  };

  const getFilteredTickets = () => {
    const lastPricedRange = getLastPricedRange(lastPricedFrom, lastPricedTo);
    const filtered = filterTicketsByDate(
        localTickets.filter(
          (ticket) =>
            matchesFilterTab(ticket, activeFilterTab, soldSubFilter) &&
            matchesUserStatusDropdown(ticket, activeFilterTab, filterStatus) &&
            matchesTicketSearchQuery(ticket, isGetUserTicketsAllowlistError ? searchQuery : debouncedTicketSearch) &&
            matchesBarcodeFilter(ticket, activeFilterTab, barcodeFilter) &&
(activeFilterTab !== 'Listed' || matchesPidStatusFilter(pidStatusFilter, ticket.confirmedVlProductionId)) &&
(activeFilterTab !== 'Listed' || pricingMethodMatches(ticket.tp_pricing_method ?? null, pricingMethodFilter)) &&
            (activeFilterTab !== 'Listed' || matchesLastPricedRange(ticket as any, lastPricedRange)) &&
(activeFilterTab !== 'Listed' || matchesLastPricedRange(ticket as any, lastPricedCustomRange)) &&
(activeFilterTab !== 'Listed' || lastPricedFilter.length === 0 || matchesLastPricedBucketFilter(ticket as any, lastPricedFilter)) &&
            (activeFilterTab !== 'Listed' || vlShareFilter === 'all' || (vlShareFilter === 'shared' ? ticket.tp_vl_share === true : ticket.tp_vl_share === false)) &&
            (activeFilterTab !== 'Listed' || !onHoldFilter || ticket.on_hold === true) &&
            (activeFilterTab !== 'Sold' || userMatchesStripeFilter(stripeAccountFilter)),
        ),
      );
    if (activeFilterTab === 'Delisted') {
      return sortUserDetailsDelistedTickets(filtered, sortUserDetailTickets, (ticket) => ticket.rawStatus || ticket.status);
    }
    return sortUserDetailTickets(filtered);
  };

  const refreshLastPricedTicketsAfterPriceChange = () => {
    const filterActive =
      lastPricedFilter.length > 0 ||
      Boolean(lastPricedFrom || lastPricedTo) ||
      Boolean(lastPricedCustomRange);
    if (!filterActive) return;
    if (lastPricedCustomRange) {
      const value = Number(lastPricedCustomValue);
      const range = getLastPricedCustomRange(value, lastPricedCustomUnit, Date.now(), lastPricedCustomWindow);
      if (range) setLastPricedCustomRange(range);
    }
    setLastPricedQueryNow(Date.now());
  };

  const applyLastPricedCustomFilter = () => {
    const value = Number(lastPricedCustomValue);
    if (!lastPricedCustomValue.trim() || !Number.isFinite(value) || value <= 0) {
      setLastPricedCustomError('Enter a positive number.');
      return;
    }

    const range = getLastPricedCustomRange(value, lastPricedCustomUnit, Date.now(), lastPricedCustomWindow);
    if (!range) {
      setLastPricedCustomError('Enter a valid positive number.');
      return;
    }

    setLastPricedCustomRange(range);
    setLastPricedCustomError('');
    setShowLastPricedFilterDropdown(false);
  };

  const clearLastPricedFilters = () => {
    setLastPricedFilter([]);
    setLastPricedFrom('');
    setLastPricedTo('');
    setLastPricedCustomValue('');
    setLastPricedCustomUnit('Hours');
    setLastPricedCustomWindow('within');
    setLastPricedCustomRange(null);
    setLastPricedCustomError('');
    setShowLastPricedFilterDropdown(false);
  };

  const ticketFilterTabs = USER_DETAILS_TICKET_FILTER_TABS;

  useEffect(() => {
    if (userId) {
      localStorage.setItem(`userdetails-ticket-filter-tab-${userId}`, activeFilterTab);
    }
  }, [activeFilterTab, userId]);

  useEffect(() => {
    if (previousTicketTabRef.current === null) {
      previousTicketTabRef.current = activeFilterTab;
      return;
    }
    if (previousTicketTabRef.current === activeFilterTab) return;
    previousTicketTabRef.current = activeFilterTab;
    setTabSwitchLoading(true);
    setLocalTickets([]);
  }, [activeFilterTab]);

  useEffect(() => {
    if (tabSwitchLoading && ticketsError) setTabSwitchLoading(false);
  }, [tabSwitchLoading, ticketsError]);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebouncedTicketSearch(searchQuery.trim()), 400);
    return () => window.clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    setTicketPageOffset(0);
    setTicketGroupsPerFullWindow(null);
    setTicketLoadedSeatWindowIndex(0);
  }, [
    activeFilterTab,
    debouncedTicketSearch,
    soldSubFilter,
    barcodeFilter,
    pidStatusFilter,
    vlShareFilter,
    pricingMethodFilter,
    lastPricedFilter,
    lastPricedFrom,
    lastPricedTo,
    lastPricedCustomRange,
    onHoldFilter,
    stripeAccountFilter,
    dateFilter,
    customFromDate,
    customToDate,
    ticketTableSort,
  ]);

  const previousTicketPageSizeRef = useRef(ticketPageSize);
  useEffect(() => {
    const previousPageSize = previousTicketPageSizeRef.current;
    if (previousPageSize === ticketPageSize) return;
    previousTicketPageSizeRef.current = ticketPageSize;
    setTicketPageOffset(0);
    // 10, 20, 50, and 100 all request the same 400-seat window. Clearing the
    // measured group count leaves every later page sliced from row 0.
    if (getGroupedPageSeatFetchSize(previousPageSize) !== getGroupedPageSeatFetchSize(ticketPageSize)) {
      setTicketGroupsPerFullWindow(null);
      setTicketLoadedSeatWindowIndex(0);
    }
  }, [ticketPageSize]);

  useEffect(() => {
    setBulkSelectedTicketIds(new Set());
    setBulkSelectedTickets([]);
  }, [activeFilterTab, searchQuery, barcodeFilter, pidStatusFilter, vlShareFilter, pricingMethodFilter, lastPricedFilter, lastPricedFrom, lastPricedTo, lastPricedCustomRange, onHoldFilter, stripeAccountFilter, filterStatus, ticketPageOffset, ticketPageSize]);

  useEffect(() => {
    setFilterStatus(defaultStatusForUserTab(activeFilterTab));
    setShowFilterDropdown(false);
    setShowBarcodeFilterDropdown(false);
    setShowStripeAccountFilterDropdown(false);
    setShowPidStatusFilterDropdown(false);
    setShowVlShareFilterDropdown(false);
    setShowPricingMethodFilterDropdown(false);
    setShowLastPricedFilterDropdown(false);
    if (activeFilterTab !== 'Sold') {
      setSoldSubFilter('all');
      setStripeAccountFilter('all');
    }
    if (activeFilterTab !== 'Listed' && activeFilterTab !== 'Sold') {
      setBarcodeFilter('all');
    }
    if (activeFilterTab !== 'Listed') {
      setOnHoldFilter(false);
      setPidStatusFilter('all');
      setVlShareFilter('all');
      setShowVlShareFilterDropdown(false);
      setPricingMethodFilter('all');
    }
  }, [activeFilterTab]);

  useEffect(() => {
    if (activeFilterTab !== 'Sold') return;
    setSoldSubFilter(soldSubFilterFromStatus(filterStatus));
  }, [activeFilterTab, filterStatus]);

  const getFilteredTeams = () => {
    if (!teamSearchQuery.trim()) return selectedTeams;
    const token = teamSearchQuery.toLowerCase();
    return selectedTeams.filter(
      (team) =>
        team.name.toLowerCase().includes(token) ||
        team.abbreviation.toLowerCase().includes(token)
    );
  };
  


  
  const serverTicketCount = (field: string): number | null => {
    const count = ticketsData?.[field]?.aggregate?.count;
    return typeof count === 'number' ? count : null;
  };

  const getTabCount = (tab: string, soldFilter: typeof soldSubFilter = 'all') => {
    const serverField: Record<string, string> = {
      All: 'tab_all',
      Verification: 'tab_verification',
      Listed: 'tab_listed',
      Sold: 'tab_sold',
      Delisted: 'tab_delisted',
      Deleted: 'tab_deleted',
      'Listing Request Cancelled': 'tab_cancelled',
      Unsold: 'tab_unsold',
      Expired: 'tab_expired',
    };
    if (!isGetUserTicketsAllowlistError && soldFilter === 'all') {
      const count = serverTicketCount(serverField[tab] || '');
      if (count != null) return count;
    }
    return localTickets.filter(
      (ticket) =>
        matchesFilterTab(ticket, tab, soldFilter) && matchesTicketSearchQuery(ticket, searchQuery),
    ).length;
  };

  const listedOnHoldCount = (() => {
    const count = !isGetUserTicketsAllowlistError ? serverTicketCount('listed_on_hold') : null;
    if (count != null) return count;
    return localTickets.filter(
      (ticket) => matchesFilterTab(ticket, 'Listed') && ticket.on_hold === true,
    ).length;
  })();

  const getSoldSubFilterCounts = () => {
    if (!isGetUserTicketsAllowlistError) {
      const all = serverTicketCount('sold_facet_all');
      const sold = serverTicketCount('sold_facet_open');
      const settled = serverTicketCount('sold_facet_settled');
      const settlementinprogress = serverTicketCount('sold_facet_progress');
      const failed = serverTicketCount('sold_facet_failed');
      const voidedpayout = serverTicketCount('sold_facet_voided');
      const paidmanuallyviaqa = serverTicketCount('sold_facet_manual');
      const qadeniedpayout = serverTicketCount('sold_facet_denied');
      const underreview = serverTicketCount('sold_facet_review');
      if ([all, sold, settled, settlementinprogress, failed, voidedpayout, paidmanuallyviaqa, qadeniedpayout, underreview].every((count) => count != null)) {
        return {
          all: all as number,
          sold: sold as number,
          settled: settled as number,
          settlementinprogress: settlementinprogress as number,
          failed: failed as number,
          voidedpayout: voidedpayout as number,
          paidmanuallyviaqa: paidmanuallyviaqa as number,
          qadeniedpayout: qadeniedpayout as number,
          underreview: underreview as number,
        };
      }
    }
    const soldTickets = localTickets.filter(
      (t) => matchesFilterTab(t, 'Sold', 'all') && matchesTicketSearchQuery(t, searchQuery),
    );
    return {
      all: soldTickets.length,
      sold: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'sold').length,
      settled: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'settled').length,
      settlementinprogress: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'settlementinprogress').length,
      failed: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'failed').length,
      voidedpayout: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'voidedpayout').length,
      paidmanuallyviaqa: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'paidmanuallyviaqa').length,
      qadeniedpayout: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'qadeniedpayout').length,
      underreview: soldTickets.filter((t) => getSoldPresentationFilterKey(t) === 'underreview').length,
    };
  };

  const getUserStatusFilterOptions = () => {
    const soldCounts = activeFilterTab === 'Sold' ? getSoldSubFilterCounts() : null;
    const soldCountByValue: Record<string, number> = soldCounts
      ? {
          'All Sold': soldCounts.all,
          Sold: soldCounts.sold,
          Settled: soldCounts.settled,
          SettlementInProgress: soldCounts.settlementinprogress,
          Failed: soldCounts.failed,
          Voided_Payout: soldCounts.voidedpayout,
          PaidManuallyViaQA: soldCounts.paidmanuallyviaqa,
          QADeniedPayout: soldCounts.qadeniedpayout,
          UnderReview: soldCounts.underreview,
        }
      : {};
    const options: Array<{ value: string; label: string }> = (() => {
      switch (activeFilterTab) {
        case 'Verification':
          return [
            { value: 'All Verification', label: 'All Verification' },
            { value: 'ToBeVerified', label: 'To Be Verified' },
            { value: 'Verified', label: 'Verified' },
          ];
        case 'Listed':
          return [
            { value: 'All Listed', label: 'All Listed' },
            { value: 'List', label: 'Listed' },
          ];
        case 'Sold':
          return [
            { value: 'All Sold', label: 'All Sold' },
            { value: 'Sold', label: 'Sold' },
            { value: 'Settled', label: 'Settled' },
            { value: 'SettlementInProgress', label: 'Settlement In Progress' },
            { value: 'Failed', label: 'Failed' },
            { value: 'Voided_Payout', label: 'Voided Payout' },
            { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
            { value: 'QADeniedPayout', label: 'QA Denied Payout' },
            { value: 'UnderReview', label: 'Under Review' },
          ];
        case 'Delisted':
          return [
            { value: 'All Delisted', label: 'All Delisted' },
            { value: 'DelistInProgress', label: 'Delist In Progress' },
            { value: 'Delist', label: 'Delist' },
            { value: 'Return', label: 'Return' },
          ];
        case 'Listing Request Cancelled':
          return [
            { value: 'All Listing Request Cancelled', label: 'All Listing Request Cancelled' },
            { value: 'ListingRequestCancelled', label: 'Listing Request Cancelled' },
          ];
        case 'Expired':
          return [
            { value: 'All Expired', label: 'All Expired' },
            { value: 'Closed', label: 'Expired' },
          ];
        case 'Unsold':
          return [
            { value: 'All Unsold', label: 'All Unsold' },
            { value: 'Unsold', label: 'Unsold' },
          ];
        case 'Deleted':
          return [
            { value: 'All Deleted', label: 'All Deleted' },
            { value: 'Deleted', label: 'Deleted' },
          ];
        default:
          return [
            { value: 'All', label: 'All' },
            { value: 'ToBeVerified', label: 'To Be Verified' },
            { value: 'Verified', label: 'Verified' },
            { value: 'List', label: 'Listed' },
            { value: 'Sold', label: 'Sold' },
            { value: 'Settled', label: 'Settled' },
            { value: 'SettlementInProgress', label: 'Settlement In Progress' },
            { value: 'Failed', label: 'Failed' },
            { value: 'Voided_Payout', label: 'Voided Payout' },
            { value: 'PaidManuallyViaQA', label: 'Paid Manually via QA' },
            { value: 'QADeniedPayout', label: 'QA Denied Payout' },
            { value: 'UnderReview', label: 'Under Review' },
            { value: 'DelistInProgress', label: 'Delist In Progress' },
            { value: 'Delist', label: 'Delist' },
            { value: 'Return', label: 'Return' },
            { value: 'Deleted', label: 'Deleted' },
            { value: 'ListingRequestCancelled', label: 'Listing Request Cancelled' },
            { value: 'Unsold', label: 'Unsold' },
            { value: 'Closed', label: 'Expired' },
          ];
      }
    })();
    return options.map((option) => {
      const count = soldCountByValue[option.value] ?? (
        option.value === 'All' || option.value.startsWith('All ')
          ? getTabCount(activeFilterTab)
          : null
      );
      return {
        ...option,
        label: count == null ? option.label : `${option.label} (${count})`,
      };
    });
  };

  const ticketHasBarcodeAttached = (ticket: Ticket) =>
    ticket.barcodeAttached === true || Boolean(String(ticket.barcode || '').trim());

  const matchesBarcodeFilter = (
    ticket: Ticket,
    tab: string,
    filter: typeof barcodeFilter,
  ) => {
    if ((tab !== 'Listed' && tab !== 'Sold') || filter === 'all') return true;
    const status = getUserTicketBarcodeStatus(ticket);
    if (filter === 'attached') return status === 'Barcode Available';
    if (filter === 'none') return status === 'Null';
    return status === 'Barcode Pending' && !ticketHasBarcodeAttached(ticket);
  };

  const isListedStatus = (status: string) => {
    const s = status.toLowerCase();
    return s === 'listed' || s === 'list';
  };

  const getTicketStatusToken = (ticket: Ticket): string =>
    normalizeStatusToken(ticket.rawStatus || ticket.status || '');

  const isCompletedSaleTicket = (ticket: Ticket) => {
    const token = getTicketStatusToken(ticket);
    return (
      token === 'sold' ||
      token === 'settled' ||
      token === 'settlementinprogress' ||
      token === 'underreview' ||
      token === 'paidmanuallyviaqa' ||
      token === 'qadeniedpayout'
    );
  };

  const isSoldStatus = (ticket: Ticket) => isCompletedSaleTicket(ticket);

  const getTicketTransitionStatus = (ticket: Ticket): string => {
    const baseStatus = mapStatusForMutation(ticket.rawStatus || ticket.status);
    if (baseStatus === 'Sold' && String(ticket.payoutStatus || '').trim() === 'Voided_Payout') {
      return 'Voided_Payout';
    }
    if (baseStatus !== 'Sold') return baseStatus;
    const presentationKey = getTicketStatusPresentation(ticket).iconStatus.toLowerCase();
    if (presentationKey === 'settled') return 'Settled';
    if (presentationKey === 'settlementinprogress') return 'SettlementInProgress';
    return 'Sold';
  };

  const getPaymentStatusForSettlementOverride = (status: string): string | null | undefined => {
    const normalized = mapStatusForMutation(status);
    if (normalized === 'SettlementInProgress') return 'Inprogress';
    if (normalized === 'Settled') return 'Success';
    if (normalized === 'Sold') return null;
    return undefined;
  };
  
  const updateLocalTicket = (tpIds: string[], updates: Partial<Ticket>) => {
    const touchedAt = new Date().toISOString();
    if (updates.rawStatus) {
      tpIds.forEach((tpId) => {
        localStatusOverridesRef.current[tpId] = updates.rawStatus as string;
      });
    }
    setLocalTickets((prev) =>
      sortUserDetailTickets(
        prev.map((t) =>
          tpIds.includes(t.tpId)
            ? { ...t, ...updates, updatedAt: updates.updatedAt ?? touchedAt }
            : t,
        ),
      ),
    );
  };

  const getDefaultDelistEmail = (): string =>
    (effectiveUserRecord?.u_email_id || editFormData?.email || '').trim();

  const openDelistEmailModal = (tpIds: string[]) => {
    const defaultEmail = getDefaultDelistEmail();
    setPendingDelistTpIds(tpIds);
    setDelistEmail(defaultEmail);
    setDelistConfirmEmail(defaultEmail);
    setShowDelistEmailModal(true);
  };

 const normalizeStatusValue = (status: string): string => mapStatusForMutation(status);
  const getTicketListPrice = (ticket: Ticket) => parseCurrency(ticket.price);

  const getTicketSoldPrice = (ticket: Ticket) => parseCurrency(ticket.soldPrice);

  const getTicketDisplayPrice = (ticket: Ticket): number | null => {
    const soldPrice = getTicketSoldPrice(ticket);
    if (soldPrice > 0) return soldPrice;
    const listPrice = getTicketListPrice(ticket);
    if (listPrice > 0) return listPrice;
    return null;
  };

  const canBulkUpdateTickets = (ticketIds: string[]): { allowed: boolean; reason?: string } => {
    if (ticketIds.length === 0) return { allowed: false, reason: 'No tickets selected' };
    const selected = getFilteredTickets().filter((t) => ticketIds.includes(t.tpId));
    const groupKey = (ticket: Ticket) =>
      `${ticket.eventId || ticket.event}|${(ticket.section || '').toLowerCase().trim()}|${(ticket.row || '').toLowerCase().trim()}`;
    const groups = new Map<string, Ticket[]>();
    for (const ticket of selected) {
      const key = groupKey(ticket);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key)!.push(ticket);
    }
    if (groups.size > 1) {
      return {
        allowed: false,
        reason: `Tickets must be from the same event, section, and row. Found ${groups.size} different groups.`,
      };
    }
    return { allowed: true };
  };

const getBulkStatusTransitions = (tickets: Ticket[]): { value: string; label: string }[] => {
  if (!tickets.length) return [];
  const allTransitions = new Map<string, { value: string; label: string }>();
  for (const ticket of tickets) {
    const transitions = getStatusTransitions(getTicketTransitionStatus(ticket));
    for (const trans of transitions) {
      if (!allTransitions.has(trans.value)) allTransitions.set(trans.value, trans);
    }
  }
  const result: { value: string; label: string }[] = [];
  for (const [value, trans] of allTransitions) {
    const isCommon = tickets.every((ticket) => {
      const ticketTransitions = getStatusTransitions(getTicketTransitionStatus(ticket));
      return ticketTransitions.some((t) => t.value === value);
    });
    if (isCommon) result.push(trans);
  }
  return result;
};

  const getDefaultBulkStatusListingPrices = (tickets: Ticket[]): Record<string, string> =>
    Object.fromEntries(tickets.map((t) => [t.tpId, getTicketListPrice(t) > 0 ? String(getTicketListPrice(t)) : '']));

  const areAllBulkStatusListingPricesValid = (tickets: Ticket[], prices: Record<string, string>): boolean =>
    tickets.every((ticket) => {
      const value = String(prices[ticket.tpId] || '').trim();
      const num = parseFloat(value);
      return !!value && !isNaN(num) && num > 0;
    });

  const resetBulkSoldState = () => {
    setBulkSoldMarketplaceId('');
    setBulkSoldLogitixAmounts({});
    setBulkSoldCommonLogitixAmount('');
    setBulkSoldFeeConfigReady(false);
    setBulkSoldFeeConfigByTicketId({});
    setBulkSoldLoading(false);
  };

  const closeBulkStatusModal = () => {
    setShowBulkStatusModal(false);
    setBulkNewStatus('');
    setBulkStatusListingPrices({});
    setBulkStatusListingCommonPrice('');
    resetBulkSoldState();
  };

  const resolveSoldFeeConfigForUser = async (): Promise<SoldFeeConfig> => {
    const pricingMode = effectiveUserRecord?.u_pricing_mode;
    const profileFee = Number(effectiveUserRecord?.u_fee_percentage ?? currentUser?.userFee);
    const isSelfPricing =
      pricingMode === 'self-pricing' ||
      (pricingMode !== 'concierge' && currentUser?.type === 'Self Pricing');

    if (isSelfPricing && userId) {
      const fallbackFee = async () => {
        if (Number.isFinite(profileFee) && profileFee > 0) return profileFee;
        try {
          const fees = await fetchUserFeePercentages([userId]);
          const fetched = fees[userId];
          if (Number.isFinite(fetched) && fetched > 0) return fetched;
        } catch (feeErr) {
          console.error('Failed to fetch user fee percent for sold:', feeErr);
        }
        return 15;
      };
      try {
        const { data } = await getSuperUserForSold({ variables: { userId } });
        const superUserPercent = Number(data?.super_user?.[0]?.percentage);
        const percent = Number.isFinite(superUserPercent) && superUserPercent > 0
          ? superUserPercent
          : await fallbackFee();
        return { feeMode: 'super', superClientPercent: percent };
      } catch (err) {
        console.error('Failed to fetch super user percent for sold:', err);
        return { feeMode: 'super', superClientPercent: await fallbackFee() };
      }
    }

    if (Number.isFinite(profileFee) && profileFee > 0) {
      return { feeMode: 'super', superClientPercent: profileFee };
    }

    if (userId) {
      try {
        const fees = await fetchUserFeePercentages([userId]);
        const conciergePercent = fees[userId];
        if (Number.isFinite(conciergePercent) && conciergePercent > 0) {
          return { feeMode: 'super', superClientPercent: conciergePercent };
        }
      } catch (err) {
        console.error('Failed to fetch user fee percent for sold:', err);
      }
    }

    return DEFAULT_SOLD_FEE_CONFIG;
  };

  const initBulkSoldFeeConfig = async (tickets: Ticket[]) => {
    try {
      await refetchMarketplaces();
    } catch {
      /* use cached marketplaces */
    }
    setBulkSoldLogitixAmounts(Object.fromEntries(tickets.map((t) => [t.tpId, ''])));
    setBulkSoldCommonLogitixAmount('');
    setBulkSoldFeeConfigReady(false);
    const feeConfig = await resolveSoldFeeConfigForUser();
    setBulkSoldFeeConfigByTicketId(Object.fromEntries(tickets.map((t) => [t.tpId, feeConfig])));
    setBulkSoldFeeConfigReady(true);
  };

  const getBulkTicketSoldFeeConfig = (ticketId: string): SoldFeeConfig =>
    bulkSoldFeeConfigByTicketId[ticketId] ?? DEFAULT_SOLD_FEE_CONFIG;

  const isBulkSoldTransitionReady = (
    tickets: Ticket[],
    logitixAmounts: Record<string, string>,
    marketplaceId: string,
    feeConfigReady: boolean,
  ): boolean => {
    if (!feeConfigReady || !marketplaceId) return false;
    const mp = marketplacesList.find((m) => m.id === marketplaceId);
    if (!mp) return false;
    return tickets.every((ticket) => {
      const listPrice = getTicketListPrice(ticket);
      const rawValue = logitixAmounts[ticket.tpId];
      const value = String(rawValue ?? '').trim();
      const logitixValue = value
        ? Number(parseFloat(value))
        : Math.round(listPrice * (100 - mp.vl_fee_percentage)) / 100;
      if (!Number.isFinite(logitixValue) || logitixValue <= 0) return false;
      const feeConfig = getBulkTicketSoldFeeConfig(ticket.tpId);
      const quickPct = effectiveSoldQuickCutPercent(mp.vl_fee_percentage, feeConfig.feeMode, feeConfig.superClientPercent);
      const quickCutDollars = Number(roundToFixed(listPrice * (quickPct / 100), 2));
      const settlement = Math.round((logitixValue - quickCutDollars) * 100) / 100;
      return settlement > 0;
    });
  };

  const handleApplyBulkStatusListingPrice = () => {
    const value = String(bulkStatusListingCommonPrice).trim();
    const priceNum = parseFloat(value);
    if (!value || isNaN(priceNum) || priceNum <= 0) {
      showError('Enter a valid price to apply to all tickets');
      return;
    }
    const normalized = String(roundToFixed(priceNum, 2));
    setBulkStatusListingPrices(
      Object.fromEntries(bulkSelectedTickets.map((ticket) => [ticket.tpId, normalized])),
    );
    setBulkStatusListingCommonPrice(normalized);
  };

  /** Prefer "Apply same list price" common field when set; else per-seat modal prices / existing list price. */
  const resolveBulkListingPriceByTpId = (tickets: Ticket[]): Record<string, string> => {
    const commonRaw = String(bulkStatusListingCommonPrice || '').trim();
    const commonNum = parseFloat(commonRaw);
    if (commonRaw && !isNaN(commonNum) && commonNum > 0) {
      const normalized = String(roundToFixed(commonNum, 2));
      return Object.fromEntries(tickets.map((ticket) => [ticket.tpId, normalized]));
    }
    return {
      ...getDefaultBulkStatusListingPrices(tickets),
      ...Object.fromEntries(
        Object.entries(bulkStatusListingPrices).filter(([, value]) => String(value || '').trim()),
      ),
    };
  };

  const handleApplyBulkSoldAmount = () => {
    const value = String(bulkSoldCommonLogitixAmount).trim();
    const num = parseFloat(value);
    if (!value || isNaN(num) || num <= 0) {
      showError('Enter a valid marketplace amount to apply to all tickets');
      return;
    }
    setBulkSoldLogitixAmounts(
      Object.fromEntries(bulkSelectedTickets.map((ticket) => [ticket.tpId, String(num)])),
    );
  };

  const handleBulkNewStatusSelect = (statusValue: string) => {
    const normalized = normalizeStatusValue(statusValue);
    // Verified → Listed must go through Victory Live (Submit to VL / List on Marketplaces), same as Manage Tickets.
    // Listed (Non-VL) stays in this modal so admin can set listing price.
    if (normalized === 'List') {
      const allVerified = bulkSelectedTickets.every(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Verified',
      );
      if (allVerified && bulkSelectedTickets.length > 0) {
        const tpIds = bulkSelectedTickets.map((ticket) => ticket.tpId);
        closeBulkStatusModal();
        void handleVlProgressAction(tpIds);
        return;
      }
    }
    setBulkNewStatus(statusValue);
    if (normalized === 'List' || normalized === 'List_NonVL') {
      const priceMap = getDefaultBulkStatusListingPrices(bulkSelectedTickets);
      setBulkStatusListingPrices(priceMap);
      const uniquePrices = [
        ...new Set(Object.values(priceMap).filter((v) => String(v).trim() !== '')),
      ];
      setBulkStatusListingCommonPrice(uniquePrices.length === 1 ? uniquePrices[0] : '');
      resetBulkSoldState();
    } else if (normalized === 'Sold') {
      setBulkStatusListingPrices({});
      setBulkStatusListingCommonPrice('');
      setBulkSoldMarketplaceId('');
      setBulkSoldLogitixAmounts({});
      setBulkSoldCommonLogitixAmount('');
      void initBulkSoldFeeConfig(bulkSelectedTickets);
    } else {
      setBulkStatusListingPrices({});
      setBulkStatusListingCommonPrice('');
      resetBulkSoldState();
    }
  };

  const clearBulkSelection = () => {
    setBulkSelectedTicketIds(new Set());
    setBulkSelectedTickets([]);
  };

  const getStatusOfTicket = (ticket: Ticket): string => {
    return normalizeStatusValue(ticket.rawStatus || ticket.status);
  };

  const getStatusesOfSelectedTickets = (ticketIds: Set<string>): Set<string> => {
    const statuses = new Set<string>();
    const filteredTicketMap = new Map(getFilteredTickets().map((t) => [t.tpId, t]));
    ticketIds.forEach((tpId) => {
      const ticket = filteredTicketMap.get(tpId);
      if (ticket) {
        statuses.add(getStatusOfTicket(ticket));
      }
    });
    return statuses;
  };

  const handleBulkSelectTicket = (ticketId: string, checked: boolean) => {
    const ticketToSelect = getFilteredTickets().find((t) => t.tpId === ticketId);
    if (!ticketToSelect) return;

    setBulkSelectedTicketIds((prev) => {
      if (!checked) {
        // Deselection is always allowed
        const next = new Set(prev);
        next.delete(ticketId);
        return next;
      }

      // For selection, check if adding this ticket would create mixed statuses
      const currentStatuses = getStatusesOfSelectedTickets(prev);
      const newTicketStatus = getStatusOfTicket(ticketToSelect);

      if (currentStatuses.size > 0 && !currentStatuses.has(newTicketStatus)) {
        // Mixed status detected
        showError('You have selected tickets with different statuses. Please select only tickets with the same status.');
        return prev;
      }

      // Same status or first selection - allow it
      const next = new Set(prev);
      next.add(ticketId);
      return next;
    });
  };

  const handleBulkSelectAllPage = (checked: boolean) => {
    if (checked) {
      const filteredTickets = visiblePageTicketsRef.current;
      if (filteredTickets.length === 0) {
        clearBulkSelection();
        return;
      }

      // Get the status of the first ticket
      const firstTicketStatus = getStatusOfTicket(filteredTickets[0]);

      // Filter to only tickets with the same status
      const ticketsWithSameStatus = filteredTickets.filter(
        (t) => getStatusOfTicket(t) === firstTicketStatus
      );

      if (ticketsWithSameStatus.length === 0) {
        clearBulkSelection();
        return;
      }

      // If there are tickets with different statuses, show info
      if (ticketsWithSameStatus.length < filteredTickets.length) {
        showInfo(
          `Selected ${ticketsWithSameStatus.length} ticket(s) with "${firstTicketStatus}" status. ` +
          `${filteredTickets.length - ticketsWithSameStatus.length} ticket(s) with different statuses were excluded.`
        );
      }

      setBulkSelectedTicketIds(new Set(ticketsWithSameStatus.map((t) => t.tpId)));
    } else {
      clearBulkSelection();
    }
  };

  const openBulkStatusModal = () => {
    const selected = getFilteredTickets().filter((t) => bulkSelectedTicketIds.has(t.tpId));
    const validation = canBulkUpdateTickets(Array.from(bulkSelectedTicketIds));
    if (!validation.allowed) {
      showError(validation.reason || 'Cannot perform bulk action on selected tickets');
      return;
    }
    setBulkSelectedTickets(selected);
    setShowBulkStatusModal(true);
    setBulkNewStatus('');
    setBulkStatusListingPrices({});
    setBulkStatusListingCommonPrice('');
  };

  const handleBulkSoldConfirm = async () => {
    if (bulkSoldLoading || !bulkSelectedTickets.length) return;
    if (!bulkSoldMarketplaceId) {
      showError('Please select a marketplace.');
      return;
    }
    const mp = marketplacesList.find((m) => m.id === bulkSoldMarketplaceId);
    if (!mp) {
      showError('Selected marketplace not found.');
      return;
    }
    setBulkSoldLoading(true);
    try {
      const results = await Promise.allSettled(
        bulkSelectedTickets.map((ticket) => {
          const listPrice = getTicketListPrice(ticket);
          const rawValue = bulkSoldLogitixAmounts[ticket.tpId];
          const value = String(rawValue ?? '').trim();
          const logitixValue = value
            ? Number(parseFloat(value))
            : Math.round(listPrice * (100 - mp.vl_fee_percentage)) / 100;
          const feeConfig = getBulkTicketSoldFeeConfig(ticket.tpId);
          const quickPct = effectiveSoldQuickCutPercent(mp.vl_fee_percentage, feeConfig.feeMode, feeConfig.superClientPercent);
          const quickCutDollars = Number(roundToFixed(logitixValue * (quickPct / 100), 2));
          const settlement = Math.round((logitixValue - quickCutDollars) * 100) / 100;
          return callMarkAsSoldRest(ticket.tpId, settlement, logitixValue, mp.name).then(() => ticket.tpId);
        }),
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      const failedCount = results.filter((r) => r.status === 'rejected').length;
      if (successIds.length > 0) {
        updateLocalTicket(
          successIds,
          { rawStatus: 'Sold', status: 'Sold', marketplace: mp.name },
        );
        showSuccess(`${successIds.length} ticket(s) marked as sold${failedCount ? `, ${failedCount} failed` : ''}`);
        setActiveFilterTab('Sold');
      }
      if (failedCount > 0 && successIds.length === 0) showError('Failed to mark selected tickets as sold');
      clearBulkSelection();
      closeBulkStatusModal();
      console.log('🔄 Refetching tickets and team sold status after bulk marking as sold...');
      await Promise.all([
        refetchTickets(),
        refetchTeamsWithSoldStatus(),
      ]);
      syncDashboardNotifications();
      console.log('✅ Refetch completed - delete button should now update for sold teams');
    } catch (err: any) {
      showError(err?.message || 'Failed to mark selected tickets as sold');
    } finally {
      setBulkSoldLoading(false);
    }
  };

const handleBulkStatusChange = async (overrides?: { tickets?: Ticket[]; status?: string }) => {
  const ticketsForUpdate = overrides?.tickets?.length ? overrides.tickets : bulkSelectedTickets;
  const statusForUpdate = overrides?.status || bulkNewStatus;
  if (!ticketsForUpdate.length || !statusForUpdate || bulkStatusChangeLoading) return;

  const targetStatus = normalizeStatusValue(statusForUpdate);
  const deletedTickets = ticketsForUpdate.filter(
    (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Deleted',
  );
  if (
    deletedTickets.length === ticketsForUpdate.length &&
    (targetStatus === 'ToBeVerified' || targetStatus === 'List')
  ) {
    setBulkStatusChangeLoading(true);
    try {
      if (targetStatus === 'List') {
        const priceByTpId = Object.fromEntries(
          deletedTickets.map((ticket) => [ticket.tpId, getTicketListPrice(ticket)]),
        );
        const invalidTicket = deletedTickets.find(
          (ticket) => !Number.isFinite(priceByTpId[ticket.tpId]) || priceByTpId[ticket.tpId] <= 0,
        );
        if (invalidTicket) {
          throw new Error('A valid listing price is required before moving deleted tickets to Listed.');
        }
        const byPrice = new Map<number, string[]>();
        deletedTickets.forEach((ticket) => {
          const price = priceByTpId[ticket.tpId];
          const ids = byPrice.get(price) || [];
          ids.push(ticket.tpId);
          byPrice.set(price, ids);
        });
        await Promise.all(
          Array.from(byPrice.entries()).map(([price, ids]) => callPublishNonVlListing(ids, price)),
        );
      }

      const results = await Promise.allSettled(
        targetStatus === 'ToBeVerified'
          ? deletedTickets.map((ticket) =>
              restoreDeletedToVerification({
                variables: { tp_id: ticket.tpId, updated_at: new Date().toISOString() },
              }).then((result) => {
                const updated = result?.data?.update_ticket_placement?.returning?.length || 0;
                if (!updated) throw new Error('No ticket was updated.');
                return ticket.tpId;
              }),
            )
          : deletedTickets.map((ticket) =>
              Promise.resolve(ticket.tpId).then((tpId) => {
                if (!tpId) throw new Error('No ticket was updated.');
                return tpId;
              }),
            ),
      );

      const successIds = results
        .filter((result): result is PromiseFulfilledResult<string> => result.status === 'fulfilled')
        .map((result) => result.value);
      const failedCount = results.filter((result) => result.status === 'rejected').length;

      if (successIds.length) {
        updateLocalTicket(successIds, {
          rawStatus: targetStatus,
          status: targetStatus === 'List' ? 'Listed' : 'To Be Verified',
        });
        showSuccess(
          `Moved ${successIds.length} ticket(s) to ${targetStatus === 'List' ? 'Listed' : 'To Be Verified'}${
            failedCount ? `, ${failedCount} failed` : ''
          }`,
        );
        setActiveFilterTab(targetStatus === 'List' ? 'Listed' : 'Verification');
      }
      if (failedCount && !successIds.length) {
        showError(`Failed to move ticket(s) to ${targetStatus === 'List' ? 'Listed' : 'To Be Verified'}`);
      }
      clearBulkSelection();
      closeBulkStatusModal();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showError(error?.message || 'Failed to update deleted tickets');
    } finally {
      setBulkStatusChangeLoading(false);
    }
    return;
  }

  if (isNonVlStatusChange(targetStatus) && !skipNonVlStatusConfirmRef.current) {
    nonVlStatusConfirmActionRef.current = async () => {
      skipNonVlStatusConfirmRef.current = true;
      try {
        await handleBulkStatusChange(overrides);
      } finally {
        skipNonVlStatusConfirmRef.current = false;
      }
    };
    setNonVlStatusConfirmSummary(
      buildNonVlStatusConfirmSummary(targetStatus, ticketsForUpdate.length),
    );
    setShowNonVlStatusConfirm(true);
    return;
  }

  const tpIds = ticketsForUpdate.map((t) => t.tpId);
  if (overrides?.tickets?.length) {
    setBulkSelectedTickets(ticketsForUpdate);
    setBulkSelectedTicketIds(new Set(tpIds));
  }
  setBulkStatusChangeLoading(true);

  try {
    if (targetStatus === 'Verified_NonVL') {
      const allEligible = ticketsForUpdate.every((t) => {
        const status = normalizeStatusValue(t.rawStatus || t.status);
        return status === 'ToBeVerified';
      });
      if (!allEligible) {
        showError('Only tickets in To Be Verified status can be verified (Non-VL).');
        return;
      }
      if (ticketsForUpdate.some((t) => isMissingVerifyRequiredFields(t))) {
        showError(
          'Event name, event date/time, section, row, and seat numbers are required before verification.',
        );
        return;
      }
      const result = await verifyTicketPlacements(tpIds);
      updateLocalTicket(tpIds, { rawStatus: 'Verified', status: 'Verified' });
      showSuccess(result?.message || `Verified ${tpIds.length} ticket(s) (Non-VL)`);
      setActiveFilterTab('Verification');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'List_NonVL') {
      const fromVerified = ticketsForUpdate.filter(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Verified',
      );
      const fromDelisted = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'Delist' || status === 'DelistInProgress' || status === 'DelistRequested';
      });
      const unsupported = ticketsForUpdate.filter(
        (ticket) => !fromVerified.includes(ticket) && !fromDelisted.includes(ticket),
      );
      if (unsupported.length > 0) {
        showError(
          'Only Verified or Delisted / Delist Requested tickets can be listed (Non-VL).',
        );
        return;
      }
      if (fromVerified.length > 0 && fromDelisted.length > 0) {
        showError('Select only Verified tickets or only Delisted tickets for Listed (Non-VL), not both.');
        return;
      }
      // Prefer common "Apply same list price" when filled; else per-seat fields / existing price.
      const priceByTpId = resolveBulkListingPriceByTpId(ticketsForUpdate);
      setBulkStatusListingPrices(priceByTpId);
      const invalidPrice = ticketsForUpdate.find((ticket) => {
        const value = String(priceByTpId[ticket.tpId] || '').trim();
        const num = parseFloat(value);
        return !value || isNaN(num) || num <= 0;
      });
      if (invalidPrice) {
        showError('All selected tickets must have a valid listing price greater than 0.');
        return;
      }
      const byPrice = new Map<number, string[]>();
      const priceUpdates = ticketsForUpdate.map((ticket) => ({
        tpId: ticket.tpId,
        priceNum: Number(parseFloat(String(priceByTpId[ticket.tpId] || '').trim())),
      }));
      priceUpdates.forEach(({ tpId, priceNum }) => {
        const existing = byPrice.get(priceNum) || [];
        existing.push(tpId);
        byPrice.set(priceNum, existing);
      });
      await Promise.all(
        Array.from(byPrice.entries()).map(([price, ids]) => callPublishNonVlListing(ids, price)),
      );
      priceUpdates.forEach(({ tpId, priceNum }) => {
        updateLocalTicket([tpId], {
          rawStatus: 'List',
          status: 'Listed',
          price: formatCurrency(priceNum),
        });
      });
      const samplePrice = priceUpdates[0]?.priceNum;
      showSuccess(
        `Listed ${tpIds.length} ticket(s) (Non-VL)${
          Number.isFinite(samplePrice) ? ` at $${samplePrice}` : ''
        }`,
      );
      setActiveFilterTab('Listed');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'Delist_NonVL') {
      const allEligible = ticketsForUpdate.every((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'List' || status === 'DelistInProgress' || status === 'DelistRequested';
      });
      if (!allEligible) {
        showError('Only Listed or Delist Requested tickets can be delisted (Non-VL).');
        return;
      }
      const results = await Promise.allSettled(
        tpIds.map((tp_id) =>
          updateTicketStatus({ variables: { tp_id, status: 'Delist' } }).then((res) => {
            const affected = res?.data?.update_ticket_placement?.returning?.length || 0;
            if (!affected) throw new Error('No ticket was updated.');
            return tp_id;
          }),
        ),
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      if (!successIds.length) {
        showError('Failed to delist tickets (Non-VL).');
        return;
      }
      updateLocalTicket(successIds, { rawStatus: 'Delist', status: 'Delisted' });
      showSuccess(`Delisted ${successIds.length} ticket(s) (Non-VL)`);
      setActiveFilterTab('Delisted');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'DelistInProgress_NonVL') {
      const allEligible = ticketsForUpdate.every((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'Verified' || status === 'Delist';
      });
      if (!allEligible) {
        showError('Only Verified or Delisted tickets can move to Delist Requested (Non-VL).');
        return;
      }
      const results = await Promise.allSettled(
        tpIds.map((tp_id) =>
          updateTicketStatus({ variables: { tp_id, status: 'DelistInProgress' } }).then((res) => {
            const affected = res?.data?.update_ticket_placement?.returning?.length || 0;
            if (!affected) throw new Error('No ticket was updated.');
            return tp_id;
          }),
        ),
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      if (!successIds.length) {
        showError('Failed to update tickets to Delist Requested (Non-VL).');
        return;
      }
      updateLocalTicket(successIds, { rawStatus: 'DelistInProgress', status: 'Delist Requested' });
      showSuccess(`Moved ${successIds.length} ticket(s) to Delist Requested (Non-VL)`);
      setActiveFilterTab('Delisted');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'Return_NonVL') {
      const allEligible = ticketsForUpdate.every((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'Delist' || status === 'DelistInProgress' || status === 'DelistRequested';
      });
      if (!allEligible) {
        showError('Only Delisted / Delist Requested tickets can be returned (Non-VL).');
        return;
      }
      const results = await Promise.allSettled(
        tpIds.map((tp_id) =>
          updateTicketStatus({ variables: { tp_id, status: 'Return' } }).then((res) => {
            const affected = res?.data?.update_ticket_placement?.returning?.length || 0;
            if (!affected) throw new Error('No ticket was updated.');
            return tp_id;
          }),
        ),
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      if (!successIds.length) {
        showError('Failed to return tickets (Non-VL).');
        return;
      }
      updateLocalTicket(successIds, { rawStatus: 'Return', status: 'Returned' });
      showSuccess(`Returned ${successIds.length} ticket(s) (Non-VL)`);
      setActiveFilterTab('Delisted');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'Unsold_NonVL') {
      const allEligible = ticketsForUpdate.every(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'List',
      );
      if (!allEligible) {
        showError('Only Listed tickets can be marked Unsold (Non-VL).');
        return;
      }
      const results = await Promise.allSettled(
        tpIds.map((tp_id) =>
          updateTicketStatus({ variables: { tp_id, status: 'Unsold' } }).then((res) => {
            const affected = res?.data?.update_ticket_placement?.returning?.length || 0;
            if (!affected) throw new Error('No ticket was updated.');
            return tp_id;
          }),
        ),
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      if (!successIds.length) {
        showError('Failed to mark tickets Unsold (Non-VL).');
        return;
      }
      updateLocalTicket(successIds, { rawStatus: 'Unsold', status: 'Unsold' });
      showSuccess(`Marked ${successIds.length} ticket(s) Unsold (Non-VL)`);
      setActiveFilterTab('Unsold');
      clearBulkSelection();
      closeBulkStatusModal();
      return;
    }

    if (targetStatus === 'Verified') {
      const allEligible = ticketsForUpdate.every((t) => {
        const status = normalizeStatusValue(t.rawStatus || t.status);
        return status === 'ToBeVerified';
      });
      if (!allEligible) {
        showError('Only tickets in To Be Verified status can be verified.');
        return;
      }
      const eventIds = [
        ...new Set(
          ticketsForUpdate
            .map((ticket) => String(ticket.eventId || '').trim())
            .filter(Boolean),
        ),
      ];
      if (eventIds.length !== 1) {
        showError('Verify tickets from one event at a time.');
        return;
      }
      const missingFields = ticketsForUpdate.some((t) => isMissingVerifyRequiredFields(t));
      if (missingFields) {
        showError(
          'Event name, event date/time, section, row, and seat numbers are required before verification.',
        );
        return;
      }
      // Stay ToBeVerified until Production ID is saved, then mark Verified.
      closeBulkStatusModal();
      clearBulkSelection();
      setBulkStatusChangeLoading(false);
      await openPidConfirmationForTickets(ticketsForUpdate);
      return;
    } else if (targetStatus === 'List') {
      const undoToListTickets = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'Delist' || status === 'DelistInProgress' || status === 'DelistRequested';
      });
      const publishToListTickets = ticketsForUpdate.filter(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Verified',
      );
      const unsupportedToList = ticketsForUpdate.filter(
        (ticket) => !undoToListTickets.includes(ticket) && !publishToListTickets.includes(ticket),
      );

      if (unsupportedToList.length > 0) {
        showError(
          'Only Verified tickets (publish) or Delist Requested / Delisted tickets (undo to Listed) can be moved to Listed in bulk.',
        );
        return;
      }

      if (undoToListTickets.length > 0 && publishToListTickets.length > 0) {
        showError('Select only Verified tickets or only Delisted tickets to move to Listed, not both.');
        return;
      }

      if (undoToListTickets.length > 0) {
        const priceMap = {
          ...getDefaultBulkStatusListingPrices(undoToListTickets),
          ...bulkStatusListingPrices,
        };
        const invalidUndoPrice = undoToListTickets.find((ticket) => {
          const value = String(priceMap[ticket.tpId] || '').trim();
          const num = parseFloat(value);
          return !value || isNaN(num) || num <= 0;
        });
        if (invalidUndoPrice) {
          showError('All selected tickets must have a valid listing price greater than 0.');
          return;
        }

        try {
          const undoTpIds = undoToListTickets.map((ticket) => ticket.tpId);
          await executeBatchedUndoDelistWithFallback(undoTpIds);

          const priceUpdates = undoToListTickets.map((ticket) => ({
            tpId: ticket.tpId,
            priceNum: Number(parseFloat(String(priceMap[ticket.tpId] || '').trim())),
          }));

          const tpIdsByPrice = new Map<number, string[]>();
          priceUpdates.forEach(({ tpId, priceNum }) => {
            const existing = tpIdsByPrice.get(priceNum) || [];
            existing.push(tpId);
            tpIdsByPrice.set(priceNum, existing);
          });

          await Promise.all(
            Array.from(tpIdsByPrice.entries()).map(([priceNum, tp_ids]) =>
              editTicketPriceBySuperUser({
                variables: { tp_ids, tp_list_price: priceNum },
              }),
            ),
          );

          priceUpdates.forEach(({ tpId, priceNum }) => {
            updateLocalTicket([tpId], { rawStatus: 'List', status: 'Listed', price: formatCurrency(priceNum) });
          });
          showSuccess(`Moved ${priceUpdates.length} ticket(s) back to Listed`);
          setActiveFilterTab('Listed');
          clearBulkSelection();
          closeBulkStatusModal();
        } catch (undoError: any) {
          showError(undoError?.message || 'Failed to move tickets back to Listed');
        }
      } else {
        // Verified → Listed must go through Victory Live steps (PID → Submit → List on Marketplaces).
        closeBulkStatusModal();
        setBulkStatusChangeLoading(false);
        await handleVlProgressAction(publishToListTickets.map((ticket) => ticket.tpId));
        return;
      }
    } else if (
      ticketsForUpdate.every((ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Sold') &&
      (targetStatus === 'Sold' || targetStatus === 'Settled' || targetStatus === 'SettlementInProgress')
    ) {
      if (!canOverrideSettlementStatus) {
        showInfo('It will update automatically when payment completes.');
        return;
      }
      const paymentStatus = getPaymentStatusForSettlementOverride(targetStatus);
      if (paymentStatus === undefined) {
        showError('That settlement status could not be applied.');
        return;
      }
      const result = await callUpdateSettlementPaymentStatusRest(tpIds, paymentStatus);
      const updatedIds: string[] = Array.isArray(result?.updatedTpIds) ? result.updatedTpIds : tpIds;
      if (!updatedIds.length) {
        showError('No sold tickets were updated.');
        return;
      }
      const nextStatusLabel =
        paymentStatus === 'Success'
          ? 'Settled'
          : paymentStatus === 'Inprogress'
            ? 'Settlement In Progress'
            : 'Sold';
      updateLocalTicket(updatedIds, {
        rawStatus: 'Sold',
        status: nextStatusLabel,
        paymentStatus,
        payoutStatus: 'Unvoided_Payout',
      });
      showSuccess(`Updated settlement status for ${updatedIds.length} ticket(s).`);
      setActiveFilterTab('Sold');
      clearBulkSelection();
      closeBulkStatusModal();
      await refreshTicketsAndNotifications();
    } else if (targetStatus === 'Sold') {
      if (!bulkSoldMarketplaceId) {
        setBulkSelectedTickets(ticketsForUpdate);
        setBulkSelectedTicketIds(new Set(tpIds));
        setBulkStatusChangeLoading(false);
        setBulkNewStatus('Sold');
        setShowBulkStatusModal(true);
        void initBulkSoldFeeConfig(ticketsForUpdate);
        return;
      }
      await handleBulkSoldConfirm();
    }
    else if (targetStatus === 'Unsold') {
      const ineligible = ticketsForUpdate.filter(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) !== 'List',
      );
      if (ineligible.length) {
        showError('Only Listed tickets can be marked as Unsold in bulk.');
        return;
      }
      await callMarkTicketsUnsoldRest(tpIds);
      updateLocalTicket(tpIds, { rawStatus: 'Unsold', status: 'Unsold' });
      showSuccess(`Marked ${tpIds.length} ticket(s) as Unsold`);
      setActiveFilterTab('Unsold');
      clearBulkSelection();
      closeBulkStatusModal();
    }
    else if (targetStatus === 'Return') {
      const ineligible = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status !== 'Delist' && status !== 'DelistInProgress' && status !== 'DelistRequested';
      });
      if (ineligible.length) {
        showError(
          'Only Delisted or Delist Requested tickets can be returned. Deselect Listing Request Cancelled or other statuses.',
        );
        return;
      }
      const eventIds = ticketsForUpdate.map((t) => t.eventId).filter(Boolean);
      const sameEvent = eventIds.length > 0 && eventIds.every((id) => id === eventIds[0]);
      if (!sameEvent) {
        showError('Please select tickets from the same event to return in bulk.');
        return;
      }
      await callReturnTicketsRest(tpIds);
      updateLocalTicket(tpIds, { rawStatus: 'Return', status: 'Returned' });
      showSuccess(`Returned ${tpIds.length} ticket(s)`);
      setActiveFilterTab('Delisted');
      clearBulkSelection();
      closeBulkStatusModal();
    }
    else if (targetStatus === 'Delist') {
      const eligible = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status === 'List' || status === 'DelistInProgress';
      });
      if (!eligible.length) {
        showError('Only Listed or Delist Requested tickets can be delisted in bulk.');
        return;
      }
      const delistTpIds = eligible.map((t) => t.tpId);
      const allListed = eligible.every(
        (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'List',
      );
      if (allListed) {
        clearBulkSelection();
        closeBulkStatusModal();
        requestListedTicketDelist(delistTpIds, eligible);
        return;
      }
      try {
        const { successIds, message } = await executeBatchedListedDelistRest(delistTpIds);
        if (successIds.length) {
          updateLocalTicket(successIds, { rawStatus: 'Delist', status: 'Delisted' });
          showSuccess(message || `Delisted ${successIds.length} ticket(s)`);
          setActiveFilterTab('Delisted');
        } else {
          showError('Failed to delist selected tickets');
        }
      } catch (error: any) {
        showError(error?.message || 'Failed to delist selected tickets');
      }
      clearBulkSelection();
      closeBulkStatusModal();
    }
    else if (targetStatus === 'DelistInProgress' || targetStatus === 'DelistRequested') {
      closeBulkStatusModal();
      openDelistEmailModal(tpIds);
    }
    else if (targetStatus === 'ListingRequestCancelled') {
      const ineligible = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status !== 'ToBeVerified';
      });
      if (ineligible.length) {
        showError('Only tickets in To Be Verified status can be marked as Listing Request Cancelled.');
        return;
      }
      const results = await Promise.allSettled(
        ticketsForUpdate.map((t) => callCancelListingRequestByAdminRest(t.tpId))
      );
      const successIds = ticketsForUpdate
        .filter((_, i) => results[i].status === 'fulfilled')
        .map((t) => t.tpId);
      if (successIds.length) {
        updateLocalTicket(successIds, { rawStatus: 'ListingRequestCancelled', status: 'Listing Request Cancelled' });
        showSuccess(`Cancelled ${successIds.length} listing request(s)`);
        setActiveFilterTab('Listing Request Cancelled');
      } else {
        showError('Failed to cancel listing requests');
      }
      clearBulkSelection();
      closeBulkStatusModal();
    }
    else if (targetStatus === 'ToBeVerified') {
      const ineligible = ticketsForUpdate.filter((ticket) => {
        const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
        return status !== 'ListingRequestCancelled';
      });
      if (ineligible.length) {
        showError(
          'Only tickets in Listing Request Cancelled can be moved to To Be Verified in bulk.',
        );
        return;
      }
      const results = await Promise.allSettled(
        ticketsForUpdate.map((ticket) =>
          restoreCancelledListingToVerification({ variables: { tp_id: ticket.tpId } }).then((result) => {
            const updated = result?.data?.update_ticket_placement?.returning?.length || 0;
            if (updated <= 0) throw new Error('Unable to restore ticket');
            return ticket.tpId;
          })
        )
      );
      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      if (successIds.length) {
        updateLocalTicket(successIds, { rawStatus: 'ToBeVerified', status: 'To Be Verified' });
        showSuccess(`Restored ${successIds.length} ticket(s) to To Be Verified`);
        setActiveFilterTab('Verification');
      } else {
        showError('Failed to restore tickets to To Be Verified');
      }
      clearBulkSelection();
      closeBulkStatusModal();
    }
    else if (targetStatus === 'Deleted') {
      const results = await Promise.allSettled(
        ticketsForUpdate.map(ticket => {
          return deleteTicketStatus({
            variables: {
              tp_id: ticket.tpId
            }
          });
        })
      );
      
      const successIds = ticketsForUpdate
        .filter((_, index) => results[index].status === 'fulfilled')
        .map(ticket => ticket.tpId);
      const failedCount = results.filter(result => result.status === 'rejected').length;

      if (successIds.length > 0) {
        updateLocalTicket(successIds, { rawStatus: 'Deleted', status: 'Deleted' });
        showSuccess(
          `Deleted ${successIds.length} ticket(s)${failedCount ? `, ${failedCount} failed` : ''}`
        );
        setActiveFilterTab('Deleted');
      }

      if (failedCount > 0 && successIds.length === 0) {
        showError('Failed to delete selected tickets');
      }

      clearBulkSelection();
      closeBulkStatusModal();
      await refreshTicketsAndNotifications();
    }
    // 👇👇👇 ఇక్కడ మాత్రమే కొత్తగా యాడ్ చేసిన కోడ్ (QA Statuses కోసం) 👇👇👇
    else if (targetStatus === 'UnderReview' || targetStatus === 'PaidManuallyViaQA' || targetStatus === 'QADeniedPayout') {
      const results = await Promise.allSettled(
        ticketsForUpdate.map((ticket) =>
          updateTicketStatus({
            variables: { tp_id: ticket.tpId, status: targetStatus }
          }).then((res) => {
            const affected = res?.data?.update_ticket_placement?.returning?.length || 0;
            if (!affected) throw new Error('No ticket was updated.');
            return ticket.tpId;
          })
        )
      );

      const successIds = results
        .filter((r): r is PromiseFulfilledResult<string> => r.status === 'fulfilled')
        .map((r) => r.value);
      
      const failedCount = results.filter((r) => r.status === 'rejected').length;

      if (successIds.length > 0) {
        updateLocalTicket(successIds, { 
          rawStatus: targetStatus, 
          status: getStatusLabel(targetStatus) 
        });
        
        const statusLabel = targetStatus === 'UnderReview' ? 'Under Review' : 
                            targetStatus === 'PaidManuallyViaQA' ? 'Paid Manually via QA' : 
                            'QA Denied Payout';
                            
        showSuccess(`Updated ${successIds.length} ticket(s) to ${statusLabel}${failedCount ? `, ${failedCount} failed` : ''}`);
        
        if (activeFilterTab !== 'Sold') {
          setActiveFilterTab('Sold');
        }
      }
      
      if (failedCount > 0 && successIds.length === 0) {
        showError(`Failed to update tickets to ${targetStatus}`);
      }
      
      clearBulkSelection();
      closeBulkStatusModal();
      await refreshTicketsAndNotifications();
    }

    else {
      showInfo('This bulk status change is not available from User Details.');
    }
  } catch (err: any) {
    showError(err?.message || 'Bulk status update failed');
  } finally {
    setBulkStatusChangeLoading(false);
    await refreshTicketsAndNotifications();
  }
};

  /**
   * Row / seat status dropdowns for multi-ticket selections must follow the same
   * paths as bulk actions (prices, Sold marketplace modal, delist email, VL, etc.).
   */
  const applyMultiTicketStatusChangeFromUi = async (tickets: Ticket[], status: string) => {
    if (!tickets.length || !status) return;

    const byId = new Map<string, Ticket>();
    tickets.forEach((ticket) => {
      if (ticket?.tpId) byId.set(ticket.tpId, ticket);
    });
    const uniqueTickets = Array.from(byId.values());
    if (uniqueTickets.length <= 1) {
      if (uniqueTickets[0]) {
        await handleStatusChange(uniqueTickets[0], status);
      }
      return;
    }

    const targetStatus = normalizeStatusValue(status);
    setBulkSelectedTickets(uniqueTickets);
    setBulkSelectedTicketIds(new Set(uniqueTickets.map((t) => t.tpId)));
    setBulkNewStatus(status);
    setBulkStatusListingPrices((prev) => ({
      ...getDefaultBulkStatusListingPrices(uniqueTickets),
      ...Object.fromEntries(
        Object.entries(prev).filter(([, value]) => String(value || '').trim()),
      ),
    }));

    if (targetStatus === 'Sold') {
      setBulkStatusListingPrices({});
      setBulkStatusListingCommonPrice('');
      setBulkSoldMarketplaceId('');
      setBulkSoldLogitixAmounts({});
      setBulkSoldCommonLogitixAmount('');
      setBulkNewStatus('Sold');
      setShowBulkStatusModal(true);
      void initBulkSoldFeeConfig(uniqueTickets);
      return;
    }

    // Listed (Non-VL): open bulk status modal so admin can set listing prices.
    if (targetStatus === 'List_NonVL') {
      const priceMap = getDefaultBulkStatusListingPrices(uniqueTickets);
      setBulkStatusListingPrices(priceMap);
      const uniquePrices = [
        ...new Set(Object.values(priceMap).filter((v) => String(v).trim() !== '')),
      ];
      setBulkStatusListingCommonPrice(uniquePrices.length === 1 ? uniquePrices[0] : '');
      setBulkNewStatus('List_NonVL');
      setShowBulkStatusModal(true);
      return;
    }

    if (targetStatus === 'DelistInProgress' || targetStatus === 'DelistRequested') {
      openDelistEmailModal(uniqueTickets.map((t) => t.tpId));
      return;
    }

    await handleBulkStatusChange({ tickets: uniqueTickets, status });
  };

  const handleBulkMarkSold = async () => {
    const selected = getFilteredTickets().filter((t) => bulkSelectedTicketIds.has(t.tpId));
    const validation = canBulkUpdateTickets(Array.from(bulkSelectedTicketIds));
    if (!validation.allowed) {
      showError(validation.reason || 'Cannot mark selected tickets as sold');
      return;
    }
    if (selected.length === 1) {
      handleMarkAsSoldFromMenu(selected[0]);
      return;
    }
    setBulkSelectedTickets(selected);
    setBulkNewStatus('Sold');
    setShowBulkStatusModal(true);
    await initBulkSoldFeeConfig(selected);
  };

  const clearSeatCardStatusForTpIds = useCallback((tpIds: string[]) => {
    if (!tpIds.length) return;
    const idSet = new Set(tpIds.filter(Boolean));
    setSeatCardStatusBySeatId((prev) => {
      const next = { ...prev };
      for (const key of Object.keys(next)) {
        if (idSet.has(key)) delete next[key];
      }
      return next;
    });
  }, []);

  const requestListedTicketDelist = useCallback((tpIds: string[], tickets: Ticket[] = []) => {
    const ids = tpIds.filter(Boolean);
    if (!ids.length) return;
    setListedDelistProgress(null);
    setListedDelistTpIds(ids);
    setListedDelistStoredEmail(
      tickets.map((ticket) => ticket.tp_delist_requested_email?.trim()).find(Boolean) || '',
    );
    setShowListedDelistConfirm(true);
  }, []);

  const cancelListedDelistConfirm = useCallback(() => {
    if (vlActionLoading) return;
    clearSeatCardStatusForTpIds(listedDelistTpIds);
    setShowListedDelistConfirm(false);
    setListedDelistTpIds([]);
    setListedDelistStoredEmail('');
    setListedDelistProgress(null);
  }, [clearSeatCardStatusForTpIds, listedDelistTpIds, vlActionLoading]);

  const confirmListedDelist = async (requestedEmailId?: string, retryStep?: DelistUiStep) => {
    if (!listedDelistTpIds.length || vlActionLoading) return;
    const ids = [...listedDelistTpIds];
    setListedDelistProgress((prev) => ({
      currentStep: retryStep || 1,
      completedSteps: retryStep
        ? (prev?.completedSteps || []).filter((step) => step < retryStep)
        : [],
      failedStep: null,
      message: undefined,
    }));
    const ok = await delistListedTicketsWithLogitix(ids, setListedDelistProgress, requestedEmailId);
    if (ok) {
      setShowListedDelistConfirm(false);
      setListedDelistTpIds([]);
      setListedDelistStoredEmail('');
      setListedDelistProgress(null);
    }
  };

  const openListedMarketplaceEdit = useCallback((tpIds: string[], tickets: Ticket[]) => {
    const ids = tpIds.filter(Boolean);
    if (!ids.length || !tickets.length) return;
    setListedMarketplaceEditTpIds(ids);
    setListedMarketplaceEditTickets(tickets);
    setListedEditMarketplaces(getEnabledMarketplaceIdsForTicket(ids[0]));
    setShowListedMarketplaceEdit(true);
  }, []);

  const buildVlSharePayloadForListedTickets = (tpIds: string[], tickets: Ticket[]) => {
    const listPriceByTpId: Record<string, number> = {};
    const sectionByTpId: Record<string, string> = {};
    const rowByTpId: Record<string, string> = {};
    const seatByTpId: Record<string, string> = {};

    for (const tpId of tpIds) {
      const ticket =
        tickets.find((row) => row.tpId === tpId) ||
        getFilteredTickets().find((row) => row.tpId === tpId);
      if (!ticket) continue;
      const price = getTicketListPrice(ticket);
      if (!Number.isFinite(price) || price <= 0) {
        throw new Error('List price must be greater than 0 before updating Victory Live.');
      }
      const section = String(ticket.section || '').trim();
      const row = String(ticket.row || '').trim();
      const seat = String(ticket.seatNo ?? '').trim();
      if (!section || !row || !seat || section === '-' || row === '-' || seat === '-') {
        throw new Error('Section, row, and seat are required.');
      }
      listPriceByTpId[tpId] = Number(roundToFixed(price, 2));
      sectionByTpId[tpId] = section;
      rowByTpId[tpId] = row;
      seatByTpId[tpId] = seat;
    }

    return {
      listPriceByTpId,
      sectionByTpId,
      rowByTpId,
      seatByTpId,
    };
  };

  const handleUpdateListedMarketplaces = async () => {
    const tpIds = listedMarketplaceEditTpIds;
    const tickets = listedMarketplaceEditTickets;
    if (!tpIds.length || listedMarketplaceEditLoading) return;
    if (listedEditMarketplaces.length === 0) {
      showError('Select at least one marketplace.');
      return;
    }

    let sharePayload;
    try {
      sharePayload = buildVlSharePayloadForListedTickets(tpIds, tickets);
    } catch (error: any) {
      showError(error?.message || 'Missing ticket details for Victory Live update.');
      return;
    }

    setListedMarketplaceEditLoading(true);
    beginVlBusy('Updating marketplace selection on Victory Live…');
    try {
      const result = await shareVlListings(tpIds, {
        shareExchange: true,
        enabledMarketplaceIds: listedEditMarketplaces,
        updateMarketplaceNotes: true,
        ...sharePayload,
      });

      const successTpIds = successfulVlTpIds(result);
      const toast = summarizeVlActionToast({
        actionLabel: 'Marketplace update',
        result,
        successMessage: 'Marketplace selection updated on Victory Live.',
      });
      if (toast.type === 'success') {
        setCachedEnabledMarketplaceIdsForMany(tpIds, listedEditMarketplaces);
        setCachedVlSharedStatusForMany(tpIds, true);
        setShowListedMarketplaceEdit(false);
        setListedMarketplaceEditTpIds([]);
        setListedMarketplaceEditTickets([]);
      } else if (successTpIds.length) {
        setCachedEnabledMarketplaceIdsForMany(successTpIds, listedEditMarketplaces);
        setCachedVlSharedStatusForMany(successTpIds, true);
      }
      showVlToast(toast);
      if (toast.type !== 'error') {
        await refreshTicketsAndNotifications();
      }
    } catch (error: any) {
      showVlToast(
        toastForVlCaughtError(error, 'Marketplace update', 'Failed to update marketplace selection on Victory Live'),
      );
    } finally {
      setListedMarketplaceEditLoading(false);
      endVlBusy();
    }
  };

  const toggleListedSharedStatus = async (
    tpIds: string[],
    tickets: Ticket[],
    targetShared: boolean,
  ) => {
    if (!tpIds.length || listedSharedToggleLoading) return;

    let sharePayload;
    try {
      sharePayload = buildVlSharePayloadForListedTickets(tpIds, tickets);
    } catch (error: any) {
      showError(error?.message || 'Missing ticket details for Victory Live update.');
      return;
    }

    const enabledMarketplaceIds = targetShared
      ? getEnabledMarketplaceIdsForTicket(tpIds[0])
      : [];

    setListedSharedToggleLoading(true);
    beginVlBusy(
      targetShared ? 'Sharing on Victory Live…' : 'Unsharing on Victory Live…',
    );
    try {
      const result = await shareVlListings(tpIds, {
        shareExchange: targetShared,
        enabledMarketplaceIds,
        ...sharePayload,
      });

      const successTpIds = successfulVlTpIds(result);
      const toast = summarizeVlActionToast({
        actionLabel: targetShared ? 'Share' : 'Unshare',
        result,
        successMessage: targetShared
          ? 'Ticket shared on selected marketplaces. Status remains Listed.'
          : 'Ticket unshared from all marketplaces. Status remains Listed.',
      });
      if (toast.type === 'success') {
        setCachedVlSharedStatusForMany(successTpIds.length ? successTpIds : tpIds, targetShared);
        await refreshTicketsAndNotifications();
      } else if (successTpIds.length) {
        setCachedVlSharedStatusForMany(successTpIds, targetShared);
        await refreshTicketsAndNotifications();
      }
      showVlToast(toast);
    } catch (error: any) {
      showVlToast(
        toastForVlCaughtError(
          error,
          targetShared ? 'Share' : 'Unshare',
          targetShared ? 'Failed to share on Victory Live.' : 'Failed to unshare on Victory Live.',
        ),
      );
    } finally {
      setListedSharedToggleLoading(false);
      endVlBusy();
    }
  };

  const renderListedVlControls = (tickets: Ticket[]) => {
    if (!tickets.length) return null;
    if (activeFilterTab !== 'Listed' && activeFilterTab !== 'All') return null;
    const representative = tickets[0];
    const rawStatus = representative.rawStatus || representative.status;
    if (
      !isVlListedTicketStatus(rawStatus) ||
      !ticketHasVlListingMarkers({
        vlListingId: representative.vlListingId,
        vlItemId: representative.vlItemId,
      })
    ) {
      return null;
    }
    const tpIds = tickets.map((row) => row.tpId).filter(Boolean);
    const busy = vlActionLoading || listedMarketplaceEditLoading || listedSharedToggleLoading;
    return (
      <ListedVlRowControls
        className={styles.listedVlControlsNoMargin}
        enabledMarketplaceIds={getEnabledMarketplaceIdsForTicket(representative.tpId)}
        disabled={busy}
        onEditMarketplaces={(e) => {
          e.stopPropagation();
          openListedMarketplaceEdit(tpIds, tickets);
        }}
      />
    );
  };

  const renderListedSharedToggle = (tickets: Ticket[]) => {
    if (!tickets.length) return null;
    if (activeFilterTab !== 'Listed' && activeFilterTab !== 'All') return null;
    const representative = tickets[0];
    const rawStatus = representative.rawStatus || representative.status;
    if (
      !isVlListedTicketStatus(rawStatus) ||
      !ticketHasVlListingMarkers({
        vlListingId: representative.vlListingId,
        vlItemId: representative.vlItemId,
      })
    ) {
      return null;
    }
    const tpIds = tickets.map((row) => row.tpId).filter(Boolean);
    const isShared = getVlSharedStatusForTicket(representative.tpId, representative);
    const busy = vlActionLoading || listedMarketplaceEditLoading || listedSharedToggleLoading;

    return (
      <ListedSharedToggle
        isShared={isShared}
        disabled={busy}
        onToggle={(e) => {
          e.stopPropagation();
          setListedShareConfirm({
            tpIds,
            tickets,
            targetShared: !isShared,
          });
        }}
      />
    );
  };

  const cancelListedShareConfirm = () => {
    if (listedSharedToggleLoading) return;
    setListedShareConfirm(null);
  };

  const confirmListedShareToggle = async () => {
    if (!listedShareConfirm || listedSharedToggleLoading) return;
    const { tpIds, tickets, targetShared } = listedShareConfirm;
    try {
      await toggleListedSharedStatus(tpIds, tickets, targetShared);
    } finally {
      setListedShareConfirm(null);
    }
  };

  const renderListedMarketplaceCell = (tickets: Ticket[]) => {
    if (activeFilterTab === 'Sold') {
      const marketplaceName =
        tickets
          .map((ticket) => String(ticket.marketplace || '').trim())
          .find((name) => name && name !== 'Other' && name !== 'Unknown') || '';
      return (
        <td className={styles.tdMarketplace} onClick={(e) => e.stopPropagation()}>
          {marketplaceName || <span className={styles.marketplaceCellEmpty}>—</span>}
        </td>
      );
    }
    return (
      <td className={styles.tdMarketplace} onClick={(e) => e.stopPropagation()}>
        {renderListedVlControls(tickets) ?? <span className={styles.marketplaceCellEmpty}>—</span>}
      </td>
    );
  };

  const renderListedSharedCell = (tickets: Ticket[]) => (
    <td className={styles.tdShared} onClick={(e) => e.stopPropagation()}>
      {renderListedSharedToggle(tickets) ?? <span className={styles.marketplaceCellEmpty}>—</span>}
    </td>
  );

  const delistListedTicketsWithLogitix = async (
    tpIds: string[],
    onProgress?: (progress: DelistJobProgress) => void,
    requestedEmailId?: string,
  ) => {
    if (!tpIds.length) return true;
    const listedTpIds = tpIds.filter((tpId) => {
      const ticket = getFilteredTickets().find((row) => row.tpId === tpId);
      return mapStatusForMutation(ticket?.rawStatus || ticket?.status || '') === 'List';
    });
    if (!listedTpIds.length) {
      openDelistEmailModal(tpIds);
      return true;
    }
    beginVlBusy(LISTED_DELIST_BUSY_MESSAGE);
    try {
      const { successIds, message, failedDetails } = await executeBatchedListedDelistRest(
        listedTpIds,
        onProgress,
        requestedEmailId,
      );
      const failedCount = listedTpIds.length - successIds.length;
      if (!successIds.length) {
        clearSeatCardStatusForTpIds(listedTpIds);
        throw new Error(
          formatDelistCleanupFailureMessage({
            failedCount: listedTpIds.length,
            failedDetails,
            fallbackMessage:
              message ||
              'Unshare failed on Victory Live — ticket was not moved to Delisted. Please try again.',
          }),
        );
      }
      clearSeatCardStatusForTpIds(listedTpIds.filter((id) => !successIds.includes(id)));
      updateLocalTicket(successIds, { rawStatus: 'Delist', status: 'Delisted' });
      if (failedCount > 0) {
        showError(
          formatDelistCleanupFailureMessage({
            failedCount,
            failedDetails,
          }),
        );
        return false;
      }
      showSuccess(formatUnshareDelistSuccessMessage(successIds.length));
      setActiveFilterTab('Delisted');
      await refreshTicketsAndNotifications();
      return true;
    } catch (error: any) {
      clearSeatCardStatusForTpIds(listedTpIds);
      if (error instanceof DelistJobError) {
        onProgress?.({
          currentStep: error.currentStep,
          completedSteps: error.completedSteps,
          failedStep: error.failedStep || error.currentStep || 1,
          message: error.message,
        });
      } else {
        onProgress?.({
          currentStep: 1,
          completedSteps: [],
          failedStep: 1,
          message: error?.message || 'Failed to unshare and delist selected tickets',
        });
      }
      return false;
    } finally {
      endVlBusy();
    }
  };

  const handleBulkDelist = () => {
    const tpIds = Array.from(bulkSelectedTicketIds);
    if (!tpIds.length) return;
    const validation = canBulkUpdateTickets(tpIds);
    if (!validation.allowed) {
      showError(validation.reason || 'Cannot delist selected tickets');
      return;
    }
    void requestListedTicketDelist(
      tpIds,
      getFilteredTickets().filter((ticket) => tpIds.includes(ticket.tpId)),
    );
  };

  const handleBulkChangePrice = () => {
    const selected = getFilteredTickets().filter((t) => bulkSelectedTicketIds.has(t.tpId));
    const validation = canBulkUpdateTickets(Array.from(bulkSelectedTicketIds));
    if (!validation.allowed) {
      showError(validation.reason || 'Cannot change price for selected tickets');
      return;
    }
    if (!selected.length) return;
    
    if (selected.length === 1) {
      setPriceModalTicket(selected[0]);
      setNewPrice(getTicketListPrice(selected[0]) > 0 ? String(getTicketListPrice(selected[0])) : '');
      setShowPriceModal(true);
      return;
    }
    
    setBulkPriceModalTickets(selected);
    setBulkPrices(Object.fromEntries(selected.map((t) => [t.tpId, getTicketListPrice(t) > 0 ? String(getTicketListPrice(t)) : ''])));
    setBulkCommonPrice('');
    setShowBulkPriceModal(true);
  };

  const resolveVlActionTickets = (tpIdsOverride?: string[]) => {
    const tpIds = tpIdsOverride?.length ? tpIdsOverride : Array.from(bulkSelectedTicketIds);
    const tickets = getFilteredTickets().filter((t) => tpIds.includes(t.tpId));
    return { tpIds, tickets };
  };

  const prepareUserVlShareModal = async (tickets: Ticket[]) => {
    const initialPrices: Record<string, string> = {};
    const initialSections: Record<string, string> = {};
    const initialRows: Record<string, string> = {};
    const initialSeats: Record<string, string> = {};
    for (const ticket of tickets) {
      const price = getTicketListPrice(ticket);
      initialPrices[ticket.tpId] = price > 0 ? String(roundToFixed(price, 2)) : '';
      initialSections[ticket.tpId] = String(ticket.section || '');
      initialRows[ticket.tpId] = String(ticket.row || '');
      initialSeats[ticket.tpId] = String(ticket.seatNo ?? '');
    }
    setVlSharePrices(initialPrices);
    setVlShareSections(initialSections);
    setVlShareRows(initialRows);
    setVlShareSeats(initialSeats);
    setVlShareQaNotes('');
    const pricingMethods = [
      ...new Set(
        tickets
          .map((ticket) => normalizePricingMethod(ticket.tp_pricing_method))
          .filter((method): method is 'MANUAL' | 'FOLLOW_MARKET' => Boolean(method)),
      ),
    ];
    setVlSharePricingMethod(
      isSelfPricingClient()
        ? 'NONE'
        : pricingMethods.length === 1
          ? pricingMethods[0]
          : '',
    );
    const notesForTickets = await seatNotesWithTeamNames();
    const matchedSeatNotes = tickets.map((ticket) => {
      const seatNumbers = parseSeatNumbersFromRange(ticket.seatNo);
      const section = String(ticket.section || '').trim();
      const row = String(ticket.row || '').trim();
      if (!userId || !section || section === '-' || !row || row === '-' || !seatNumbers.length) return null;
      return findSeatLevelNoteForListing(notesForTickets, {
        userId: String(userId).trim(),
        teamId: String(ticket.lc_id || '').trim(),
        eventName: String(ticket.event || '').trim(),
        section,
        row,
        seatStart: seatNumbers[0],
        seatEnd: seatNumbers[seatNumbers.length - 1],
      });
    });
    const seats = matchedSeatNotes.every(Boolean)
      ? tickets.flatMap((ticket, index) => {
          const note = matchedSeatNotes[index];
          if (!note) return [];
          return expandListingSeatNumbers(ticket.seatNo).map((seat) => ({
            section: String(ticket.section || ''),
            row: String(ticket.row || ''),
            seat,
            internalNote: note.internalNote,
            externalNote: note.externalNote,
          }));
        })
      : [];
    const seeded = seats.length
      ? formatListingPopupNotes(seats)
      : {
          internalNotes: String(tickets[0]?.internalNotes || ''),
          externalNotes: String(tickets[0]?.externalNotes || ''),
        };
    const listingNotes = seedListingNoteFields({
      notes: notesForTickets,
      locations: ticketNoteLocations(tickets),
      seatNumbers: tickets.flatMap((ticket) => expandListingSeatNumbers(ticket.seatNo)),
      internalSeed: seeded.internalNotes,
      externalSeed: seeded.externalNotes,
    });
    const internalChoices = withListingAmenityNotes(listingNotes.internalChoices);
    const externalChoices = withListingAmenityNotes(listingNotes.externalChoices);
    const internalDraft = composeListingNoteDraft(
      listingNotes.internalQuery,
      internalChoices,
      listingNotes.customNote,
      'internal',
    );
    const externalDraft = composeListingNoteDraft(
      listingNotes.externalQuery,
      externalChoices,
      listingNotes.customNote,
      'external',
    );
    setVlShareInternalNoteChoices(internalChoices);
    setVlShareExternalNoteChoices(externalChoices);
    setVlShareListingCustom(listingNotes.customNote);
    setVlShareInternalNoteQuery(internalDraft.query);
    setVlShareExternalNoteQuery(externalDraft.query);
    setVlShareInternalNotes(internalDraft.sent);
    setVlShareExternalNotes(externalDraft.sent);
    setVlShareQaNotes('');
    setVlEnabledMarketplaces(VL_MARKETPLACE_OPTIONS.map((m) => m.id));
    setBulkSelectedTicketIds(new Set(tickets.map((ticket) => ticket.tpId).filter(Boolean)));
    setShowVlShareModal(true);
  };

  const handleVlProgressAction = async (tpIdsOverride?: string[]) => {
    const { tpIds, tickets } = resolveVlActionTickets(tpIdsOverride);
    if (!tpIds.length) {
      showInfo('No tickets selected');
      return;
    }
    setOpenActionTicketId(null);
    if (tpIdsOverride?.length) {
      setBulkSelectedTicketIds(new Set(tpIdsOverride));
    }

    const vlProgress = getVlProgressForUserTickets(tickets);
    if (!vlProgress) {
      showError(
        'VL action needs all selected tickets to share the same status: To Be Verified or Verified.',
      );
      return;
    }
    if (activeFilterTab !== 'Verification' && activeFilterTab !== 'All') {
      showError(
        vlProgress.step === 'confirm'
          ? 'Production ID confirmation is only available on the Verification (or All) filter.'
          : vlProgress.step === 'submit'
          ? 'Submit to VL is only available on the Verification (or All) filter.'
          : 'List on Marketplace is only available on the Verification (or All) filter.',
      );
      return;
    }

    if (vlProgress.step === 'confirm') {
      await openPidConfirmationForTickets(tickets);
      return;
    }

    if (vlProgress.step === 'share') {
      wrongPidFlowRef.current = null;
      await prepareUserVlShareModal(tickets);
      return;
    }

    // Submit step (Verification): create VL inventory directly (no second PID review).
    await executeSubmitListingsToVl(tpIds, tickets);
  };

  const handleShareVlListings = async () => {
    const tpIds = Array.from(bulkSelectedTicketIds);
    if (tpIds.length === 0) {
      showInfo('No tickets selected');
      return;
    }
    if (vlEnabledMarketplaces.length === 0) {
      showError('Select at least one marketplace, or cancel.');
      return;
    }
    if (
      !isSelfPricingClient() &&
      vlSharePricingMethod !== 'MANUAL' &&
      vlSharePricingMethod !== 'FOLLOW_MARKET' &&
      vlSharePricingMethod !== 'NONE'
    ) {
      showError('Please select a pricing method.');
      return;
    }

    const ticketsForBarcodeContext = getFilteredTickets().filter((ticket) => tpIds.includes(ticket.tpId));

    const listPriceByTpId: Record<string, number> = {};
    const sectionByTpId: Record<string, string> = {};
    const rowByTpId: Record<string, string> = {};
    const seatByTpId: Record<string, string> = {};
    for (const tpId of tpIds) {
      const raw = (vlSharePrices[tpId] ?? '').trim().replace(/,/g, '');
      const price = Number(raw);
      if (!Number.isFinite(price) || price <= 0) {
        showError('Enter a valid list price greater than 0 for each seat.');
        return;
      }
      const section = (vlShareSections[tpId] ?? '').trim();
      const row = (vlShareRows[tpId] ?? '').trim();
      const seat = (vlShareSeats[tpId] ?? '').trim();
      if (!section || !row || !seat) {
        showError('Enter section, row, and seat for each ticket.');
        return;
      }
      listPriceByTpId[tpId] = Number(roundToFixed(price, 2));
      sectionByTpId[tpId] = section;
      rowByTpId[tpId] = row;
      seatByTpId[tpId] = seat;
    }

    setVlShareLoading(true);
    beginVlBusy('Sharing listings on Victory Live…');
    let shouldAutoSyncBarcodes = false;
    const clearingWrongPid = wrongPidFlowRef.current === 'relist';
    try {
      const result = await shareVlListings(tpIds, {
        shareExchange: true,
        clearWrongPid: clearingWrongPid,
        enabledMarketplaceIds: vlEnabledMarketplaces,
        listPriceByTpId,
        sectionByTpId,
        rowByTpId,
        seatByTpId,
        internalNotes: vlShareInternalNotes,
        externalNotes: vlShareExternalNotes,
        pricingMethod: isSelfPricingClient()
          ? 'NONE'
          : vlSharePricingMethod === 'MANUAL' || vlSharePricingMethod === 'FOLLOW_MARKET'
            ? vlSharePricingMethod
            : 'NONE',
      });
      const toast = summarizeVlActionToast({
        actionLabel: 'Share',
        result,
        successMessage:
          result.results?.find((r) => r.status === 'success')?.message ||
          'All inventory is listed on all marketplaces.',
        extraFailNote:
          'Admin was not changed. Please try again, or use Sync from VL if Victory Live already listed them.',
      });
      const successfulTpIds = successfulVlTpIds(result);
      if (toast.type === 'success' || successfulTpIds.length) {
        const listedIds = successfulTpIds.length
          ? successfulTpIds
          : toast.type === 'success'
            ? tpIds
            : [];
        setCachedEnabledMarketplaceIdsForMany(listedIds, vlEnabledMarketplaces);
        listedIds.forEach((tpId) => {
          const savedVl = (result.results || []).find((row) => row.tpId === tpId && row.status === 'success');
          const savedListingId = String(savedVl?.vlListingId || '').trim();
          const savedItemId = String(savedVl?.vlItemId || '').trim();
          updateLocalTicket([tpId], {
            rawStatus: 'List',
            status: 'Listed',
            price: formatCurrency(listPriceByTpId[tpId]),
            section: sectionByTpId[tpId],
            row: rowByTpId[tpId],
            seatNo: seatByTpId[tpId],
            tp_pricing_method:
              isSelfPricingClient() || vlSharePricingMethod === 'NONE'
                ? null
                : vlSharePricingMethod === 'MANUAL' || vlSharePricingMethod === 'FOLLOW_MARKET'
                  ? vlSharePricingMethod
                  : null,
            internalNotes: vlShareInternalNotes,
            externalNotes: vlShareExternalNotes,
            ...(savedListingId ? { vlListingId: savedListingId } : {}),
            ...(savedItemId ? { vlItemId: savedItemId } : {}),
            ...(clearingWrongPid ? { tpWrongPid: false } : {}),
          });
        });
        if (clearingWrongPid) wrongPidFlowRef.current = null;
        if (toast.type === 'success') setActiveFilterTab('Listed');
        shouldAutoSyncBarcodes = toast.type === 'success';
        try {
          await refetchNotes();
          await refetchSeatLevelNotes();
        } catch {
          // Notes refresh is best-effort; listing already succeeded.
        }
      }
      const qaNote = vlShareQaNotes.trim();
      if (qaNote && userId) {
        try {
          await addNote({ variables: { userId, type: 'qa', content: qaNote } });
          await refetchNotes();
        } catch (noteError) {
          console.warn('Failed to save QA note from List on VL', noteError);
          showError('The QA note could not be saved. It was not sent to Victory Live.');
        }
      }
      showVlToast(toast);
      setShowVlShareModal(false);
      clearBulkSelection();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showVlToast(toastForVlCaughtError(error, 'Share', 'Failed to share listings on Victory Live'));
    } finally {
      setVlShareLoading(false);
      endVlBusy();
    }

    // After List on Marketplace succeeds, open barcode confirm gate (does not auto-crawl).
    if (shouldAutoSyncBarcodes) {
      await handleSyncBarcodes(tpIds, ticketsForBarcodeContext);
    }
  };

  /** Open VL production search to write/overwrite PID in DB only (no VL submit). */
  const handleOpenAddPid = async (tickets: Ticket[]) => {
    if (!tickets.length) {
      showInfo('No tickets selected');
      return;
    }
    setOpenActionTicketId(null);

    const pool = localTickets.length ? localTickets : tickets;
    const groupedTickets = expandUserTicketsToSameGroup(tickets, pool);
    const preferredEventId =
      tickets.map((ticket) => String(ticket.eventId || '').trim()).find(Boolean) ||
      groupedTickets.map((ticket) => String(ticket.eventId || '').trim()).find(Boolean) ||
      '';
    const scopedTickets = preferredEventId
      ? groupedTickets.filter((ticket) => String(ticket.eventId || '').trim() === preferredEventId)
      : groupedTickets;
    const addPidTickets = scopedTickets.length ? scopedTickets : groupedTickets;
    const eventIds = [
      ...new Set(addPidTickets.map((ticket) => String(ticket.eventId || '').trim()).filter(Boolean)),
    ];
    if (eventIds.length !== 1) {
      showError('Add PID for tickets from one event at a time.');
      return;
    }

    const ticketForEvent = addPidTickets.find((ticket) => ticket.eventId) || addPidTickets[0];
    const eventId = eventIds[0];
    const eventName = String(ticketForEvent?.event || '').trim();
    const venue = String(ticketForEvent?.venue || '').trim();
    const dateTbd = isEventDateTbdForVerification(ticketForEvent);
    const eventDate = dateTbd
      ? ''
      : formatVenueEventDateYmd(
          ticketForEvent?.eventDateRaw || ticketForEvent?.date,
          ticketForEvent?.eventTimeZone,
        ) || String(ticketForEvent?.eventDateRaw || ticketForEvent?.date || '').slice(0, 10);

    setVlProductionModalMode('add-pid');
    setVlProductionMismatch({
      code: 'VL_PRODUCTION_MISMATCH',
      eventId,
      eventName,
      venue,
      eventDate,
      reason:
        'Save the Production ID to QuickAsyst only. Ticket status stays the same and Victory Live is not updated.',
      queriesTried: [],
      candidates: [],
    });
    setVlProductionSearchQuery(eventName);
    setVlProductionSearchResults([]);
    setVlSelectedProductionId('');
    setVlEnteredProductionId('');
    setVlAddPidTab('search');
    setVlPendingSubmitTpIds(addPidTickets.map((ticket) => ticket.tpId));
    setShowVlProductionMapModal(true);
    setVlProductionSearchLoading(true);
    try {
      const result = await searchVlProductions({
        query: eventName || undefined,
        eventId,
        eventName: eventName || undefined,
        venue: venue || undefined,
        eventDate: eventDate || undefined,
      });
      setVlProductionSearchResults(result.productions || []);
      if (result.productions?.length) {
        setVlSelectedProductionId('');
        if (!result.suggestedProductionId && !result.productions.some((p) => p.isSuggested)) {
          showInfo(
            result.dateTbdMonths
              ? 'No exact Production ID match. Review Date TBD results (today through next 6 months) and pick the correct one.'
              : 'No exact Production ID match. Review all ±2 day results and pick the correct one.',
          );
        }
      } else {
        setVlSelectedProductionId('');
        showInfo('No Victory Live productions found for that search');
      }
    } catch (error: any) {
      showError(error?.message || 'Failed to search Victory Live productions');
    } finally {
      setVlProductionSearchLoading(false);
    }
  };

  const handleOpenProductionSync = async (tickets: Ticket[]) => {
    if (!tickets.length) {
      showInfo('No tickets selected');
      return;
    }
    setOpenActionTicketId(null);
    const ticketForEvent = tickets.find((t) => t.eventId) || tickets[0];
    const eventId = String(ticketForEvent?.eventId || '').trim();
    if (!eventId) {
      showError('Missing event id for production mapping');
      return;
    }
    const eventName = String(ticketForEvent?.event || '').trim();
    const venue = String(ticketForEvent?.venue || '').trim();
    const dateTbd = isEventDateTbdForVerification(ticketForEvent);
    const eventDate = dateTbd
      ? ''
      : formatVenueEventDateYmd(
          ticketForEvent?.eventDateRaw || ticketForEvent?.date,
          ticketForEvent?.eventTimeZone,
        ) || String(ticketForEvent?.eventDateRaw || ticketForEvent?.date || '').slice(0, 10);
    const tpIds = tickets.map((t) => t.tpId);

    setVlProductionModalMode('retry-submit');
    setVlProductionMismatch({
      code: 'VL_PRODUCTION_MISMATCH',
      eventId,
      eventName,
      venue,
      eventDate,
      reason: 'Overwrite the Victory Live production, then move tickets to Verified.',
      queriesTried: [],
      candidates: [],
    });
    setVlProductionSearchQuery(eventName);
    setVlProductionSearchResults([]);
    setVlSelectedProductionId('');
    setVlPendingSubmitTpIds(tpIds);
    setShowVlProductionMapModal(true);
    setVlProductionSearchLoading(true);
    try {
      const result = await searchVlProductions({
        query: eventName || undefined,
        eventId,
        eventName: eventName || undefined,
        venue: venue || undefined,
        eventDate: eventDate || undefined,
      });
      setVlProductionSearchResults(result.productions || []);
      if (result.productions?.length) {
        setVlSelectedProductionId('');
        if (!result.suggestedProductionId && !result.productions.some((p) => p.isSuggested)) {
          showInfo(
            result.dateTbdMonths
              ? 'No exact Production ID match. Review Date TBD results (today through next 6 months) and pick the correct one.'
              : 'No exact Production ID match. Review all ±2 day results and pick the correct one.',
          );
        }
      } else {
        setVlSelectedProductionId('');
        showInfo('No Victory Live productions found for that search');
      }
    } catch (error: any) {
      showError(error?.message || 'Failed to search Victory Live productions');
    } finally {
      setVlProductionSearchLoading(false);
    }
  };

  const executeSubmitListingsToVl = async (
    tpIds: string[],
    tickets: Ticket[],
    options?: { preserveStatus?: boolean; clearWrongPid?: boolean },
  ) => {
    beginVlBusy('Submitting to Victory Live…');
    try {
      const submitResult = await submitListingsToVl(tpIds, {
        defaultListPrice: 9999,
        preserveStatus: options?.preserveStatus,
        clearWrongPid: options?.clearWrongPid,
      });
      const mismatch =
        submitResult.results?.find((r) => r.code === 'VL_PRODUCTION_MISMATCH' && r.productionMismatch)
          ?.productionMismatch ||
        (submitResult.code === 'VL_PRODUCTION_MISMATCH' ? submitResult.details : null);

      if (mismatch?.eventId) {
        showInfo(
          mismatch.reason ||
            'No exact Victory Live production match. Map the correct production, then retry Submit.',
        );
        await handleOpenProductionSync(tickets);
        return { remapped: true };
      }

      const toast = summarizeVlActionToast({
        actionLabel: 'Submit',
        result: submitResult,
        successMessage: options?.preserveStatus
          ? `Created Victory Live inventory for ${submitResult.successCount || 0} seat(s). Status stays Listed.`
          : `Submitted ${submitResult.successCount || 0} seat(s) to Victory Live → Verified`,
        extraFailNote: submitResult.results?.some((r) =>
          String(r.message || '').toLowerCase().includes('vl ok but db'),
        )
          ? 'Admin was not updated — use Sync from VL if inventory already exists on Victory Live.'
          : undefined,
      });
      const okIds = successfulVlTpIds(submitResult);
      for (const row of submitResult.results || []) {
        if (row.status !== 'success' || !row.tpId) continue;
        const listingId = String(row.vlListingId || row.vlTicketGroupId || '').trim();
        const itemId = String(row.vlItemId || '').trim();
        if (!listingId && !itemId && options?.preserveStatus) continue;
        updateLocalTicket([row.tpId], {
          ...(!options?.preserveStatus ? { rawStatus: 'Verified', status: 'Verified' } : {}),
          ...(listingId ? { vlListingId: listingId } : {}),
          ...(itemId ? { vlItemId: itemId } : {}),
          ...(options?.clearWrongPid ? { tpWrongPid: false } : {}),
        });
      }
      if (okIds.length && !options?.preserveStatus && !(submitResult.results || []).some((row) => row.status === 'success')) {
        updateLocalTicket(okIds, {
          rawStatus: 'Verified',
          status: 'Verified',
          ...(options?.clearWrongPid ? { tpWrongPid: false } : {}),
        });
      }
      showVlToast(toast);
      clearBulkSelection();
      await refreshTicketsAndNotifications();
      const fullySucceeded =
        (submitResult.failedCount || 0) === 0 &&
        (submitResult.unknownCount || 0) === 0 &&
        (submitResult.successCount || 0) > 0;
      return { remapped: false, fullySucceeded };
    } catch (error: any) {
      showVlToast(toastForVlCaughtError(error, 'Submit', 'Failed to submit to Victory Live'));
      return { remapped: false, fullySucceeded: false };
    } finally {
      endVlBusy();
    }
  };

  const openPidConfirmationForTickets = async (tickets: Ticket[]) => {
    if (!tickets.length) return;
    const eventIds = [
      ...new Set(tickets.map((ticket) => String(ticket.eventId || '').trim()).filter(Boolean)),
    ];
    if (eventIds.length !== 1) {
      showError('Verify tickets from one event at a time so its Production ID can be confirmed.');
      return;
    }

    const ticket = tickets[0];
    const eventId = eventIds[0];
    const eventName = String(ticket.event || '').trim();
    const venue = String(ticket.venue || '').trim();
    const dateTbd = isEventDateTbdForVerification(ticket);
    const eventDate = dateTbd
      ? ''
      : formatVenueEventDateYmd(ticket.eventDateRaw, ticket.eventTimeZone) ||
        String(ticket.eventDateRaw || '').slice(0, 10);
    const context: ProductionMismatchDetails = {
      code: 'VL_PRODUCTION_MISMATCH',
      eventId,
      eventName,
      venue,
      eventDate,
      reason:
        'Select the correct Production ID. Submit to VL and Mark Verified saves the PID and creates Victory Live inventory.',
      queriesTried: [],
      candidates: [],
    };

    setVlProductionModalMode('confirm');
    setVlProductionMismatch(context);
    setVlProductionSearchQuery(eventName);
    setVlProductionSearchResults([]);
    setVlSelectedProductionId('');
    setVlPendingSubmitTpIds(tickets.map((row) => row.tpId));
    setShowVlProductionMapModal(true);
    setVlProductionSearchLoading(true);
    try {
      const result = await searchVlProductions({
        eventId,
        eventName,
        venue,
        eventDate: eventDate || undefined,
      });
      const productions = result.productions || [];
      setVlProductionSearchResults(productions);
      setVlSelectedProductionId('');
      const tbdWindow =
        result.eventDateStart && result.eventDateEnd
          ? `${result.eventDateStart} to ${result.eventDateEnd}`
          : 'today through the next 6 months';
      if (!productions.length) {
        showInfo(
          dateTbd || result.dateTbdMonths
            ? `No matching Victory Live production found for Date TBD (${tbdWindow}). Search again or escalate.`
            : 'No matching Victory Live production found within ±2 days. Search again or escalate.',
        );
      } else if (!result.suggestedProductionId && !productions.some((p) => p.isSuggested)) {
        showInfo(
          dateTbd || result.dateTbdMonths
            ? `No exact Production ID match. Review Date TBD results (${tbdWindow}) and pick the correct one.`
            : 'No exact Production ID match. Review all ±2 day results and pick the correct one.',
        );
      }
    } catch (error: any) {
      showError(
        error?.message ||
          'Production ID search failed. Status stays To Be Verified until a PID is confirmed.',
      );
    } finally {
      setVlProductionSearchLoading(false);
    }
  };

  const handleSearchVlProductions = async () => {
    if (!vlProductionMismatch?.eventId && !vlProductionSearchQuery.trim()) {
      showError('Enter an event/venue/date search');
      return;
    }
    setVlProductionSearchLoading(true);
    try {
      const result = await searchVlProductions({
        query: vlProductionSearchQuery.trim() || undefined,
        eventId: vlProductionMismatch?.eventId,
        eventName: vlProductionMismatch?.eventName,
        venue: vlProductionMismatch?.venue,
        eventDate: vlProductionMismatch?.eventDate,
      });
      setVlProductionSearchResults(result.productions || []);
      if (result.productions?.length) {
        setVlSelectedProductionId('');
        if (!result.suggestedProductionId && !result.productions.some((p) => p.isSuggested)) {
          showInfo(
            result.dateTbdMonths
              ? 'No exact Production ID match. Review Date TBD results (today through next 6 months) and pick the correct one.'
              : 'No exact Production ID match. Review all ±2 day results and pick the correct one.',
          );
        }
      } else {
        setVlSelectedProductionId('');
        showInfo('No Victory Live productions found for that search');
      }
    } catch (error: any) {
      showError(error?.message || 'Failed to search Victory Live productions');
    } finally {
      setVlProductionSearchLoading(false);
    }
  };

  const handleMapVlProductionAndRetry = async () => {
    const eventId = vlProductionMismatch?.eventId;
    const isAddPidOnly = vlProductionModalMode === 'add-pid';
    const wrongPidFlow = wrongPidFlowRef.current;
    const keepCurrentStatus = wrongPidFlow === 'relist';
    const usingEnteredPid = isAddPidOnly && vlAddPidTab === 'enter';
    const productionId = (
      usingEnteredPid ? vlEnteredProductionId : vlSelectedProductionId
    ).trim();
    if (!eventId) {
      showError('Missing event id for production mapping');
      return;
    }
    if (!/^\d+$/.test(productionId)) {
      showError(
        usingEnteredPid
          ? 'Enter a valid numeric Production ID'
          : 'Select a Victory Live production id',
      );
      return;
    }

    setVlProductionMapLoading(true);
    beginVlBusy('Saving Production ID…');
    let shouldSubmitToVl = false;
    let submitTpIds: string[] = [];
    let ticketsForSubmit: Ticket[] = [];
    try {
      let tpIds = vlPendingSubmitTpIds.length
        ? vlPendingSubmitTpIds
        : Array.from(bulkSelectedTicketIds);
      if (!tpIds.length) {
        throw new Error(
          isAddPidOnly
            ? 'No tickets selected for Add PID'
            : vlProductionModalMode === 'confirm'
              ? 'No tickets selected for Submit to VL'
              : 'No tickets selected for production overwrite',
        );
      }

      if (isAddPidOnly) {
        const seedTickets = localTickets.filter((ticket) => tpIds.includes(ticket.tpId));
        const expanded = expandUserTicketsToSameGroup(
          seedTickets.length ? seedTickets : [],
          localTickets,
        ).filter((ticket) => String(ticket.eventId || '').trim() === eventId);
        if (expanded.length) {
          tpIds = expanded.map((ticket) => ticket.tpId).filter(Boolean);
        }
      }

      const selectedProduction = vlProductionSearchResults.find(
        (row) => String(row.productionId) === productionId,
      );
      const result = await confirmVlProduction({
        eventId,
        productionId,
        ticketPlacementIds: tpIds,
        stubhubId: selectedProduction?.stubhubId ?? null,
        seatgeekId: selectedProduction?.seatgeekId ?? null,
        ...(isAddPidOnly || keepCurrentStatus ? { savePidOnly: true } : {}),
      });
      const effectiveEventId = String(result.eventId || eventId).trim();
      const stubhubId =
        selectedProduction?.stubhubId ?? result.production?.stubhubId ?? null;
      const seatgeekId =
        selectedProduction?.seatgeekId ?? result.production?.seatgeekId ?? null;

      const confirmedSet = new Set(
        Array.isArray(result.ticketPlacementIds) && result.ticketPlacementIds.length
          ? result.ticketPlacementIds.map((id: string) => String(id))
          : tpIds,
      );

      if (isAddPidOnly) {
        const patchPidOnly = (ticket: Ticket) =>
          confirmedSet.has(ticket.tpId)
            ? {
                ...ticket,
                eventId: effectiveEventId || ticket.eventId,
                confirmedVlProductionId: productionId,
                stubhubId: stubhubId ?? ticket.stubhubId,
                seatgeekId: seatgeekId ?? ticket.seatgeekId,
                confirmationMessage: result.confirmationMessage || 'PID Saved',
                pidConfirmedAt: result.confirmedAt,
              }
            : ticket;
        setLocalTickets((prev) => sortUserDetailTickets(prev.map(patchPidOnly)));
        showSuccess(
          result.message ||
            `Production ${productionId} saved to QuickAsyst. Victory Live was not updated.`,
        );
        wrongPidFlowRef.current = null;
        setShowVlProductionMapModal(false);
        setVlProductionMismatch(null);
        setVlPendingSubmitTpIds([]);
        clearBulkSelection();
        return;
      }

      const patchAfterConfirm = (ticket: Ticket) => {
        if (confirmedSet.has(ticket.tpId)) {
          return {
            ...ticket,
            ...(keepCurrentStatus ? {} : { rawStatus: 'Verified', status: 'Verified' }),
            eventId: effectiveEventId || ticket.eventId,
            confirmedVlProductionId: productionId,
            stubhubId: stubhubId ?? ticket.stubhubId,
            seatgeekId: seatgeekId ?? ticket.seatgeekId,
            confirmationMessage: keepCurrentStatus ? ticket.confirmationMessage : 'PID Confirmed',
            pidConfirmedAt: result.confirmedAt,
          };
        }
        return ticket;
      };
      ticketsForSubmit = (
        tpIds
          .map((tpId) => localTickets.find((ticket) => ticket.tpId === tpId))
          .filter((ticket): ticket is Ticket => Boolean(ticket))
      ).map(patchAfterConfirm);
      if (!keepCurrentStatus) {
        setLocalTickets((prev) => sortUserDetailTickets(prev.map(patchAfterConfirm)));
      }
      if (vlProductionModalMode === 'retry-submit' && !keepCurrentStatus) {
        clearBulkSelection();
        setActiveFilterTab('Verification');
      }
      shouldSubmitToVl = true;
      submitTpIds = tpIds;
    } catch (error: any) {
      showError(error?.message || (isAddPidOnly ? 'Failed to save Production ID' : 'Failed to map production'));
    } finally {
      endVlBusy();
      if (!shouldSubmitToVl) {
        setVlProductionMapLoading(false);
      }
    }

    // Keep the PID modal + top loader visible until inventory is created.
    if (shouldSubmitToVl && submitTpIds.length) {
      try {
        const submitOutcome = await executeSubmitListingsToVl(submitTpIds, ticketsForSubmit, {
          preserveStatus: wrongPidFlow === 'relist',
          clearWrongPid: wrongPidFlow === 'resubmit',
        });
        if (wrongPidFlow === 'relist' && submitOutcome?.fullySucceeded) {
          wrongPidFlowRef.current = 'relist';
          const relistTickets = ticketsForSubmit.length
            ? ticketsForSubmit
            : localTickets.filter((ticket) => submitTpIds.includes(ticket.tpId));
          await prepareUserVlShareModal(relistTickets);
        } else if (!submitOutcome?.remapped) {
          wrongPidFlowRef.current = null;
        }
        if (!submitOutcome?.remapped) {
          setShowVlProductionMapModal(false);
          setVlProductionMismatch(null);
          setVlPendingSubmitTpIds([]);
        }
      } finally {
        setVlProductionMapLoading(false);
      }
    }
  };

  const openSyncFromVlScopeModal = (tpIdsOverride?: string[]) => {
    const { tpIds, tickets } = resolveVlActionTickets(tpIdsOverride);
    if (!tpIds.length) {
      showInfo('No tickets selected');
      return;
    }
    setOpenActionTicketId(null);
    const statuses = tickets.map((t) => normalizeStatusValue(t.rawStatus || t.status));
    if (!statuses.every((s) => s === 'ToBeVerified' || s === 'Verified' || s === 'List')) {
      showError('Sync from VL requires To Be Verified, Verified, or Listed tickets');
      return;
    }
    setSyncFromVlScopeTpIds(tpIds);
    setShowSyncFromVlScopeModal(true);
  };

  const handleSyncVlGroups = async (
    tpIdsOverride?: string[],
    syncScope?: SyncFromVlScope | SyncFromVlScope[],
  ) => {
    const { tpIds, tickets } = resolveVlActionTickets(tpIdsOverride);
    if (!tpIds.length) {
      showInfo('No tickets selected');
      return;
    }
    if (!syncScope) {
      openSyncFromVlScopeModal(tpIds);
      return;
    }
    const syncScopes = Array.isArray(syncScope) ? syncScope : [syncScope];
    if (syncScopes.length === 0) {
      showError('Select at least one item to sync');
      return;
    }
    setOpenActionTicketId(null);
    const statuses = tickets.map((t) => normalizeStatusValue(t.rawStatus || t.status));
    if (!statuses.every((s) => s === 'ToBeVerified' || s === 'Verified' || s === 'List')) {
      showError('Sync from VL requires To Be Verified, Verified, or Listed tickets');
      return;
    }
    beginVlBusy('Syncing from Victory Live…');
    setSyncFromVlConfirming(true);
    const scopeLabel = syncScopes.map((scope) => scope.replace(/_/g, ' ')).join(', ');
    const shareOnly = syncScopes.length === 1 && syncScopes[0] === 'share_status';
    try {
      const result = await syncVlListingStatus(tpIds, { syncScope: syncScopes });
      const successCount = result.successCount || 0;
      const unchangedCount = result.unchangedCount || 0;
      const listingUpdates = (result.results || []).filter(
        (r) => r.vlListingId && !isVlUnknownStatus(r.status) && String(r.status || '').toLowerCase() !== 'failed',
      );

      for (const row of result.results || []) {
        if (isVlUnknownStatus(row.status) || String(row.status || '').toLowerCase() === 'failed') continue;
        if (row.enabledMarketplaceIds?.length) {
          setCachedEnabledMarketplaceIds(row.tpId, row.enabledMarketplaceIds);
        }
        if (row.shared != null) {
          setCachedVlSharedStatus(row.tpId, row.shared);
        } else if (
          !shareOnly &&
          (row.newStatus === 'List' || row.newStatus === 'Verified')
        ) {
          setCachedVlSharedStatus(row.tpId, row.newStatus === 'List');
        }
      }

      setLocalTickets((prev) =>
        prev.map((ticket) => {
          const row = result.results?.find((r) => r.tpId === ticket.tpId);
          if (!row) return ticket;
          if (isVlUnknownStatus(row.status) || String(row.status || '').toLowerCase() === 'failed') return ticket;
          const next: Ticket = {
            ...ticket,
            ...(row.vlListingId ? { vlListingId: String(row.vlListingId) } : {}),
            ...(row.vlItemId ? { vlItemId: String(row.vlItemId) } : {}),
            ...(row.barcode != null
              ? { barcode: row.barcode, barcodeAttached: Boolean(row.barcode) }
              : {}),
            ...(row.section != null ? { section: String(row.section) } : {}),
            ...(row.row != null ? { row: String(row.row) } : {}),
            ...(row.seat != null ? { seatNo: String(row.seat) } : {}),
            ...(row.onHold != null ? { on_hold: row.onHold } : {}),
            ...(row.eventName ? { event: row.eventName } : {}),
            ...(row.venue ? { venue: row.venue } : {}),
            ...(row.productionId ? { confirmedVlProductionId: String(row.productionId) } : {}),
            ...(row.listPrice != null && Number.isFinite(Number(row.listPrice))
              ? { price: formatCurrency(Number(row.listPrice)) }
              : {}),
            ...(row.internalNotes != null ? { internalNotes: row.internalNotes } : {}),
            ...(row.externalNotes != null ? { externalNotes: row.externalNotes } : {}),
          };
          if (
            row.newStatus &&
            !shareOnly &&
            (row.status === 'success' || row.status === 'unchanged') &&
            !(String(ticket.rawStatus || '') === 'List' && row.newStatus === 'Verified')
          ) {
            next.rawStatus = row.newStatus;
            next.status = getStatusLabel(row.newStatus);
          }
          return next;
        }),
      );

      showVlToast(
        summarizeVlActionToast({
          actionLabel: `Sync from VL (${scopeLabel})`,
          result,
          successMessage:
            listingUpdates.length > 0 && syncScopes.length === 1 && syncScopes[0] === 'merge_split'
              ? `Synced ${listingUpdates.length} seat(s) from Victory Live` +
                (unchangedCount ? ` (${unchangedCount} already current)` : '')
              : `Synced ${successCount} seat(s) — ${scopeLabel}` +
                (unchangedCount ? ` (${unchangedCount} already current)` : ''),
          skipMessage: unchangedCount
            ? `No Victory Live ${scopeLabel} changes found (${unchangedCount} already current)`
            : result.message || `No Victory Live ${scopeLabel} changes found`,
        }),
      );
      setShowSyncFromVlScopeModal(false);
      clearBulkSelection();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showVlToast(toastForVlCaughtError(error, 'Sync from VL', 'Failed to sync from Victory Live'));
    } finally {
      setSyncFromVlConfirming(false);
      endVlBusy();
    }
  };

  const openBarcodeSyncConfirm = async (ticketsForContext?: Ticket[]) => {
    setOpenActionTicketId(null);
    setShowBarcodeSyncConfirmModal(true);
    setBarcodeSyncRecommendLoading(true);
    setBarcodeSyncRecommendError(null);
    setBarcodeSyncRecommendation(null);
    try {
      const ticket = ticketsForContext?.[0];
      const recommendation = await recommendBarcodeSyncAccounts({
        eventName: ticket?.event ? String(ticket.event) : undefined,
        venue: ticket?.venue ? String(ticket.venue) : undefined,
        league: ticket?.league ? String(ticket.league) : undefined,
        eventId: ticket?.eventId,
      });
      setBarcodeSyncRecommendation(recommendation);
    } catch (error: any) {
      setBarcodeSyncRecommendError(error?.message || 'Failed to load recommended barcode accounts');
    } finally {
      setBarcodeSyncRecommendLoading(false);
    }
  };

  const buildBarcodeSyncFailures = (result: CheckBarcodesResult): string[] => {
    const tickets = getFilteredTickets();
    const qaBarcodeByTpId = new Map(
      tickets.map((ticket) => [String(ticket.tpId), String(ticket.barcode || '').trim()]),
    );
    const failures: string[] = [];
    for (const seat of result.seats || []) {
      const seatLabel = `Sec ${seat.section || '—'} / Row ${seat.row || '—'} / Seat ${seat.seat ?? '—'}`;
      const vlBarcode = String(seat.barcode || '').trim();
      const qaBarcode = qaBarcodeByTpId.get(String(seat.tpId)) || '';
      if (!seat.barcodeAttached) {
        failures.push(`${seatLabel}: missing barcode on Victory Live`);
        continue;
      }
      if (qaBarcode && vlBarcode && qaBarcode !== vlBarcode) {
        failures.push(
          `${seatLabel}: barcode mismatch (QuickAsyst: ${qaBarcode}; Victory Live: ${vlBarcode})`,
        );
      }
    }
    return failures;
  };

  const confirmBarcodeSync = async (accountIds: string[]) => {
    if (!accountIds.length) {
      showInfo('Select at least one account to sync');
      return;
    }
    if (!barcodeSyncTargetTpIds.length) {
      showError('Select at least one seat before Sync Barcodes so verification can run after crawl.');
      return;
    }
    setBarcodeSyncConfirming(true);
    beginVlBusy('Starting Victory Live account crawl…');
    try {
      const crawl = await startVlAccountCrawl({
        accountIds,
        ticketPlacementIds: barcodeSyncTargetTpIds,
      });
      const crawlResults = (crawl.results || []).map((row) => ({
        accountId: row.accountId,
        status: row.success ? 'processing' as const : 'failed' as const,
        message: row.success ? 'Crawl started on Victory Live' : (row.message || 'Failed to start crawl'),
        username: row.username,
        marketplaceName: row.marketplaceName,
      }));
      const startedAccountIds = crawlResults
        .filter((row) => row.status === 'processing')
        .map((row) => row.accountId);

      setShowBarcodeSyncConfirmModal(false);
      setShowCheckBarcodesModal(false);
      setCheckBarcodesResult(null);
      setShowBarcodeSyncSummaryModal(true);
      setBarcodeSyncSummary({
        phase: 'crawling',
        accountIds: crawl.accountIds || accountIds,
        crawlMessage: crawl.message || 'Crawl requested. Waiting for Victory Live to finish…',
        crawlResults,
      });

      if (!startedAccountIds.length) {
        setBarcodeSyncSummary((prev) =>
          prev
            ? {
                ...prev,
                phase: 'failure',
                crawlMessage: 'Crawl did not start.',
                verificationMessage: 'Could not start crawl for any selected account.',
              }
            : prev,
        );
        showError(crawl.message || 'Failed to start Victory Live account crawl');
        return;
      }

      const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
      const maxPollAttempts = 120;
      let statusDone = false;
      for (let attempt = 0; attempt < maxPollAttempts; attempt += 1) {
        const status = await getVlAccountCrawlStatus(startedAccountIds);
        setBarcodeSyncSummary((prev) =>
          prev
            ? {
                ...prev,
                phase: 'crawling',
                crawlMessage: `Crawl in progress: ${status.processingCount} processing, ${status.completedCount} completed, ${status.failedCount} failed.`,
                crawlResults: status.results.map((row) => ({
                  accountId: row.accountId,
                  status: row.status,
                  crawlStatus: row.crawlStatus,
                  message: row.message || row.lastErrorMessage || row.crawlStatus || undefined,
                  username: prev.crawlResults.find((item) => item.accountId === row.accountId)?.username,
                  marketplaceName: prev.crawlResults.find((item) => item.accountId === row.accountId)?.marketplaceName,
                })),
              }
            : prev,
        );
        if (status.complete) {
          statusDone = true;
          break;
        }
        await sleep(5000);
      }

      if (!statusDone) {
        setBarcodeSyncSummary((prev) =>
          prev
            ? {
                ...prev,
                phase: 'failure',
                crawlMessage: 'Timed out waiting for Victory Live crawl to complete.',
                verificationMessage: 'Timed out waiting for Victory Live crawl to complete.',
              }
            : prev,
        );
        showError('Timed out while waiting for crawl completion. Please retry Check Barcodes.');
        return;
      }

      setBarcodeSyncSummary((prev) =>
        prev
          ? {
              ...prev,
              phase: 'verifying',
              crawlMessage: 'Crawl completed on Victory Live.',
              verificationMessage: 'Crawl completed. Verifying seat barcodes…',
            }
          : prev,
      );

      const eventId = String(
        getFilteredTickets().find((ticket) => barcodeSyncTargetTpIds.includes(ticket.tpId))?.eventId || '',
      ).trim();
      const verification = await checkVlBarcodes(
        barcodeSyncTargetTpIds,
        eventId
          ? { eventId, persist: true, logVerification: true }
          : { persist: true, logVerification: true },
      );
      const failures = buildBarcodeSyncFailures(verification);

      setShowCheckBarcodesModal(false);
      setCheckBarcodesResult(null);
      setBarcodeSyncSummary((prev) =>
        prev
          ? {
              ...prev,
              phase: failures.length ? 'failure' : 'success',
              crawlMessage: 'Crawl completed on Victory Live.',
              verificationResult: verification,
              failures,
              verificationMessage: failures.length
                ? `${failures.length} seat(s) failed barcode verification.`
                : `Success: all ${verification.total} seat(s) have matching barcodes in Victory Live.`,
            }
          : prev,
      );

      if (failures.length) {
        showError(`${failures.length} seat(s) failed barcode verification`);
      } else {
        showSuccess(`Barcode sync complete: all ${verification.total} seat(s) verified`);
      }
      void refetchTickets();
    } catch (error: any) {
      const message = error?.message || 'Failed to sync barcodes';
      setBarcodeSyncSummary((prev) =>
        prev
          ? {
              ...prev,
              phase: 'failure',
              crawlMessage:
                prev.phase === 'crawling'
                  ? 'Crawl stopped with an error.'
                  : 'Crawl completed on Victory Live.',
              verificationMessage: message,
            }
          : prev,
      );
      showError(message);
    } finally {
      setBarcodeSyncConfirming(false);
      endVlBusy();
    }
  };

  const handleSyncBarcodes = async (_tpIdsOverride?: string[], ticketsForContext?: Ticket[]) => {
    const tpIds = _tpIdsOverride?.length
      ? _tpIdsOverride
      : ticketsForContext?.length
        ? ticketsForContext.map((ticket) => ticket.tpId).filter(Boolean)
        : resolveVlActionTickets().tpIds;
    if (!tpIds.length) {
      showInfo('Select at least one seat before Sync Barcodes');
      return;
    }
    const tickets =
      ticketsForContext ||
      getFilteredTickets().filter((ticket) => tpIds.includes(ticket.tpId));
    setBarcodeSyncTargetTpIds(tpIds);
    setBarcodeSyncSummary(null);
    setShowBarcodeSyncSummaryModal(false);
    setShowCheckBarcodesModal(false);
    setCheckBarcodesResult(null);
    await openBarcodeSyncConfirm(tickets.length ? tickets : undefined);
  };

  const handleCheckBarcodes = async (tpIdsOverride?: string[]) => {
    if (barcodeSyncSummary?.phase === 'crawling' || barcodeSyncSummary?.phase === 'verifying') {
      showInfo('Barcode crawl is in progress. Wait for completion before running Check Barcodes.');
      return;
    }
    const resolved = resolveVlActionTickets(tpIdsOverride);
    const tpIds = resolved.tpIds.length
      ? resolved.tpIds
      : resolved.tickets.map((t) => t.tpId).filter(Boolean);
    if (!tpIds.length) {
      showInfo('No tickets selected');
      return;
    }
    const eventId = String(resolved.tickets[0]?.eventId || '').trim();
    closeTicketActionMenu();
    setShowBarcodeSyncSummaryModal(false);
    setShowCheckBarcodesModal(true);
    setCheckBarcodesLoading(true);
    setCheckBarcodesError(null);
    setCheckBarcodesResult(null);
    try {
      const result = await checkVlBarcodes(tpIds, eventId ? { eventId } : undefined);
      setCheckBarcodesResult(result);
      void refetchTickets();
    } catch (error: any) {
      setCheckBarcodesError(error?.message || 'Failed to check barcodes');
    } finally {
      setCheckBarcodesLoading(false);
    }
  };

  const isUserConciergeClient = () => {
    const pricingMode = String(effectiveUserRecord?.u_pricing_mode || '').trim().toLowerCase();
    if (pricingMode === 'concierge') return true;
    if (pricingMode === 'self-pricing') return false;
    return getUserDetailCsvClientType() === 'Concierge';
  };

  const isSelfPricingClient = () => {
    const pricingMode = String(effectiveUserRecord?.u_pricing_mode || '').trim().toLowerCase();
    if (pricingMode === 'self-pricing') return true;
    if (pricingMode === 'concierge') return false;
    return currentUser?.type === 'Self Pricing';
  };

  const cancelSelfPricingPriceConfirm = () => {
    if (priceModalLoading || bulkPriceLoading) return;
    selfPricingPriceConfirmActionRef.current = null;
    setShowSelfPricingPriceConfirm(false);
    setSelfPricingPriceConfirmSummary('');
  };

  const confirmSelfPricingPriceChange = async () => {
    const action = selfPricingPriceConfirmActionRef.current;
    if (!action) return;
    try {
      await action();
    } finally {
      selfPricingPriceConfirmActionRef.current = null;
      setShowSelfPricingPriceConfirm(false);
      setSelfPricingPriceConfirmSummary('');
    }
  };

  const cancelNonVlStatusConfirm = () => {
    if (bulkStatusChangeLoading || changeStatusLoading || listedModalLoading) return;
    nonVlStatusConfirmActionRef.current = null;
    setShowNonVlStatusConfirm(false);
    setNonVlStatusConfirmSummary('');
  };

  const confirmNonVlStatusChange = async () => {
    const action = nonVlStatusConfirmActionRef.current;
    if (!action) return;
    try {
      await action();
    } finally {
      nonVlStatusConfirmActionRef.current = null;
      setShowNonVlStatusConfirm(false);
      setNonVlStatusConfirmSummary('');
    }
  };

  const handleRefreshConciergePrices = async (tpIdsOverride?: string[]) => {
    const { tpIds, tickets } = resolveVlActionTickets(tpIdsOverride);
    if (!tpIds.length) {
      showInfo('No tickets selected');
      return;
    }
    setOpenActionTicketId(null);
    const listed = tickets.filter((t) => normalizeStatusValue(t.rawStatus || t.status) === 'List');
    if (!listed.length) {
      showError('Refresh VL prices requires Listed tickets');
      return;
    }

    beginVlBusy('Refreshing list prices from Victory Live…');
    try {
      const result = await syncConciergeVlPrices(
        listed.map((t) => t.tpId),
        { includeAllHistory: true },
      );
      const successCount = result.successCount || 0;
      const unchangedCount = result.unchangedCount || 0;
      const upCount = result.upCount || 0;
      const downCount = result.downCount || 0;

      setLocalTickets((prev) =>
        prev.map((ticket) => {
          const row = result.results?.find((r) => r.tpId === ticket.tpId);
          if (!row || row.newPrice == null) return ticket;
          if (
            row.status === 'skipped' ||
            row.status === 'failed' ||
            isVlUnknownStatus(row.status)
          ) {
            return ticket;
          }
          return {
            ...ticket,
            price: formatCurrency(Number(row.newPrice)),
            ...(row.vlListingId ? { vlListingId: String(row.vlListingId) } : {}),
            ...(row.vlItemId ? { vlItemId: String(row.vlItemId) } : {}),
          };
        }),
      );

      setConciergePriceResults(result.results || []);
      setConciergeRecentChanges(result.recentChanges || []);
      setShowConciergePriceModal(true);

      showVlToast(
        summarizeVlActionToast({
          actionLabel: 'Refresh VL prices',
          result,
          successMessage:
            `Updated ${successCount} price(s): ${upCount} up, ${downCount} down` +
            (unchangedCount ? `; ${unchangedCount} unchanged` : ''),
          skipMessage: unchangedCount
            ? `No price changes (${unchangedCount} already current)`
            : result.message || 'No concierge price updates',
        }),
      );
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showVlToast(toastForVlCaughtError(error, 'Refresh VL prices', 'Failed to refresh concierge prices'));
    } finally {
      endVlBusy();
    }
  };

  const closeTicketActionMenu = () => {
    setOpenActionTicketId(null);
  };

  const renderVlRowActionItems = (tickets: Ticket[], filterTab: string) => {
    if (!tickets.length) return null;
    const statuses = tickets.map((t) => normalizeStatusValue(t.rawStatus || t.status));
    const unique = [...new Set(statuses)];
    if (unique.length !== 1) return null;
    const status = unique[0];
    const tpIds = tickets.map((t) => t.tpId);
    const hasVlIds = tickets.every((t) => Boolean(t.vlListingId || t.vlItemId));
    const vlProgress = getVlProgressForUserTickets(tickets);
    const items: React.ReactNode[] = [];
    const tabAllowsProgress = filterTab === 'Verification' || filterTab === 'All';

    if (tabAllowsProgress && vlProgress) {
      items.push(
        <button
          key="vl-progress"
          className={styles.ticketActionItem}
          disabled={isTicketTableBusy}
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            void handleVlProgressAction(tpIds);
          }}
        >
          {vlProgress.step === 'submit' ? <ExternalLink size={14} /> : <Share2 size={14} />}
          {' '}
          {vlProgress.label}
        </button>,
      );
    }

    // Verified with a mapped PID can still overwrite/remap (failed submit, wrong event, etc.).
    const hasMappedPid = tickets.every((ticket) => {
      const pid = String(getUserTicketVlProductionId(ticket) || '').trim();
      return Boolean(pid && /^\d+$/.test(pid));
    });
    if (
      status === 'Verified' &&
      (filterTab === 'Verification' || filterTab === 'All') &&
      hasMappedPid
    ) {
      items.push(
        <button
          key="vl-remap-production"
          className={styles.ticketActionItem}
          disabled={isTicketTableBusy}
          title="Overwrite the mapped Victory Live Production ID, then resubmit inventory"
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            void handleOpenProductionSync(tickets);
          }}
        >
          <MapPinned size={14} /> Remap PID
        </button>,
      );
    }

    if (
      (status === 'ToBeVerified' || status === 'Verified' || status === 'List') &&
      (filterTab === 'Verification' || filterTab === 'Listed' || filterTab === 'All')
    ) {
      items.push(
        <button
          key="vl-add-pid"
          className={styles.ticketActionItem}
          disabled={isTicketTableBusy}
          title="Save Production ID for the whole ticket group in QuickAsyst only (does not update Victory Live)"
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            void handleOpenAddPid(tickets);
          }}
        >
          <MapPinned size={14} /> Add PID
        </button>,
      );
    }

    if (status === 'ToBeVerified' || status === 'Verified' || status === 'List') {
      items.push(
        <button
          key="vl-sync"
          className={styles.ticketActionItem}
          disabled={isTicketTableBusy}
          title="Choose what to sync from Victory Live (merge/split, barcode, price, notes, …)"
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            openSyncFromVlScopeModal(tpIds);
          }}
        >
          <RefreshCcw size={14} /> Sync from VL
        </button>,
      );
      if (hasVlIds) {
        items.push(
          <button
            key="vl-check-barcodes"
            className={styles.ticketActionItem}
            disabled={
              isTicketTableBusy ||
              barcodeSyncSummary?.phase === 'crawling' ||
              barcodeSyncSummary?.phase === 'verifying'
            }
            title="See whether Victory Live has barcodes on these seats"
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              void handleCheckBarcodes(tpIds);
            }}
          >
            <ClipboardCheck size={14} /> Check Barcodes
          </button>,
          <button
            key="vl-barcodes"
            className={styles.ticketActionItem}
            disabled={
              isTicketTableBusy ||
              barcodeSyncSummary?.phase === 'crawling' ||
              barcodeSyncSummary?.phase === 'verifying'
            }
            title="Resync barcodes — confirm Seasons/Purchase accounts first"
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              void handleSyncBarcodes(tpIds, tickets);
            }}
          >
            <ScanBarcode size={14} /> Resync Barcodes
          </button>,
        );
      }
    }

    if (
      (filterTab === 'Listed' || filterTab === 'All' || status === 'List') &&
      status === 'List'
    ) {
      items.push(
        <button
          key="vl-prices-refresh"
          className={styles.ticketActionItem}
          disabled={isTicketTableBusy}
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            void handleRefreshConciergePrices(tpIds);
          }}
        >
          <RefreshCcw size={14} /> Refresh VL Prices
        </button>,
      );
    }

    return items.length ? <>{items}</> : null;
  };

  /** Same ⋮ options as Manage Tickets (plus Mark as Sold shortcut on Listed). */
  const confirmWrongPid = async () => {
    if (!wrongPidConfirm || wrongPidLoading) return;
    setWrongPidLoading(true);
    try {
      await markWrongPid(wrongPidConfirm.tpIds);
      const idSet = new Set(wrongPidConfirm.tpIds);
      setLocalTickets((prev) =>
        prev.map((ticket) =>
          idSet.has(ticket.tpId)
            ? { ...ticket, tpWrongPid: true, vlListingId: null, vlItemId: null }
            : ticket,
        ),
      );
      showInfo('Wrong PID inventory removed from Victory Live. Ticket status was not changed.');
      setWrongPidConfirm(null);
      closeTicketActionMenu();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showError(error?.message || 'Failed to remove the wrong Production ID inventory');
    } finally {
      setWrongPidLoading(false);
    }
  };

  const openWrongPidResubmit = async (tickets: Ticket[]) => {
    wrongPidFlowRef.current = 'resubmit';
    closeTicketActionMenu();
    await handleOpenProductionSync(tickets);
  };

  const openWrongPidRelist = async (tickets: Ticket[]) => {
    wrongPidFlowRef.current = 'relist';
    closeTicketActionMenu();
    await handleOpenProductionSync(tickets);
  };

  const renderTicketRowActionMenuItems = (tickets: Ticket[]) => {
    if (!tickets.length) return null;
    const representative = tickets[0];
    const status = normalizeStatusValue(representative.rawStatus || representative.status);
    const tpIds = tickets.map((t) => t.tpId).filter(Boolean);
    const isReturnOrDeleted =
      status === 'Return' ||
      status === 'Deleted' ||
      activeFilterTab === 'Deleted';
    const canChangePrice = status === 'List' || status === 'Verified';
    const canDelete = ['Verified', 'List', 'Delist', 'ToBeVerified'].includes(status);

    const groupStatuses = [...new Set(tickets.map((ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status)))];
    const showWrongPid = groupStatuses.length === 1 && (groupStatuses[0] === 'Verified' || groupStatuses[0] === 'List');

    return (
      <>
        {showWrongPid && (
          <button
            className={styles.ticketActionItem}
            title="Remove this ticket group from the wrong Victory Live production"
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              setWrongPidConfirm({ tpIds, tickets });
            }}
          >
            <X size={14} /> Wrong PID
          </button>
        )}
        <button
          className={styles.ticketActionItem}
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            setTicketForView(representative);
            setShowTicketViewModal(true);
          }}
        >
          <Eye size={14} /> View Details
        </button>
        {!isReturnOrDeleted && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              openChangeStatusModal(representative);
            }}
          >
            <CheckCircle size={14} /> Change Status
          </button>
        )}
        {normalizedPortalRole !== roles.SUPER_USER && groupStatuses.every((g) => ['ToBeVerified', 'Verified', 'List'].includes(g)) && (
          <button
            className={styles.ticketActionItem}
            disabled={groupStatuses.includes('List')}
            title={
              groupStatuses.includes('List')
                ? 'Already on Victory Live. Delist these tickets before changing seat numbers.'
                : 'Make these odd-only or even-only seats'
            }
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              openSeatModeDialog(tickets);
            }}
          >
            <Edit size={14} /> Odd/Even seat numbers
          </button>
        )}
        <button
          className={styles.ticketActionItem}
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            openEditTicketModal(representative, tickets);
          }}
        >
          <Edit size={14} /> Edit Details
        </button>
        {(activeFilterTab === 'Sold' || status === 'Sold' || status === 'Settled' || status === 'SettlementInProgress') && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              setSelectedTicketForCommission(representative);
              setCommissionOverrideInput(
                representative.tp_sales_rep_commission_override == null
                  ? getTicketSalesRepCommission(representative).toFixed(2)
                  : Number(representative.tp_sales_rep_commission_override).toFixed(2),
              );
              setShowCommissionModal(true);
            }}
          >
            <DollarSign size={14} /> Edit Commission
          </button>
        )}
        {activeFilterTab === 'Listed' && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              const pricingTpIds = [
                ...new Set(
                  tickets.map((t) => String(t.tpId || '').trim()).filter(Boolean),
                ),
              ];
              setSelectedTicketForPricingMethod(representative);
              setPricingMethodTpIds(pricingTpIds.length ? pricingTpIds : [representative.tpId]);
              const methods = [
                ...new Set(
                  tickets
                    .map((t) => normalizePricingMethod(t.tp_pricing_method))
                    .filter((method): method is 'MANUAL' | 'FOLLOW_MARKET' => Boolean(method)),
                ),
              ];
              setPricingMethodFormData(
                isSelfPricingClient()
                  ? 'NONE'
                  : methods.length === 1
                    ? methods[0]
                    : resolvePricingMethodSelection(representative.tp_pricing_method),
              );
              setShowPricingMethodModal(true);
            }}
          >
            <DollarSign size={14} /> Pricing Method Status
          </button>
        )}
        {canChangePrice && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              if (tpIds.length > 1) {
                setBulkPriceModalTickets(tickets);
                setBulkPrices(
                  Object.fromEntries(
                    tickets.map((t) => [
                      t.tpId,
                      getTicketListPrice(t) > 0 ? String(getTicketListPrice(t)) : '',
                    ]),
                  ),
                );
                setBulkCommonPrice('');
                setShowBulkPriceModal(true);
              } else {
                handlePriceChangeClick(representative);
              }
            }}
          >
            <DollarSign size={14} /> Change Price
          </button>
        )}
        <button
          className={styles.ticketActionItem}
          onClick={(e) => {
            e.stopPropagation();
            closeTicketActionMenu();
            setTicketForPriceLogs(representative);
            setPriceLogsTpIds(tpIds.length ? tpIds : [representative.tpId]);
            setShowPriceLogsModal(true);
          }}
        >
          <History size={14} /> Price Change Logs
        </button>
        {status === 'List' && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              void handleMarkAsSoldFromMenu(representative);
            }}
          >
            <CreditCard size={14} /> Mark as Sold
          </button>
        )}
        {/* {status !== 'List' && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              void requestListedTicketDelist(tpIds);
            }}
          >
            <Package size={14} /> Delist
          </button>
        )} */}
        {renderVlRowActionItems(tickets, activeFilterTab)}
        {/* {canDelete && (
          <button
            className={styles.ticketActionItem}
            onClick={(e) => {
              e.stopPropagation();
              closeTicketActionMenu();
              openTicketDeleteConfirm(representative);
            }}
          >
            <Trash2 size={14} /> Delete
          </button>
        )} */}
      </>
    );
  };

  const handleApplyBulkCommonPrice = () => {
    const value = String(bulkCommonPrice).trim();
    const priceNum = parseFloat(value);
    if (!value || isNaN(priceNum) || priceNum <= 0) {
      showError('Enter a valid price to apply to all tickets');
      return;
    }
    setBulkPrices(
      Object.fromEntries(bulkPriceModalTickets.map((ticket) => [ticket.tpId, String(priceNum)])),
    );
  };

  const areAllBulkPricesValid = (tickets: Ticket[], prices: Record<string, string>): boolean =>
    tickets.every((ticket) => {
      const value = String(prices[ticket.tpId] || '').trim();
      const num = parseFloat(value);
      return !!value && !isNaN(num) && num > 0;
    });

  const executeConfirmBulkPricing = async (confirmed = false) => {
    if (bulkPriceLoading || !bulkPriceModalTickets.length) return;
    if (!areAllBulkPricesValid(bulkPriceModalTickets, bulkPrices)) {
      showError('All tickets must have a valid price greater than 0');
      return;
    }

    const hasLargePriceChange = bulkPriceModalTickets.some((ticket) =>
      requiresPriceChangeConfirmation(
        getTicketListPrice(ticket),
        Number(parseFloat(String(bulkPrices[ticket.tpId] || '').trim())),
      ),
    );
    if (hasLargePriceChange && !confirmed) {
      setPriceConfirmationFlow('bulkPrice');
      setShowBulkPriceModal(false);
      return;
    }

    setBulkPriceLoading(true);
    const bulkPendingIds = bulkPriceModalTickets.map((ticket) => ticket.tpId);
    markPriceUpdatePending(bulkPendingIds, true);
    try {
      const tpIds = bulkPriceModalTickets.map((t) => t.tpId);
      const uniquePrices = Array.from(new Set(Object.values(bulkPrices).map((p) => parseFloat(p.toString()))));

      if (uniquePrices.length === 1) {
        const priceNum = uniquePrices[0];
        const res = await editTicketPriceBySuperUser({
          variables: { tp_ids: tpIds, tp_list_price: priceNum },
        });
        const payload = res?.data?.editTicketPriceBySuperUser;
        const rawMsg = String(payload?.message || '').trim();

        if (!isVictoryLivePriceUpdateSuccess(rawMsg)) {
          showError(priceUpdateFailureMessage(rawMsg));
          return;
        }

        showSuccess(rawMsg);
        updateLocalTicket(tpIds, {
          price: formatCurrency(priceNum),
          last_priced_at: new Date().toISOString(),
        });
        markPriceUpdatePending(tpIds, false);
        refreshLastPricedTicketsAfterPriceChange();
      } else {
        const results = await Promise.allSettled(
          bulkPriceModalTickets.map((ticket) => {
            const priceNum = parseFloat(String(bulkPrices[ticket.tpId] || '').trim());
            return editTicketPriceBySuperUser({
              variables: { tp_ids: [ticket.tpId], tp_list_price: priceNum },
            }).then((result) => {
              const message = String(result?.data?.editTicketPriceBySuperUser?.message || '').trim();
              if (!isVictoryLivePriceUpdateSuccess(message)) {
                throw new Error(priceUpdateFailureMessage(message));
              }
              return { tpId: ticket.tpId, priceNum };
            });
          }),
        );

        const successUpdates = results
          .filter((r): r is PromiseFulfilledResult<{ tpId: string; priceNum: number }> => r.status === 'fulfilled')
          .map((r) => r.value);
        const failedCount = results.filter((r) => r.status === 'rejected').length;
        results.forEach((result, index) => {
          if (result.status === 'rejected') {
            markPriceUpdatePending([bulkPriceModalTickets[index].tpId], false);
          }
        });

        if (successUpdates.length > 0) {
          successUpdates.forEach(({ tpId, priceNum }) => {
            updateLocalTicket([tpId], {
              price: formatCurrency(priceNum),
              last_priced_at: new Date().toISOString(),
            });
            refreshLastPricedTicketsAfterPriceChange();
          });
          markPriceUpdatePending(successUpdates.map(({ tpId }) => tpId), false);
          showSuccess(
            `Price updated for ${successUpdates.length} ticket(s)${failedCount ? `, ${failedCount} failed` : ''}`,
          );
        } else if (failedCount > 0) {
          const rejected = results.find((result) => result.status === 'rejected');
          const reason = rejected?.status === 'rejected' ? rejected.reason : null;
          showError(reason instanceof Error ? reason.message : 'Failed to update price on VL side please try again.');
        }
      }

      setShowBulkPriceModal(false);
      setBulkPriceModalTickets([]);
      setBulkPrices({});
      setBulkCommonPrice('');
      clearBulkSelection();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      if (isBackendActionTimeoutError(error)) {
        setShowBulkPriceModal(false);
        setBulkPriceModalTickets([]);
        setBulkPrices({});
        setBulkCommonPrice('');
        clearBulkSelection();
        await refreshTicketsAndNotifications();
        showInfo(
          'Victory Live result is UNKNOWN for this price update. We refreshed the list — if the new price shows, you are all set. Do not retry yet; use Sync from VL if it does not match.',
        );
        return;
      }
      const gqlMsgs = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: { message?: string }) => e.message).filter(Boolean)
        : [];
      const detail = gqlMsgs.length ? gqlMsgs.join(' ') : error?.message;
      showError(formatUserDetailsError(detail, 'Failed to update prices'));
    } finally {
      setBulkPriceLoading(false);
      markPriceUpdatePending(bulkPendingIds, false);
    }
  };

  const handleConfirmBulkPricing = async () => {
    if (bulkPriceLoading || !bulkPriceModalTickets.length) return;
    if (!areAllBulkPricesValid(bulkPriceModalTickets, bulkPrices)) {
      showError('All tickets must have a valid price greater than 0');
      return;
    }

    if (isSelfPricingClient()) {
      const uniquePrices = [
        ...new Set(Object.values(bulkPrices).map((p) => parseFloat(String(p).trim()))),
      ];
      const priceSummary =
        uniquePrices.length === 1
          ? `New price: $${uniquePrices[0].toFixed(2)}`
          : 'Multiple new prices selected';
      selfPricingPriceConfirmActionRef.current = executeConfirmBulkPricing;
      setSelfPricingPriceConfirmCount(bulkPriceModalTickets.length);
      setSelfPricingPriceConfirmSummary(
        `Do you want to change the price for ${bulkPriceModalTickets.length} self-pricing ticket(s)? ${priceSummary}.`,
      );
      setShowSelfPricingPriceConfirm(true);
      return;
    }

    await executeConfirmBulkPricing();
  };
  
const handleStatusChange = async (ticket: Ticket, newStatusRaw: string) => {
  const currentStatus = mapStatusForMutation(ticket.rawStatus || ticket.status);
  let targetStatus = mapStatusForMutation(newStatusRaw);
  
  if (newStatusRaw === 'Move to Listed' || newStatusRaw === 'Listed (Undo)') {
    targetStatus = 'List';
  }
  
  if (targetStatus === 'DelistRequested') {
    targetStatus = 'DelistInProgress';
  }

  if (
    currentStatus === 'Deleted' &&
    (targetStatus === 'ToBeVerified' || targetStatus === 'List')
  ) {
    await runStatusMutation('Updating ticket status...', async () => {
      try {
        if (targetStatus === 'List') {
          const price = getTicketListPrice(ticket);
          if (!Number.isFinite(price) || price <= 0) {
            throw new Error('A valid listing price is required before moving deleted tickets to Listed.');
          }
          await callPublishNonVlListing([ticket.tpId], price);
        }

        if (targetStatus === 'ToBeVerified') {
          const result = await restoreDeletedToVerification({
            variables: { tp_id: ticket.tpId, updated_at: new Date().toISOString() },
          });
          const updated = result?.data?.update_ticket_placement?.returning?.length || 0;
          if (!updated) {
            throw new Error('No ticket was updated.');
          }
        }

        updateLocalTicket([ticket.tpId], {
          rawStatus: targetStatus,
          status: targetStatus === 'List' ? 'Listed' : 'To Be Verified',
        });

        showSuccess(
          `Ticket moved to ${targetStatus === 'List' ? 'Listed' : 'To Be Verified'} successfully`,
        );
        setActiveFilterTab(targetStatus === 'List' ? 'Listed' : 'Verification');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to update deleted ticket status');
      }
    });
    return;
  }

  const normalizedTarget = normalizeStatusValue(newStatusRaw);
  if (isNonVlStatusChange(normalizedTarget) && !skipNonVlStatusConfirmRef.current) {
    nonVlStatusConfirmActionRef.current = async () => {
      skipNonVlStatusConfirmRef.current = true;
      try {
        await handleStatusChange(ticket, newStatusRaw);
      } finally {
        skipNonVlStatusConfirmRef.current = false;
      }
    };
    setNonVlStatusConfirmSummary(buildNonVlStatusConfirmSummary(normalizedTarget, 1));
    setShowNonVlStatusConfirm(true);
    return;
  }

  // Listed (Non-VL): always open price popup first (single seat / single selection).
  if (
    (currentStatus === 'Verified' ||
      currentStatus === 'Delist' ||
      currentStatus === 'DelistInProgress' ||
      currentStatus === 'DelistRequested') &&
    targetStatus === 'List_NonVL'
  ) {
    setOpenStatusDropdown(null);
    setSeatCardStatusDropdownOpen({});
    const existing = parseCurrency(ticket.price);
    setListedModalTicket(ticket);
    setListedPrice(
      Number.isFinite(existing) && existing > 0 ? String(roundToFixed(existing, 2)) : '',
    );
    setShowListedModal(true);
    return;
  }

  // ---- Non-VL paths (QA status only; never call Victory Live) ----
  if (currentStatus === 'ToBeVerified' && targetStatus === 'Verified_NonVL') {
    if (isMissingVerifyRequiredFields(ticket)) {
      showError(
        'Event name, event date/time, section, row, and seat numbers are required before verification.',
      );
      return;
    }
    await runStatusMutation('Verifying ticket…', async () => {
      try {
        const result = await verifyTicketPlacements([ticket.tpId]);
        updateLocalTicket([ticket.tpId], { rawStatus: 'Verified', status: 'Verified' });
        showSuccess(result?.message || 'Ticket verified successfully (Non-VL)');
        setActiveFilterTab('Verification');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to verify ticket');
      }
    });
    return;
  }

  if (
    (currentStatus === 'List' ||
      currentStatus === 'DelistInProgress' ||
      currentStatus === 'DelistRequested') &&
    targetStatus === 'Delist_NonVL'
  ) {
    await runStatusMutation('Moving ticket to Delisted…', async () => {
      try {
        const result = await updateTicketStatus({
          variables: { tp_id: ticket.tpId, status: 'Delist' },
        });
        const affected = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (!affected) {
          showError('No ticket was updated.');
          return;
        }
        updateLocalTicket([ticket.tpId], { rawStatus: 'Delist', status: 'Delisted' });
        showSuccess('Ticket delisted successfully (Non-VL)');
        setActiveFilterTab('Delisted');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to delist ticket (Non-VL)');
      }
    });
    return;
  }

  if (
    (currentStatus === 'Verified' || currentStatus === 'Delist') &&
    targetStatus === 'DelistInProgress_NonVL'
  ) {
    await runStatusMutation('Moving to Delist Requested…', async () => {
      try {
        const result = await updateTicketStatus({
          variables: { tp_id: ticket.tpId, status: 'DelistInProgress' },
        });
        const affected = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (!affected) {
          showError('No ticket was updated.');
          return;
        }
        updateLocalTicket([ticket.tpId], { rawStatus: 'DelistInProgress', status: 'Delist Requested' });
        showSuccess('Ticket moved to Delist Requested (Non-VL)');
        setActiveFilterTab('Delisted');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to update Delist Requested (Non-VL)');
      }
    });
    return;
  }

  if (
    (currentStatus === 'Delist' ||
      currentStatus === 'DelistInProgress' ||
      currentStatus === 'DelistRequested') &&
    targetStatus === 'Return_NonVL'
  ) {
    await runStatusMutation('Returning ticket…', async () => {
      try {
        const result = await updateTicketStatus({
          variables: { tp_id: ticket.tpId, status: 'Return' },
        });
        const affected = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (!affected) {
          showError('No ticket was updated.');
          return;
        }
        updateLocalTicket([ticket.tpId], { rawStatus: 'Return', status: 'Returned' });
        showSuccess('Ticket marked Returned (Non-VL)');
        setActiveFilterTab('Delisted');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to return ticket (Non-VL)');
      }
    });
    return;
  }

  if (currentStatus === 'List' && targetStatus === 'Unsold_NonVL') {
    await runStatusMutation('Marking ticket Unsold…', async () => {
      try {
        const result = await updateTicketStatus({
          variables: { tp_id: ticket.tpId, status: 'Unsold' },
        });
        const affected = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (!affected) {
          showError('No ticket was updated.');
          return;
        }
        updateLocalTicket([ticket.tpId], { rawStatus: 'Unsold', status: 'Unsold' });
        showSuccess('Ticket marked Unsold (Non-VL)');
        setActiveFilterTab('Unsold');
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to mark Unsold (Non-VL)');
      }
    });
    return;
  }

  if (currentStatus === 'List' && targetStatus === 'Delist') {
    requestListedTicketDelist([ticket.tpId], [ticket]);
    return;
  }

  if (currentStatus === 'ToBeVerified' && targetStatus === 'Verified') {
    if (isMissingVerifyRequiredFields(ticket)) {
      showError(
        'Event name, event date/time, section, row, and seat numbers are required before verification.',
      );
      return;
    }
    // Stay ToBeVerified until Production ID is saved.
    await openPidConfirmationForTickets([ticket]);
    return;
  }

  if (currentStatus === 'ListingRequestCancelled' && targetStatus === 'ToBeVerified') {
    await runStatusMutation('Moving ticket to To Be Verified…', async () => {
      try {
        const result = await restoreCancelledListingToVerification({
          variables: { tp_id: ticket.tpId },
        });
        const updated = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (updated <= 0) {
          showError('Unable to move ticket to To Be Verified');
          return;
        }
        showSuccess('Ticket moved to To Be Verified');
        updateLocalTicket([ticket.tpId], { rawStatus: 'ToBeVerified', status: 'To Be Verified' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Verification');
      } catch (error: any) {
        showError(error?.message || 'Failed to move ticket to To Be Verified');
      }
    });
    return;
  }

  if (currentStatus === 'ToBeVerified' && (targetStatus === 'Invalid' || targetStatus === 'ListingRequestCancelled')) {
    await runStatusMutation('Cancelling listing request…', async () => {
      try {
        await callCancelListingRequestByAdminRest(ticket.tpId);
        showSuccess('Ticket marked as Listing Request Cancelled');
        updateLocalTicket([ticket.tpId], { rawStatus: 'ListingRequestCancelled', status: 'Listing Request Cancelled' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Listing Request Cancelled');
      } catch (error: any) {
        showError(error?.message || 'Failed to cancel listing request');
      }
    });
    return;
  }

  if (currentStatus === 'Verified' && targetStatus === 'List') {
    // Victory Live flow only: Submit to VL (or List on Marketplaces when already ingested).
    // Do not open the Listed price modal when seats already have a list price.
    setOpenStatusDropdown(null);
    await handleVlProgressAction([ticket.tpId]);
    return;
  }

  if ((currentStatus === 'List' || currentStatus === 'Unsold' || currentStatus === 'UnderReview') && targetStatus === 'Sold') {
    setSoldModalTicket(ticket);
    setSoldMarketplaceId('');
    setSoldLogitixAmount('0');
    setSoldFeeConfigReady(false);
    setShowSoldModal(true);
    try {
      await refetchMarketplaces();
    } catch {
      /* use cached marketplaces */
    }
    const feeConfig = await resolveSoldFeeConfigForUser();
    setSoldFeeMode(feeConfig.feeMode);
    setSoldSuperClientPercent(feeConfig.superClientPercent);
    setSoldFeeConfigReady(true);
    return;
  }

  const qaStatuses = new Set(['UnderReview', 'PaidManuallyViaQA', 'QADeniedPayout']);
  if (qaStatuses.has(targetStatus)) {
    await runStatusMutation('Updating ticket status…', async () => {
      try {
        const result = await updateTicketStatus({
          variables: { tp_id: ticket.tpId, status: targetStatus }
        });
        const affected = result?.data?.update_ticket_placement?.returning?.length || 0;
        if (!affected) {
          showError('No ticket was updated.');
          return;
        }
        updateLocalTicket([ticket.tpId], { rawStatus: targetStatus, status: getStatusLabel(targetStatus) });
        showSuccess(
          targetStatus === 'UnderReview'
            ? 'Ticket moved to Under Review successfully.'
            : targetStatus === 'PaidManuallyViaQA'
              ? 'Ticket marked Paid Manually via QA successfully.'
              : 'Ticket marked QA Denied Payout successfully.'
        );
        if (activeFilterTab !== 'Sold') {
          setActiveFilterTab('Sold');
        }
        await refreshTicketsAndNotifications();
      } catch (error: any) {
        showError(error?.message || 'Failed to update ticket status');
      }
    });
    return;
  }

  if (currentStatus === 'Sold' && (targetStatus === 'Sold' || targetStatus === 'Settled' || targetStatus === 'SettlementInProgress')) {
    if (!canOverrideSettlementStatus) {
      showInfo('It will update automatically when payment completes.');
      return;
    }
    const paymentStatus = getPaymentStatusForSettlementOverride(targetStatus);
    if (paymentStatus === undefined) {
      showError('That settlement status could not be applied.');
      return;
    }
    await runStatusMutation('Updating settlement status…', async () => {
      try {
        const result = await callUpdateSettlementPaymentStatusRest([ticket.tpId], paymentStatus);
        const updatedIds: string[] = Array.isArray(result?.updatedTpIds) ? result.updatedTpIds : [ticket.tpId];
        if (!updatedIds.length) {
          showError('No sold ticket was updated.');
          return;
        }
        const nextStatusLabel =
          paymentStatus === 'Success'
            ? 'Settled'
            : paymentStatus === 'Inprogress'
              ? 'Settlement In Progress'
              : 'Sold';
        updateLocalTicket(updatedIds, {
          rawStatus: 'Sold',
          status: nextStatusLabel,
          paymentStatus,
          payoutStatus: 'Unvoided_Payout',
        });
        showSuccess(result?.message || 'Settlement status updated successfully.');
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Sold');
      } catch (error: any) {
        showError(error?.message || 'Failed to update settlement status');
      }
    });
    return;
  }

  // Delist Requested must go through email/notification flow (same as Manage Tickets).
  if (targetStatus === 'DelistInProgress' || targetStatus === 'DelistRequested') {
    setOpenStatusDropdown(null);
    openDelistEmailModal([ticket.tpId]);
    return;
  }

  if (
    (currentStatus === 'Delist' ||
      currentStatus === 'DelistInProgress' ||
      currentStatus === 'DelistRequested') &&
    targetStatus === 'Return'
  ) {
    await runStatusMutation('Returning ticket…', async () => {
      try {
        const returnResponse = await callReturnTicketsRest([ticket.tpId]);
        const returnMsg = String(returnResponse?.message || '').toLowerCase();
        if (returnMsg.includes('fail') || returnMsg.includes('error')) {
          showError(returnResponse?.message || 'Failed to return ticket');
          return;
        }
        showSuccess(returnResponse?.message || 'Ticket returned successfully');
        updateLocalTicket([ticket.tpId], { rawStatus: 'Return', status: 'Returned' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Delisted');
      } catch (error: any) {
        showError(error?.message || 'Failed to return ticket');
      }
    });
    return;
  }

  if ((currentStatus === 'DelistInProgress' || currentStatus === 'Delist') && targetStatus === 'Delist') {
    await runStatusMutation('Moving ticket to Delisted…', async () => {
      try {
        const res = await callDelistTicketByAdminRest(ticket.tpId);
        const rawMsg = String(res?.message || '').trim();
        const normalized = rawMsg.toLowerCase();
        if (normalized.includes('fail') || normalized.includes('error')) {
          showError(rawMsg || 'Failed to delist ticket');
          return;
        }
        showSuccess(rawMsg || 'Ticket delisted successfully');
        updateLocalTicket([ticket.tpId], { rawStatus: 'Delist', status: 'Delisted' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Delisted');
      } catch (error: any) {
        showError(error?.message || 'Failed to delist ticket');
      }
    });
    return;
  }

  if (
    (currentStatus === 'DelistInProgress' ||
      currentStatus === 'DelistRequested' ||
      currentStatus === 'Delist') &&
    targetStatus === 'List'
  ) {
    await runStatusMutation('Moving ticket to Listed…', async () => {
      try {
        await executeUndoDelistWithFallback(ticket.tpId, currentStatus);
        showSuccess('Ticket moved to Listed successfully');
        updateLocalTicket([ticket.tpId], { rawStatus: 'List', status: 'Listed' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Listed');
      } catch (error: any) {
        showError(error?.message || 'Failed to move ticket to Listed');
      }
    });
    return;
  }

  if (currentStatus === 'List' && targetStatus === 'Unsold') {
    await runStatusMutation('Marking ticket Unsold…', async () => {
      try {
        const response = await callMarkTicketsUnsoldRest([ticket.tpId]);
        showSuccess(response?.message || 'Ticket marked as Unsold successfully');
        updateLocalTicket([ticket.tpId], { rawStatus: 'Unsold', status: 'Unsold' });
        await refreshTicketsAndNotifications();
        setActiveFilterTab('Unsold');
      } catch (error: any) {
        showError(error?.message || 'Failed to mark ticket as Unsold');
      }
    });
    return;
  }

  if (currentStatus === 'Invalid' && targetStatus === 'ToBeVerified') {
    showInfo('Restoring an invalid ticket is not available from this page. Use Manage Tickets instead.');
    return;
  }

  if (targetStatus === 'Deleted') {
    setShowChangeStatusModal(false);
    setChangeStatusTicket(null);
    setSelectedNewStatus('');
    openTicketDeleteConfirm(ticket);
    return;
  }
  };

  const openChangeStatusModal = (ticket: Ticket) => {
    const currentToken = getTicketTransitionStatus(ticket);
    const transitions = getStatusTransitions(currentToken);
    if (transitions.length === 0) {
      showError('No status changes available for this ticket.');
      return;
    }
    setChangeStatusTicket(ticket);
    setSelectedNewStatus('');
    setShowChangeStatusModal(true);
    setOpenActionTicketId(null);
  };
  
  const handleChangeStatusConfirm = async () => {
    if (!changeStatusTicket || !selectedNewStatus) return;
    setChangeStatusLoading(true);
    try {
      await handleStatusChange(changeStatusTicket, selectedNewStatus);
      setShowChangeStatusModal(false);
      setChangeStatusTicket(null);
      setSelectedNewStatus('');
    } catch (error: any) {
      showError(error?.message || 'Failed to change status');
    } finally {
      setChangeStatusLoading(false);
    }
  };
  
const openEditTicketModal = async (ticket: Ticket, groupTickets?: Ticket[]) => {
  const ticketsForEdit = (groupTickets?.length ? groupTickets : [ticket])
    .slice()
    .sort((a, b) => {
      const seatA = parseAndSortSeatNumbers(a.seatNo).map((value) => Number(value)).filter(Number.isFinite);
      const seatB = parseAndSortSeatNumbers(b.seatNo).map((value) => Number(value)).filter(Number.isFinite);
      const firstA = seatA[0] ?? Number.MAX_SAFE_INTEGER;
      const firstB = seatB[0] ?? Number.MAX_SAFE_INTEGER;
      if (firstA !== firstB) return firstA - firstB;
      return String(a.tpId || '').localeCompare(String(b.tpId || ''));
    });
  const noteSource = ticketsForEdit[0] || ticket;
  const parkingNotes = isParkingPassRow(noteSource.row);
  const initialInternal = parkingNotes ? PARKING_INTERNAL_NOTE : String(noteSource.internalNotes || '').trim();
  const initialExternal = parkingNotes ? PARKING_EXTERNAL_NOTE : String(noteSource.externalNotes || '').trim();
  const notesForTickets = await seatNotesWithTeamNames();
  const locations = ticketNoteLocations(ticketsForEdit);
  setEditInternalNoteChoices(withListingAmenityNotes(listingNoteChoices(notesForTickets, locations, 'internalNote')));
  setEditExternalNoteChoices(withListingAmenityNotes(listingNoteChoices(notesForTickets, locations, 'externalNote')));
  
  const allSeatNumbers: number[] = [];
  ticketsForEdit.forEach((row) => {
    parseSeatNumbersFromRange(row.seatNo).forEach((seat) => {
      if (Number.isFinite(seat) && seat > 0) allSeatNumbers.push(seat);
    });
  });
  const startSeat = allSeatNumbers.length > 0 ? Math.min(...allSeatNumbers) : '';
  const endSeat = allSeatNumbers.length > 0 ? Math.max(...allSeatNumbers) : '';
  setEditTicket(noteSource);
  setEditTicketGroup(ticketsForEdit);
  setEditTicketInitialNotes({ internal: initialInternal, external: initialExternal });
// Group edit = more than one ticket in the selected group
const isGroupEdit = ticketsForEdit.length > 1;

setEditTicketForm({
  section: noteSource.section === '-' ? '' : noteSource.section,
  row: noteSource.row === '-' ? '' : noteSource.row,
  seatStart: String(startSeat),
  seatEnd: String(endSeat),
  isGroupEdit,
  price: parseCurrency(noteSource.price).toString(),
  internalNotes: initialInternal,
  externalNotes: initialExternal,
});
  setShowEditTicketModal(true);
  setOpenActionTicketId(null);
};
const closePricingMethodModal = () => {
  if (pricingMethodLoading) return;
  setShowPricingMethodModal(false);
  setSelectedTicketForPricingMethod(null);
  setPricingMethodTpIds([]);
  setPricingMethodFormData('');
  setPricingMethodLoading(false);
};

const handlePricingMethodStatusConfirm = async () => {
  if (!selectedTicketForPricingMethod || pricingMethodLoading) return;
  if (
    pricingMethodFormData !== 'MANUAL' &&
    pricingMethodFormData !== 'FOLLOW_MARKET' &&
    pricingMethodFormData !== 'NONE'
  ) {
    showError('Please select a valid pricing method.');
    return;
  }
  if (
    isSelfPricingClient() &&
    (pricingMethodFormData === 'MANUAL' || pricingMethodFormData === 'FOLLOW_MARKET')
  ) {
    showError('Self Pricing tickets cannot use Manual or Follow the Market. Select Nothing.');
    return;
  }

  try {
    setPricingMethodLoading(true);

    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;

    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');

    const methodToSave = isSelfPricingClient() ? 'NONE' : pricingMethodFormData;

    const response = await fetch(`${nodeApiBaseUrl}/api/tickets/pricing-method`, {
      method: 'PUT',
      headers,
      body: JSON.stringify({
        tpIds: pricingMethodTpIds.length ? pricingMethodTpIds : [selectedTicketForPricingMethod.tpId],
        pricingMethod: methodToSave,
        tp_id: selectedTicketForPricingMethod.tpId,
      }),
    });

    const parsed = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(parsed?.message || parsed?.error || parsed?.errors?.[0]?.message || 'Failed to update pricing method');
    }

    updateLocalTicket(pricingMethodTpIds.length ? pricingMethodTpIds : [selectedTicketForPricingMethod.tpId], {
      tp_pricing_method:
        methodToSave === 'MANUAL' || methodToSave === 'FOLLOW_MARKET' ? methodToSave : null,
    });
    showSuccess(parsed?.message || 'Pricing method updated successfully.');
    closePricingMethodModal();
    await refreshTicketsAndNotifications();
  } catch (error: any) {
    console.error('Pricing method update error:', error);
    showError(formatUserDetailsError(error, 'Failed to update pricing method'));
  } finally {
    setPricingMethodLoading(false);
  }
};

const handleEditTicketSave = async () => {
  if (!editTicket) return;
  const { section, row, seatStart, seatEnd, internalNotes, externalNotes } = editTicketForm;
  const isGroupEdit = editTicketGroup.length > 1;
  const seatNumberEditable =
    ['Verified', 'ToBeVerified'].includes(
      normalizeStatusValue(editTicket.rawStatus || editTicket.status),
    ) &&
    editTicketGroup.every((ticket) =>
      ['Verified', 'ToBeVerified'].includes(
        normalizeStatusValue(ticket.rawStatus || ticket.status),
      ),
    );
  
  // Validate at least one field
  if (
    !section.trim() &&
    !row.trim() &&
    !internalNotes.trim() &&
    !externalNotes.trim() &&
    (!seatNumberEditable || (!seatStart.trim() && !seatEnd.trim()))
  ) {
    showError('Please fill at least one field to update.');
    return;
  }

  const preparedSection = section.trim() || (editTicket.section === '-' ? '' : editTicket.section).trim();
  const preparedRow = row.trim() || (editTicket.row === '-' ? '' : editTicket.row).trim();
  const currentSection = (editTicket.section === '-' ? '' : editTicket.section).trim().toLowerCase();
  const currentRow = (editTicket.row === '-' ? '' : editTicket.row).trim().toLowerCase();
  const sectionOrRowChanged =
    preparedSection.toLowerCase() !== currentSection ||
    preparedRow.toLowerCase() !== currentRow;

  const trimmedInternal = internalNotes.trim();
  const trimmedExternal = externalNotes.trim();
  const notesChanged =
    trimmedInternal !== editTicketInitialNotes.internal.trim() ||
    trimmedExternal !== editTicketInitialNotes.external.trim();

  // Current seat numbers as a sorted array
  const currentSeatNumbers = editTicketGroup
    .map((ticket) => String(ticket.seatNo === '-' ? '' : ticket.seatNo).trim())
    .filter(Boolean)
    .sort((a, b) => Number(a) - Number(b));
const startSeatVal = seatStart.trim();
const endSeatVal = seatEnd.trim();
let preparedSeatNumber = '';
if (startSeatVal && endSeatVal) {
  // Both single & group edits use Start / End seat inputs.
  preparedSeatNumber =
    startSeatVal === endSeatVal ? startSeatVal : `${startSeatVal}-${endSeatVal}`;
} else {
  preparedSeatNumber = currentSeatNumbers.join(', ');
}
  const normalizeSeatNumbers = (value: string) =>
    value.trim().replace(/\s*,\s*/g, ',');
  const seatNumberChanged =
    seatNumberEditable &&
    normalizeSeatNumbers(preparedSeatNumber) !== normalizeSeatNumbers(currentSeatNumbers.join(', '));

  if (!sectionOrRowChanged && !notesChanged && !seatNumberChanged) {
    showError('No changes detected.');
    return;
  }

  if (sectionOrRowChanged && (!preparedSection || !preparedRow)) {
    showError('Section and row are required when updating placement details.');
    return;
  }
  if (!isGroupEdit && sectionOrRowChanged && !preparedSeatNumber.trim()) {
    showError('Section, Row, and Seat Number are required.');
    return;
  }

  const parseSeatInt = (value: string | number | null | undefined): number | null => {
    if (value === null || value === undefined) return null;
    const raw = String(value).trim();
    if (!raw) return null;
    if (raw.includes('-')) {
      const first = Number.parseInt(raw.split('-')[0], 10);
      return Number.isFinite(first) ? first : null;
    }
    if (raw.includes(',')) {
      const first = Number.parseInt(raw.split(',')[0].trim(), 10);
      return Number.isFinite(first) ? first : null;
    }
    const n = Number.parseInt(raw, 10);
    return Number.isFinite(n) ? n : null;
  };

  const parseSeatNumberList = (value: string): number[] | null => {
    const seats: number[] = [];
    for (const part of value.split(',')) {
      const range = part.trim().match(/^(\d+)\s*-\s*(\d+)$/);
      if (range) {
        const start = Number(range[1]);
        const end = Number(range[2]);
        if (end < start || end - start + 1 > editTicketGroup.length) return null;
        for (let seat = start; seat <= end; seat += 1) seats.push(seat);
        continue;
      }
      if (!/^\d+$/.test(part.trim())) return null;
      seats.push(Number(part.trim()));
      if (seats.length > editTicketGroup.length) return null;
    }
    return seats.length === editTicketGroup.length ? seats : null;
  };

  const updatedGroupSeats =
    seatNumberChanged && isGroupEdit ? parseSeatNumberList(preparedSeatNumber) : null;
  if (seatNumberChanged && isGroupEdit && !updatedGroupSeats) {
    showError(`Enter exactly ${editTicketGroup.length} seat numbers, separated by commas.`);
    return;
  }

  const seatNum =
    updatedGroupSeats?.[0] ??
    (seatNumberEditable ? parseSeatInt(preparedSeatNumber) : parseSeatInt(editTicket.seatNo));
  if (seatNum == null) {
    showError('Seat must be a valid number.');
    return;
  }

  const groupSeatUpdates = seatNumberChanged
    ? editTicketGroup.map((ticket, index) => ({
        tp_id: ticket.tpId,
        tp_seat_no: updatedGroupSeats?.[index] ?? seatNum,
      }))
    : [];

  const groupTpIds = editTicketGroup.map((row) => row.tpId).filter(Boolean);
  const placementId = String(editTicket.tpId || '').trim();
  const eventId = String(editTicket.eventId || '').trim();
  if (!placementId) {
    showError('Ticket placement ID is missing.');
    return;
  }
  if (!eventId) {
    showError('Event ID is missing.');
    return;
  }

  setEditTicketLoading(true);
  try {
    const cachedMarketplaces = getCachedEnabledMarketplaceIds(placementId);
    const runEdit = (forceUpdate?: boolean) =>
      callEditTicketsRest({
        e_id: eventId,
        tp_id: placementId,
        tp_section: preparedSection,
        tp_row: preparedRow,
        tp_seat_no: seatNum,
        ...(groupSeatUpdates.length ? { group_seat_updates: groupSeatUpdates } : {}),
        ...(groupTpIds.length > 1 ? { group_tp_ids: groupTpIds } : {}),
        ...(notesChanged
          ? {
              internalNotes: trimmedInternal,
              externalNotes: trimmedExternal,
              ...(cachedMarketplaces?.length
                ? { enabledMarketplaceIds: cachedMarketplaces }
                : {}),
            }
          : {}),
        ...(forceUpdate ? { forceUpdate: true } : {}),
      });

    let restData = await runEdit();
    if (restData?.requiresConfirmation) {
      const shouldProceed = window.confirm(
        restData?.message ||
          'Matching ticket details exist in delisted/returned tickets. Do you want to proceed?',
      );
      if (!shouldProceed) return;
      restData = await runEdit(true);
    }

    const msg = String(restData?.message || '').toLowerCase();
    const looksFailed =
      !msg.includes('success') ||
      msg.includes('fail') ||
      msg.includes('error') ||
      msg.includes('unauthorized') ||
      msg.includes("couldn't update");
    if (looksFailed) {
      showError(restData?.message || 'Failed to update ticket details');
      return;
    }

    updateLocalTicket(groupTpIds.length ? groupTpIds : [placementId], {
      ...(sectionOrRowChanged
        ? {
            section: preparedSection,
            row: preparedRow,
            ...(!isGroupEdit
              ? { seatNo: seatNumberEditable ? String(seatNum) : editTicket.seatNo }
              : {}),
          }
        : {}),
    });
    for (const seatUpdate of groupSeatUpdates) {
      updateLocalTicket([seatUpdate.tp_id], {
        seatNo: String(seatUpdate.tp_seat_no),
      });
    }
    showSuccess(
      isGroupEdit
        ? `Ticket details updated on Victory Live for ${editTicketGroup.length} seats.`
        : restData?.message || 'Ticket details updated successfully',
    );
    setShowEditTicketModal(false);
    setEditTicket(null);
    setEditTicketGroup([]);
    await refetchNotes();
    await refetchSeatLevelNotes();
    await refreshTicketsAndNotifications();
  } catch (error: any) {
    showError(error?.message || 'Failed to update ticket details');
  } finally {
    setEditTicketLoading(false);
  }
};
  const handleListedModalConfirm = async () => {
    if (!listedModalTicket) return;
    const priceNum = parseFloat(listedPrice);
    if (isNaN(priceNum) || priceNum <= 0) {
      showError('Please enter a valid price greater than 0.');
      return;
    }
    setListedModalLoading(true);
    try {
      await callPublishNonVlListing([listedModalTicket.tpId], priceNum);
      showSuccess(`Ticket listed (Non-VL) at $${priceNum}`);
      updateLocalTicket([listedModalTicket.tpId], { rawStatus: 'List', status: 'Listed', price: formatCurrency(priceNum) });
      setShowListedModal(false);
      setListedModalTicket(null);
      setListedPrice('');
      setActiveFilterTab('Listed');
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      showError(error?.message || 'Failed to list ticket');
    } finally {
      setListedModalLoading(false);
    }
  };
const hasSoldTicketsForTeam = (teamId: string, teamName: string, teamAbbr: string): boolean => {
  const teamNameLower = teamName.toLowerCase().trim();
  const teamAbbrLower = teamAbbr.toLowerCase().trim();

  return localTickets.some(ticket => {
    const rawStatus = (ticket.rawStatus || ticket.status).toLowerCase();
    const isSold = rawStatus === 'sold';
    if (!isSold) return false;

    const eventName = ticket.event.toLowerCase();
    return eventName.includes(teamNameLower) || eventName.includes(teamAbbrLower);
  });
};
  const handleSoldModalConfirm = async () => {
    if (!soldModalTicket) return;
    if (!soldMarketplaceId) { showError('Please select a marketplace.'); return; }
    const mp = marketplacesList.find(m => m.id === soldMarketplaceId);
    if (!mp) { showError('Selected marketplace not found.'); return; }
    const listPrice = parseCurrency(soldModalTicket.price);
    const logitixNum = parseFloat(String(soldLogitixAmount || '').trim());
    if (isNaN(logitixNum) || logitixNum <= 0) { showError('Please enter the amount received from marketplace.'); return; }
    const quickPct = effectiveSoldQuickCutPercent(mp.vl_fee_percentage, soldFeeMode, soldSuperClientPercent);
const quickCutDollars = Number(roundToFixed(logitixNum * (quickPct / 100), 2));
    const settlement = Math.round((logitixNum - quickCutDollars) * 100) / 100;
    if (settlement <= 0) { showError('Amount settled to user must be greater than zero.'); return; }
    setSoldModalLoading(true);
    try {
      const restData = await callMarkAsSoldRest(soldModalTicket.tpId, settlement, logitixNum, mp.name);
      const rawMsg = String(restData?.message || '');
      if (!rawMsg.toLowerCase().includes('success')) throw new Error(rawMsg || 'Failed to mark ticket as sold');
      updateLocalTicket([soldModalTicket.tpId], { rawStatus: 'Sold', status: 'Sold', soldPrice: formatCurrency(settlement), marketplace: mp.name });
      if (userId) {
        saveMarketplaceCache(userId, soldModalTicket.tpId, mp.name);
      }
      showSuccess(rawMsg || 'Ticket marked as sold successfully');
      setShowSoldModal(false);
      setSoldModalTicket(null);
      setSoldMarketplaceId('');
      setSoldLogitixAmount('0');
      setActiveFilterTab('Sold');
      console.log('🔄 Refetching tickets and team sold status after marking as sold...');
      await Promise.all([
        refetchTickets(),
        refetchTeamsWithSoldStatus(),
      ]);
      syncDashboardNotifications();
      console.log('✅ Refetch completed - delete button should now update for sold teams');
    } catch (err: any) {
      showError(err?.message || 'Failed to mark ticket as sold');
    } finally {
      setSoldModalLoading(false);
    }
  };
  
  const closeSoldModal = () => {
    setShowSoldModal(false);
    setSoldModalTicket(null);
    setSoldMarketplaceId('');
    setSoldLogitixAmount('0');
    setSoldFeeConfigReady(false);
    setSoldFeeMode('default');
    setSoldSuperClientPercent(null);
  };
  
  const handlePriceChangeClick = (ticket: Ticket) => {
    setPriceModalTicket(ticket);
    setNewPrice(parseCurrency(ticket.price).toString());
    setShowPriceModal(true);
  };

  const openChangePriceForTickets = (tickets: Ticket[]) => {
    if (!tickets.length) return;
    if (tickets.length > 1) {
      setBulkPriceModalTickets(tickets);
      setBulkPrices(
        Object.fromEntries(
          tickets.map((t) => [
            t.tpId,
            getTicketListPrice(t) > 0 ? String(getTicketListPrice(t)) : '',
          ]),
        ),
      );
      setBulkCommonPrice('');
      setShowBulkPriceModal(true);
      return;
    }
    handlePriceChangeClick(tickets[0]);
  };

  const canClickListedPrice =
    activeFilterTab === 'Listed' && (isSelfPricingClient() || isUserConciergeClient());

  const renderListedPriceCell = (tickets: Ticket[], display: string) => (
    <td
      className={styles.tdPrice}
      onClick={canClickListedPrice ? (e) => e.stopPropagation() : undefined}
    >
      {canClickListedPrice ? (
        <button
          type="button"
          className={styles.clickablePrice}
          title="Change Price"
          onClick={(e) => {
            e.stopPropagation();
            openChangePriceForTickets(tickets);
          }}
        >
          <Pencil size={13} aria-hidden />
          <span className={styles.userDetailsPriceValue}>
        {normalizePricingMethod(tickets[0]?.tp_pricing_method) === 'MANUAL' && (
              <span className={styles.userDetailsManualPriceBadge} title="Manually Priced" aria-label="Manually Priced">
                <DollarSign size={13} aria-hidden />
              </span>
            )}
            {normalizePricingMethod(tickets[0]?.tp_pricing_method) === 'FOLLOW_MARKET' && (
              <span className={styles.userDetailsFollowMarketBadge} title="Follow the Market" aria-label="Follow the Market">
                <TrendingUp size={13} aria-hidden />
              </span>
            )}
            {display}
          </span>
        </button>
      ) : (
        <span className={styles.userDetailsPriceValue}>
          {normalizePricingMethod(tickets[0]?.tp_pricing_method) === 'MANUAL' && (
            <span className={styles.userDetailsManualPriceBadge} title="Manually Priced" aria-label="Manually Priced">
              <DollarSign size={13} aria-hidden />
            </span>
          )}
          {normalizePricingMethod(tickets[0]?.tp_pricing_method) === 'FOLLOW_MARKET' && (
            <span className={styles.userDetailsFollowMarketBadge} title="Follow the Market" aria-label="Follow the Market">
              <TrendingUp size={13} aria-hidden />
            </span>
          )}
          {display}
        </span>
      )}
    </td>
  );
  
  const handlePriceModalConfirm = async (confirmed = false) => {
    if (!priceModalTicket) return;
    const priceNum = parseFloat(newPrice);
    if (isNaN(priceNum) || priceNum <= 0) {
      showError('Please enter a valid price.');
      return;
    }
    if (requiresPriceChangeConfirmation(getTicketListPrice(priceModalTicket), priceNum) && !confirmed) {
      setPriceConfirmationFlow('single');
      setShowPriceModal(false);
      return;
    }
    const targetTpIds = bulkPriceTpIds.length > 0 ? bulkPriceTpIds : [priceModalTicket.tpId];
    setPriceModalLoading(true);
    markPriceUpdatePending(targetTpIds, true);
    try {
      const res = await editTicketPriceBySuperUser({
        variables: { tp_ids: targetTpIds, tp_list_price: priceNum },
      });
      const payload = res?.data?.editTicketPriceBySuperUser;
      const rawMsg = String(payload?.message || '').trim();
      if (payload?.requiresConfirmation) {
        showInfo(rawMsg || 'Price update requires confirmation.');
        return;
      }
      if (!isVictoryLivePriceUpdateSuccess(rawMsg)) {
        showError(priceUpdateFailureMessage(rawMsg));
        return;
      }
      showSuccess(rawMsg);
      updateLocalTicket(targetTpIds, {
        price: formatCurrency(priceNum),
        last_priced_at: new Date().toISOString(),
      });
      markPriceUpdatePending(targetTpIds, false);
      refreshLastPricedTicketsAfterPriceChange();
      setShowPriceModal(false);
      setPriceModalTicket(null);
      setNewPrice('');
      setBulkPriceTpIds([]);
      clearBulkSelection();
      await refreshTicketsAndNotifications();
    } catch (error: any) {
      if (isBackendActionTimeoutError(error)) {
        setShowPriceModal(false);
        setPriceModalTicket(null);
        setNewPrice('');
        setBulkPriceTpIds([]);
        await refreshTicketsAndNotifications();
        showInfo(
          'Victory Live result is UNKNOWN for this price update. We refreshed the list — if the new price shows, you are all set. Do not retry yet; use Sync from VL if it does not match.',
        );
        return;
      }
      const gqlMsgs = Array.isArray(error?.graphQLErrors)
        ? error.graphQLErrors.map((e: { message?: string }) => e.message).filter(Boolean)
        : [];
      const detail = gqlMsgs.length ? gqlMsgs.join(' ') : error?.message;
      showError(formatUserDetailsError(detail, 'Failed to update price'));
    } finally {
      setPriceModalLoading(false);
      markPriceUpdatePending(targetTpIds, false);
    }
  };

  const confirmPriceChange = async () => {
    const flow = priceConfirmationFlow;
    setPriceConfirmationFlow(null);
    if (flow === 'single') await handlePriceModalConfirm(true);
    if (flow === 'bulkPrice') await executeConfirmBulkPricing(true);
  };

  const cancelPriceChangeConfirmation = () => {
    const flow = priceConfirmationFlow;
    setPriceConfirmationFlow(null);
    if (flow === 'single') setShowPriceModal(true);
    if (flow === 'bulkPrice') setShowBulkPriceModal(true);
  };

  const getPriceConfirmationChanges = (): Array<{ currentPrice: unknown; proposedPrice: number }> => {
    if (priceConfirmationFlow === 'single' && priceModalTicket) {
      return [{
        currentPrice: getTicketListPrice(priceModalTicket),
        proposedPrice: Number(parseFloat(newPrice)) || 0,
      }];
    }
    if (priceConfirmationFlow === 'bulkPrice') {
      return bulkPriceModalTickets.map((ticket) => ({
        currentPrice: getTicketListPrice(ticket),
        proposedPrice: Number(parseFloat(String(bulkPrices[ticket.tpId] || ''))) || 0,
      }));
    }
    return [];
  };
  
  const handleMarkAsSoldFromMenu = async (ticket: Ticket) => {
    setSoldModalTicket(ticket);
    setSoldMarketplaceId('');
    setSoldLogitixAmount('0');
    setSoldFeeConfigReady(false);
    setShowSoldModal(true);
    try {
      await refetchMarketplaces();
    } catch {
      /* use cached marketplaces */
    }
    const feeConfig = await resolveSoldFeeConfigForUser();
    setSoldFeeMode(feeConfig.feeMode);
    setSoldSuperClientPercent(feeConfig.superClientPercent);
    setSoldFeeConfigReady(true);
  };
  
  useEffect(() => {
    if (!showSoldModal || !soldModalTicket || !soldFeeConfigReady) return;
    if (!soldMarketplaceId) {
      setSoldLogitixAmount('0');
      return;
    }
    const mp = marketplacesList.find(m => m.id === soldMarketplaceId);
    if (!mp) return;
    const listPriceNum = parseCurrency(soldModalTicket.price);
    const expected = Math.round(listPriceNum * (100 - mp.vl_fee_percentage)) / 100;
    setSoldLogitixAmount(String(Number(roundToFixed(expected, 2))));
  }, [showSoldModal, soldMarketplaceId, soldModalTicket?.price, soldFeeConfigReady, marketplacesList]);
  
  
  const enrichUserTicketsWithVlProductionIds = useCallback(
    async (tickets: Ticket[]) => {
      const tpIds = [
        ...new Set(tickets.map((ticket) => String(ticket.tpId || '').trim()).filter(Boolean)),
      ];
      if (!tpIds.length) return;
      try {
        const chunkSize = 400;
        const productionByTpId = new Map<string, string>();
        const marketplaceByTpId = new Map<
          string,
          { stubhubId: string | null; seatgeekId: string | null }
        >();
        for (let i = 0; i < tpIds.length; i += chunkSize) {
          const chunk = tpIds.slice(i, i + chunkSize);
          const { data } = await apolloClient.query({
            query: GET_PLACEMENT_VL_PRODUCTION_IDS,
            variables: { tpIds: chunk },
            fetchPolicy: 'network-only',
          });
          for (const row of data?.ticket_placement || []) {
            const tpId = String(row?.tp_id || '').trim();
            const productionId = String(row?.tp_vl_production_id || '').trim();
            if (tpId && productionId) productionByTpId.set(tpId, productionId);
            if (!tpId) continue;
            const stubhubId = String(row?.tp_stubhub_id || '').trim() || null;
            const seatgeekId = String(row?.tp_seatgeek_id || '').trim() || null;
            if (stubhubId || seatgeekId) {
              marketplaceByTpId.set(tpId, { stubhubId, seatgeekId });
            }
          }
        }
        if (!productionByTpId.size && !marketplaceByTpId.size) return;

        setLocalTickets((prev) =>
          prev.map((ticket) => {
            const tpId = String(ticket.tpId || '').trim();
            const seatPid = productionByTpId.get(tpId) || '';
            const seatLinks = marketplaceByTpId.get(tpId);
            if (!seatPid && !seatLinks) return ticket;
            const productionId = seatPid || String(ticket.confirmedVlProductionId || '').trim();
            const nextStubhub = seatLinks ? seatLinks.stubhubId : ticket.stubhubId ?? null;
            const nextSeatgeek = seatLinks ? seatLinks.seatgeekId : ticket.seatgeekId ?? null;
            if (
              ticket.confirmedVlProductionId === productionId &&
              ticket.stubhubId === nextStubhub &&
              ticket.seatgeekId === nextSeatgeek
            ) {
              return ticket;
            }
            return {
              ...ticket,
              confirmedVlProductionId: productionId || null,
              stubhubId: nextStubhub,
              seatgeekId: nextSeatgeek,
            };
          }),
        );
      } catch (err) {
        console.warn('[Userdetails] Failed to load VL production ids', err);
      }
    },
    [apolloClient],
  );

  useEffect(() => {
    // Only apply primary when the query actually returned a tickets payload.
    // Field/schema errors (e.g. unknown columns) leave ticketsData undefined and
    // must not wipe the list to [] — that previously showed Tickets (0).
    // Listing ids used for grouping arrive on the marketplace lookup. Wait for
    // that payload so the first group paint is the final order. A page click
    // inside the loaded seat window does not change either response.
    const marketplacesPending = Boolean(userId) && userTicketMarketplacesLoading && !userTicketMarketplacesData && !isGetUserTicketsAllowlistError;
    if (marketplacesPending) return;
    const hasPrimaryPayload = Array.isArray(ticketsData?.tickets);
    if (hasPrimaryPayload) {
      if (
        appliedUserTicketsPayloadRef.current === ticketsData &&
        appliedUserTicketMarketplacesRef.current === userTicketMarketplacesData
      ) {
        return;
      }
      appliedUserTicketsPayloadRef.current = ticketsData;
      appliedUserTicketMarketplacesRef.current = userTicketMarketplacesData;
      setTicketSeatTotal(Number(ticketsData?.tickets_aggregate?.aggregate?.count ?? 0));
      setTicketLoadedSeatWindowIndex(pendingTicketSeatWindowIndexRef.current);
      const primaryTickets = transformTicketsData(ticketsData, userId);
      const preserveMarketplaceFromOldTickets = (oldTickets: Ticket[], newTickets: Ticket[]): Ticket[] => {
        const oldMarketplaceMap = new Map<string, string | null>();
        const oldPidMap = new Map<string, string | null>();
        const oldDeepLinkMap = new Map<string, { stubhubId?: string | null; seatgeekId?: string | null }>();
        const oldVlMap = new Map<string, { vlListingId?: string | null; vlItemId?: string | null }>();
        const oldCommissionOverrideMap = new Map<string, number | string | null>();
        oldTickets.forEach(t => {
          if (t.marketplace) {
            oldMarketplaceMap.set(t.tpId, t.marketplace);
          }
          if (t.confirmedVlProductionId) {
            oldPidMap.set(t.tpId, t.confirmedVlProductionId);
          }
          if (t.stubhubId || t.seatgeekId) {
            oldDeepLinkMap.set(t.tpId, {
              stubhubId: t.stubhubId ?? null,
              seatgeekId: t.seatgeekId ?? null,
            });
          }
          if (t.vlListingId || t.vlItemId) {
            oldVlMap.set(t.tpId, {
              vlListingId: t.vlListingId ?? null,
              vlItemId: t.vlItemId ?? null,
            });
          }
          if (t.tp_sales_rep_commission_override != null) {
            oldCommissionOverrideMap.set(t.tpId, t.tp_sales_rep_commission_override);
          }
        });
        
        return newTickets.map(t => {
          const preservedMarketplace = oldMarketplaceMap.get(t.tpId);
          const preservedPid = oldPidMap.get(t.tpId);
          const preservedDeepLinks = oldDeepLinkMap.get(t.tpId);
          const preservedVl = oldVlMap.get(t.tpId);
          let next = t;
          if (preservedMarketplace && !t.marketplace) {
            next = { ...next, marketplace: preservedMarketplace };
          }
          if (preservedPid && !t.confirmedVlProductionId) {
            next = { ...next, confirmedVlProductionId: preservedPid };
          }
          if (preservedDeepLinks && !t.stubhubId && !t.seatgeekId) {
            next = {
              ...next,
              stubhubId: preservedDeepLinks.stubhubId ?? null,
              seatgeekId: preservedDeepLinks.seatgeekId ?? null,
            };
          }
          // GET_USER_TICKETS omits VL ids — keep sync / marketplace lookup ids across refetch.
          if (preservedVl && !t.vlListingId && !t.vlItemId) {
            next = {
              ...next,
              vlListingId: preservedVl.vlListingId ?? null,
              vlItemId: preservedVl.vlItemId ?? null,
            };
          }
          const preservedCommissionOverride = oldCommissionOverrideMap.get(t.tpId);
          if (preservedCommissionOverride != null && t.tp_sales_rep_commission_override == null) {
            next = { ...next, tp_sales_rep_commission_override: preservedCommissionOverride };
          }
          return next;
        });
      };
      
      const mergedTickets = applyMarketplaceLookupToTickets(
        preserveMarketplaceFromOldTickets(localTickets, primaryTickets),
      ).map((ticket) => {
        const override = localStatusOverridesRef.current[ticket.tpId];
        if (!override) return ticket;
        const serverStatus = mapStatusForMutation(ticket.rawStatus || ticket.status || '');
        const overrideStatus = mapStatusForMutation(override);
        if (serverStatus === overrideStatus) {
          delete localStatusOverridesRef.current[ticket.tpId];
          return ticket;
        }
        return { ...ticket, rawStatus: override, status: getStatusLabel(override) };
      });
      setLocalTickets(mergedTickets);
      setTabSwitchLoading(false);
      void enrichUserTicketsWithVlProductionIds(mergedTickets);
      return;
    }
    if (!isGetUserTicketsAllowlistError) return;
    if (appliedUserTicketsPayloadRef.current === fallbackManageTicketsData) return;
    appliedUserTicketsPayloadRef.current = fallbackManageTicketsData;
    const fallbackTickets = applyMarketplaceLookupToTickets(transformFallbackManageTicketsData(fallbackManageTicketsData, userId));
      setLocalTickets(fallbackTickets.map((ticket) => {
        const override = localStatusOverridesRef.current[ticket.tpId];
        if (!override) return ticket;
        const serverStatus = mapStatusForMutation(ticket.rawStatus || ticket.status || '');
        const overrideStatus = mapStatusForMutation(override);
        if (serverStatus === overrideStatus) {
          delete localStatusOverridesRef.current[ticket.tpId];
          return ticket;
        }
        return { ...ticket, rawStatus: override, status: getStatusLabel(override) };
      }));
    setTabSwitchLoading(false);
    void enrichUserTicketsWithVlProductionIds(fallbackTickets);
  }, [ticketsData, fallbackManageTicketsData, userId, isGetUserTicketsAllowlistError, marketplaceByTicketPlacementId, applyMarketplaceLookupToTickets, enrichUserTicketsWithVlProductionIds, userTicketMarketplacesLoading, userTicketMarketplacesData]);

  const hasAddressValues = (user: UserData): boolean => {
    return !!(user.address1?.trim() || user.address2?.trim() || user.city?.trim() || user.state?.trim() || user.zip?.trim() || user.country?.trim());
  };
  
  // REST API calls
  const callUpdateTicketStatusRest = async (ticketPlacementId: string[], isValid: boolean, isUndoRequest = false) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/updateTicketStatus`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: {
          ticketPlacementId,
          isValid,
          isUndoRequest,
        },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to update ticket status';
      throw new Error(message);
    }
    return responseData;
  };

  const callDelistTicketByAdminRest = async (ticketPlacementId: string) => {
    return delistTicketByAdminRequest(ticketPlacementId);
  };

  const callCancelListingRequestByAdminRest = async (ticketPlacementId: string) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/cancelListingRequestBySuperUser`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: { ticketPlacementId },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to cancel listing request';
      throw new Error(message);
    }
    return responseData;
  };

  const callUndoDelistRequestToListRest = async (tpId: string) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/undoDelistRequestToList`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: { tpId },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to undo delist request';
      throw new Error(message);
    }
    return responseData;
  };

  const callRelistTicketBySuperUserRest = async (ticketPlacementIds: string | string[]) => {
    const ids = (Array.isArray(ticketPlacementIds) ? ticketPlacementIds : [ticketPlacementIds]).filter(
      Boolean,
    );
    if (!ids.length) {
      throw new Error('No tickets selected for relist');
    }
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const input =
      ids.length === 1
        ? { ticketPlacementId: ids[0] }
        : { ticketPlacementIds: ids };
    const response = await fetch(`${nodeApiBaseUrl}/api/relistTicketBySuperUser`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ input }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to relist ticket';
      throw new Error(message);
    }
    return responseData;
  };

  const assertRelistRestSuccess = (response: any) => {
    const message = String(response?.message || '').toLowerCase();
    if (message.includes('fail') || message.includes('error')) {
      throw new Error(response?.message || 'Failed to relist ticket');
    }
  };

  /** One Logitix BulkUpdate per selection — keeps VL groups intact on bulk undo. */
  const executeBatchedUndoDelistWithFallback = async (tpIds: string[]): Promise<void> => {
    if (!tpIds.length) return;
    const response = await callRelistTicketBySuperUserRest(tpIds);
    assertRelistRestSuccess(response);
  };

  const executeUndoDelistWithFallback = async (tpId: string, _currentStatus?: string): Promise<void> => {
    await executeBatchedUndoDelistWithFallback([tpId]);
  };

  const callDelistTicketsRest = async (
    ticketPlacementIds: string[],
    requestedEmailId: string,
    onProgress?: (progress: DelistJobProgress) => void,
  ) => {
    return delistTicketsRequest(ticketPlacementIds, requestedEmailId, onProgress);
  };

  const getDelistRequestEmail = () =>
    String(globalState?.profile?.mailId || localStorage.getItem('adminMailId') || '').trim().toLowerCase();

  const assertDelistTicketsRestSuccess = (data: any, fallbackMessage: string) => {
    const message = String(data?.message || '').trim();
    const status = String(data?.status || '').toLowerCase();
    const normalized = message.toLowerCase();
    if (
      status === 'failure' ||
      (normalized.includes('fail') && !normalized.includes('successfully'))
    ) {
      throw new Error(message || fallbackMessage);
    }
    return message;
  };

  /** Listed → Delisted: Unshare, add period, then delete Victory Live inventory. */
  const executeBatchedListedDelistRest = async (
    ticketPlacementIds: string[],
    onProgress?: (progress: DelistJobProgress) => void,
    requestedEmailId?: string,
  ) => {
    if (!ticketPlacementIds.length) {
      return { successIds: [] as string[], message: '' };
    }
    const data = await callDelistTicketsRest(
      ticketPlacementIds,
      (requestedEmailId || getDelistRequestEmail()).trim(),
      onProgress,
    );
    const message = assertDelistTicketsRestSuccess(
      data,
      "We couldn't complete the delist request. Please try again.",
    );
    const successIds = readDelistSuccessTpIds(data);
    return {
      successIds,
      message: message || 'Ticket delisted successfully',
      failedDetails: Array.isArray(data?.failedDetails) ? data.failedDetails : [],
    };
  };

  const callEditTicketsRest = async (editInput: {
    e_id: string;
    tp_id: string;
    tp_section: string;
    tp_row: string;
    tp_seat_no: number;
    tp_list_price?: number;
    pricingMethod?: 'MANUAL' | 'FOLLOW_MARKET';
    forceUpdate?: boolean;
    group_tp_ids?: string[];
    group_seat_updates?: Array<{ tp_id: string; tp_seat_no: number }>;
    internalNotes?: string;
    externalNotes?: string;
    enabledMarketplaceIds?: string[];
  }) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const editTicketsInput: Record<string, unknown> = {
      e_id: editInput.e_id,
      tp_id: editInput.tp_id,
      tp_section: editInput.tp_section,
      tp_row: editInput.tp_row,
      tp_seat_no: editInput.tp_seat_no,
    };
    if (editInput.tp_list_price != null) editTicketsInput.tp_list_price = editInput.tp_list_price;
    if (editInput.pricingMethod) editTicketsInput.pricingMethod = editInput.pricingMethod;
    if (editInput.forceUpdate != null) editTicketsInput.forceUpdate = editInput.forceUpdate;
    if (editInput.group_tp_ids?.length) editTicketsInput.group_tp_ids = editInput.group_tp_ids;
    if (editInput.group_seat_updates?.length) {
      editTicketsInput.group_seat_updates = editInput.group_seat_updates;
    }
    if (Object.prototype.hasOwnProperty.call(editInput, 'internalNotes')) {
      editTicketsInput.internalNotes = editInput.internalNotes;
    }
    if (Object.prototype.hasOwnProperty.call(editInput, 'externalNotes')) {
      editTicketsInput.externalNotes = editInput.externalNotes;
    }
    if (editInput.enabledMarketplaceIds?.length) {
      editTicketsInput.enabledMarketplaceIds = editInput.enabledMarketplaceIds;
    }
    const response = await fetch(`${nodeApiBaseUrl}/api/editTickets`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ input: { editTicketsInput } }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(responseData?.message || responseData?.error || 'Failed to update ticket details');
    }
    return responseData;
  };

  const callPublishTicketsRest = async (ticketPlacementIds: string[], listPrice: number) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/publishTickets`, {
      method: 'POST', headers,
      body: JSON.stringify({ input: { publishTicketInput: { ticketPlacementIds, listPrice } } })
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(responseData?.message || 'Failed to publish tickets');
    return responseData;
  };

  /** Non-VL list / delist-undo: always writes List + price (publishTickets skips Delist / invalid seats). */
  const callPublishNonVlListing = async (ticketPlacementIds: string[], listPrice: number) => {
    const result = await publishNonVlListingMutation({
      variables: { tp_ids: ticketPlacementIds, tp_list_price: listPrice },
    });
    const affected = result?.data?.update_ticket_placement?.affected_rows ?? 0;
    if (!affected) {
      throw new Error('No tickets were updated. Reload and try again.');
    }
    return result.data.update_ticket_placement;
  };
  
  const callReturnTicketsRest = async (ticketPlacementId: string[]) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/returnTickets`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: { ticketPlacementId },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to return tickets';
      throw new Error(message);
    }
    return responseData;
  };

  const callMarkTicketsUnsoldRest = async (ticketPlacementIds: string[]) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/markTicketsUnsold`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: { ticketPlacementIds },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to mark ticket as Unsold';
      throw new Error(message);
    }
    return responseData;
  };
const callMarkAsSoldRest = async (ticketPlacementId: string, soldAmount: number, logitixAmount: number, marketplaceName: string) => {
  const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
  const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
  const hasuraRole = localStorage.getItem('x-hasura-user-role');
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (idToken) headers.Authorization = `Bearer ${idToken}`;
  if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
  const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
  if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
  
  console.log('📤 SENDING MARK_AS_SOLD REQUEST:', {
    ticketPlacementId,
    soldAmount,
    logitixAmount,
    marketplaceName,
    timestamp: new Date().toISOString()
  });
  
  const response = await fetch(`${nodeApiBaseUrl}/api/markAsSold`, {
    method: 'POST', 
    headers,
    body: JSON.stringify({ 
      input: { 
        ticketPlacementId, 
        soldAmount, 
        logitixAmount, 
        marketplaceName
      } 
    })
  });
  const responseData = await response.json().catch(() => ({}));
  
  if (!response.ok) {
    console.error('❌ MARK_AS_SOLD FAILED:', {
      status: response.status,
      ticketPlacementId,
      marketplaceName,
      error: responseData?.message || 'Unknown error'
    });
    throw new Error(responseData?.message || 'Failed to mark ticket as sold');
  }
  
  console.log('✅ MARK_AS_SOLD SUCCESS:', {
    ticketPlacementId,
    marketplaceName,
    response: responseData
  });
  
  return responseData;
};

  const callUpdateSettlementPaymentStatusRest = async (
    ticketPlacementIds: string[],
    paymentStatus: string | null,
  ) => {
    const idTokenKey = Object.keys(localStorage).find((key) => key.includes('idToken')) as string;
    const idToken = idTokenKey ? localStorage.getItem(idTokenKey) : '';
    const hasuraRole = localStorage.getItem('x-hasura-user-role');
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    if (idToken) headers.Authorization = `Bearer ${idToken}`;
    if (hasuraRole) headers['x-hasura-role'] = hasuraRole;
    const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
    if (!nodeApiBaseUrl) throw new Error('Backend API URL not configured');
    const response = await fetch(`${nodeApiBaseUrl}/api/updateSettlementPaymentStatus`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        input: {
          ticketPlacementIds,
          paymentStatus,
        },
      }),
    });
    const responseData = await response.json().catch(() => ({}));
    if (!response.ok) {
      const message =
        responseData?.message ||
        responseData?.error ||
        responseData?.errors?.[0]?.message ||
        'Failed to update settlement status';
      throw new Error(message);
    }
    return responseData;
  };

  const handleDelistTicketsSubmit = async () => {
    if (!pendingDelistTpIds.length || !delistEmail.trim()) return;
    setDelistRequestLoading(true);
    const hadPreVerificationTickets = pendingDelistTpIds.some((tpId) => {
      const ticket = currentTickets.find((row) => row.tpId === tpId);
      return mapStatusForMutation(ticket?.rawStatus || ticket?.status || '') === 'ToBeVerified';
    });
    try {
      const data = await callDelistTicketsRest(pendingDelistTpIds, delistEmail.trim());
      const message = String(data?.message || '');
      const normalized = message.toLowerCase();
      const status = String(data?.status || '').toLowerCase();
      const successIds = readDelistSuccessTpIds(data);

      const successFromApi = Array.isArray(data?.successTpIds) ? data.successTpIds.length : 0;
      const hasBackendSuccesses = successFromApi > 0;
      const nextRawStatus = hadPreVerificationTickets ? 'ListingRequestCancelled' : 'Delist';
      const nextLabel = hadPreVerificationTickets ? 'Listing Request Cancelled' : 'Delisted';
      const nextTab = hadPreVerificationTickets ? 'Listing Request Cancelled' : 'Delisted';

      if (
        hasBackendSuccesses &&
        (status === 'failure' || (normalized.includes('failed') && !normalized.includes('success')))
      ) {
        showSuccess(
          message ||
            (successFromApi === pendingDelistTpIds.length
              ? (hadPreVerificationTickets ? 'Listing request cancelled successfully' : 'Delist request submitted successfully')
              : 'Delist request submitted for some tickets; refresh if counts look off.'),
        );
        updateLocalTicket(successIds, { rawStatus: nextRawStatus, status: nextLabel });
        if (activeFilterTab !== nextTab) setActiveFilterTab(nextTab);
      } else if (status === 'failure' || (normalized.includes('failed') && !normalized.includes('success'))) {
        showError(message || 'Failed to delist tickets');
      } else if (status === 'partial_success' || (normalized.includes('failed') && normalized.includes('success'))) {
        showInfo(message || 'Delist request processed with partial success');
        updateLocalTicket(successIds, { rawStatus: nextRawStatus, status: nextLabel });
        if (activeFilterTab !== nextTab) setActiveFilterTab(nextTab);
      } else if (status === 'success' || normalized.includes('success')) {
        showSuccess(message || (hadPreVerificationTickets ? 'Listing request cancelled successfully' : 'Delist request submitted successfully'));
        updateLocalTicket(successIds, { rawStatus: nextRawStatus, status: nextLabel });
        if (activeFilterTab !== nextTab) setActiveFilterTab(nextTab);
      } else {
        showInfo(message || 'Delist request processed');
        updateLocalTicket(successIds, { rawStatus: nextRawStatus, status: nextLabel });
        if (activeFilterTab !== nextTab) setActiveFilterTab(nextTab);
      }
      await refreshTicketsAndNotifications();
      setShowDelistEmailModal(false);
      setPendingDelistTpIds([]);
      setDelistEmail('');
      setDelistConfirmEmail('');
      clearBulkSelection();
    } catch (err: any) {
      showError(err?.message || 'Failed to delist tickets');
      setShowDelistEmailModal(false);
      setPendingDelistTpIds([]);
      setDelistEmail('');
      setDelistConfirmEmail('');
      clearBulkSelection();
    } finally {
      setDelistRequestLoading(false);
    }
  };
  
  const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const getTeamSeatTickets = (teamName: string, abbreviation: string) => {
  const normalizedName = (teamName || '').trim().toLowerCase();
  const normalizedAbbrev = (abbreviation || '').trim();
  const abbrRegex = normalizedAbbrev ? new RegExp(`\\b${escapeRegExp(normalizedAbbrev)}\\b`, 'i') : null;
  
  return currentTickets.filter((ticket) => {
    const eventName = (ticket.event || '').toLowerCase();
    if (normalizedName && eventName.includes(normalizedName)) return true;
    if (abbrRegex && abbrRegex.test(ticket.event || '')) return true;
    return false;
  });
};
  
  const getContrastTextColor = (hexColor: string) => {
    const normalized = (hexColor || '').replace('#', '').trim();
    if (normalized.length !== 6 || Number.isNaN(Number(`0x${normalized}`))) return '#ffffff';
    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? '#0f172a' : '#ffffff';
  };

  const getTeamAbbreviation = (abbrev: string | null | undefined, name: string): string => {
    if (abbrev && abbrev.trim()) return abbrev.trim().substring(0, 3).toUpperCase();
    if (!name) return '?';
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 3).toUpperCase();
  };
  
  // Render Functions
  const renderInlineEditForm = () => {
    if (!editFormData) return null;
    return (
      <>
        <div className={styles.formSection}>
          <h4><Building size={16} /> Business Information</h4>
          <div className={styles.formRow}>
            <div className={styles.formGroup}><label>Business Name</label><input type="text" name="business" value={editFormData.business} onChange={handleInputChange} className={styles.formInput} placeholder="Enter business name" /></div>
            <div className={styles.formGroup}><label>User Fee Percentage (%)</label><input type="number" name="userFee" value={editFormData.userFee} onChange={handleInputChange} className={styles.formInput} placeholder={editFormData.type === 'Self Pricing' ? '15' : '20'} min="0" max="100" step="0.1" disabled={!canEditPricing} /><small className={styles.inputHint}>{canEditPricing ? 'Total fee charged to user' : 'Only admin, sub-admin, or sales rep can update user fee'}</small></div>
          </div>
        </div>
        <div className={styles.formSection}>
          <h4><User size={16} /> Contact Information</h4>
          <div className={styles.formRow}>
            <div className={styles.formGroup}><label>Full Name</label><input type="text" value={editFormData.name} className={styles.formInput} placeholder="Full name" readOnly /><small className={styles.inputHint}>Read-only field</small></div>
            <div className={styles.formGroup}><label>User Type</label><select name="type" value={editFormData.type} onChange={handleInputChange} className={styles.formSelect} disabled={!canEditPricing}><option value="Self Pricing">Self Pricing</option><option value="Concierge">Concierge</option></select>{!canEditPricing && <small className={styles.inputHint}>Only admin, sub-admin, or sales rep can change user type</small>}</div>
          </div>
          <div className={styles.formRow}>
            <div className={styles.formGroup}><label>Email Address</label><input type="email" name="email" value={editFormData.email} onChange={handleInputChange} className={styles.formInput} placeholder="Enter email" /></div>
            <div className={styles.formGroup}><label>Phone Number</label><input type="text" name="phone" value={editFormData.phone} onChange={handleInputChange} className={styles.formInput} placeholder="Enter phone number" /></div>
          </div>
        </div>
        {currentUser && hasAddressValues(currentUser) && (
          <div className={styles.formSection}>
            <h4><MapPin size={16} /> Address</h4>
            <div className={styles.formGroup}><label>Street Address</label><input type="text" name="address1" value={editFormData.address1} onChange={handleInputChange} className={styles.formInput} placeholder="Street address" /></div>
            <div className={styles.formRow}>
              <div className={styles.formGroup}><label>City</label><input type="text" name="city" value={editFormData.city} onChange={handleInputChange} className={styles.formInput} placeholder="City" /></div>
              <div className={styles.formGroup}><label>State</label><input type="text" name="state" value={editFormData.state} onChange={handleInputChange} className={styles.formInput} placeholder="State" /></div>
              <div className={styles.formGroup}><label>ZIP Code</label><input type="text" name="zip" value={editFormData.zip} onChange={handleInputChange} className={styles.formInput} placeholder="ZIP code" /></div>
            </div>
            <div className={styles.formGroup}><label>Country</label><input type="text" name="country" value={editFormData.country} onChange={handleInputChange} className={styles.formInput} placeholder="Country" /></div>
          </div>
        )}
        <div className={styles.editFormFooter}><button className={styles.cancelBtn} onClick={handleCancelEdit} disabled={updateLoading || emailUpdateLoading}>Cancel</button><button className={styles.saveBtn} onClick={handleSaveEdit} disabled={updateLoading || emailUpdateLoading}>{updateLoading || emailUpdateLoading ? 'Saving...' : 'Save Changes'}</button></div>
      </>
    );
  };
  
  const renderListedShareConfirmModal = () => {
    if (!listedShareConfirm || !listedShareConfirm.tpIds.length) return null;
    return (
      <ListedShareConfirmModal
        targetShared={listedShareConfirm.targetShared}
        ticketCount={listedShareConfirm.tpIds.length}
        loading={listedSharedToggleLoading}
        onCancel={cancelListedShareConfirm}
        onConfirm={confirmListedShareToggle}
      />
    );
  };

  const renderListedDelistConfirmModal = () => {
    if (!showListedDelistConfirm || !listedDelistTpIds.length) return null;
    return (
      <ListedDelistConfirmModal
        ticketCount={listedDelistTpIds.length}
        enableReturnEmailSelection
        qaUserEmail={authenticatedProfileEmail}
        storedReturnEmail={listedDelistStoredEmail}
        loading={vlActionLoading}
        progress={listedDelistProgress}
        onCancel={cancelListedDelistConfirm}
        onConfirm={(requestedEmailId) => confirmListedDelist(requestedEmailId)}
        onRetryStep={(step, requestedEmailId) => void confirmListedDelist(requestedEmailId, step)}
      />
    );
  };

  const renderSelfPricingPriceConfirmModal = () => {
    if (!showSelfPricingPriceConfirm) return null;
    return (
      <SelfPricingPriceConfirmModal
        ticketCount={selfPricingPriceConfirmCount}
        summary={selfPricingPriceConfirmSummary}
        loading={priceModalLoading || bulkPriceLoading}
        onCancel={cancelSelfPricingPriceConfirm}
        onConfirm={confirmSelfPricingPriceChange}
      />
    );
  };

  const renderNonVlStatusConfirmModal = () => {
    if (!showNonVlStatusConfirm) return null;
    return (
      <NonVlStatusConfirmModal
        summary={nonVlStatusConfirmSummary}
        loading={bulkStatusChangeLoading || changeStatusLoading || listedModalLoading}
        onCancel={cancelNonVlStatusConfirm}
        onConfirm={confirmNonVlStatusChange}
      />
    );
  };

  const renderListedMarketplaceEditModal = () => {
    if (!showListedMarketplaceEdit || !listedMarketplaceEditTpIds.length) return null;
    return (
      <div
 className={styles.modalOverlay}
 >
        <div
          className={`${styles.modalContent} ${styles.vlShareModal}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.modalHeader}>
            <h3>Edit marketplace selection</h3>
            <button
              type="button"
              className={styles.modalClose}
              disabled={listedMarketplaceEditLoading}
              onClick={() => setShowListedMarketplaceEdit(false)}
            >
              ×
            </button>
          </div>
          <div className={styles.modalBody}>
            <p className={styles.vlShareHint}>
              Choose which Victory Live marketplaces this listing is shared to. The ticket stays
              Listed — only marketplace sites change.
            </p>
            <div className={styles.vlShareMarketplaceActions}>
              <button
                type="button"
                className={styles.modalCancel}
                onClick={() =>
                  setListedEditMarketplaces(VL_MARKETPLACE_OPTIONS.map((m) => m.id))
                }
                disabled={listedMarketplaceEditLoading}
              >
                Select all
              </button>
              <button
                type="button"
                className={styles.modalCancel}
                onClick={() => setListedEditMarketplaces([])}
                disabled={listedMarketplaceEditLoading}
              >
                Clear all
              </button>
            </div>
            <div className={styles.vlShareMarketplaceGrid}>
              {VL_MARKETPLACE_OPTIONS.map((m) => {
                const checked = listedEditMarketplaces.includes(m.id);
                return (
                  <label key={m.id} className={styles.vlShareMarketplaceOption}>
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={listedMarketplaceEditLoading}
                      onChange={() => {
                        setListedEditMarketplaces((prev) =>
                          checked ? prev.filter((id) => id !== m.id) : [...prev, m.id],
                        );
                      }}
                    />
                    <MarketplaceBrandMark id={m.id} />
                    {m.label}
                  </label>
                );
              })}
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.modalCancel}
              onClick={() => setShowListedMarketplaceEdit(false)}
              disabled={listedMarketplaceEditLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.modalConfirm}
              onClick={() => void handleUpdateListedMarketplaces()}
              disabled={listedMarketplaceEditLoading || listedEditMarketplaces.length === 0}
            >
              {listedMarketplaceEditLoading ? 'Saving…' : 'Save marketplaces'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderDeleteConfirm = () => {
    return (
      <div className={styles.deleteConfirmOverlay}>
        <div className={styles.deleteConfirmContainer}>
          <h3>Delete User</h3>
          <p>Are you sure you want to delete this user? This action cannot be undone.</p>
          <div className={styles.deleteConfirmActions}>
            <button className={styles.cancelBtn} onClick={() => setShowDeleteConfirm(false)} disabled={deleteLoading}>Cancel</button>
            <button className={styles.deleteConfirmBtn} onClick={handleDeleteUser} disabled={deleteLoading}>{deleteLoading ? 'Deleting...' : 'Delete User'}</button>
          </div>
        </div>
      </div>
    );
  };

  const renderTicketDeleteConfirm = () => {
    if (!showTicketDeleteConfirm || !ticketPendingDelete) return null;
    const statusLabel = getStatusLabel(ticketPendingDelete.rawStatus || ticketPendingDelete.status || '');
    const statusToken = normalizeStatusToken(ticketPendingDelete.rawStatus || ticketPendingDelete.status || '');
    const statusBg = (statusToken.includes('list') || statusToken.includes('verified')) ? '#ecfdf5' : '#eef2ff';
    const statusColor = (statusToken.includes('list') || statusToken.includes('verified')) ? '#166534' : '#1d4ed8';
    return (
      <div className={styles.deleteConfirmOverlay}>
        <div className={`${styles.deleteConfirmContainer} ${styles.ticketDeleteContainer}`} onClick={(e) => e.stopPropagation()}>
          <div className={styles.ticketDeleteHeader}>
            <div className={styles.ticketDeleteHeaderLeft}>
              <div className={styles.ticketDeleteIcon}><AlertTriangle color="#b91c1c" size={18} /></div>
              <div className={styles.ticketDeleteTitleBlock}>
                <div className={styles.ticketDeleteTitle}>Delete Ticket</div>
                <div className={styles.ticketDeleteSubtitle}>This will remove the ticket from active views</div>
              </div>
            </div>
            <button className={styles.ticketDeleteClose} onClick={() => setShowTicketDeleteConfirm(false)} aria-label="Close"><X size={18} /></button>
          </div>

          <div className={styles.ticketDeleteEventBlock}>
            <div className={styles.ticketDeleteEventName}>{ticketPendingDelete.event}</div>
            <div className={styles.ticketDeleteEventMeta}>{`${ticketPendingDelete.section || ''} • Row ${ticketPendingDelete.row || '-'} • Seat ${ticketPendingDelete.seatNo || '-'}`}</div>
            <div className={styles.ticketDeleteStatusWrap}>
              <span className={styles.ticketDeleteStatusBadge} style={{ background: statusBg, color: statusColor }}>{statusLabel}</span>
            </div>
          </div>

          <div className={styles.ticketDeleteWarning}>
            
            <div>
              <b>Are you sure you want to delete this ticket?</b>
              <p style={{ margin: 0, marginTop: 6 }}>This action will remove the ticket from active views and cannot be undone.</p>
            </div>
          </div>

          <div className={styles.ticketDeleteActions}>
            <button className={styles.cancelBtn} onClick={() => setShowTicketDeleteConfirm(false)} disabled={ticketDeleteLoading}>Cancel</button>
            <button className={styles.deleteConfirmBtn} onClick={handleConfirmDeleteTicket} disabled={ticketDeleteLoading}>
              {ticketDeleteLoading ? 'Deleting…' : 'Delete Ticket'}
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  const renderSeatLevelNotes = () => {
    const hasSeatDetails = (ticket: Ticket) =>
      Boolean(
        String(ticket.section || '').trim() &&
          String(ticket.row || '').trim() &&
          parseSeatNumbersFromRange(ticket.seatNo).length,
      );
    const availableTeams = Array.from(
      new Map(
        selectedTeams
          .filter((team) => getTeamSeatTickets(team.name, team.abbreviation).some(hasSeatDetails))
          .map((team) => [team.id, team]),
      ).values(),
    );
    /** Dropdown for the note boxes: this user's saved notes for the spot, plus the standard phrases. */
    const seatNoteDropdownChoices = (field: 'internalNote' | 'externalNote') =>
      withListingAmenityNotes(
        profileNoteChoices(
          seatLevelNotes,
          {
            userId: String(userId || ''),
            teamId: seatLevelTeam?.id,
            teamName: seatLevelTeam?.name,
            section: seatLevelNoteForm.section,
            row: seatLevelNoteForm.row,
          },
          field,
        ),
      );
    const selectedTeamTickets = seatLevelTeam
      ? getTeamSeatTickets(seatLevelTeam.name, seatLevelTeam.abbreviation).filter(hasSeatDetails)
      : [];
    const seatingLocations = Array.from(
      selectedTeamTickets.reduce((locations, ticket) => {
        const section = String(ticket.section || '').trim();
        const row = String(ticket.row || '').trim();
        const seatNumbers = parseSeatNumbersFromRange(ticket.seatNo);
        if (!section || !row || seatNumbers.length === 0) return locations;

        const locationKey = `${section}|${row}`;
        const location = locations.get(locationKey) || { section, row, ranges: [] as Array<{ start: number; end: number }> };
        const start = seatNumbers[0];
        const end = seatNumbers[seatNumbers.length - 1];
        const alreadyStored = location.ranges.some((range) => range.start === start && range.end === end);
        if (!alreadyStored) location.ranges.push({ start, end });
        locations.set(locationKey, location);
        return locations;
      }, new Map<string, { section: string; row: string; ranges: Array<{ start: number; end: number }> }>())
    ).flatMap(([, location]) => {
      const individualSeats = new Set<number>();
      const explicitRanges: Array<{ start: number; end: number }> = [];
      location.ranges.forEach((range) => {
        if (range.start === range.end) individualSeats.add(range.start);
        else explicitRanges.push(range);
      });

      const groupedSingles: Array<{ start: number; end: number }> = [];
      Array.from(individualSeats).sort((a, b) => a - b).forEach((seat) => {
        const previous = groupedSingles[groupedSingles.length - 1];
        if (previous && seat === previous.end + 1) previous.end = seat;
        else groupedSingles.push({ start: seat, end: seat });
      });

      return [...explicitRanges, ...groupedSingles]
        .sort((a, b) => a.start - b.start)
        .map((range) => ({
          section: location.section,
          row: location.row,
          seats: `${range.start}${range.end !== range.start ? `-${range.end}` : ''}`,
          seatStart: range.start,
          seatEnd: range.end,
        }));
    });
    const visibleNotes = seatLevelNotes.filter((note) => note.userId === userId && note.teamId === seatLevelTeam?.id);
    const sections = Array.from(new Set(seatingLocations.map((location) => location.section)));
    const rows = Array.from(new Set(seatingLocations.filter((location) => location.section === seatLevelSection).map((location) => location.row)));
    const ranges = seatingLocations.filter((location) => location.section === seatLevelSection && location.row === seatLevelRow);
    const selectedLocation = ranges.find((location) => location.seats === seatLevelRange);
    const selectedNote = selectedLocation ? matchedSeatLevelNote : null;

    const handleSaveSeatLevelNote = async () => {
      const startSeat = Number(seatLevelNoteForm.startSeat);
      const endSeat = Number(seatLevelNoteForm.endSeat);
      if (!userId || !seatLevelTeam || !seatLevelNoteForm.section || !seatLevelNoteForm.row || !Number.isInteger(startSeat) || !Number.isInteger(endSeat) || startSeat <= 0 || endSeat < startSeat) {
        showError('Team, section, row, start seat, and end seat are required for saved seat notes.');
        return;
      }
      try {
        const internalNote = seatLevelNoteForm.internalNote.trim();
        const externalNote = seatLevelNoteForm.externalNote.trim();
        const now = new Date().toISOString();
        if (seatLevelNoteForm.id) {
          await updateSeatLevelNote({ variables: {
            vlsn_id: seatLevelNoteForm.id,
            internal_note: internalNote,
            external_note: externalNote,
          }});
          setSeatLevelNotes((previous) => previous.map((note) => note.id === seatLevelNoteForm.id
            ? { ...note, internalNote, externalNote, updatedAt: now }
            : note));
        } else {
          const result = await insertSeatLevelNote({ variables: {
            u_id: userId, lc_id: seatLevelTeam.id,
            section: seatLevelNoteForm.section.trim(), seat_row: seatLevelNoteForm.row.trim(),
            seat_start: startSeat, seat_end: endSeat,
            internal_note: internalNote, external_note: externalNote,
          }});
          const insertedId = String(result.data?.insert_user_victory_live_seat_notes_one?.vlsn_id || '');
          if (!insertedId) throw new Error('Seat-level note was saved but no note ID was returned.');
          setSeatLevelNotes((previous) => [...previous, {
            id: insertedId,
            userId,
            teamId: seatLevelTeam.id,
            teamName: seatLevelTeam.name,
            section: seatLevelNoteForm.section.trim(),
            row: seatLevelNoteForm.row.trim(),
            seatStart: startSeat,
            seatEnd: endSeat,
            internalNote,
            externalNote,
            createdAt: now,
            updatedAt: now,
          }]);
        }
        setSeatLevelNoteForm({ id: '', team: '', section: '', row: '', startSeat: '', endSeat: '', internalNote: '', externalNote: '' });
        setShowSeatLevelNoteForm(false);
        showSuccess(seatLevelNoteForm.id ? 'Seat-level note updated.' : 'Seat-level note saved.');
      } catch (error: any) {
        showError(error?.message || 'Unable to save notes. Please try again.');
      }
    };

    const handleDeleteSeatLevelNote = async (noteId: string) => {
      const confirmed = window.confirm('Delete this seat-level note?');
      if (!confirmed) return;

      try {
        await deleteSeatLevelNote({ variables: { vlsn_id: noteId } });
        setSeatLevelNotes((previous) => previous.filter((note) => note.id !== noteId));
        await refetchSeatLevelNotes();
      } catch (error: any) {
        showError(error?.message || 'Unable to delete notes. Please try again.');
      }
    };

    return (
      <div style={{ marginTop: 18, paddingTop: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 12 }}>
         
          <span style={{ fontSize: 12, color: '#64748b' }}>Select a seating location below</span>
        </div>

        {availableTeams.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>Team</div>
            <SearchableTeamSelect
              teams={availableTeams}
              value={seatLevelTeam}
              onChange={(team) => {
                setSeatLevelTeam(team);
                setSeatLevelSection('');
                setSeatLevelRow('');
                setSeatLevelRange('');
              }}
            />
          </div>
        )}

       <div style={{ display: 'grid', gap: 10, marginBottom: 14 }}>
          <label style={{ fontSize: 12, color: '#64748b' }}>Section
            <SearchableValueSelect
              options={sections}
              value={seatLevelSection}
              disabled={!seatLevelTeam}
              placeholder={seatLevelTeam ? 'Select Section' : 'Select Team First'}
              searchPlaceholder="Search Section..."
              onChange={(value) => { setSeatLevelSection(value); setSeatLevelRow(''); setSeatLevelRange(''); }}
            />
          </label>
          <label style={{ fontSize: 12, color: '#64748b' }}>Row
            <SearchableValueSelect
              options={rows}
              value={seatLevelRow}
              disabled={!seatLevelSection}
              placeholder={seatLevelSection ? 'Select Row' : 'Select Section First'}
              searchPlaceholder="Search Row..."
              onChange={(value) => { setSeatLevelRow(value); setSeatLevelRange(''); }}
            />
          </label>
          <label style={{ fontSize: 12, color: '#64748b' }}>Seat Range
            <SearchableValueSelect
              options={ranges.map((location) => location.seats)}
              value={seatLevelRange}
              disabled={!seatLevelRow}
              placeholder={seatLevelRow ? 'Select Seat Range' : 'Select Row First'}
              searchPlaceholder="Search Seat Range..."
              onChange={setSeatLevelRange}
            />
          </label>
        </div>

        {showSeatLevelNoteForm && selectedLocation && seatLevelTeam && (
          <div className={styles.modalOverlay} role="presentation">
            <div className={styles.modal} role="dialog" aria-modal="true" aria-labelledby="seat-level-note-title">
              <div className={styles.modalHeader}>
                <h3 id="seat-level-note-title">{seatLevelNoteForm.id ? 'Edit Victory Live Note' : 'Add Victory Live Note'}</h3>
                <button type="button" className={styles.closeBtn} onClick={() => setShowSeatLevelNoteForm(false)} aria-label="Close note popup"><X size={18} /></button>
              </div>
              <div className={styles.modalBody}>
                <div style={{ display: 'grid', gap: 12 }}>
                  {(() => {
                    const isEditMode = Boolean(seatLevelNoteForm.id);
                    return (
                      <>
                  <div className={styles.seatNoteMetaGrid}>
                    <label style={{ fontSize: 12, color: '#64748b' }}>Team
                      <SearchableTeamSelect
                        teams={availableTeams}
                        value={seatLevelTeam}
                        disabled={isEditMode}
                        onChange={(team) => {
                          setSeatLevelTeam(team);
                          setSeatLevelNoteForm((previous) => ({ ...previous, team: team?.id || '', section: '', row: '', startSeat: '', endSeat: '' }));
                        }}
                      />
                    </label>
                    <label style={{ fontSize: 12, color: '#64748b' }}>Section<input value={seatLevelNoteForm.section} readOnly={isEditMode} onChange={(event) => setSeatLevelNoteForm((previous) => ({ ...previous, section: event.target.value, row: '', startSeat: '', endSeat: '' }))} style={{ display: 'block', width: '100%', marginTop: 5, border: '1px solid #dbeafe', borderRadius: 8, padding: '9px 10px' }} /></label>
                    <label style={{ fontSize: 12, color: '#64748b' }}>Row<input value={seatLevelNoteForm.row} readOnly={isEditMode} onChange={(event) => setSeatLevelNoteForm((previous) => ({ ...previous, row: event.target.value, startSeat: '', endSeat: '' }))} style={{ display: 'block', width: '100%', marginTop: 5, border: '1px solid #dbeafe', borderRadius: 8, padding: '9px 10px' }} /></label>
                  </div>
                  <div className={styles.seatNoteMetaGrid}>
                    <label style={{ fontSize: 12, color: '#64748b' }}>Start Seat<input type="number" min="1" value={seatLevelNoteForm.startSeat} readOnly={isEditMode} onChange={(event) => setSeatLevelNoteForm((previous) => ({ ...previous, startSeat: event.target.value }))} style={{ display: 'block', width: '100%', marginTop: 5, border: '1px solid #dbeafe', borderRadius: 8, padding: '9px 10px' }} /></label>
                    <label style={{ fontSize: 12, color: '#64748b' }}>End Seat<input type="number" min="1" value={seatLevelNoteForm.endSeat} readOnly={isEditMode} onChange={(event) => setSeatLevelNoteForm((previous) => ({ ...previous, endSeat: event.target.value }))} style={{ display: 'block', width: '100%', marginTop: 5, border: '1px solid #dbeafe', borderRadius: 8, padding: '9px 10px' }} /></label>
                  </div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>
                    Internal Notes
                    <div style={{ marginTop: 5 }}>
                      <ListingNoteCombobox
                        value={seatLevelNoteForm.internalNote}
                        options={seatNoteDropdownChoices('internalNote')}
                        sentValue={seatLevelNoteForm.internalNote}
                        placeholder="Search or enter internal notes"
                        onChange={(value) => {
                          const draft = composeListingNoteDraft(value, seatNoteDropdownChoices('internalNote'), '', 'internal');
                          setSeatLevelNoteForm((prev) => ({ ...prev, internalNote: draft.query }));
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>
                    External Notes
                    <div style={{ marginTop: 5 }}>
                      <ListingNoteCombobox
                        value={seatLevelNoteForm.externalNote}
                        options={seatNoteDropdownChoices('externalNote')}
                        sentValue={seatLevelNoteForm.externalNote}
                        placeholder="Search or enter external notes"
                        onChange={(value) => {
                          const draft = composeListingNoteDraft(value, seatNoteDropdownChoices('externalNote'), '', 'external');
                          setSeatLevelNoteForm((prev) => ({ ...prev, externalNote: draft.query }));
                        }}
                      />
                    </div>
                  </div>
                      </>
                    );
                  })()}
                </div>
              </div>
              <div className={styles.modalFooter}>
                <button type="button" className={styles.cancelBtn} onClick={() => setShowSeatLevelNoteForm(false)}>Cancel</button>
                <button type="button" className={styles.saveBtn} onClick={handleSaveSeatLevelNote}>{seatLevelNoteForm.id ? 'Save Changes' : 'Save Notes'}</button>
              </div>
            </div>
          </div>
        )}

        {/* {selectedLocation && (
          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 12, marginBottom: 14 }}>
            <div style={{ fontWeight: 700, marginBottom: 8 }}>Selected Seating Location</div>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>
              {selectedLocation.section} / Row {selectedLocation.row} / Seats {selectedLocation.seats}
            </div>
            {selectedNote ? (
              <div style={{ display: 'grid', gap: 8 }}>
                <div><b style={{ fontSize: 12 }}>Internal Notes</b><div style={{ marginTop: 4, whiteSpace: 'pre-wrap' }}>{selectedNote.internalNote || '—'}</div></div>
                <div><b style={{ fontSize: 12 }}>External Notes</b><div style={{ marginTop: 4, whiteSpace: 'pre-wrap' }}>{selectedNote.externalNote || '—'}</div></div>
                <button type="button" onClick={() => { setSeatLevelNoteForm({ id: selectedNote.id, team: seatLevelTeam?.id || '', section: selectedLocation.section, row: selectedLocation.row, startSeat: String(selectedLocation.seatStart), endSeat: String(selectedLocation.seatEnd), internalNote: selectedNote.internalNote, externalNote: selectedNote.externalNote }); setShowSeatLevelNoteForm(true); }} className={styles.addNote}>Edit</button>
              </div>
            ) : (
              <div style={{ color: '#64748b', fontSize: 13 }}>
                <div style={{ marginBottom: 8 }}>No notes have been configured for this seating location.</div>
                <button type="button" onClick={() => { setSeatLevelNoteForm({ id: '', team: seatLevelTeam?.id || '', section: selectedLocation.section, row: selectedLocation.row, startSeat: String(selectedLocation.seatStart), endSeat: String(selectedLocation.seatEnd), internalNote: '', externalNote: '' }); setShowSeatLevelNoteForm(true); }} className={styles.addNote}>+ Add Notes</button>
              </div>
            )}
          </div>
        )} */}

        {seatLevelNotesLoading && (
          <div className={styles.loadingSmall}><Loader size={18} className={styles.spinner} /><span>Loading saved notes...</span></div>
        )}
        {seatLevelNotesError && (
          <div style={{ color: '#b91c1c', fontSize: 13, marginBottom: 12 }}>
            Unable to load saved notes. Seating locations are still available.
            <button type="button" onClick={() => refetchSeatLevelNotes()} className={styles.addNote}>Retry</button>
          </div>
        )}
        {availableTeams.length === 0 ? (
          <div style={{ color: '#64748b', fontSize: 13 }}>No teams with tickets are available for this user.</div>
        ) : seatingLocations.length === 0 ? (
          <div style={{ color: '#64748b', fontSize: 13 }}>No seating locations found for this team.</div>
        ) : !selectedLocation ? (
          <div style={{ color: '#64748b', fontSize: 13 }}>Select a seat range to view or add notes.</div>
        ) : (
          <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
            {/* <div style={{ fontWeight: 700, color: '#0f172a', marginBottom: 8 }}>
              Section {selectedLocation.section}
            </div>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#334155', marginBottom: 8 }}>
              Row {selectedLocation.row}
            </div> */}
            <div style={{ border: '1px solid #dbeafe', borderRadius: 12, background: '#fff', padding: 12 }}>
              {/* <div style={{ fontSize: 12, color: '#64748b', marginBottom: 8 }}>Seats {selectedLocation.seats}</div> */}
              {selectedNote ? (
                <>
                  <div><b style={{ fontSize: 12 }}>Internal Notes</b><div style={{ marginTop: 4, whiteSpace: 'pre-wrap' }}>{selectedNote.internalNote || '—'}</div></div>
                  <div style={{ marginTop: 8 }}><b style={{ fontSize: 12 }}>External Notes</b><div style={{ marginTop: 4, whiteSpace: 'pre-wrap' }}>{selectedNote.externalNote || '—'}</div></div>
                  <div className={styles.seatLevelActionRow}>
                    <button
                      type="button"
                      onClick={() => {
                        setSeatLevelNoteForm({
                          id: selectedNote.id,
                          team: seatLevelTeam?.id || '',
                          section: selectedLocation.section,
                          row: selectedLocation.row,
                          startSeat: String(selectedLocation.seatStart),
                          endSeat: String(selectedLocation.seatEnd),
                          internalNote: selectedNote.internalNote,
                          externalNote: selectedNote.externalNote,
                        });
                        setShowSeatLevelNoteForm(true);
                      }}
                      className={styles.seatLevelEditBtn}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => handleDeleteSeatLevelNote(selectedNote.id)}
                      className={styles.seatLevelDeleteBtn}
                      aria-label="Delete seat-level note"
                      title="Delete note"
                    >
                      <Trash2 size={12} />
                    </button>
                  </div>
                </>
              ) : (
                <div style={{ color: '#64748b', fontSize: 13 }}>
                  <div style={{ marginBottom: 8 }}>No notes available for this seat range.</div>
                  <button type="button" onClick={() => { setSeatLevelNoteForm({ id: '', team: seatLevelTeam?.id || '', section: selectedLocation.section, row: selectedLocation.row, startSeat: String(selectedLocation.seatStart), endSeat: String(selectedLocation.seatEnd), internalNote: '', externalNote: '' }); setShowSeatLevelNoteForm(true); }} className={styles.addNote}>+ Add Notes</button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderNotesSection = (type: 'qa' | 'internal' | 'external', title: string) => {
    const filteredNotes = notes.filter(note => note.type === type);
    const showNoteState = type === 'qa' ? showQANote : type === 'internal' ? showInternalNote : showExternalNote;
    const setShowNoteState = type === 'qa' ? setShowQANote : type === 'internal' ? setShowInternalNote : setShowExternalNote;
    return (
      <div className={styles.noteSection}>
        <h4>{title}</h4>
        {filteredNotes.length > 0 && (
          <div className={styles.notesList}>
            {filteredNotes.map((note) => (
              <div key={note.id} className={styles.noteItem}>
                {editingNote?.id === note.id ? (
                  <div className={styles.noteEditContainer}>
                    <textarea className={styles.textarea} rows={2} value={editingNote.content} onChange={(e) => setEditingNote({ ...editingNote, content: e.target.value })} placeholder="Edit note..." />
                    <div className={styles.noteActions}>
                      <button className={styles.saveBtn} onClick={handleUpdateNote} disabled={updateNoteLoading}>Save</button>
                      <button className={styles.cancelBtn} onClick={() => setEditingNote(null)}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className={styles.noteContent}>
                      <p>{note.content}</p>
                      <div className={styles.noteMeta}>
                        <span className={styles.noteDate}>{new Date(note.createdAt).toLocaleString()}</span>
                        <span className={styles.noteAuthor}>by {note.createdBy}</span>
                      </div>
                    </div>
                    <div className={styles.noteButtons}>
                      <button className={styles.deleteNoteBtn} onClick={() => handleDeleteNote(note)} disabled={deleteNoteLoading}><Trash2 size={12} /></button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        )}
        {!showNoteState ? (
          <button className={styles.addNote} onClick={() => setShowNoteState(true)}><Plus size={14} /> Add {title.toLowerCase()} note...</button>
        ) : (
          <div className={styles.noteInputContainer}>
            <textarea
              className={styles.textarea}
              rows={3}
              placeholder={`Write ${title.toLowerCase()} note...`}
              value={newNoteContentByType[type]}
              onChange={(e) => setNewNoteContentByType((prev) => ({ ...prev, [type]: e.target.value }))}
            />
            <div className={styles.noteActions}>
              <button className={styles.saveBtn} onClick={() => handleAddNote(type)} disabled={addNoteLoading}>Save</button>
              <button className={styles.cancelBtn} onClick={() => { setShowNoteState(false); setNewNoteContentByType((prev) => ({ ...prev, [type]: '' })); }}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    );
  };
  
  const renderVoidPayoutsModal = () => {
    if (!showVoidPayoutsModal) return null;
    return (
      <div className={styles.modalOverlay}>
        <div className={styles.voidModal}>
          <div className={styles.modalHeader}><AlertTriangle size={20} color="#dc2626" /><h3>Void Payouts</h3><button className={styles.closeBtn} onClick={() => setShowVoidPayoutsModal(false)}><X size={18} /></button></div>
          <div className={styles.modalBody}>
            <p className={styles.warningText}>Are you sure you want to void payouts for <strong>{currentUser?.name}</strong>?</p>
            <p className={styles.warningSubtext}>Tickets sold by this user will not generate payouts until restored.</p>
            <div className={styles.formGroup}>
              <label htmlFor="voidReason">Reason (optional)</label>
              <textarea id="voidReason" className={styles.textarea} rows={3} placeholder="e.g., Pending investigation, payment issue..." value={voidReason} onChange={(e) => setVoidReason(e.target.value)} />
            </div>
            <div className={styles.formGroup} style={{ marginTop: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}><input type="checkbox" checked={addNoteOnVoid} onChange={(e) => setAddNoteOnVoid(e.target.checked)} /> <span>Add a note with this void action</span></label>
              {addNoteOnVoid && (
                <textarea className={styles.textarea} rows={3} placeholder="Optional note to attach to this void action" value={voidPayoutNote} onChange={(e) => setVoidPayoutNote(e.target.value)} />
              )}
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button className={styles.cancelBtn} onClick={() => setShowVoidPayoutsModal(false)} disabled={isVoidingPayouts}>Cancel</button>
            <button className={styles.dangerBtn} onClick={handleVoidPayouts} disabled={isVoidingPayouts}>{isVoidingPayouts ? 'Voiding...' : 'Void Payouts'}</button>
          </div>
        </div>
      </div>
    );
  };
  
const renderAddTeamModal = () => {
  if (!showAddTeamModal) return null;
  
  const assignedTeamIds = new Set(preferredCategoryIds);
  const unassignedTeams = availableTeamsForUser.filter(team => !assignedTeamIds.has(team.lc_id));
  
  const leagueMap = new Map<string, string>(
    (allLeaguesData?.leagues || []).map((league: any) => [league.l_id, league.l_name || league.l_id]),
  );
  unassignedTeams.forEach(team => {
    if (team.l_id && !leagueMap.has(team.l_id)) {
      leagueMap.set(team.l_id, team.l_id);
    }
  });
  
  const uniqueLeagues = Array.from(
    new Set(
      unassignedTeams
        .map((t) => t.l_id)
        .filter((id): id is string => typeof id === 'string' && id.trim().length > 0),
    ),
  );
  
  let leagueFilteredTeams = unassignedTeams;
  if (selectedLeagueFilter !== 'all') {
    leagueFilteredTeams = unassignedTeams.filter(team => team.l_id === selectedLeagueFilter);
  }
  
  const searchLower = teamSearchQuery.toLowerCase().trim();
  const filteredTeams = leagueFilteredTeams.filter(team =>
    !searchLower || 
    (team.lc_name || '').toLowerCase().includes(searchLower) ||
    (team.lc_abbrev || '').toLowerCase().includes(searchLower)
  );
  
  return (
    <div
      className={styles.modalOverlay}
      style={{
        animation: 'fadeIn 0.2s ease-out',
        backgroundColor: 'rgba(0,0,0,0.6)',
        backdropFilter: 'blur(2px)',
        zIndex: 1000,
      }}
    >
      <div 
        className={styles.modal} 
        style={{ 
          maxWidth: '580px', 
          width: '90%',
          animation: 'slideUp 0.3s ease-out', 
          backgroundColor: 'var(--card-bg)', 
          borderRadius: '16px', 
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ 
          background: 'linear-gradient(135deg, var(--accent) 0%, rgba(0,0,0,0.08) 100%)', 
          color: 'var(--card-bg)', 
          padding: '20px 24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>Add Team to User</h3>
            <p style={{ margin: '4px 0 0', fontSize: '13px', opacity: 0.8 }}>
              Select a team to assign to this user
            </p>
          </div>
          <button 
            className={styles.closeBtn} 
            onClick={() => { setShowAddTeamModal(false); setTeamSearchQuery(''); setSelectedLeagueFilter('all'); }} 
            style={{ 
              background: 'rgba(255,255,255,0.15)', 
              border: 'none', 
              color: 'white', 
              borderRadius: '8px', 
              padding: '6px 10px', 
              cursor: 'pointer', 
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
          >
            <X size={18} />
            <span style={{ fontSize: '13px' }}>Close</span>
          </button>
        </div>
        
        <div style={{ padding: '16px 24px', borderBottom: '1px solid var(--border)', backgroundColor: 'var(--bg)' }}>
          {uniqueLeagues.length > 0 && (
            <div style={{ marginBottom: '12px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'var(--muted)', marginBottom: '8px' }}>Filter by League</label>
              <select
                value={selectedLeagueFilter}
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setSelectedLeagueFilter(e.target.value)}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #cbd5e1',
                  borderRadius: '10px',
                  fontSize: '13px',
                  fontFamily: 'inherit',
                  backgroundColor: '#ffffff',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onFocus={(e: React.FocusEvent<HTMLSelectElement>) => {
                  e.currentTarget.style.borderColor = '#3b82f6';
                  e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e: React.FocusEvent<HTMLSelectElement>) => {
                  e.currentTarget.style.borderColor = '#cbd5e1';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <option value="all">All Leagues</option>
                {uniqueLeagues.map((leagueId) => (
                  <option key={leagueId} value={leagueId}>{leagueMap.get(leagueId) || leagueId || 'Unknown'}</option>
                ))}
              </select>
            </div>
          )}
          
          <div style={{ position: 'relative' }}>
            <Search size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--muted)' }} />
            <input
              type="text"
              placeholder="Search teams by name or abbreviation..."
              value={teamSearchQuery}
              onChange={(e) => setTeamSearchQuery(e.target.value)}
              autoFocus
              style={{
                width: '100%',
                padding: '10px 12px 10px 36px',
                border: `1px solid ${getComputedStyle(document.documentElement).getPropertyValue('--border') || '#cbd5e1'}`,
                borderRadius: '10px',
                fontSize: '14px',
                fontFamily: 'inherit',
                boxSizing: 'border-box',
                transition: 'all 0.2s',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text)'
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = '#3b82f6';
                e.currentTarget.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = '#cbd5e1';
                e.currentTarget.style.boxShadow = 'none';
              }}
            />
          </div>
          {teamSearchQuery && filteredTeams.length === 0 && !availableTeamsLoading && (
              <div style={{ fontSize: '12px', color: 'var(--muted)', marginTop: '8px', textAlign: 'center' }}>
              No teams found matching "{teamSearchQuery}"
            </div>
          )}
        </div>
        
        <div className={styles.modalBody} style={{ backgroundColor: 'var(--card-bg)', padding: 0 }}>
          {availableTeamsLoading ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', padding: '60px 20px' }}>
              <Loader size={24} className={styles.spinner} style={{ color: 'var(--accent)' }} />
              <span style={{ color: 'var(--muted)', fontSize: '14px' }}>Loading available teams...</span>
            </div>
          ) : unassignedTeams.length === 0 ? (
            <div style={{ padding: '60px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>✅</div>
              <p style={{ color: '#475569', fontSize: '15px', margin: 0, fontWeight: 500 }}>
                All available teams are already assigned
              </p>
              <p style={{ color: '#94a3b8', fontSize: '13px', marginTop: '8px' }}>
                This user has been assigned to all teams
              </p>
            </div>
          ) : filteredTeams.length === 0 ? (
            <div style={{ padding: '60px 20px', textAlign: 'center' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>🔍</div>
              <p style={{ color: '#475569', fontSize: '15px', margin: 0 }}>
                No teams match "{teamSearchQuery}"
              </p>
            </div>
          ) : (
            <div style={{ 
              maxHeight: '420px', 
              overflowY: 'auto', 
              padding: '16px 20px',
              scrollBehavior: 'smooth'
            }}>
                      <div style={{ marginBottom: '12px', fontSize: '12px', color: 'var(--muted)', fontWeight: 500 }}>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {filteredTeams.map((team) => {
                  const teamAbbr = getTeamAbbreviation(team.lc_abbrev, team.lc_name);
                  const isAdding = addingTeamId === team.lc_id;
                  
                  return (
                    <div
                      key={team.lc_id}
                      onClick={() => !isAdding && handleAddTeam(team.lc_id)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '12px',
                        padding: '10px',
                        borderRadius: '10px',
                        background: 'transparent',
                        cursor: addingTeamId === null ? 'pointer' : 'default',
                        transition: 'background 0.15s, transform 0.15s',
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            width: '48px',
                            height: '48px',
                            backgroundColor: team.lc_colour_code || '#9ca3af',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: getContrastTextColor(team.lc_colour_code || '#9ca3af'),
                            fontWeight: 'bold',
                            fontSize: '13px',
                            flexShrink: 0,
                            overflow: 'hidden',
                            textTransform: 'uppercase'
                          }}
                        >
                          {teamAbbr}
                        </div>

                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{
                            fontWeight: 600,
                            color: 'var(--text)',
                            fontSize: '15px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            marginBottom: '4px'
                          }}>
                            {team.lc_name}
                          </div>
                          <div style={{
                            fontSize: '12px',
                            color: 'var(--muted)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                          }}>
                            <span>{team.lc_abbrev || '—'}</span>
                            {team.l_id && leagueMap.get(team.l_id) && (
                              <>
                                <span style={{ color: 'var(--border)' }}>•</span>
                                <span style={{ color: 'var(--muted)', fontWeight: 500 }}>
                                  {leagueMap.get(team.l_id)}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '40px',
                          height: '40px',
                          backgroundColor: isAdding ? 'var(--input-bg)' : 'var(--accent-muted, #dbeafe)',
                          borderRadius: '10px',
                          transition: 'all 0.2s',
                          flexShrink: 0
                        }}
                      >
                        {isAdding ? (
                          <Loader size={18} style={{ animation: 'spin 1s linear infinite', color: 'var(--muted)' }} />
                        ) : (
                          <Plus size={20} color="var(--accent)" strokeWidth={2.5} />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        
        <div className={styles.modalFooter}>
          <button
            className={styles.cancelBtn}
            onClick={() => { setShowAddTeamModal(false); setTeamSearchQuery(''); setSelectedLeagueFilter('all'); }}
            disabled={addingTeamId !== null}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
  const getCtStatusBadgeClass = (status: string) => {
    const s = (status || '').toLowerCase().replace(/\s/g, '');
    if (s === 'verified' || s === 'settled') return styles.ctStatusBadgeVerified;
    if (s === 'list' || s === 'listed') return styles.ctStatusBadgeListed;
    if (s === 'sold') return styles.ctStatusBadgeSold;
    if (s === 'tobeverified') return styles.ctStatusBadgeToBeVerified;
    if (
      s === 'delist' ||
      s === 'delistinprogress' ||
      s === 'delistrequested' ||
      s === 'listingrequestcancelled' ||
      s === 'return' ||
      s === 'returned' ||
      s === 'invalid'
    ) {
      return styles.ctStatusBadgeInvalid;
    }
    if (s === 'unsold') return styles.ctStatusBadgeToBeVerified;
    return styles.ctStatusBadgeDefault;
  };

  const getCtStatusOptionClass = (statusValue: string, isSelected: boolean): string => {
    const isDelistOpt = statusValue === 'DelistInProgress' || statusValue === 'DelistRequested';
    if (isSelected) {
      return isDelistOpt
        ? `${styles.ctStatusOption} ${styles.ctStatusOptionOrangeSelected}`
        : `${styles.ctStatusOption} ${styles.ctStatusOptionSelected}`;
    }
    if (isDelistOpt) {
      return `${styles.ctStatusOption} ${styles.ctStatusOptionOrange}`;
    }
    return styles.ctStatusOption;
  };

  const renderBulkStatusModal = () => {
    if (!showBulkStatusModal || bulkSelectedTickets.length === 0) return null;
    const isBulkListTransition =
      normalizeStatusValue(bulkNewStatus) === 'List' ||
      normalizeStatusValue(bulkNewStatus) === 'List_NonVL';
    const isBulkSoldTransition = normalizeStatusValue(bulkNewStatus) === 'Sold';
    const bulkUndoToListTickets = bulkSelectedTickets.filter((ticket) => {
      const status = normalizeStatusValue(ticket.rawStatus || ticket.status);
      return status === 'Delist' || status === 'DelistInProgress' || status === 'DelistRequested';
    });
    const bulkPublishToListTickets = bulkSelectedTickets.filter(
      (ticket) => normalizeStatusValue(ticket.rawStatus || ticket.status) === 'Verified',
    );
    const isBulkListUndoOnly =
      isBulkListTransition && bulkUndoToListTickets.length === bulkSelectedTickets.length;
    const isBulkListPublishOnly =
      isBulkListTransition && bulkPublishToListTickets.length === bulkSelectedTickets.length;
    const bulkListPricesValid = isBulkListTransition
      ? areAllBulkStatusListingPricesValid(bulkSelectedTickets, bulkStatusListingPrices)
      : true;
    const bulkSoldReady = isBulkSoldTransitionReady(
      bulkSelectedTickets,
      bulkSoldLogitixAmounts,
      bulkSoldMarketplaceId,
      bulkSoldFeeConfigReady,
    );
    const bulkSelectedMp = marketplacesList.find((m) => m.id === bulkSoldMarketplaceId);
    const bulkSeatLabels = bulkSelectedTickets
      .map((t) => (t.seatNo === '-' ? '' : t.seatNo))
      .filter(Boolean)
      .join(', ');
    const bulkConfirmDisabled =
      !bulkNewStatus ||
      bulkStatusChangeLoading ||
      bulkSoldLoading ||
      (isBulkListTransition && (!isBulkListUndoOnly && !isBulkListPublishOnly || !bulkListPricesValid)) ||
      (isBulkSoldTransition && !bulkSoldReady);
    const first = bulkSelectedTickets[0];

    return (
      <div className={styles.modalOverlay}>
        <div
          className={styles.ctModalContent}
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: isBulkListTransition || isBulkSoldTransition ? '720px' : '600px' }}
        >
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <RefreshRoundedIcon className={styles.ctRotateIcon} fontSize="small" />
              <span className={styles.ctModalTitle}>
                {isBulkSoldTransition
                  ? 'Change Ticket Status'
                  : `Bulk Status Change (${bulkSelectedTickets.length} tickets)`}
              </span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={closeBulkStatusModal}>×</button>
          </div>
          <div className={styles.ctModalBody}>
            {(() => {
              const validation = canBulkUpdateTickets(bulkSelectedTickets.map((t) => t.tpId));
              if (!validation.allowed && validation.reason) {
                return (
                  <div className={styles.bulkActionWarning}>
                    <AlertTriangle size={16} />
                    <span>{validation.reason}</span>
                  </div>
                );
              }
              return null;
            })()}
            <div className={styles.ctEventName}>
              {first.event}
              {bulkSelectedTickets.some((t) => t.eventId && t.eventId !== first.eventId) ? ' (Multiple Events)' : ''}
            </div>
            <div className={styles.ctEventDetails}>
              {isBulkSoldTransition ? (
                <>
                  Section {first.section === '-' ? 'N/A' : first.section} • Row {first.row === '-' ? 'N/A' : first.row}
                  {bulkSeatLabels ? ` • Seats ${bulkSeatLabels}` : ''}
                </>
              ) : (
                <>
                  Section: {first.section === '-' ? 'N/A' : first.section} • Row: {first.row === '-' ? 'N/A' : first.row}
                  {bulkSelectedTickets.some(
                    (t) =>
                      (t.section === '-' ? '' : t.section) !== (first.section === '-' ? '' : first.section) ||
                      (t.row === '-' ? '' : t.row) !== (first.row === '-' ? '' : first.row),
                  ) && ' (Multiple sections/rows - bulk update not allowed)'}
                </>
              )}
            </div>
            {isBulkSoldTransition || first.date ? (
              <div className={styles.ctEventDate}>{first.date}</div>
            ) : null}

            {isBulkSoldTransition ? (
              <div className={styles.ctCurrentStatusRow} style={{ marginTop: 8 }}>
                <span className={styles.ctCurrentStatusLabel}>Tickets selected:</span>
                <b>{bulkSelectedTickets.length}</b>
              </div>
            ) : null}

            <div className={styles.ctCurrentStatusRow}>
              <span className={styles.ctCurrentStatusLabel}>
                {isBulkSoldTransition ? 'Current Status:' : 'Current Statuses:'}
              </span>
              {isBulkSoldTransition ? (
                <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeListed}`}>
                  {getStatusIcon('List')} Listed
                </span>
              ) : (
                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                  {Array.from(new Set(bulkSelectedTickets.map((t) => getStatusLabel(t.rawStatus || t.status)))).map((status) => (
                    <span key={status} className={`${styles.ctStatusBadge} ${getCtStatusBadgeClass(status)}`}>
                      {getStatusIcon(status)} {status}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className={styles.ctNewStatusTitle}>Select New Status:</div>
            <div className={styles.ctStatusOptions}>
              {getBulkStatusTransitions(bulkSelectedTickets).map((st) => (
                <button
                  key={st.value}
                  type="button"
                  className={getCtStatusOptionClass(st.value, bulkNewStatus === st.value)}
                  onClick={() => handleBulkNewStatusSelect(st.value)}
                >
                  {st.label}
                </button>
              ))}
            </div>

            {isBulkSoldTransition ? null : bulkNewStatus ? (
              <div className={styles.ctTransitionVisual}>
                <span className={styles.ctStatusBadge}>
                  {bulkSelectedTickets.length} Ticket(s)
                </span>
                <ArrowRight size={16} className={styles.ctTransArrow} />
                <span className={`${styles.ctStatusBadge} ${getCtStatusBadgeClass(bulkNewStatus)}`}>
                  {getStatusIcon(bulkNewStatus)} {getStatusLabel(bulkNewStatus)}
                </span>
              </div>
            ) : null}

            {isBulkListTransition && isBulkListUndoOnly ? (
              <div className={styles.ctModalListHint}>
                Undo delist and return these tickets to the <strong>Listed</strong> tab. Enter a listing price for each seat (required if current price is $0).
              </div>
            ) : null}

            {isBulkSoldTransition && (
              <>
                {!bulkSoldFeeConfigReady ? (
                  <div style={{ margin: '12px 0', fontSize: 14 }}>Loading fee settings…</div>
                ) : null}
                <div style={{ marginBottom: 16 }}>
                  <div className={styles.ctPriceLabel} style={{ marginBottom: 8 }}>Marketplace:</div>
                  <select
                    className={styles.ctMarketplaceSelect}
                    value={bulkSoldMarketplaceId}
                    disabled={!bulkSoldFeeConfigReady || marketplacesList.length === 0}
                    onChange={(e) => setBulkSoldMarketplaceId(e.target.value)}
                  >
                    <option value="">
                      {marketplacesList.length === 0 ? 'No active marketplaces' : 'Choose a marketplace...'}
                    </option>
                    {marketplacesList.map((mp) => (
                      <option key={mp.id} value={mp.id}>{mp.name} ({mp.vl_fee_percentage}%)</option>
                    ))}
                  </select>
                </div>
                {/* <div className={styles.ctPriceLabel} style={{ marginTop: 4 }}>Apply same Logitix amount to all (optional)</div>
                <div style={{ fontSize: 12, marginBottom: 6 }}>
                  Defaults to list price minus marketplace fee for each ticket.
                </div>
                <div className={styles.ctPriceInputWrapper} style={{ marginBottom: 12 }}>
                  <span className={styles.ctPriceDollar}>$</span>
                  <input
                    type="number"
                    className={styles.ctPriceInput}
                    value={bulkSoldCommonLogitixAmount}
                 
                  />
                  <button
                    type="button"
                    className={styles.ctConfirmBtn}
                    style={{ marginLeft: 12, minWidth: 120 }}
                    onClick={handleApplyBulkSoldAmount}
                    disabled={!bulkSoldFeeConfigReady || !bulkSoldMarketplaceId}
                  >
                    Apply to all
                  </button>
                </div> */}

                <div className={styles.ctTransitionVisual}>
                  <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeListed}`}>
                    {getStatusIcon('List')} Listed
                  </span>
                  <ArrowRight size={16} className={styles.ctTransArrow} />
                  <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeSold}`}>
                    {getStatusIcon('Sold')} Sold
                  </span>
                </div>
              </>
            )}

            {isBulkListTransition && (
              <>
                <div className={styles.ctPriceLabel} style={{ marginTop: 12 }}>
                  {isBulkListPublishOnly && bulkSelectedTickets.length === 1
                    ? 'Listing Price (required):'
                    : 'Apply same list price to all (optional)'}
                </div>
                <div className={styles.ctPriceInputWrapper} style={{ marginBottom: 12 }}>
                  <span className={styles.ctPriceDollar}>$</span>
                  <input
                    type="number"
                    className={styles.ctPriceInput}
                    value={bulkStatusListingCommonPrice}
                    onChange={(e) => setBulkStatusListingCommonPrice(e.target.value)}
                    placeholder="Enter price"
                    min="0"
                    step="1"
                  />
                  <button
                    type="button"
                    className={styles.ctConfirmBtn}
                    style={{ marginLeft: 12, minWidth: 120 }}
                    onClick={handleApplyBulkStatusListingPrice}
                  >
                    Apply to all
                  </button>
                </div>
              </>
            )}

            <div
              className={styles.ctModalListSection}
              style={{
                marginTop: 16,
                maxHeight: isBulkListTransition || isBulkSoldTransition ? 360 : 200,
                overflowY: 'auto',
              }}
            >
              <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 8 }}>
                {isBulkListTransition
                  ? 'Listing price per ticket (required):'
                  : isBulkSoldTransition
                    ? 'Amount received from Logitix per ticket:'
                    : 'Affected tickets:'}
              </div>
              {(isBulkListTransition || isBulkSoldTransition
                ? bulkSelectedTickets
                : bulkSelectedTickets.slice(0, 5)
              ).map((ticket) => {
                const currentPrice = getTicketDisplayPrice(ticket);
                  if (isBulkSoldTransition) {
                    const listPriceNum = getTicketListPrice(ticket);
                    const ticketFeeConfig = getBulkTicketSoldFeeConfig(ticket.tpId);
                    const quickPct = bulkSelectedMp
                      ? effectiveSoldQuickCutPercent(
                          bulkSelectedMp.vl_fee_percentage,
                          ticketFeeConfig.feeMode,
                          ticketFeeConfig.superClientPercent,
                        )
                      : 0;
                    const quickCutDollars = bulkSelectedMp && bulkSoldFeeConfigReady
                      ? Number(roundToFixed(listPriceNum * (quickPct / 100), 2))
                      : 0;
                    const expectedFromLogitix = bulkSelectedMp
                      ? Math.round(listPriceNum * (100 - bulkSelectedMp.vl_fee_percentage)) / 100
                      : null;
                    const logitixParsed = parseFloat(String(bulkSoldLogitixAmounts[ticket.tpId] || '').trim());
                    const hasLogitixInput = !isNaN(logitixParsed) && logitixParsed > 0;
                    const receivedForSettlement =
                      hasLogitixInput ? logitixParsed : expectedFromLogitix != null ? expectedFromLogitix : null;
                    const usingEnteredLogitix = hasLogitixInput;
                    const settlementAmount =
                      receivedForSettlement != null && bulkSelectedMp && bulkSoldFeeConfigReady
                        ? Math.round((receivedForSettlement - quickCutDollars) * 100) / 100
                        : null;
                    const clientFeeLabel =
                      ticketFeeConfig.feeMode === 'super' && ticketFeeConfig.superClientPercent != null
                        ? `${ticketFeeConfig.superClientPercent}% client fee`
                        : `${DEFAULT_CONCIERGE_PERCENT}% client fee (default)`;

                    return (
                      <div key={ticket.tpId} className={styles.ctModalListItem}>
                        <div className={styles.ctEventDetails} style={{ marginBottom: 8 }}>
                          Seat {ticket.seatNo === '-' ? 'N/A' : ticket.seatNo} • Section {ticket.section === '-' ? 'N/A' : ticket.section} • Row {ticket.row === '-' ? 'N/A' : ticket.row}
                        </div>
                        <div className={styles.ctCurrentStatusRow} style={{ marginTop: 0, marginBottom: 8 }}>
                          <span className={styles.ctCurrentStatusLabel}>List price:</span>
                          <b>${formatNumberWithCommas(listPriceNum)}</b>
                        </div>
                        <div className={styles.ctModalListItemMeta} style={{ marginBottom: 8 }}>{clientFeeLabel}</div>
                        <div className={styles.ctPriceLabel}>Amount received from Logitix</div>
                        <div className={styles.cttPriceInputWrapper} style={{ marginBottom: 8 }}>
                          <span className={styles.ctPriceDollar}>$</span>
                          <input
                            type="number"
                            className={styles.ctPriceInput}
                            value={bulkSoldLogitixAmounts[ticket.tpId] ?? '0'}
                           
                          />
                        </div>
                        {bulkSelectedMp && bulkSoldFeeConfigReady ? (
                          <div className={styles.ctFeeBreakdown}>
                            <div><b>Sold details (preview)</b></div>
                            <div>Marketplace: {bulkSelectedMp.name} ({bulkSelectedMp.vl_fee_percentage}%)</div>
                            <div>
                              QuickAsyst fee ({quickPct}% of list):{' '}
                              <span style={{ color: '#b91c1c' }}>
                                {quickCutDollars != null ? `-$${formatNumberWithCommas(quickCutDollars)}` : '—'}
                              </span>
                            </div>
                            <div style={{ marginTop: 8 }}>
                              <span className={styles.ctCurrentStatusLabel}>Amount settled to user</span>
                            </div>
                            <div style={{ fontSize: 20, fontWeight: 700 }}>
                              {settlementAmount != null ? `$${formatNumberWithCommas(settlementAmount)}` : '—'}
                            </div>
                            {receivedForSettlement != null && quickCutDollars != null && settlementAmount != null ? (
                              <div style={{ fontSize: 12, marginTop: 6 }}>
                                ${formatNumberWithCommas(receivedForSettlement)}{' '}
                                {usingEnteredLogitix ? 'received' : 'expected'} − $
                                {formatNumberWithCommas(quickCutDollars)} QuickAsyst fee
                                {usingEnteredLogitix ? '' : ' (preview)'}
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </div>
                    );
                  }

                  if (isBulkListTransition) {
                    return (
                      <div
                        key={ticket.tpId}
                        className={styles.ctModalListItem}
                        style={{
                          display: 'grid',
                          gridTemplateColumns: '1.2fr 1fr',
                          gap: 10,
                          alignItems: 'center',
                        }}
                      >
                        <div>
                          <div className={styles.ctModalListItemLabel}>Seat {ticket.seatNo === '-' ? 'N/A' : ticket.seatNo}</div>
                          <div className={styles.ctModalListItemMeta}>
                            {getStatusLabel(ticket.rawStatus || ticket.status)}
                            {currentPrice != null && <> • Current: {formatCurrency(currentPrice)}</>}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <span className={styles.ctPriceDollar}>$</span>
                          <input
                            type="number"
                            className={styles.ctPriceInput}
                            value={bulkStatusListingPrices[ticket.tpId] ?? ''}
                            onChange={(e) =>
                              setBulkStatusListingPrices({
                                ...bulkStatusListingPrices,
                                [ticket.tpId]: e.target.value,
                              })
                            }
                            placeholder="Price"
                            min="0"
                            step="1"
                          />
                        </div>
                      </div>
                    );
                  }

                  return (
                    <div
                      key={ticket.tpId}
                      className={styles.ctModalListItem}
                      style={{ fontSize: 12, padding: '4px 0', display: 'flex', justifyContent: 'space-between', gap: 12 }}
                    >
                      <span className={styles.ctModalListItemLabel}>Seat {ticket.seatNo === '-' ? 'N/A' : ticket.seatNo}</span>
                      <span className={styles.ctModalListItemMeta} style={{ textAlign: 'right' }}>
                        {getStatusLabel(ticket.rawStatus || ticket.status)}
                        {currentPrice != null && <> • {formatCurrency(currentPrice)}</>}
                      </span>
                    </div>
                  );
                })}
              {!isBulkListTransition && !isBulkSoldTransition && bulkSelectedTickets.length > 5 ? (
                <div className={styles.ctModalListMore}>
                  ... and {bulkSelectedTickets.length - 5} more
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={closeBulkStatusModal}>
              {isBulkSoldTransition ? 'Back' : 'Cancel'}
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${bulkConfirmDisabled ? styles.ctConfirmBtnDisabled : ''}`}
              disabled={bulkConfirmDisabled}
              onClick={() => void handleBulkStatusChange()}
            >
              {bulkStatusChangeLoading || bulkSoldLoading
                ? 'Saving…'
                : isBulkSoldTransition
                  ? `Confirm ${bulkSelectedTickets.length} Ticket(s)`
                  : `Update ${bulkSelectedTickets.length} Ticket(s)`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderChangeStatusModal = () => {
    if (!showChangeStatusModal || !changeStatusTicket) return null;
    const currentToken = getTicketTransitionStatus(changeStatusTicket);
    const transitions = getStatusTransitions(currentToken);
    const currentLabel = getStatusLabel(currentToken);
    const selectedLabel = selectedNewStatus ? getStatusLabel(selectedNewStatus) : '';

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <RefreshRoundedIcon className={styles.ctRotateIcon} fontSize="small" />
              <span className={styles.ctModalTitle}>Change Ticket Status</span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={() => setShowChangeStatusModal(false)}>
              ×
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <div className={styles.ctEventName}>{changeStatusTicket.event}</div>
            <div className={styles.ctEventDetails}>
              Section {changeStatusTicket.section === '-' ? 'N/A' : changeStatusTicket.section} • Row {changeStatusTicket.row === '-' ? 'N/A' : changeStatusTicket.row} • Seats {changeStatusTicket.seatNo === '-' ? 'N/A' : changeStatusTicket.seatNo}
            </div>
            <div className={styles.ctEventDate}>{changeStatusTicket.date}</div>

            <div className={styles.ctCurrentStatusRow}>
              <span className={styles.ctCurrentStatusLabel}>Current Status:</span>
              <span className={`${styles.ctStatusBadge} ${getCtStatusBadgeClass(currentToken)}`}>
                {getStatusIcon(currentToken)} {currentLabel}
              </span>
            </div>

            <div className={styles.ctNewStatusTitle}>Select New Status:</div>
            <div className={styles.ctStatusOptions}>
              {transitions.map((opt) => (
                <button
                  key={opt.value}
                  type="button"
                  className={getCtStatusOptionClass(opt.value, selectedNewStatus === opt.value)}
                  onClick={() => setSelectedNewStatus(opt.value)}
                >
                  {opt.label}
                </button>
              ))}
            </div>

            {selectedNewStatus && (
              <div className={styles.ctTransitionVisual}>
                <span className={`${styles.ctStatusBadge} ${getCtStatusBadgeClass(currentToken)}`}>
                  {getStatusIcon(currentToken)} {currentLabel}
                </span>
                <ArrowRight size={16} className={styles.ctTransArrow} />
                <span className={`${styles.ctStatusBadge} ${getCtStatusBadgeClass(selectedNewStatus)}`}>
                  {getStatusIcon(selectedNewStatus)} {selectedLabel}
                </span>
              </div>
            )}
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={() => setShowChangeStatusModal(false)}>
              Back
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${(!selectedNewStatus || changeStatusLoading) ? styles.ctConfirmBtnDisabled : ''}`}
              disabled={!selectedNewStatus || changeStatusLoading}
              onClick={handleChangeStatusConfirm}
            >
              {changeStatusLoading ? 'Saving...' : 'Confirm Change'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderPricingMethodStatusModal = () => {
    if (!showPricingMethodModal || !selectedTicketForPricingMethod) return null;

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
          <div className={styles.modalHeader}>
            <h3><DollarSign size={18} /> Pricing Method Status</h3>
            <button className={styles.modalClose} onClick={closePricingMethodModal} disabled={pricingMethodLoading}><X size={18} /></button>
          </div>
          <div className={styles.modalBody}>
            <div className={styles.modalEventInfo}>
              <div className={styles.modalEventName}>{selectedTicketForPricingMethod.event}</div>
              <div className={styles.modalEventDetails}>
                {selectedTicketForPricingMethod.section || 'N/A'} • {selectedTicketForPricingMethod.row || 'N/A'} • {selectedTicketForPricingMethod.seatNo || 'N/A'}
              </div>
            </div>

       <div className={styles.editField}>
  <label>Pricing method</label>
  <div className={styles.userDetailsPricingMethods} role="radiogroup" aria-label="Pricing method">
    {!isSelfPricingClient() && (
      <>
    <label className={`${styles.userDetailsPricingOption} ${pricingMethodFormData === 'MANUAL' ? styles.userDetailsPricingOptionSelected : ''}`}>
      <input
        type="radio"
        name="user-details-pricing-method-status"
        value="MANUAL"
        checked={pricingMethodFormData === 'MANUAL'}
        disabled={pricingMethodLoading}
        onChange={() => setPricingMethodFormData('MANUAL')}
      />
      
      <span>Manually Priced</span><span
        className={styles.userDetailsManualPriceBadge}
        title="Manually Priced"
        aria-label="Manually Priced"
      >
        <DollarSign size={13} aria-hidden />
      </span>
    </label>
    <label className={`${styles.userDetailsPricingOption} ${pricingMethodFormData === 'FOLLOW_MARKET' ? styles.userDetailsPricingOptionSelected : ''}`}>
      <input
        type="radio"
        name="user-details-pricing-method-status"
        value="FOLLOW_MARKET"
        checked={pricingMethodFormData === 'FOLLOW_MARKET'}
        disabled={pricingMethodLoading}
        onChange={() => setPricingMethodFormData('FOLLOW_MARKET')}
      />
      
      <span>Follow Market Tool</span><span
        className={styles.userDetailsFollowMarketBadge}
        title="Follow Market"
        aria-label="Follow Market"
      >
        <TrendingUp size={13} aria-hidden />
      </span>
    </label>
      </>
    )}
    <label className={`${styles.userDetailsPricingOption} ${pricingMethodFormData === 'NONE' ? styles.userDetailsPricingOptionSelected : ''}`}>
      <input
        type="radio"
        name="user-details-pricing-method-status"
        value="NONE"
        checked={pricingMethodFormData === 'NONE'}
        disabled={pricingMethodLoading}
        onChange={() => setPricingMethodFormData('NONE')}
      />
      <span>Nothing</span>
    </label>
  </div>
  {isSelfPricingClient() && (
    <p style={{ marginTop: 8, fontSize: 13, opacity: 0.8 }}>
      Self Pricing tickets do not use Manual or Follow the Market.
    </p>
  )}
</div>
          </div>
          <div className={styles.modalFooter}>
            <button className={styles.modalCancel} onClick={closePricingMethodModal} disabled={pricingMethodLoading}>Cancel</button>
            <button className={styles.modalConfirm} onClick={handlePricingMethodStatusConfirm} disabled={pricingMethodLoading}>
              {pricingMethodLoading ? 'Saving…' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    );
  };

const renderEditTicketModal = () => {
  if (!showEditTicketModal || !editTicket) return null;
  const isGroupEdit = editTicketGroup.length > 1;
  const seatNumberEditable =
    ['Verified', 'ToBeVerified'].includes(
      normalizeStatusValue(editTicket.rawStatus || editTicket.status),
    ) &&
    editTicketGroup.every((ticket) =>
      ['Verified', 'ToBeVerified'].includes(
        normalizeStatusValue(ticket.rawStatus || ticket.status),
      ),
    );

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
        <div className={styles.ctModalHeader}>
          <div className={styles.ctModalTitleRow}>
            <Edit size={18} className={styles.ctRotateIcon} />
            <span className={styles.ctModalTitle}>Edit Ticket Details</span>
          </div>
          <button
            type="button"
            className={styles.ctModalClose}
            onClick={() => {
              if (!editTicketLoading) {
                setShowEditTicketModal(false);
                setEditTicketGroup([]);
              }
            }}
            disabled={editTicketLoading}
          >
            <X size={18} />
          </button>
        </div>

        <div className={styles.ctModalBody}>
          <div className={styles.ctEventName}>{editTicket.event}</div>
          <div className={styles.ctEventDetails}>{editTicket.date}</div>
          {isGroupEdit && (
            <small className={styles.inputHint} style={{ display: 'block', marginTop: 6 }}>
              Updating {editTicketGroup.length} seats in this listing on Victory Live and QuickAsyst.
              Section, row, and notes apply to all seats.
            </small>
          )}

          {editTicketLoading && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '12px 0 4px', fontSize: 14, color: 'var(--text-secondary, #666)' }}>
              <span className={styles.spinner} aria-hidden />
              Saving to Victory Live and QuickAsyst…
            </div>
          )}

          <div className={styles.editField} style={{ marginTop: 12 }}>
            <label>Section</label>
            <input
              type="text"
              value={editTicketForm.section}
              disabled={editTicketLoading}
              onChange={(e) => setEditTicketForm({ ...editTicketForm, section: e.target.value })}
              placeholder="Section"
            />
          </div>
          <div className={styles.editField}>
            <label>Row</label>
            <input
              type="text"
              value={editTicketForm.row}
              disabled={editTicketLoading}
              onChange={(e) => {
                const row = e.target.value;
                setEditTicketForm((current) => ({
                  ...current,
                  row,
                  ...(isParkingPassRow(row)
                    ? { internalNotes: PARKING_INTERNAL_NOTE, externalNotes: PARKING_EXTERNAL_NOTE }
                    : {}),
                }));
              }}
              placeholder="Row"
            />
          </div>
   {seatNumberEditable && (
  <div style={{ display: 'flex', gap: '16px', width: '100%' }}>
    <div className={styles.editField} style={{ flex: 1 }}>
      <label>Start Seat</label>
      <input
        type="number"
        placeholder="e.g. 802"
        value={editTicketForm.seatStart}
        disabled={editTicketLoading}
        onChange={(e) => setEditTicketForm({ ...editTicketForm, seatStart: e.target.value })}
      />
    </div>
    <div className={styles.editField} style={{ flex: 1 }}>
      <label>End Seat</label>
      <input
        type="number"
        placeholder="e.g. 803"
        value={editTicketForm.seatEnd}
        disabled={editTicketLoading}
        onChange={(e) => setEditTicketForm({ ...editTicketForm, seatEnd: e.target.value })}
      />
    </div>
  </div>
)}
          <div className={styles.editField}>
            <label>Internal Note</label>
            {isParkingPassRow(editTicketForm.row) ? (
              <textarea
                rows={3}
                value={editTicketForm.internalNotes}
                disabled={editTicketLoading}
                onChange={(e) => setEditTicketForm((current) => ({ ...current, internalNotes: e.target.value }))}
              />
            ) : (
            <ListingNoteCombobox
              value={editTicketForm.internalNotes}
              options={editInternalNoteChoices}
              sentValue={editTicketForm.internalNotes}
              disabled={editTicketLoading}
              placeholder="Search or enter internal notes"
              onChange={(value) => {
                const draft = composeListingNoteDraft(value, editInternalNoteChoices, '', 'internal');
                setEditTicketForm((current) => ({ ...current, internalNotes: draft.query }));
              }}
            />
            )}
          </div>
          <div className={styles.editField}>
            <label>External Note</label>
            {isParkingPassRow(editTicketForm.row) ? (
              <textarea
                rows={3}
                value={editTicketForm.externalNotes}
                disabled={editTicketLoading}
                onChange={(e) => setEditTicketForm((current) => ({ ...current, externalNotes: e.target.value }))}
              />
            ) : (
            <ListingNoteCombobox
              value={editTicketForm.externalNotes}
              options={editExternalNoteChoices}
              sentValue={editTicketForm.externalNotes}
              disabled={editTicketLoading}
              placeholder="Search or enter external notes"
              onChange={(value) => {
                const draft = composeListingNoteDraft(value, editExternalNoteChoices, '', 'external');
                setEditTicketForm((current) => ({ ...current, externalNotes: draft.query }));
              }}
            />
            )}
          </div>
        </div>

        <div className={styles.ctModalFooter}>
          <button
            type="button"
            className={styles.ctBackBtn}
            onClick={() => {
              setShowEditTicketModal(false);
              setEditTicketGroup([]);
            }}
            disabled={editTicketLoading}
          >
            Cancel
          </button>
          <button
            type="button"
            className={`${styles.ctConfirmBtn} ${editTicketLoading ? styles.ctConfirmBtnDisabled : ''}`}
            onClick={handleEditTicketSave}
            disabled={editTicketLoading}
          >
            {editTicketLoading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};
  const renderPriceChangeConfirmationModal = () => {
    if (!priceConfirmationFlow) return null;

    return (
      <div className={styles.modalOverlay}>
        <div className={`${styles.modalContent} ${styles.priceChangeModal}`} onClick={(e) => e.stopPropagation()}>
          <div className={styles.modalHeader}>
            <h3>
              <span className={styles.priceChangeIcon}><AlertCircle size={19} /></span>
              Price Change Warning
            </h3>
            <button type="button" className={styles.modalClose} onClick={cancelPriceChangeConfirmation}>
              <X size={18} />
            </button>
          </div>
          <div className={styles.modalBody}>
            <div className={styles.priceChangeWarning}>
              <strong>Large price change</strong>
              <span>{getPriceChangeWarningNote(getPriceConfirmationChanges())}</span>
            </div>

            {priceConfirmationFlow === 'single' && priceModalTicket && (
              <div className={`${styles.modalEventInfo} ${styles.priceChangeDetails}`}>
                <div className={styles.modalEventName}>{priceModalTicket.event}</div>
                <div className={styles.modalEventDetails}>
                  Section {priceModalTicket.section || 'N/A'} • Row {priceModalTicket.row || 'N/A'} • Seat {priceModalTicket.seatNo || 'N/A'}
                </div>
                <div className={styles.priceRow}>
                  <span>Current price</span>
                  <strong>{formatCurrency(getTicketListPrice(priceModalTicket))}</strong>
                </div>
                <div className={`${styles.priceRow} ${styles.newPriceRow}`}>
                  <span>New price</span>
                  <strong>{formatCurrency(Number(parseFloat(newPrice)) || 0)}</strong>
                </div>
              </div>
            )}

            {priceConfirmationFlow === 'bulkPrice' && (
              <table className={styles.priceChangeTable}>
                <thead>
                  <tr>
                    <th>Seat #</th>
                    <th>Current Price</th>
                    <th>New Price</th>
                  </tr>
                </thead>
                <tbody>
                  {bulkPriceModalTickets.map((ticket) => (
                    <tr key={ticket.tpId}>
                      <td>{ticket.seatNo || 'N/A'}</td>
                      <td>{formatCurrency(getTicketListPrice(ticket))}</td>
                      <td>{formatCurrency(Number(parseFloat(String(bulkPrices[ticket.tpId] || ''))) || 0)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          <div className={styles.modalFooter}>
            <button type="button" className={styles.modalCancel} onClick={cancelPriceChangeConfirmation}>
              Cancel
            </button>
            <button type="button" className={styles.modalConfirm} onClick={() => { void confirmPriceChange(); }}>
              Proceed with change
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderListedModal = () => {
    if (!showListedModal || !listedModalTicket) return null;
    const currentSt = listedModalTicket.rawStatus || listedModalTicket.status;
    const currentLabel = getStatusLabel(currentSt);
    const getBadgeClass = (st: string) => {
      const s = st.toLowerCase().replace(/\s/g, '');
      if (s === 'verified') return styles.ctStatusBadgeVerified;
      if (s === 'list') return styles.ctStatusBadgeListed;
      return styles.ctStatusBadgeDefault;
    };

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <RefreshRoundedIcon className={styles.ctRotateIcon} fontSize="small" />
              <span className={styles.ctModalTitle}>Change Ticket Status</span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={() => setShowListedModal(false)}>
              ×
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <div className={styles.ctEventName}>{listedModalTicket.event}</div>
            <div className={styles.ctEventDetails}>
              Section {listedModalTicket.section === '-' ? 'N/A' : listedModalTicket.section} • Row {listedModalTicket.row === '-' ? 'N/A' : listedModalTicket.row} • Seats {listedModalTicket.seatNo === '-' ? 'N/A' : listedModalTicket.seatNo}
            </div>
            <div className={styles.ctEventDate}>{listedModalTicket.date}</div>

            <div className={styles.ctCurrentStatusRow}>
              <span className={styles.ctCurrentStatusLabel}>Current Status:</span>
              <span className={`${styles.ctStatusBadge} ${getBadgeClass(currentSt)}`}>
                {getStatusIcon(currentSt)} {currentLabel}
              </span>
            </div>

            <div className={styles.ctNewStatusTitle}>Select New Status:</div>
            <div className={styles.ctStatusOptions}>
              <button type="button" className={`${styles.ctStatusOption} ${styles.ctStatusOptionSelected}`}>
                Listed (Non-VL)
              </button>
            </div>

            <div className={styles.ctTransitionVisual}>
              <span className={`${styles.ctStatusBadge} ${getBadgeClass(currentSt)}`}>
                {getStatusIcon(currentSt)} {currentLabel}
              </span>
              <ArrowRight size={16} className={styles.ctTransArrow} />
              <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeListed}`}>
                {getStatusIcon('List')} Listed (Non-VL)
              </span>
            </div>

            <div className={styles.ctPriceLabel}>Listing Price (required):</div>
            <div className={styles.ctPriceInputWrapper}>
              <span className={styles.ctPriceDollar}>$</span>
              <input
                type="number"
                className={styles.ctPriceInput}
                value={listedPrice}
                onChange={(e) => setListedPrice(e.target.value)}
                placeholder="Enter listing price"
                min="0"
                step="1"
              />
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={() => setShowListedModal(false)}>
              Back
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${(!listedPrice || listedModalLoading) ? styles.ctConfirmBtnDisabled : ''}`}
              disabled={!listedPrice || listedModalLoading}
              onClick={handleListedModalConfirm}
            >
              {listedModalLoading ? 'Saving...' : 'Confirm Change'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderSoldModal = () => {
    if (!showSoldModal || !soldModalTicket) return null;
    const listPriceNum = parseCurrency(soldModalTicket.price);
    const selectedMp = marketplacesList.find((m) => m.id === soldMarketplaceId);
    const expectedFromLogitix = selectedMp ? Math.round(listPriceNum * (100 - selectedMp.vl_fee_percentage)) / 100 : null;
    const quickPct = selectedMp && soldFeeConfigReady
      ? effectiveSoldQuickCutPercent(selectedMp.vl_fee_percentage, soldFeeMode, soldSuperClientPercent) : 0;
    const quickCutDollars = selectedMp && listPriceNum && soldFeeConfigReady
      ? Number(roundToFixed(listPriceNum * (quickPct / 100), 2)) : 0;
    const logitixParsed = parseFloat(soldLogitixAmount);
    const hasLogitixInput = !isNaN(logitixParsed) && logitixParsed > 0;
    const receivedForSettlement = hasLogitixInput ? logitixParsed : expectedFromLogitix;
    const settlementAmount = receivedForSettlement != null && quickCutDollars != null
      ? Math.round((receivedForSettlement - quickCutDollars) * 100) / 100 : null;
    const confirmDisabled = !soldFeeConfigReady || soldModalLoading || !soldMarketplaceId ||
      !soldLogitixAmount.trim() || settlementAmount == null || settlementAmount <= 0;

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <RefreshRoundedIcon className={styles.ctRotateIcon} fontSize="small" />
              <span className={styles.ctModalTitle}>Change Ticket Status</span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={closeSoldModal}>
              ×
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <div className={styles.ctEventName}>{soldModalTicket.event}</div>
            <div className={styles.ctEventDetails}>
              Section {soldModalTicket.section === '-' ? 'N/A' : soldModalTicket.section} • Row {soldModalTicket.row === '-' ? 'N/A' : soldModalTicket.row} • Seats {soldModalTicket.seatNo === '-' ? 'N/A' : soldModalTicket.seatNo}
            </div>
            <div className={styles.ctEventDate}>{soldModalTicket.date}</div>

            <div className={styles.ctCurrentStatusRow} style={{ marginTop: 8 }}>
              <span className={styles.ctCurrentStatusLabel}>List price:</span>
              <b>${formatNumberWithCommas(listPriceNum)}</b>
            </div>

            <div className={styles.ctCurrentStatusRow}>
              <span className={styles.ctCurrentStatusLabel}>Current Status:</span>
              <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeListed}`}>
                {getStatusIcon('List')} Listed
              </span>
            </div>

            <div className={styles.ctNewStatusTitle}>Select New Status:</div>
            <div className={styles.ctStatusOptions}>
              <button type="button" className={`${styles.ctStatusOption} ${styles.ctStatusOptionSelected}`}>
                Sold
              </button>
            </div>

            {!soldFeeConfigReady && <div style={{ margin: '12px 0', fontSize: 14 }}>Loading fee settings…</div>}

            <div style={{ marginBottom: 16 }}>
              <div className={styles.ctPriceLabel} style={{ marginBottom: 8 }}>Marketplace:</div>
              <select
                className={styles.ctMarketplaceSelect}
                value={soldMarketplaceId}
                disabled={!soldFeeConfigReady || marketplacesList.length === 0}
                onChange={(e) => setSoldMarketplaceId(e.target.value)}
              >
                <option value="">{marketplacesList.length === 0 ? 'No active marketplaces available' : 'Choose a marketplace...'}</option>
                {marketplacesList.map((mp) => (
                  <option key={mp.id} value={mp.id}>{mp.name} ({mp.vl_fee_percentage}%)</option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: 16 }}>
              <div className={styles.ctPriceLabel}>Amount received from Logitix</div>
              <div style={{ fontSize: 12, marginBottom: 6 }}>Defaults to list price minus marketplace fee (edit if your payout differs).</div>
              <div className={styles.ctPriceInputWrapper}>
                <span className={styles.ctPriceDollar}>$</span>
                <input
                  type="number"
                  inputMode="decimal"
                  step="0.01"
                  min="0"
                  className={styles.ctPriceInput}
                  value={soldLogitixAmount || '0'}
                  onChange={(e) => setSoldLogitixAmount(sanitizePriceInput(e.target.value))}
                  placeholder="0"
                />
              </div>
            </div>

            <div className={styles.ctTransitionVisual}>
              <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeListed}`}>
                {getStatusIcon('List')} Listed
              </span>
              <ArrowRight size={16} className={styles.ctTransArrow} />
              <span className={`${styles.ctStatusBadge} ${styles.ctStatusBadgeSold}`}>
                {getStatusIcon('Sold')} Sold
              </span>
            </div>

            {selectedMp && soldFeeConfigReady && (
              <div className={styles.ctFeeBreakdown}>
                <div><b>Sold details (preview)</b></div>
                <div>Marketplace: {selectedMp.name} ({selectedMp.vl_fee_percentage}%)</div>
                <div>QuickAsyst fee ({quickPct}% of list): <span className={styles.deductionAmount}>{quickCutDollars != null ? `-$${formatNumberWithCommas(quickCutDollars)}` : '—'}</span></div>
                <div style={{ marginTop: 8 }}><span className={styles.ctCurrentStatusLabel}>Amount settled to user</span></div>
                <div style={{ fontSize: 20, fontWeight: 700 }}>{settlementAmount != null ? `$${formatNumberWithCommas(settlementAmount)}` : '—'}</div>
                {receivedForSettlement != null && quickCutDollars != null && settlementAmount != null && (
                  <div style={{ fontSize: 12, marginTop: 6 }}>
                    ${formatNumberWithCommas(receivedForSettlement)} {hasLogitixInput ? 'received' : 'expected'} − ${formatNumberWithCommas(quickCutDollars)} QuickAsyst fee
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={closeSoldModal}>
              Back
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${confirmDisabled ? styles.ctConfirmBtnDisabled : ''}`}
              disabled={confirmDisabled}
              onClick={handleSoldModalConfirm}
            >
              {soldModalLoading ? 'Saving...' : 'Confirm Change'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderPriceModal = () => {
    if (!showPriceModal || !priceModalTicket) return null;
    const bulkCount = bulkPriceTpIds.length;
    const currentPriceDisplay = priceModalTicket.price || '$0';

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '480px' }}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <DollarSign className={styles.ctRotateIcon} size={18} />
              <span className={styles.ctModalTitle}>Confirm Price Change</span>
            </div>
            <button type="button" className={styles.ctModalClose} disabled={priceModalLoading} onClick={() => { setShowPriceModal(false); setBulkPriceTpIds([]); }}>
              <X size={18} />
            </button>
          </div>
          <div className={styles.ctModalBody}>
            {priceModalLoading && (
              <div className={styles.modalInlineBusy} role="status" aria-live="polite">
                <div className={styles.vlBusySpinner} />
                <span>Updating list price — please wait…</span>
              </div>
            )}
            <div className={styles.ctEventName}>{priceModalTicket.event}</div>
            <div className={styles.ctEventDetails}>
              Section {priceModalTicket.section || 'N/A'} • Row {priceModalTicket.row || 'N/A'} • Seats {priceModalTicket.seatNo || 'N/A'}
            </div>

            <div className={styles.ctCurrentStatusRow} style={{ marginTop: 12 }}>
              <span className={styles.ctCurrentStatusLabel}>Current Price:</span>
              <span className={styles.ctEventName}>{currentPriceDisplay}</span>
            </div>

            <div className={styles.ctPriceLabel} style={{ marginTop: 16 }}>New Price</div>
            <div className={styles.ctPriceInputWrapper}>
              <span className={styles.ctPriceDollar}>$</span>
              <input
                type="number"
                className={styles.ctPriceInput}
                value={newPrice}
                onChange={(e) => setNewPrice(e.target.value)}
                placeholder="0"
                min="0"
              />
            </div>

            <div className={styles.ctModalListMore}>
              <CheckSquare size={12} /> {bulkCount > 0 ? bulkCount : 1} ticket(s) selected
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} disabled={priceModalLoading} onClick={() => { setShowPriceModal(false); setBulkPriceTpIds([]); }}>
              Cancel
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${priceModalLoading ? styles.ctConfirmBtnDisabled : ''}`}
              onClick={() => { void handlePriceModalConfirm(); }}
              disabled={priceModalLoading}
            >
              {priceModalLoading ? 'Updating...' : 'Confirm Price Change'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderDelistEmailModal = () => {
    if (!showDelistEmailModal) return null;
    const isFormValid = delistEmail && delistConfirmEmail && emailRegexPattern.test(delistEmail) && delistEmail === delistConfirmEmail;

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '450px' }}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <Package size={18} className={styles.ctRotateIcon} />
              <span className={styles.ctModalTitle}>Delist Request</span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={() => setShowDelistEmailModal(false)}>
              <X size={18} />
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <div className={styles.ctEventDetails} style={{ marginBottom: 12 }}>
              Please provide the email address to return the tickets to
            </div>
            <div className={styles.ctCurrentStatusRow}>
              <span className={styles.ctCurrentStatusLabel}>Delisting:</span>
              <span className={styles.ctEventName}>{pendingDelistTpIds.length} ticket(s)</span>
            </div>
            <div className={styles.editField} style={{ marginTop: 12 }}>
              <label>Email *</label>
              <input
                type="email"
                placeholder="name@company.com"
                value={delistEmail}
                onChange={(e) => setDelistEmail(e.target.value)}
                className={styles.formInput}
              />
            </div>
            <div className={styles.editField}>
              <label>Confirm Email *</label>
              <input
                type="email"
                placeholder="name@company.com"
                value={delistConfirmEmail}
                onChange={(e) => setDelistConfirmEmail(e.target.value)}
                className={styles.formInput}
              />
              {delistEmail && delistConfirmEmail && delistEmail !== delistConfirmEmail && (
                <small className={styles.errorText}>Emails do not match</small>
              )}
              {delistEmail && !emailRegexPattern.test(delistEmail) && (
                <small className={styles.errorText}>Enter a valid email address</small>
              )}
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={() => setShowDelistEmailModal(false)}>
              Cancel
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${(!isFormValid || delistRequestLoading) ? styles.ctConfirmBtnDisabled : ''}`}
              onClick={() => void handleDelistTicketsSubmit()}
              disabled={!isFormValid || delistRequestLoading}
            >
              {delistRequestLoading ? 'Processing...' : 'Submit Delist Request'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderBulkPriceModal = () => {
    if (!showBulkPriceModal || bulkPriceModalTickets.length === 0) return null;

    const allPricesValid = areAllBulkPricesValid(bulkPriceModalTickets, bulkPrices);

    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '750px' }}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <DollarSign className={styles.ctRotateIcon} size={20} />
              <span className={styles.ctModalTitle}>Bulk Change Price</span>
            </div>
            <button type="button" className={styles.ctModalClose} onClick={() => setShowBulkPriceModal(false)}>
              ×
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <div className={styles.ctEventName}>{bulkPriceModalTickets[0]?.event || 'Selected Tickets'}</div>
            <div className={styles.ctEventDetails}>
              {bulkPriceModalTickets.length} ticket(s) selected • Section {bulkPriceModalTickets[0]?.section || 'N/A'} • Row {bulkPriceModalTickets[0]?.row || 'N/A'}
            </div>

            <div className={styles.ctPriceLabel} style={{ marginTop: 16, marginBottom: 8 }}>
              Apply same price to all selected tickets (optional)
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 16 }}>
              <div className={styles.ctPriceInputWrapper} style={{ flex: 1 }}>
                <span className={styles.ctPriceDollar}>$</span>
                <input
                  type="number"
                  className={styles.ctPriceInput}
                  value={bulkCommonPrice}
                  onChange={(e) => setBulkCommonPrice(e.target.value)}
                  placeholder="Enter price"
                  min="0"
                  step="1"
                />
              </div>
              <button
                type="button"
                className={styles.ctConfirmBtn}
                style={{ minWidth: 140 }}
                onClick={handleApplyBulkCommonPrice}
              >
                <span>Apply to all</span>
              </button>
            </div>

            <div className={styles.ctModalSectionDivider}>
              <div className={styles.ctPriceLabel} style={{ marginBottom: 12 }}>Individual ticket prices</div>
              <div style={{ maxHeight: '400px', overflowY: 'auto', display: 'grid', gap: 12 }}>
                {bulkPriceModalTickets.map((ticket) => {
                  const currentPrice = getTicketListPrice(ticket);
                  return (
                    <div key={ticket.tpId} className={styles.ctBulkPriceCard}>
                      <div>
                        <div className={styles.ctBulkPriceCardTitle}>Seat {ticket.seatNo || 'N/A'}</div>
                        <div className={styles.ctBulkPriceCardMeta}>{ticket.event || 'N/A'}</div>
                        <div className={styles.ctBulkPriceCardMeta}>
                          Current price: ${currentPrice > 0 ? currentPrice.toFixed(2) : '0.00'}
                        </div>
                      </div>
                      <div className={styles.ctPriceInputWrapper}>
                        <span className={styles.ctPriceDollar}>$</span>
                        <input
                          type="number"
                          className={styles.ctPriceInput}
                          value={bulkPrices[ticket.tpId] ?? ''}
                          onChange={(e) =>
                            setBulkPrices({
                              ...bulkPrices,
                              [ticket.tpId]: e.target.value,
                            })
                          }
                          placeholder="0"
                          min="0"
                          step="1"
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button type="button" className={styles.ctBackBtn} onClick={() => setShowBulkPriceModal(false)}>
              Cancel
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${bulkPriceLoading ? styles.ctConfirmBtnDisabled : ''}`}
              disabled={bulkPriceLoading || !allPricesValid}
              onClick={() => { void handleConfirmBulkPricing(); }}
            >
              {bulkPriceLoading ? 'Saving…' : `Update ${bulkPriceModalTickets.length} Ticket${bulkPriceModalTickets.length > 1 ? 's' : ''}`}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderVlShareModal = () => {
    if (!showVlShareModal) return null;
    const vlShareSelectedTickets = Array.from(bulkSelectedTicketIds)
      .map((tpId) => getFilteredTickets().find((ticket) => ticket.tpId === tpId))
      .filter((ticket): ticket is Ticket => Boolean(ticket));
    if (!vlShareSelectedTickets.length) return null;

    const vlShareUseCommonPrice =
      vlShareSelectedTickets.length > 1 &&
      vlShareSelectedTickets.every(
        (ticket) => getTicketListPrice(ticket) === getTicketListPrice(vlShareSelectedTickets[0]),
      );
    const vlShareCommonTpId = vlShareSelectedTickets[0]?.tpId || '';
    const vlSharePriceMarketplaceLinks = (
      <EventMarketplaceDeepLinks
        stubhubId={vlShareSelectedTickets[0]?.stubhubId}
        seatgeekId={vlShareSelectedTickets[0]?.seatgeekId}
        ticketmasterId={undefined}
        vividSeatsId={undefined}
        eventName={vlShareSelectedTickets[0]?.event}
        eventDate={formatVenueEventDateYmd(
          vlShareSelectedTickets[0]?.eventDateRaw,
          vlShareSelectedTickets[0]?.eventTimeZone,
        )}
        venue={vlShareSelectedTickets[0]?.venue}
        className={styles.marketplaceDeepLinksInline}
        linkClassName={styles.marketplaceDeepLink}
        disabledClassName={styles.marketplaceDeepLinkDisabled}
        stubhubClassName={styles.marketplaceDeepLinkStubhub}
        seatgeekClassName={styles.marketplaceDeepLinkSeatgeek}
        ticketmasterClassName={styles.marketplaceDeepLinkTicketmaster}
        vividseatsClassName={styles.marketplaceDeepLinkVivid}
      />
    );
    const sameSectionRow =
      vlShareUseCommonPrice &&
      vlShareSelectedTickets.every(
        (t) =>
          String(t.section || '') === String(vlShareSelectedTickets[0]?.section || '') &&
          String(t.row || '') === String(vlShareSelectedTickets[0]?.row || ''),
      );

    return (
      <div
 className={`${styles.modalOverlay} ${styles.vlProductionMapModalOverlay}`}
 >
        <div
          className={`${styles.modalContent} ${styles.vlShareModal}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.modalHeader}>
            <h3>Share on Victory Live</h3>
            <button
              type="button"
              className={styles.modalClose}
              onClick={() => {
                wrongPidFlowRef.current = null;
                setShowVlShareModal(false);
              }}
              disabled={vlShareLoading}
            >
              <X size={18} />
            </button>
          </div>
          <div className={styles.modalBody}>
            <p className={styles.vlShareHint}>
              Select marketplaces, edit section/row/seat/price/notes for {bulkSelectedTicketIds.size}{' '}
              seat(s). Updates Victory Live and QuickAsyst; QA status becomes Listed on success.
            </p>
            {vlShareSelectedTickets[0] && (
              <div className={styles.vlShareEventSummary}>
                <div className={styles.eventName}>{vlShareSelectedTickets[0].event || 'Selected tickets'}</div>
              </div>
            )}

            {vlShareLoading && (
              <div className={styles.vlShareLoadingRow}>
                <div className={styles.spinner} />
                Sharing to Victory Live…
              </div>
            )}

            <div className={styles.vlShareSection}>
              <label className={styles.vlShareLabel}>Section / Row / Seat</label>
              {vlShareSelectedTickets.length === 1 ? (
                <div className={styles.vlShareFieldStack}>
                  <div className={styles.vlShareSeatGrid}>
                    <input
                      type="text"
                      className={styles.vlShareInput}
                      value={vlShareSections[vlShareSelectedTickets[0].tpId] ?? ''}
                      disabled={vlShareLoading}
                      onChange={(e) =>
                        setVlShareSections((prev) => ({
                          ...prev,
                          [vlShareSelectedTickets[0].tpId]: e.target.value,
                        }))
                      }
                      placeholder="Section"
                    />
                    <input
                      type="text"
                      className={styles.vlShareInput}
                      value={vlShareRows[vlShareSelectedTickets[0].tpId] ?? ''}
                      disabled={vlShareLoading}
                      onChange={(e) =>
                        setVlShareRows((prev) => ({
                          ...prev,
                          [vlShareSelectedTickets[0].tpId]: e.target.value,
                        }))
                      }
                      placeholder="Row"
                    />
                    <input
                      type="text"
                      className={styles.vlShareInput}
                      value={vlShareSeats[vlShareSelectedTickets[0].tpId] ?? ''}
                      disabled={vlShareLoading}
                      onChange={(e) =>
                        setVlShareSeats((prev) => ({
                          ...prev,
                          [vlShareSelectedTickets[0].tpId]: e.target.value,
                        }))
                      }
                      placeholder="Seat"
                    />
                  </div>
                  <div>
                    <label className={styles.vlShareLabel}>
                      List price
                      {vlSharePriceMarketplaceLinks}
                    </label>
                    <div className={styles.vlSharePriceWrap}>
                      <input
                        type="text"
                        className={styles.vlSharePriceInput}
                        inputMode="decimal"
                        value={vlSharePrices[vlShareSelectedTickets[0].tpId] ?? ''}
                        disabled={vlShareLoading}
                        onChange={(e) =>
                          setVlSharePrices((prev) => ({
                            ...prev,
                            [vlShareSelectedTickets[0].tpId]: sanitizePriceInput(e.target.value),
                          }))
                        }
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
              ) : sameSectionRow ? (
                <div className={styles.vlShareFieldStack}>
                  <div className={styles.vlShareSeatGridTwo}>
                    <input
                      type="text"
                      className={styles.vlShareInput}
                      value={vlShareSections[vlShareCommonTpId] ?? ''}
                      disabled={vlShareLoading}
                      onChange={(e) => {
                        const nextValue = e.target.value;
                        setVlShareSections((prev) => {
                          const next = { ...prev };
                          for (const ticket of vlShareSelectedTickets) next[ticket.tpId] = nextValue;
                          return next;
                        });
                      }}
                      placeholder="Section for all"
                    />
                    <input
                      type="text"
                      className={styles.vlShareInput}
                      value={vlShareRows[vlShareCommonTpId] ?? ''}
                      disabled={vlShareLoading}
                      onChange={(e) => {
                        const nextValue = e.target.value;
                        setVlShareRows((prev) => {
                          const next = { ...prev };
                          for (const ticket of vlShareSelectedTickets) next[ticket.tpId] = nextValue;
                          return next;
                        });
                      }}
                      placeholder="Row for all"
                    />
                  </div>
                  <div className={styles.vlShareSeatList}>
                    {vlShareSelectedTickets.map((ticket) => (
                      <div key={ticket.tpId} className={styles.vlShareSeatRow}>
                        <span className={styles.vlShareSeatRowLabel}>Seat</span>
                        <input
                          type="text"
                          className={styles.vlShareInput}
                          value={vlShareSeats[ticket.tpId] ?? ''}
                          disabled={vlShareLoading}
                          onChange={(e) =>
                            setVlShareSeats((prev) => ({ ...prev, [ticket.tpId]: e.target.value }))
                          }
                          placeholder="Seat"
                        />
                      </div>
                    ))}
                  </div>
                  <div>
                    <label className={styles.vlShareLabel}>
                      List price
                      {vlSharePriceMarketplaceLinks}
                    </label>
                    <div className={styles.vlSharePriceWrap}>
                      <input
                        type="text"
                        className={styles.vlSharePriceInput}
                        inputMode="decimal"
                        value={vlSharePrices[vlShareCommonTpId] ?? ''}
                        disabled={vlShareLoading}
                        onChange={(e) => {
                          const nextValue = sanitizePriceInput(e.target.value);
                          setVlSharePrices((prev) => {
                            const next = { ...prev };
                            for (const ticket of vlShareSelectedTickets) next[ticket.tpId] = nextValue;
                            return next;
                          });
                        }}
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <div className={styles.vlShareTicketList}>
                  {vlShareSelectedTickets.map((ticket) => (
                    <div key={ticket.tpId} className={styles.vlShareTicketBlock}>
                      <div className={styles.vlShareSeatGrid}>
                        <input
                          type="text"
                          className={styles.vlShareInput}
                          value={vlShareSections[ticket.tpId] ?? ''}
                          disabled={vlShareLoading}
                          onChange={(e) =>
                            setVlShareSections((prev) => ({ ...prev, [ticket.tpId]: e.target.value }))
                          }
                          placeholder="Section"
                        />
                        <input
                          type="text"
                          className={styles.vlShareInput}
                          value={vlShareRows[ticket.tpId] ?? ''}
                          disabled={vlShareLoading}
                          onChange={(e) =>
                            setVlShareRows((prev) => ({ ...prev, [ticket.tpId]: e.target.value }))
                          }
                          placeholder="Row"
                        />
                        <input
                          type="text"
                          className={styles.vlShareInput}
                          value={vlShareSeats[ticket.tpId] ?? ''}
                          disabled={vlShareLoading}
                          onChange={(e) =>
                            setVlShareSeats((prev) => ({ ...prev, [ticket.tpId]: e.target.value }))
                          }
                          placeholder="Seat"
                        />
                      </div>
                      <div>
                        <label className={styles.vlShareLabel}>
                          List price
                          {vlSharePriceMarketplaceLinks}
                        </label>
                        <div className={styles.vlSharePriceWrap}>
                        <input
                          type="text"
                          className={styles.vlSharePriceInput}
                          inputMode="decimal"
                          value={vlSharePrices[ticket.tpId] ?? ''}
                          disabled={vlShareLoading}
                          onChange={(e) =>
                            setVlSharePrices((prev) => ({
                              ...prev,
                              [ticket.tpId]: sanitizePriceInput(e.target.value),
                            }))
                          }
                          placeholder="0.00"
                        />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {!isSelfPricingClient() && (
            <div className={styles.vlShareSection}>
              <label className={styles.vlShareLabel}>Pricing method</label>
              <div className={styles.userDetailsPricingMethods} role="radiogroup" aria-label="Pricing method">
                <label className={`${styles.userDetailsPricingOption} ${vlSharePricingMethod === 'MANUAL' ? styles.userDetailsPricingOptionSelected : ''}`}>
                  <input
                    type="radio"
                    name="vl-share-pricing-method"
                    value="MANUAL"
                    checked={vlSharePricingMethod === 'MANUAL'}
                    disabled={vlShareLoading}
                    onChange={() => setVlSharePricingMethod('MANUAL')}
                  />
                  <span>Manually Priced</span>
                  <span className={styles.userDetailsManualPriceBadge} title="Manually Priced" aria-label="Manually Priced">
                    <DollarSign size={13} aria-hidden />
                  </span>
                </label>
                <label className={`${styles.userDetailsPricingOption} ${vlSharePricingMethod === 'FOLLOW_MARKET' ? styles.userDetailsPricingOptionSelected : ''}`}>
                  <input
                    type="radio"
                    name="vl-share-pricing-method"
                    value="FOLLOW_MARKET"
                    checked={vlSharePricingMethod === 'FOLLOW_MARKET'}
                    disabled={vlShareLoading}
                    onChange={() => setVlSharePricingMethod('FOLLOW_MARKET')}
                  />
                  <span>Follow the Market — Active</span>
                  <span className={styles.userDetailsFollowMarketBadge} title="Follow Market" aria-label="Follow Market">
                    <TrendingUp size={13} aria-hidden />
                  </span>
                </label>
                <label className={`${styles.userDetailsPricingOption} ${vlSharePricingMethod === 'NONE' ? styles.userDetailsPricingOptionSelected : ''}`}>
                  <input
                    type="radio"
                    name="vl-share-pricing-method"
                    value="NONE"
                    checked={vlSharePricingMethod === 'NONE'}
                    disabled={vlShareLoading}
                    onChange={() => setVlSharePricingMethod('NONE')}
                  />
                  <span>Nothing</span>
                </label>
              </div>
            </div>
            )}

            <div className={styles.vlShareSection}>
              <label className={styles.vlShareLabel}>Internal notes</label>
              {isParkingPassNoteGroup(vlShareSelectedTickets.map((ticket) => vlShareRows[ticket.tpId] ?? ticket.row)) ? (
                <textarea
                  className={styles.vlShareTextarea}
                  rows={3}
                  value={vlShareInternalNotes}
                  disabled={vlShareLoading}
                  onChange={(e) => {
                    setVlShareInternalNoteQuery(e.target.value);
                    setVlShareInternalNotes(e.target.value);
                  }}
                />
              ) : (
              <ListingNoteCombobox
                value={vlShareInternalNoteQuery}
                options={vlShareInternalNoteChoices}
                sentValue={vlShareInternalNotes}
                disabled={vlShareLoading}
                placeholder="Search or enter internal notes"
                onChange={(value) => {
                  const draft = composeListingNoteDraft(value, vlShareInternalNoteChoices, vlShareListingCustom, 'internal');
                  setVlShareInternalNoteQuery(draft.query);
                  setVlShareInternalNotes(draft.sent);
                }}
              />
              )}
            </div>

            <div className={styles.vlShareSection}>
              <label className={styles.vlShareLabel}>External notes</label>
              {isParkingPassNoteGroup(vlShareSelectedTickets.map((ticket) => vlShareRows[ticket.tpId] ?? ticket.row)) ? (
                <textarea
                  className={styles.vlShareTextarea}
                  rows={3}
                  value={vlShareExternalNotes}
                  disabled={vlShareLoading}
                  onChange={(e) => {
                    setVlShareExternalNoteQuery(e.target.value);
                    setVlShareExternalNotes(e.target.value);
                  }}
                />
              ) : (
              <ListingNoteCombobox
                value={vlShareExternalNoteQuery}
                options={vlShareExternalNoteChoices}
                sentValue={vlShareExternalNotes}
                disabled={vlShareLoading}
                placeholder="Search or enter external notes"
                onChange={(value) => {
                  const draft = composeListingNoteDraft(value, vlShareExternalNoteChoices, vlShareListingCustom, 'external');
                  setVlShareExternalNoteQuery(draft.query);
                  setVlShareExternalNotes(draft.sent);
                }}
              />
              )}
            </div>

            <div className={styles.vlShareSection}>
              <label className={styles.vlShareLabel}>QA notes</label>
              <textarea
                className={styles.vlShareTextarea}
                value={vlShareQaNotes}
                disabled={vlShareLoading}
                onChange={(e) => setVlShareQaNotes(e.target.value)}
                placeholder="QA notes (saved in QuickAsyst only, not sent to Victory Live)"
                rows={2}
              />
            </div>

            <div className={styles.vlShareMarketplaceActions}>
              <button
                type="button"
                className={styles.modalCancel}
                onClick={() => setVlEnabledMarketplaces(VL_MARKETPLACE_OPTIONS.map((m) => m.id))}
                disabled={vlShareLoading}
              >
                Select all
              </button>
              <button
                type="button"
                className={styles.modalCancel}
                onClick={() => setVlEnabledMarketplaces([])}
                disabled={vlShareLoading}
              >
                Clear all
              </button>
            </div>

            <div className={styles.vlShareMarketplaceGrid}>
              {VL_MARKETPLACE_OPTIONS.map((m) => {
                const checked = vlEnabledMarketplaces.includes(m.id);
                return (
                  <label key={m.id} className={styles.vlShareMarketplaceOption}>
                    <input
                      type="checkbox"
                      checked={checked}
                      disabled={vlShareLoading}
                      onChange={() => {
                        setVlEnabledMarketplaces((prev) =>
                          checked ? prev.filter((id) => id !== m.id) : [...prev, m.id],
                        );
                      }}
                    />
                    <MarketplaceBrandMark id={m.id} />
                    {m.label}
                  </label>
                );
              })}
            </div>
          </div>
          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.modalCancel}
              onClick={() => {
                wrongPidFlowRef.current = null;
                setShowVlShareModal(false);
              }}
              disabled={vlShareLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`${styles.ctConfirmBtn} ${vlShareLoading ? styles.ctConfirmBtnDisabled : ''}`}
              onClick={() => { void handleShareVlListings(); }}
              disabled={vlShareLoading}
            >
              {vlShareLoading ? 'Sharing…' : 'Share & List'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderVlProductionMapModal = () => {
    if (!showVlProductionMapModal || !vlProductionMismatch) return null;
    const busy = vlProductionMapLoading || vlProductionSearchLoading;
    return (
      <div
 className={`${styles.modalOverlay} ${styles.vlProductionMapModalOverlay}`}
 >
        <div
          className={`${styles.modalContent} ${styles.vlProductionMapModal}`}
          onClick={(e) => e.stopPropagation()}
        >
          {vlProductionMapLoading && (
            <div className={styles.vlModalBusyOverlay} role="status" aria-live="polite">
              <div className={styles.vlBusySpinner} />
              <p>
                {vlActionLoading
                  ? vlBusyMessage
                  : vlProductionModalMode === 'add-pid'
                    ? 'Saving Production ID…'
                    : 'Submitting to Victory Live…'}
              </p>
            </div>
          )}
          <div className={styles.modalHeader}>
            <h3>Search Events for Production IDs</h3>
            <button
              type="button"
              className={styles.modalClose}
              disabled={busy}
              onClick={() => {
                wrongPidFlowRef.current = null;
                setShowVlProductionMapModal(false);
              }}
            >
              ×
            </button>
          </div>
          <div className={styles.modalBody}>
            <p className={styles.vlShareHint}>
              {vlProductionModalMode === 'add-pid'
                ? 'Add or overwrite the Production ID for '
                : vlProductionModalMode === 'confirm'
                  ? 'Select the Production ID for '
                  : 'Overwrite the Victory Live production for '}
              <strong>{vlProductionMismatch.eventName}</strong> @ {vlProductionMismatch.venue} on{' '}
              {vlProductionMismatch.eventDate}.{' '}
              {vlProductionModalMode === 'add-pid'
                ? 'Saves to QuickAsyst only — ticket status stays the same and Victory Live is not updated.'
                : vlProductionModalMode === 'confirm'
                  ? 'Submit to VL and Mark Verified saves the PID, creates Victory Live inventory, and moves tickets to Verified in one step.'
                  : 'This overwrites the PID, submits inventory to Victory Live, and moves tickets to Verified.'}
            </p>
            {/* Enter PID tab hidden for now — search is the only visible option.
            <button
              type="button"
              role="tab"
              aria-selected={vlAddPidTab === 'enter'}
              className={`${styles.vlAddPidTab} ${vlAddPidTab === 'enter' ? styles.vlAddPidTabActive : ''}`}
              disabled={vlProductionMapLoading}
              onClick={() => setVlAddPidTab('enter')}
            >
              Enter PID
            </button>
            */}
            {(vlProductionModalMode !== 'add-pid' || vlAddPidTab === 'search') && (
              <>
                <div className={styles.vlProductionSearchRow}>
                  <input
                    className={styles.vlProductionSearchInput}
                    value={vlProductionSearchQuery}
                    disabled={busy}
                    onChange={(e) => setVlProductionSearchQuery(e.target.value)}
                    placeholder="Event name (e.g. New York Yankees)"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        void handleSearchVlProductions();
                      }
                    }}
                  />
                  <button
                    type="button"
                    className={styles.modalConfirm}
                    onClick={() => void handleSearchVlProductions()}
                    disabled={busy}
                  >
                    {vlProductionSearchLoading ? 'Searching…' : 'Search'}
                  </button>
                </div>
                <div className={styles.vlProductionTableWrap}>
                  <table className={styles.vlProductionTable}>
                    <thead>
                      <tr>
                        <th />
                        <th>Production ID</th>
                        <th>Event Name</th>
                        <th>Venue</th>
                        <th>Date</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {vlProductionSearchResults.length === 0 ? (
                        <tr>
                          <td colSpan={6}>No productions found — adjust the search or escalate</td>
                        </tr>
                      ) : (
                        vlProductionSearchResults.map((row) => (
                          <tr
                            key={row.productionId}
                            className={
                              vlSelectedProductionId === row.productionId
                                ? styles.vlProductionRowSelected
                                : undefined
                            }
                            onClick={() => setVlSelectedProductionId(row.productionId)}
                          >
                            <td>
                              <input
                                type="radio"
                                name="udVlProductionPick"
                                checked={vlSelectedProductionId === row.productionId}
                                onChange={() => setVlSelectedProductionId(row.productionId)}
                                disabled={vlProductionMapLoading}
                              />
                            </td>
                            <td>
                              <div className={styles.vlProductionIdCell}>
                                <span>{row.productionId}</span>
                                {(row as any).isSuggested ? (
                                  <span className={styles.suggestedPidPill}>Suggested</span>
                                ) : null}
                              </div>
                            </td>
                            <td>{displayVlEventName(row.eventName) || '—'}</td>
                            <td>{row.venueName || '—'}</td>
                            <td>
                              {(() => {
                                const raw = String(row.eventDate || '');
                                const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
                                return m ? `${m[2]}/${m[3]}/${m[1]}` : raw || '—';
                              })()}
                            </td>
                            <td>
                              {(row as any).eventTime ||
                                (() => {
                                  const raw = String(row.eventDate || '');
                                  const m = raw.match(/[T\s](\d{1,2}):(\d{2})/);
                                  if (!m) return '—';
                                  const h = Number(m[1]);
                                  const ampm = h >= 12 ? 'PM' : 'AM';
                                  const h12 = h % 12 === 0 ? 12 : h % 12;
                                  return `${String(h12).padStart(2, '0')}:${m[2]} ${ampm}`;
                                })()}
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {vlProductionModalMode === 'add-pid' && vlAddPidTab === 'enter' && (
              <div className={styles.vlEnterPidPanel}>
                <label className={styles.vlEnterPidLabel} htmlFor="ud-vl-enter-production-id">
                  Production ID
                </label>
                <div className={styles.vlProductionSearchRow}>
                  <input
                    id="ud-vl-enter-production-id"
                    className={styles.vlProductionSearchInput}
                    value={vlEnteredProductionId}
                    disabled={vlProductionMapLoading}
                    inputMode="numeric"
                    autoComplete="off"
                    placeholder="Enter Production ID (numbers only)"
                    onChange={(e) => setVlEnteredProductionId(e.target.value.replace(/[^\d]/g, ''))}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        void handleMapVlProductionAndRetry();
                      }
                    }}
                  />
                </div>
                <p className={styles.vlEnterPidHint}>
                  Saves this Production ID to QuickAsyst only. Ticket status stays the same.
                </p>
              </div>
            )}
          </div>
          <div className={styles.modalFooter}>
            <button
              type="button"
              className={styles.modalCancel}
              onClick={() => {
                wrongPidFlowRef.current = null;
                setShowVlProductionMapModal(false);
              }}
              disabled={vlProductionMapLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.modalConfirm}
              onClick={() => void handleMapVlProductionAndRetry()}
              disabled={
                vlProductionMapLoading ||
                (vlProductionModalMode === 'add-pid' && vlAddPidTab === 'enter'
                  ? !/^\d+$/.test(vlEnteredProductionId.trim())
                  : !vlSelectedProductionId)
              }
            >
              {vlProductionMapLoading
                ? vlProductionModalMode === 'add-pid'
                  ? 'Saving…'
                  : 'Submitting to VL…'
                : vlProductionModalMode === 'add-pid'
                  ? vlAddPidTab === 'enter'
                    ? 'Add PID'
                    : 'Save PID to QuickAsyst'
                  : vlProductionModalMode === 'confirm'
                    ? 'Submit to VL and Mark Verified'
                    : 'Overwrite, Submit to VL & Mark Verified'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderConciergePriceModal = () => {
    if (!showConciergePriceModal) return null;
    const changed = conciergePriceResults.filter(
      (r) =>
        r.status === 'up' ||
        r.status === 'down' ||
        r.status === 'failed' ||
        isVlUnknownStatus(r.status),
    );
    const rowsToShow = changed.length ? changed : conciergePriceResults;
    return (
      <div className={styles.modalOverlay}>
        <div className={styles.ctModalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: 640 }}>
          <div className={styles.ctModalHeader}>
            <div className={styles.ctModalTitleRow}>
              <RefreshCcw className={styles.ctRotateIcon} size={20} />
              <span className={styles.ctModalTitle}>Concierge Price Updates</span>
            </div>
            <button
              type="button"
              className={styles.ctModalClose}
              onClick={() => setShowConciergePriceModal(false)}
              disabled={isTicketTableBusy}
            >
              ×
            </button>
          </div>
          <div className={styles.ctModalBody}>
            <p style={{ marginTop: 0 }}>This run (from Victory Live)</p>
            <div style={{ maxHeight: 240, overflowY: 'auto', marginBottom: 16 }}>
              {rowsToShow.map((row) => (
                <div
                  key={row.tpId}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '8px 0',
                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                    fontSize: 13,
                  }}
                >
                  {row.direction === 'up' ? (
                    <TrendingUp size={16} color="#16a34a" />
                  ) : row.direction === 'down' ? (
                    <TrendingDown size={16} color="#dc2626" />
                  ) : (
                    <RefreshCcw size={14} />
                  )}
                  <div style={{ flex: 1 }}>
                    <div>
                      {row.eventName || 'Event'} • Sec {row.section || 'N/A'} • Row {row.row || 'N/A'} • Seat{' '}
                      {row.seat ?? 'N/A'}
                    </div>
                    <div style={{ opacity: 0.75 }}>
                      {row.oldPrice != null ? `$${Number(row.oldPrice).toFixed(2)}` : '—'}
                      {' → '}
                      {row.newPrice != null ? `$${Number(row.newPrice).toFixed(2)}` : '—'}
                      {row.message ? ` · ${row.message}` : ''}
                    </div>
                  </div>
                </div>
              ))}
              {!conciergePriceResults.length && (
                <div style={{ opacity: 0.7, padding: '8px 0' }}>No results for this run.</div>
              )}
            </div>
            <p style={{ marginBottom: 8 }}>All price changes ({conciergeRecentChanges.length})</p>
            <div style={{ maxHeight: 280, overflowY: 'auto' }}>
              {conciergeRecentChanges.length === 0 ? (
                <div style={{ opacity: 0.7, padding: '8px 0' }}>No price change history for these seats yet.</div>
              ) : (
                conciergeRecentChanges.map((row) => (
                  <div
                    key={row.lpId}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '8px 0',
                      borderBottom: '1px solid rgba(0,0,0,0.06)',
                      fontSize: 13,
                    }}
                  >
                    {row.direction === 'up' ? (
                      <TrendingUp size={16} color="#16a34a" />
                    ) : row.direction === 'down' ? (
                      <TrendingDown size={16} color="#dc2626" />
                    ) : (
                      <RefreshCcw size={14} />
                    )}
                    <div style={{ flex: 1 }}>
                      <div>
                        {row.eventName || 'Event'} • Sec {row.section || 'N/A'} • Row {row.row || 'N/A'} • Seat{' '}
                        {row.seat ?? 'N/A'}
                      </div>
                      <div style={{ opacity: 0.75 }}>
                        {row.oldPrice != null ? `$${Number(row.oldPrice).toFixed(2)}` : '—'}
                        {' → '}
                        {row.newPrice != null ? `$${Number(row.newPrice).toFixed(2)}` : '—'}
                        {row.editType ? ` · ${row.editType}` : ''}
                        {row.createdAt ? ` · ${new Date(row.createdAt).toLocaleString()}` : ''}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div className={styles.ctModalFooter}>
            <button
              type="button"
              className={styles.ctConfirmBtn}
              onClick={() => setShowConciergePriceModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderTeamSeatsModal = () => {
  if (!selectedTeamForSeats) return null;
  
  // Get tickets for this team from currentTickets (which is already dynamic)
  const teamTickets = getTeamSeatTickets(selectedTeamForSeats.name, selectedTeamForSeats.abbreviation);
  
  const seatInfoKey = `${userId || 'unknown'}:${selectedTeamForSeats.id}`;
  
  // Get saved seat info from the query (dynamic)
  const savedSeatRows: SeatInfoRow[] = Array.isArray(userSavedSeatInfoData?.user_saved_seat_info)
    ? userSavedSeatInfoData.user_saved_seat_info.map((row: any) => ({
        id: `saved-${row.ussi_id}`, 
        event: row.team_name || selectedTeamForSeats.name, 
        date: '-',
        section: row.section || '-', 
        row: row.seat_row || '-', 
        seatNo: row.start_seat || '-',
        source: 'saved' as const, 
        ussiId: row.ussi_id
      })) : [];
  
  // Convert tickets to seat rows with event time
  const ticketSeatRows: SeatInfoRow[] = teamTickets.map((ticket) => ({
    id: `ticket-${ticket.tpId}`, 
    event: ticket.event, 
    date: ticket.date,
    eventTime: ticket.eventTime || '', // Include event time
    section: ticket.section, 
    row: ticket.row, 
    seatNo: ticket.seatNo,
    source: 'ticket' as const, 
    ticketId: ticket.tpId,
    status: ticket.status,
    price: ticket.price
  }));
  
  // Use local overrides if they exist, otherwise use ticket rows or saved rows
  let displayRows: SeatInfoRow[] = ticketSeatRows.length > 0 ? ticketSeatRows : savedSeatRows;
  if (localSeatInfoOverrides[seatInfoKey]) {
    displayRows = localSeatInfoOverrides[seatInfoKey];
  }
  
  const startSeatEdit = (row: SeatInfoRow) => {
    setEditingSeatTicketId(row.id);
    setSeatEditForm({ 
      section: row.section === '-' ? '' : row.section, 
      row: row.row === '-' ? '' : row.row, 
      seatNo: row.seatNo === '-' ? '' : row.seatNo 
    });
  };
  
  const cancelSeatEdit = () => { 
    setEditingSeatTicketId(null); 
    setSeatEditForm({ section: '', row: '', seatNo: '' }); 
  };
  
  const saveSeatEdit = async (rowItem: SeatInfoRow) => {
    const section = seatEditForm.section.trim();
    const row = seatEditForm.row.trim();
    const seatNo = Number(seatEditForm.seatNo);
    if (!section || !row || !Number.isFinite(seatNo) || seatNo <= 0) {
      showError('Section, row, and a valid seat number are required.');
      return;
    }
    try {
      setSavingSeatTicketId(rowItem.id);
      if (!selectedTeamForSeats || !isValidUuid(selectedTeamForSeats.id) || !userId) {
        showError('Cannot save seat info for this team.');
        return;
      }
      if (rowItem.source === 'saved' && rowItem.ussiId) {
        await updateUserSavedSeatInfo({ 
          variables: { 
            ussi_id: rowItem.ussiId, 
            section, 
            seat_row: row, 
            start_seat: String(Math.trunc(seatNo)), 
            end_seat: String(Math.trunc(seatNo)) 
          } 
        });
      } else {
        await insertUserSavedSeatInfo({ 
          variables: { 
            u_id: userId, 
            lc_id: selectedTeamForSeats.id, 
            team_name: selectedTeamForSeats.name, 
            section, 
            seat_row: row, 
            start_seat: String(Math.trunc(seatNo)), 
            end_seat: String(Math.trunc(seatNo)) 
          } 
        });
      }
      await refetchUserSavedSeatInfo();
      setLocalSeatInfoOverrides((prev) => {
        const updatedRows = (prev[seatInfoKey] || displayRows).map(seatRow => 
          seatRow.id === rowItem.id ? { ...seatRow, section, row, seatNo: String(Math.trunc(seatNo)) } : seatRow
        );
        return { ...prev, [seatInfoKey]: updatedRows };
      });
      showSuccess('Seat info saved successfully.');
      cancelSeatEdit();
    } catch (error: any) {
      const message = (error?.message || '').toLowerCase();
      if (message.includes('query is not allowed') || message.includes('allowlist')) {
        setLocalSeatInfoOverrides((prev) => {
          const updatedRows = (prev[seatInfoKey] || displayRows).map(seatRow => 
            seatRow.id === rowItem.id ? { ...seatRow, section, row, seatNo: String(Math.trunc(seatNo)) } : seatRow
          );
          return { ...prev, [seatInfoKey]: updatedRows };
        });
        showSuccess('Seat info saved locally (allowlist restriction).');
        cancelSeatEdit();
      } else {
        showError(error?.message || 'Failed to save seat info.');
      }
    } finally { 
      setSavingSeatTicketId(null); 
    }
  };
  
  return (
    <div className={styles.teamSeatModalOverlay} onClick={() => setSelectedTeamForSeats(null)}>
      <div className={styles.teamSeatModal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.teamSeatModalHeader}>
          <h3>{selectedTeamForSeats.name} - Seat Info</h3>
          <button 
            className={styles.closeBtn} 
            onClick={() => setSelectedTeamForSeats(null)}
          >
            <X size={20} />
          </button>
        </div>
        <div className={styles.teamSeatModalBody}>
          {userSavedSeatInfoLoading ? (
            <div className={styles.loadingSmall}>
              <Loader size={20} className={styles.spinner} />
              <span>Loading seat info...</span>
            </div>
          ) : displayRows.length > 0 ? (
            <div className={styles.teamSeatTableWrapper}>
              <table className={styles.teamSeatTable}>
                <thead>
                  <tr>
                    <th>Event</th>
                    <th>Date & Time</th>
                    <th>Section</th>
                    <th>Row</th>
                    <th>Seat</th>
                    <th>Status</th>
                    <th>Price</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {displayRows.map((rowItem) => (
                    <tr key={`${selectedTeamForSeats.id}-${rowItem.id}`}>
                      <td>{rowItem.event}</td>
                      <td>
                        {rowItem.date !== '-' ? (
                          <>
                            {rowItem.date}
                            {rowItem.eventTime ? ` • ${rowItem.eventTime}` : ''}
                          </>
                        ) : '-'}
                      </td>
                      <td>
                        {editingSeatTicketId === rowItem.id ? 
                          <input className={styles.teamSeatInput} value={seatEditForm.section} onChange={(e) => setSeatEditForm(prev => ({ ...prev, section: e.target.value }))} /> 
                          : rowItem.section}
                      </td>
                      <td>
                        {editingSeatTicketId === rowItem.id ? 
                          <input className={styles.teamSeatInput} value={seatEditForm.row} onChange={(e) => setSeatEditForm(prev => ({ ...prev, row: e.target.value }))} /> 
                          : rowItem.row}
                      </td>
                      <td>
                        {editingSeatTicketId === rowItem.id ? 
                          <input className={styles.teamSeatInput} type="number" min="1" value={seatEditForm.seatNo} onChange={(e) => setSeatEditForm(prev => ({ ...prev, seatNo: e.target.value }))} /> 
                          : rowItem.seatNo}
                      </td>
                      <td>
                        {rowItem.source === 'ticket' ? (
                          <span className={`${styles.statusBadge} ${getStatusColorClass(rowItem.status || '')}`}>
                            {rowItem.status || 'Unknown'}
                          </span>
                        ) : (
                          <span className={styles.savedBadge}>Saved</span>
                        )}
                      </td>
                      <td>
                        {rowItem.source === 'ticket' && rowItem.price ? (
                          <span>{rowItem.price}</span>
                        ) : (
                          <span>—</span>
                        )}
                      </td>
                      <td>
                        {editingSeatTicketId === rowItem.id ? (
                          <div className={styles.teamSeatActionGroup}>
                            <button className={styles.teamSeatSaveBtn} onClick={() => saveSeatEdit(rowItem)} disabled={savingSeatTicketId === rowItem.id}>
                              {savingSeatTicketId === rowItem.id ? 'Saving...' : 'Save'}
                            </button>
                            <button className={styles.teamSeatCancelBtn} onClick={cancelSeatEdit} disabled={savingSeatTicketId === rowItem.id}>
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <button className={styles.teamSeatEditBtn} onClick={() => startSeatEdit(rowItem)}>
                            Edit
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className={styles.emptyState}>
              <p>No seat info found for this team.</p>
              <p className={styles.emptyStateSub}>Add seat information by clicking Edit on a row.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
  const emailEnabledResolved = (emailStatusData?.user?.[0]?.u_email_enabled) ?? (currentUser?.emailEnabled ?? true);
  const currentTickets = localTickets;
  const filteredTickets = useMemo(
    () => getFilteredTickets(),
    // Page offset is intentionally absent: slicing a loaded window must not rebuild groups.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      localTickets,
      activeFilterTab,
      soldSubFilter,
      filterStatus,
      isGetUserTicketsAllowlistError,
      searchQuery,
      debouncedTicketSearch,
      barcodeFilter,
      pidStatusFilter,
      vlShareFilter,
      pricingMethodFilter,
      lastPricedFrom,
      lastPricedTo,
      lastPricedCustomRange,
      lastPricedFilter,
      onHoldFilter,
      stripeAccountFilter,
      currentUser?.stripeAccountId,
      currentUser?.stripeAccountIsDue,
      currentUser?.stripeTransfersStatus,
      dateFilter,
      customFromDate,
      customToDate,
    ],
  );
  const serverTicketPaging = !isGetUserTicketsAllowlistError;
  const ticketPageTotal = serverTicketPaging ? ticketSeatTotal : filteredTickets.length;
  const ticketsForTable = filteredTickets;

  useEffect(() => {
    setMatchedSeatLevelNote(null);
    if (!userId || !seatLevelTeam || !seatLevelSection || !seatLevelRow || !seatLevelRange) return;

    const selectedSeatBounds = parseSeatNumbersFromRange(seatLevelRange);
    if (!selectedSeatBounds.length) return;

    const matching = findMatchingSeatLevelNote(seatLevelNotes, {
      userId,
      teamId: seatLevelTeam.id,
      teamName: seatLevelTeam.name,
      section: seatLevelSection,
      row: seatLevelRow,
      seatStart: selectedSeatBounds[0],
      seatEnd: selectedSeatBounds[selectedSeatBounds.length - 1],
    });
    setMatchedSeatLevelNote(matching as SeatLevelNoteEntry | null);
  }, [userId, seatLevelTeam?.id, seatLevelTeam?.name, seatLevelSection, seatLevelRow, seatLevelRange, seatLevelNotes]);

  type UserTicketDisplayRow =
    | {
        kind: 'group';
        groupKey: string;
        groupLabel: string;
        summary: {
          event: string;
          section: string;
          row: string;
          seatLabel: string;
          seatMode?: 'odd' | 'even' | null;
          totalQuantity: number;
          status: string;
          date: string;
          eventTime: string;
          venue: string;
          league: string;
          email: string;
        };
        tickets: Ticket[];
      }
    | {
        kind: 'ticket';
        ticket: Ticket;
      };

  const buildUserTicketDisplayRows = (tickets: Ticket[]): UserTicketDisplayRow[] => {
    const originals = new Map(tickets.map((ticket) => [ticket.tpId, ticket]));
    const boundarySource = localTickets.length ? localTickets : tickets;
    const rows = buildManageTicketDisplayGroups(
      tickets.map((ticket) => toManageTicketGroupingRecord(ticket)),
      activeFilterTab,
      boundarySource.map((ticket) => toManageTicketGroupingRecord(ticket)),
    );

    return rows.flatMap((row): UserTicketDisplayRow[] => {
      if (row.kind !== 'group' && row.kind !== 'ticket') return [];
      const sourceTickets = (row.kind === 'group' ? row.tickets : [row.ticket])
        .map((ticket) => originals.get(String(ticket.tp_id || '').trim()))
        .filter((ticket): ticket is Ticket => Boolean(ticket));
      if (!sourceTickets.length) return [];
      if (row.kind === 'ticket' || sourceTickets.length === 1) {
        return [{ kind: 'ticket', ticket: sourceTickets[0] }];
      }
      const groupFirst = sourceTickets[0];
      return [{
        kind: 'group',
        groupKey: row.groupKey,
        groupLabel: groupFirst.event || 'Event',
        summary: {
          event: groupFirst.event || 'N/A',
          section: groupFirst.section || 'N/A',
          row: groupFirst.row || 'N/A',
          seatLabel: row.summary.seatLabel,
          seatMode: row.summary.seatMode ?? null,
          totalQuantity: sourceTickets.length,
          status: groupFirst.rawStatus || groupFirst.status || 'Unknown',
          date: groupFirst.date || 'TBD',
          eventTime: groupFirst.eventTime || '',
          venue: groupFirst.venue || 'N/A',
          league: groupFirst.league || 'N/A',
          email: groupFirst.email || 'N/A',
        },
        tickets: sourceTickets,
      }];
    });
  };

  const displayTicketRows = useMemo(() => {
    const rows = activeFilterTab === 'Delisted'
      ? [0, 1, 2, 3].flatMap((rank) =>
          buildUserTicketDisplayRows(
            ticketsForTable.filter(
              (ticket) => getUserDetailsDelistedGroupRank(ticket.rawStatus || ticket.status) === rank,
            ),
          ),
        )
      : buildUserTicketDisplayRows(ticketsForTable);
    if (!isManageTicketTableSortEnabled(activeFilterTab)) return rows;
    return sortManageTicketRowsByValues(rows, ticketTableSort, (row) => {
      const ticket = row.kind === 'group' ? row.tickets[0] : row.ticket;
      const priceValue = activeFilterTab === 'Sold' ? ticket.soldPrice : ticket.price;
      const normalizedPrice = String(priceValue ?? '').replace(/[$,]/g, '').trim();
      const parsedPrice = normalizedPrice && normalizedPrice !== '-'
        ? Number(normalizedPrice)
        : null;
      return {
        eventDate: ticket.eventDateRaw ?? ticket.date,
        section: ticket.section,
        row: ticket.row,
        price: parsedPrice !== null && Number.isFinite(parsedPrice) ? parsedPrice : null,
        lastPriced: ticket.last_priced_at ?? null,
      };
    });
  }, [ticketsForTable, localTickets, activeFilterTab, ticketTableSort]);

  const pagedDisplayRows = (() => {
    if (!serverTicketPaging || ticketSeatsFitOneFetch) {
      return displayTicketRows.slice(ticketPageOffset, ticketPageOffset + ticketPageSize);
    }
    const requestedWindow = getGroupedSeatWindowIndex(ticketPageOffset, ticketGroupsPerFullWindow);
    if (ticketGroupsPerFullWindow && requestedWindow !== ticketLoadedSeatWindowIndex) return [];
    const localOffset = getGroupedWindowLocalOffset(ticketPageOffset, ticketGroupsPerFullWindow);
    return displayTicketRows.slice(localOffset, localOffset + ticketPageSize);
  })();
  const pageTickets = pagedDisplayRows.flatMap((row) => (row.kind === 'group' ? row.tickets : [row.ticket]));
  visiblePageTicketsRef.current = pageTickets;

  // Victory Live support on the Tickets tab: same mail icon, badge, thread and composer as Manage Tickets.
  const vlSupportTabEnabled =
    (activeFilterTab === 'Listed' || activeFilterTab === 'Verification') && normalizedPortalRole !== roles.SUPER_USER;
  const vlSupport = useVlSupportCards({
    tpIds: vlSupportTabEnabled ? pageTickets.map((t) => t.tpId) : [],
    enabled: vlSupportTabEnabled,
    ownerInitials: deriveVlSupportOwnerInitials(globalState?.profile?.firstName, globalState?.profile?.lastName),
    onSent: (result) => {
      if (result.redirectedForNonProd) {
        showInfo(`Test environment: email went to ${result.sentTo ?? 'the QA inbox'}, not Victory Live.`);
      } else {
        showSuccess(`Email sent to ${result.sentTo ?? 'Victory Live'}`);
      }
      if (result.warning) showInfo(result.warning);
    },
    onCompleted: () => showSuccess('Victory Live support ticket marked complete'),
    onError: (message) => showError(message),
  });
  // "Change seat numbers" (odd / even): trims a card to odd-only or even-only seats before it is on Victory Live.
  const seatModeDialog = useSeatModeDialog({
    onChanged: () => void handleRefresh(),
    onSuccess: (message) => showSuccess(message),
    onError: (message) => showError(message),
  });
  const openSeatModeDialog = (tickets: Ticket[]) =>
    seatModeDialog.open({
      tpIds: tickets.map((t) => t.tpId),
      seats: tickets.map((t) => Number(t.seatNo)),
      currentMode: tickets.length && tickets.every((t) => t.seatMode === tickets[0].seatMode) ? tickets[0].seatMode ?? null : null,
      eventName: tickets[0]?.event,
    });
  /** Verification: only listings still in To Be Verified / Verified can ask Victory Live for the PID. */
  const canContactVlForTickets = (tickets: Ticket[]) =>
    vlSupportTabEnabled &&
    (activeFilterTab === 'Listed' ||
      tickets.every((t) => ['ToBeVerified', 'Verified'].includes(normalizeStatusValue(t.rawStatus || t.status))));
  const vlSupportControlFor = (rowKey: string, tickets: Ticket[]) =>
    canContactVlForTickets(tickets) ? vlSupport.renderControl(rowKey, tickets.map((t) => t.tpId)) : null;
  const vlSupportPanelFor = (
    rowKey: string,
    tickets: Ticket[],
    summary: { event?: string; date?: string; eventTime?: string; section?: string; row?: string; seatLabel?: string },
  ) => {
    if (!canContactVlForTickets(tickets)) return null;
    const details: VlSupportEventDetails = {
      eventName: summary.event || 'N/A',
      eventDate: summary.eventTime ? `${summary.date || 'TBD'} ${summary.eventTime}` : summary.date || 'TBD',
      pid: tickets.map((t) => getUserTicketVlProductionId(t)).find(Boolean) || 'N/A',
      section: summary.section && summary.section !== '-' ? summary.section : 'N/A',
      row: summary.row && summary.row !== '-' ? summary.row : 'N/A',
      seats: summary.seatLabel && summary.seatLabel !== '-' ? summary.seatLabel : 'N/A',
    };
    return vlSupport.renderPanelRow(
      rowKey,
      tickets.map((t) => t.tpId),
      details,
      ticketTableColSpan,
      styles.expandedRow,
      activeFilterTab === 'Verification' ? 'need_pid' : undefined,
    );
  };
  const multiWindowTicketPaging = serverTicketPaging && !ticketSeatsFitOneFetch;
  const loadedWindowSeats = filteredTickets.length;
  const loadedWindowGroups = displayTicketRows.length;
  const seatTotalForPages = Math.max(ticketSeatTotal, 0);
  const moreSeatWindows =
    multiWindowTicketPaging &&
    loadedWindowSeats >= ticketGroupedFetchSize &&
    seatTotalForPages > (ticketSeatWindowIndex + 1) * ticketGroupedFetchSize;
  const knownGroupedTotal = multiWindowTicketPaging
    ? resolveLoadedGroupedRowTotal({
        seatTotal: seatTotalForPages,
        loadedSeats: loadedWindowSeats,
        loadedGroups: loadedWindowGroups,
        fetchSize: ticketGroupedFetchSize,
        groupsPerFullWindow: ticketGroupsPerFullWindow,
        windowIndex: ticketSeatWindowIndex,
      })
    : null;
  const groupsThroughLoadedWindow =
    ticketSeatWindowIndex * (ticketGroupsPerFullWindow && ticketGroupsPerFullWindow > 0 ? ticketGroupsPerFullWindow : loadedWindowGroups) +
    loadedWindowGroups;
  const groupedTicketTotal = !multiWindowTicketPaging
    ? displayTicketRows.length
    : (knownGroupedTotal ?? Math.max(
        groupsThroughLoadedWindow,
        pagedDisplayRows.length > 0 ? ticketPageOffset + pagedDisplayRows.length : 0,
      ));
  const ticketCurrentPage = groupedTicketTotal === 0 ? 0 : Math.floor(ticketPageOffset / ticketPageSize) + 1;
  const ticketPageCount = Math.max(
    1,
    Math.ceil(groupedTicketTotal / ticketPageSize) || 1,
    moreSeatWindows ? ticketCurrentPage + 1 : 1,
  );
  const nextTicketPageDisabled = !hasAnotherGroupedPage({
    pageOffset: ticketPageOffset,
    displayedRows: pagedDisplayRows.length,
    loadedGroups: multiWindowTicketPaging ? loadedWindowGroups : displayTicketRows.length,
    groupsPerFullWindow: multiWindowTicketPaging ? ticketGroupsPerFullWindow : null,
    moreSeatWindows,
  });
  const ticketRangeStart = groupedTicketTotal === 0 || pagedDisplayRows.length === 0 ? 0 : ticketPageOffset + 1;
  const ticketRangeEnd = groupedTicketTotal === 0 || pagedDisplayRows.length === 0
    ? 0
    : Math.min(ticketPageOffset + pagedDisplayRows.length, groupedTicketTotal);

  useEffect(() => {
    if (!serverTicketPaging || ticketSeatsFitOneFetch) return;
    if (filteredTickets.length < ticketGroupedFetchSize || displayTicketRows.length <= 0) return;
    if (ticketSeatWindowIndex !== 0) return;
    setTicketGroupsPerFullWindow((prev) => (
      prev === displayTicketRows.length ? prev : displayTicketRows.length
    ));
  }, [
    serverTicketPaging,
    ticketSeatsFitOneFetch,
    filteredTickets.length,
    displayTicketRows.length,
    ticketGroupedFetchSize,
    ticketSeatWindowIndex,
  ]);

  const handleTicketTableSort = (column: ManageTicketSortColumn) => {
    if (!isManageTicketTableSortEnabled(activeFilterTab)) return;
    setTicketTableSort((current) => ({
      column,
      direction: current?.column === column && current.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const renderTicketSortableHeader = (label: string, column: ManageTicketSortColumn, className: string) => {
    if (!isManageTicketTableSortEnabled(activeFilterTab)) {
      return <th className={className}>{label}</th>;
    }
    const activeDirection = ticketTableSort?.column === column ? ticketTableSort.direction : null;
    return (
      <th
        className={className}
        aria-sort={activeDirection ? (activeDirection === 'asc' ? 'ascending' : 'descending') : 'none'}
      >
        <button
          type="button"
          className={styles.sortableHeader}
          onClick={() => handleTicketTableSort(column)}
          aria-label={`Sort by ${label}${activeDirection ? `, ${activeDirection === 'asc' ? 'ascending' : 'descending'}` : ''}`}
        >
          {label}
          {activeDirection && <span aria-hidden="true">{activeDirection === 'asc' ? ' ↑' : ' ↓'}</span>}
        </button>
      </th>
    );
  };

  const toggleTicketGroup = (groupKey: string) => {
    setExpandedTicketGroupKeys((prev) => ({ ...prev, [groupKey]: !prev[groupKey] }));
  };

  const renderSeatCardStatus = (ticket: Ticket, seatKey: string) => {
    const resolvedSeatStatus = seatCardStatusBySeatId[seatKey] || ticket.rawStatus || ticket.status || '';
    const displayTicket = { ...ticket, rawStatus: resolvedSeatStatus, status: resolvedSeatStatus };
    const pres = getTicketStatusPresentation(displayTicket);
    const status = normalizeStatusValue(resolvedSeatStatus || ticket.rawStatus || ticket.status).toLowerCase();
    const paymentUiKey = pres.iconStatus.toLowerCase();
    const transitions = getStatusTransitions(getTicketTransitionStatus(displayTicket));
    const isReadOnlyStatus = !canOverrideSettlementStatus && (paymentUiKey === 'settled' || paymentUiKey === 'settlementinprogress');

    if (
      isReadOnlyStatus ||
      status === 'return' ||
      status === 'closed' ||
      status === 'unsold' ||
      status === 'invalid' ||
      !transitions.length
    ) {
      return (
        <span className={`${styles.seatStatusBadge} ${styles.statusBadge} ${getStatusColorClass(pres.iconStatus)}`}>
          {getStatusIcon(pres.iconStatus)} {pres.label}
        </span>
      );
    }

    return (
      <div className={styles.seatStatusDropdownWrapper} onClick={(e) => e.stopPropagation()}>
        <button
          className={`${styles.seatStatusBadge} ${styles.statusBadge} ${getStatusColorClass(pres.iconStatus)} ${styles.statusDropdownBtn}`}
          disabled={isTicketTableBusy}
          onClick={(e) => {
            e.stopPropagation();
            if (isTicketTableBusy) return;
            setSeatCardStatusDropdownOpen((prev) => ({ ...prev, [seatKey]: !prev[seatKey] }));
          }}
        >
          {getStatusIcon(pres.iconStatus)} {pres.label}
          <ChevronDown size={10} style={{ marginLeft: 3 }} />
        </button>
        {seatCardStatusDropdownOpen[seatKey] && (
          <div className={styles.statusDropdownList}>
            {transitions.map((opt) => (
              <div
                key={opt.value}
                className={styles.statusDropdownListItem}
                onClick={async (e) => {
                  e.stopPropagation();
                  setSeatCardStatusDropdownOpen((prev) => ({ ...prev, [seatKey]: false }));
                  // Don't paint Delist/Verified/Sold until confirm + API succeed.
                  if (!shouldDeferSeatStatusPaint(normalizeStatusValue(opt.value))) {
                    setSeatCardStatusBySeatId((prev) => ({ ...prev, [seatKey]: opt.value }));
                  }
                  const selectedIds = Array.from(bulkSelectedTicketIds);
                  const ticketsForUpdate =
                    selectedIds.length > 1 && selectedIds.includes(ticket.tpId)
                      ? getFilteredTickets().filter((t) => selectedIds.includes(t.tpId))
                      : [ticket];
                  if (ticketsForUpdate.length > 1) {
                    await applyMultiTicketStatusChangeFromUi(ticketsForUpdate, opt.value);
                    return;
                  }
                  await handleStatusChange(ticket, opt.value);
                }}
              >
                {getStatusIcon(opt.value)} {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderTicketTableRow = (row: UserTicketDisplayRow) => {
    if (row.kind === 'group') {
      const isExpanded = Boolean(expandedTicketGroupKeys[row.groupKey]);
      const groupSelectedCount = row.tickets.filter((ticket) => bulkSelectedTicketIds.has(ticket.tpId)).length;
      const groupAllSelected = row.tickets.length > 0 && row.tickets.every((ticket) => bulkSelectedTicketIds.has(ticket.tpId));
      const groupSomeSelected = groupSelectedCount > 0 && !groupAllSelected;

      return (
        <React.Fragment key={row.groupKey}>
          <tr
            className={[
              styles.groupedRow,
              isExpanded ? styles.groupedRowExpanded : '',
              openStatusDropdown === row.tickets[0]?.tpId ||
              openActionTicketId === row.tickets[0]?.tpId
                ? styles.statusMenuOpen
                : '',
            ].filter(Boolean).join(' ')}
            onClick={() => toggleTicketGroup(row.groupKey)}
          >
            <td className={`${styles.checkboxCell} ${styles.stickyCheckbox}`} onClick={(e) => e.stopPropagation()}>
              <input
                type="checkbox"
                className={styles.ticketCheckbox}
                checked={groupAllSelected}
                ref={(element) => {
                  if (element) {
                    element.indeterminate = groupSomeSelected;
                  }
                }}
                onChange={(e) => {
                  e.stopPropagation();
                  const nextSelection = new Set(bulkSelectedTicketIds);
                  row.tickets.forEach((ticket) => {
                    if (e.target.checked) nextSelection.add(ticket.tpId);
                    else nextSelection.delete(ticket.tpId);
                  });
                  setBulkSelectedTicketIds(nextSelection);
                }}
              />
            </td>
            {renderUserDetailsEventCell({
              ticket: row.tickets[0],
              eventName: row.summary.event,
              dateLabel: row.summary.date || 'TBD',
              timeLabel: row.summary.eventTime,
              showBarcodeStatusIcon: activeFilterTab === 'Listed' || activeFilterTab === 'Sold',
              groupTickets: row.tickets,
              onBarcodeStatusSelect: (tickets, status) => {
                void handleUserBarcodeStatusUpdate(tickets, status);
              },
              extraContent: vlSupportControlFor(row.groupKey, row.tickets),
            })}
            <td className={styles.tdSection}>{row.summary.section || 'N/A'}</td>
            <td className={styles.tdRow}>{row.summary.row || 'N/A'}</td>
            <td className={styles.tdSeat}>
              <SeatModeBadge mode={row.summary.seatMode} />
              <div>{row.summary.seatLabel || 'N/A'}</div>
            </td>
            <td className={styles.tdStatus}>
              <WrongPidRetryButton
                wrongPid={row.tickets.some((ticket) => ticket.tpWrongPid === true)}
                status={normalizeStatusValue(row.tickets[0]?.rawStatus || row.tickets[0]?.status)}
                disabled={isTicketTableBusy}
                className={styles.wrongPidRetryBtn}
                onResubmit={() => void openWrongPidResubmit(row.tickets)}
                onRelist={() => void openWrongPidRelist(row.tickets)}
              />
              {(() => {
                const representativeTicket = row.tickets[0];
                const displayGroupTicket = {
                  ...representativeTicket,
                  rawStatus: row.summary.status,
                  status: row.summary.status,
                };
                const pres = getTicketStatusPresentation(displayGroupTicket);
                const paymentUiKey = pres.iconStatus.toLowerCase();
                const rawStatusLower = normalizeStatusValue(row.summary.status || representativeTicket.rawStatus || representativeTicket.status).toLowerCase();
                const currentStatusForTransitions = getTicketTransitionStatus(displayGroupTicket);
                const transitions = getStatusTransitions(currentStatusForTransitions);
                const isGroupPaymentReadOnly = !canOverrideSettlementStatus && (paymentUiKey === 'settled' || paymentUiKey === 'settlementinprogress');

                if (
                  isGroupPaymentReadOnly ||
                  rawStatusLower === 'closed' ||
                  rawStatusLower === 'unsold' ||
                  rawStatusLower === 'invalid' ||
                  rawStatusLower === 'return' ||
                  !transitions.length
                ) {
                  return (
                    <span className={`${styles.statusBadge} ${styles[getStatusColorClass(pres.iconStatus)] || ''}`}>
                      {getStatusIcon(pres.iconStatus)} {pres.label}
                    </span>
                  );
                }

                const isStatusMenuOpen = openStatusDropdown === representativeTicket.tpId;
                return (
                  <div
                    className={[styles.statusDropdownWrapper, isStatusMenuOpen ? styles.statusDropdownOpen : ''].filter(Boolean).join(' ')}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className={`${styles.statusBadge} ${styles[getStatusColorClass(pres.iconStatus)] || ''} ${styles.statusDropdownBtn}`}
                      disabled={isTicketTableBusy}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isTicketTableBusy) return;
                        setOpenStatusDropdown(isStatusMenuOpen ? null : representativeTicket.tpId);
                      }}
                    >
                      {getStatusIcon(pres.iconStatus)} {pres.label}
                      <ChevronDown size={12} style={{ marginLeft: 4 }} />
                    </button>
                    {isStatusMenuOpen && (
                      <div className={styles.statusDropdownList}>
                        {transitions.map((opt) => (
                          <div
                            key={opt.value}
                            className={styles.statusDropdownListItem}
                            onClick={async (e) => {
                              e.stopPropagation();
                              setOpenStatusDropdown(null);
                              const selectedIds = Array.from(bulkSelectedTicketIds);
                              const groupTpIds = row.tickets.map((t) => t.tpId);
                              const selectedInGroup = selectedIds.filter((id) => groupTpIds.includes(id));
                              // No seats selected → change status for the whole group (same as Manage Tickets).
                              const ticketsForUpdate =
                                selectedInGroup.length > 0
                                  ? row.tickets.filter((t) => selectedInGroup.includes(t.tpId))
                                  : row.tickets;
                              if (ticketsForUpdate.length > 1) {
                                await applyMultiTicketStatusChangeFromUi(ticketsForUpdate, opt.value);
                                return;
                              }
                              await handleStatusChange(ticketsForUpdate[0] || representativeTicket, opt.value);
                            }}
                          >
                            {getStatusIcon(opt.value)} {opt.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })()}
            </td>
            {showMarketplaceColumn && renderListedMarketplaceCell(row.tickets)}
            {showSharedColumn && renderListedSharedCell(row.tickets)}
            {showListPriceColumn && renderListedPriceCell(row.tickets, displayPrice(row.tickets[0]?.price))}
            {showsLastPricedColumn && (() => {
              const firstTicket = row.tickets[0];
              const pricePending = row.tickets.some((ticket) => priceUpdatePendingIds.has(ticket.tpId));
              const badge = getLastPricedBadge(firstTicket as any);
              const lastPricedValue = getLastPricedDisplayValue(firstTicket as any);
              return (
                <td className={styles.tdLastPriced}>
                  <div className={styles.lastPricedCell}>
                    {pricePending ? (
                      <span className={styles.lastPricedSpinner} role="status" aria-label="Updating price" />
                    ) : (
                      <span className={styles.lastPricedDate} title={describeLastPricedBucket(firstTicket as any)}>
                        {lastPricedValue}
                      </span>
                    )}
                    {!pricePending && badge ? (
                      <span
                        className={`${styles.stalenessBadge} ${styles[badge.className]}`}
                        title={badge.title}
                        aria-label={badge.ariaLabel}
                      >
                        {badge.label}
                      </span>
                    ) : null}
                  </div>
                </td>
              );
            })()}
            {showSoldPriceColumns && (
              <>
                <td className={styles.tdPrice}>{displayPrice(row.tickets[0]?.soldPrice)}</td>
                <td className={styles.tdPrice}>
                  {(() => {
                    const commission = getTicketSalesRepCommission(row.tickets[0]);
                    return (
                      <span className={styles.commissionValueWithEdit}>
                        {commission > 0 ? formatCurrency(commission) : '—'}
                        {canEditSoldCommission && (
                        <button
                          type="button"
                          className={styles.commissionEditButton}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSelectedTicketForCommission(row.tickets[0]);
                            setCommissionOverrideInput(
                              row.tickets[0].tp_sales_rep_commission_override == null
                                ? getTicketSalesRepCommission(row.tickets[0]).toFixed(2)
                                : Number(row.tickets[0].tp_sales_rep_commission_override).toFixed(2),
                            );
                            setShowCommissionModal(true);
                          }}
                          title="Edit commission for this line"
                          aria-label="Edit commission for this line"
                        >
                          <Pencil size={13} aria-hidden />
                        </button>
                        )}
                      </span>
                    );
                  })()}
                </td>
              </>
            )}
            <td className={styles.tdActions} onClick={(e) => e.stopPropagation()}>
              <div className={styles.actionMenuWrapper}>
                <button
                  type="button"
                  className={styles.actionMenuBtn}
                  onClick={(e) => {
                    const tpId = row.tickets[0]?.tpId;
                    if (!tpId) return;
                    toggleTicketActionMenu(tpId, e);
                  }}
                >
                  <MoreVertical size={16} />
                </button>
                {openActionTicketId === row.tickets[0]?.tpId && (
                  <div className={styles.actionMenuList}>
                    {renderTicketRowActionMenuItems(row.tickets)}
                  </div>
                )}
              </div>
            </td>
          </tr>
          {vlSupportPanelFor(row.groupKey, row.tickets, row.summary)}
          {isExpanded && (
            <tr className={styles.expandedRow}>
              <td colSpan={ticketTableColSpan}>
                <div className={styles.expandedContent}>
                  <div className={styles.expandedMeta}>
                    <span>
                      <span className={styles.expandedMetaLabel}>Venue:</span> {row.summary.venue}
                    </span>
                    <span className={styles.expandedMetaDivider}>|</span>
                    <span>
                      <span className={styles.expandedMetaLabel}>League:</span> {row.summary.league}
                    </span>
                    <span className={styles.expandedMetaDivider}>|</span>
                    <span>
                      <span className={styles.expandedMetaLabel}>Email:</span> {row.summary.email}
                    </span>
                    {showExpandedCommission && (
                      <>
                        <span className={styles.expandedMetaDivider}>|</span>
                        <span>
                          <span className={styles.expandedMetaLabel}>Commission:</span>{' '}
                          {getTicketSalesRepCommission(row.tickets[0]) > 0 ? formatCurrency(getTicketSalesRepCommission(row.tickets[0])) : '—'}
                        </span>
                        <span className={styles.expandedMetaDivider}>|</span>
                        <span>
                          <span className={styles.expandedMetaLabel}>Marketplace:</span>{' '}
                          {row.tickets[0]?.marketplace || '—'}
                        </span>
                      </>
                    )}
                  </div>
                  <div className={styles.expandedHeader}>
                    <div>
                      <h4>
                        Grouped Seats <span className={styles.seatCountLabel}>({row.tickets.length} tickets)</span>
                      </h4>
                      {(activeFilterTab === 'Listed' || activeFilterTab === 'Sold') && !getUserTicketsBarcodeStatus(row.tickets).allAttached && (
                        <p className={styles.barcodeMissingSummary}>
                          {getUserBarcodeMissingSummary(row.tickets)}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={styles.seatsGrid}>
                    {row.tickets.map((ticket) => {
                      const selected = bulkSelectedTicketIds.has(ticket.tpId);
                      return (
                        <div
                          key={ticket.tpId}
                          className={`${styles.seatCard} ${selected ? styles.selectedSeat : ''}`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleBulkSelectTicket(ticket.tpId, !selected);
                          }}
                        >
                          <div className={styles.seatCardHeader}>
                            <div className={styles.seatSelection}>
                              {selected ? (
                                <CheckSquare size={14} className={styles.checkedIcon} />
                              ) : (
                                <Square size={14} className={styles.uncheckedIcon} />
                              )}
                              <span className={styles.seatNumber}>{ticket.seatNo === '-' ? 'Seat N/A' : `Seat ${ticket.seatNo}`}</span>
                            </div>
                            <div className={styles.seatCardHeaderActions}>{renderSeatCardStatus(ticket, ticket.tpId)}</div>
                          </div>
                          <div className={styles.seatDetails}>
                            <span>Sec {ticket.section === '-' ? 'N/A' : ticket.section} • Row {ticket.row === '-' ? 'N/A' : ticket.row}</span>
                            <span className={styles.seatPrice}>{displayPrice(ticket.price)}</span>
                          </div>
                          {(activeFilterTab === 'Listed' || activeFilterTab === 'Sold') && renderUserSeatBarcodeStatus(ticket)}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </td>
            </tr>
          )}
        </React.Fragment>
      );
    }

    const ticket = row.ticket;
    const pres = getTicketStatusPresentation(ticket);
    const paymentUiKey = pres.iconStatus.toLowerCase();
    const rawStatusLower = (ticket.rawStatus || ticket.status).toLowerCase();
    const statusClassForColor = getStatusColorClass(pres.iconStatus);
    const currentStatusForTransitions = getTicketTransitionStatus(ticket);
    const transitions = getStatusTransitions(currentStatusForTransitions);
    const isPaymentReadOnly = !canOverrideSettlementStatus && (paymentUiKey === 'settled' || paymentUiKey === 'settlementinprogress');

    const isStatusMenuOpen = openStatusDropdown === ticket.tpId;
    const isActionMenuOpen = openActionTicketId === ticket.tpId;
    return (
      <React.Fragment key={ticket.tpId}>
      <tr
        key={ticket.tpId}
        className={isStatusMenuOpen || isActionMenuOpen ? styles.statusMenuOpen : undefined}
      >
        <td className={`${styles.checkboxCell} ${styles.stickyCheckbox}`} onClick={(e) => e.stopPropagation()}>
          <input
            type="checkbox"
            className={styles.ticketCheckbox}
            checked={bulkSelectedTicketIds.has(ticket.tpId)}
            onChange={(e) => handleBulkSelectTicket(ticket.tpId, e.target.checked)}
          />
        </td>
        {renderUserDetailsEventCell({
          ticket,
          eventName: ticket.event,
          dateLabel: ticket.date,
          timeLabel: ticket.eventTime,
          showBarcodeStatusIcon: activeFilterTab === 'Listed' || activeFilterTab === 'Sold',
          groupTickets: [ticket],
          onBarcodeStatusSelect: (tickets, status) => {
            void handleUserBarcodeStatusUpdate(tickets, status);
          },
          extraContent: vlSupportControlFor(ticket.tpId, [ticket]),
        })}
        <td className={styles.tdSection}>{ticket.section === '-' ? 'N/A' : ticket.section}</td>
        <td className={styles.tdRow}>{ticket.row === '-' ? 'N/A' : ticket.row}</td>
        <td className={styles.tdSeat}>
          <SeatModeBadge mode={ticket.seatMode} />
          <div>{ticket.seatNo === '-' ? 'N/A' : ticket.seatNo}</div>
        </td>
        <td className={styles.tdStatus}>
          <WrongPidRetryButton
            wrongPid={ticket.tpWrongPid === true}
            status={normalizeStatusValue(ticket.rawStatus || ticket.status)}
            disabled={isTicketTableBusy}
            className={styles.wrongPidRetryBtn}
            onResubmit={() => void openWrongPidResubmit([ticket])}
            onRelist={() => void openWrongPidRelist([ticket])}
          />
          {(() => {
            if (
              isPaymentReadOnly ||
              rawStatusLower === 'closed' ||
              rawStatusLower === 'unsold' ||
              rawStatusLower === 'invalid' ||
              rawStatusLower === 'return'
            ) {
              return (
                <span className={`${styles.status} ${styles[statusClassForColor] || ''}`}>
                  {getStatusIcon(pres.iconStatus)} {pres.label}
                </span>
              );
            }
            if (!transitions.length) {
              return (
                <span className={`${styles.status} ${styles[statusClassForColor] || ''}`}>
                  {getStatusIcon(pres.iconStatus)} {pres.label}
                </span>
              );
            }
            return (
              <div className={[styles.statusDropdownWrapper, isStatusMenuOpen ? styles.statusDropdownOpen : ''].filter(Boolean).join(' ')}>
                <button
                  className={`${styles.status} ${styles[statusClassForColor] || ''} ${styles.statusDropdownBtn}`}
                  disabled={isTicketTableBusy}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isTicketTableBusy) return;
                    setOpenStatusDropdown(isStatusMenuOpen ? null : ticket.tpId);
                  }}
                >
                  {getStatusIcon(pres.iconStatus)} {pres.label}{' '}
                  <ChevronDown size={12} style={{ marginLeft: 4 }} />
                </button>
                {isStatusMenuOpen && (
                  <div className={styles.statusDropdownList}>
                    {transitions.map((opt) => (
                      <div
                        key={opt.value}
                        className={styles.statusDropdownListItem}
                        onClick={async (e) => {
                          e.stopPropagation();
                          setOpenStatusDropdown(null);
                          const selectedIds = Array.from(bulkSelectedTicketIds);
                          const ticketsForUpdate =
                            selectedIds.length > 1 && selectedIds.includes(ticket.tpId)
                              ? getFilteredTickets().filter((t) => selectedIds.includes(t.tpId))
                              : [ticket];
                          if (ticketsForUpdate.length > 1) {
                            await applyMultiTicketStatusChangeFromUi(ticketsForUpdate, opt.value);
                            return;
                          }
                          await handleStatusChange(ticket, opt.value);
                        }}
                      >
                        {getStatusIcon(opt.value)} {opt.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })()}
        </td>
        {showMarketplaceColumn && renderListedMarketplaceCell([ticket])}
        {showSharedColumn && renderListedSharedCell([ticket])}
        {showListPriceColumn && renderListedPriceCell([ticket], displayPrice(ticket.price))}
        {activeFilterTab === 'Listed' && (() => {
          const pricePending = priceUpdatePendingIds.has(ticket.tpId);
          const badge = getLastPricedBadge(ticket as any);
          const lastPricedValue = getLastPricedDisplayValue(ticket as any);
          return (
            <td className={styles.tdLastPriced}>
              <div className={styles.lastPricedCell}>
                {pricePending ? (
                  <span className={styles.lastPricedSpinner} role="status" aria-label="Updating price" />
                ) : (
                  <span className={styles.lastPricedDate} title={describeLastPricedBucket(ticket as any)}>
                    {lastPricedValue}
                  </span>
                )}
                {!pricePending && badge ? (
                  <span
                    className={`${styles.stalenessBadge} ${styles[badge.className]}`}
                    title={badge.title}
                    aria-label={badge.ariaLabel}
                  >
                    {badge.label}
                  </span>
                ) : null}
              </div>
            </td>
          );
        })()}
        {showSoldPriceColumns && (
          <>
            <td className={styles.tdPrice}>{displayPrice(ticket.soldPrice)}</td>
            <td className={styles.tdPrice}>
              {(() => {
                const commission = getTicketSalesRepCommission(ticket);
                return (
                  <span className={styles.commissionValueWithEdit}>
                    {commission > 0 ? formatCurrency(commission) : '—'}
                    {canEditSoldCommission && (
                    <button
                      type="button"
                      className={styles.commissionEditButton}
                      onClick={(event) => {
                        event.stopPropagation();
                        setSelectedTicketForCommission(ticket);
                        setCommissionOverrideInput(
                          ticket.tp_sales_rep_commission_override == null
                            ? getTicketSalesRepCommission(ticket).toFixed(2)
                            : Number(ticket.tp_sales_rep_commission_override).toFixed(2),
                        );
                        setShowCommissionModal(true);
                      }}
                      title="Edit commission for this line"
                      aria-label="Edit commission for this line"
                    >
                      <Pencil size={13} aria-hidden />
                    </button>
                    )}
                  </span>
                );
              })()}
            </td>
          </>
        )}
        <td className={styles.tdActions}>
          <div className={styles.actionMenuWrapper}>
            <button
              type="button"
              className={styles.actionMenuBtn}
              onClick={(e) => toggleTicketActionMenu(ticket.tpId, e)}
            >
              <MoreVertical size={16} />
            </button>
            {openActionTicketId === ticket.tpId && (
              <div className={styles.actionMenuList}>
                {renderTicketRowActionMenuItems([ticket])}
              </div>
            )}
          </div>
        </td>
      </tr>
      {vlSupportPanelFor(ticket.tpId, [ticket], { event: ticket.event, date: ticket.date, eventTime: ticket.eventTime, section: ticket.section, row: ticket.row, seatLabel: ticket.seatNo })}
      </React.Fragment>
    );
  };
  const showSoldPriceColumns = activeFilterTab === 'Sold';
  const showExpandedCommission = activeFilterTab === 'Sold';
  const showListPriceColumn = activeFilterTab === 'Listed';
  const showMarketplaceColumn = activeFilterTab === 'Listed' || activeFilterTab === 'Sold';
  const showSharedColumn = activeFilterTab === 'Listed';
  const showsLastPricedColumn = activeFilterTab === 'Listed';
  const ticketTableColSpan =
    7 +
    (showListPriceColumn ? 1 : 0) +
    (showSoldPriceColumns ? 2 : 0) +
    (showMarketplaceColumn ? 1 : 0) +
    (showSharedColumn ? 1 : 0) +
    (showsLastPricedColumn ? 1 : 0);
  const salesRepCommissionRate = Number(effectiveUserRecord?.sales_reps?.sr_commission_rate ?? 0);
  const getTicketSalesRepCommission = (ticket: Ticket): number => {
    const manualOverride = Number(ticket.tp_sales_rep_commission_override);
    if (
      ticket.tp_sales_rep_commission_override != null &&
      Number.isFinite(manualOverride) &&
      manualOverride >= 0
    ) {
      return Math.round(manualOverride * 100) / 100;
    }
    const quickCut = qaProfitByTicketPlacementId.get(ticket.tpId) ?? ticket.qaProfit ?? 0;
    return getSalesRepCommissionAmount(quickCut, salesRepCommissionRate);
  };
  const selectedTickets = filteredTickets.filter((t) => bulkSelectedTicketIds.has(t.tpId));
  const areSelectedTicketsAllListed = selectedTickets.length > 0 && selectedTickets.every((t) => normalizeStatusValue(t.rawStatus || t.status) === 'List');
  const marketplaceBlockingFirstPaint =
    localTickets.length === 0 &&
    Boolean(userId) &&
    userTicketMarketplacesLoading &&
    !userTicketMarketplacesData &&
    !isGetUserTicketsAllowlistError;
  const isTicketsLoading = ticketsLoading
    || marketplaceBlockingFirstPaint
    || (isGetUserTicketsAllowlistError && fallbackTicketsLoading);
  const tierThresholds = [{ label: 'VIP', threshold: '$20k+', minAmount: 20000 }, { label: 'Silver', threshold: '$10k+', minAmount: 10000 }, { label: 'Bronze', threshold: '$5k+', minAmount: 5000 }];
  const rawSalesAmount = effectiveUserRecord?.tickets_sold_amount || 0;
  const activeTier = tierThresholds.find(t => rawSalesAmount >= t.minAmount)?.label || null;
  const analytics = analyticsData?.user_analytics?.[0] || {};
  const visibleUserTickets = currentTickets.filter(
    (t) => activeFilterTab === 'All' || !isUserDetailFailToTransferTicket(t),
  );  const getTicketQuantity = (ticket: Ticket & { total_count?: number; grouped_ticket_data?: Array<{ tp_id?: string }> }) => {
    const totalCount = Number(ticket.total_count ?? 0);
    if (totalCount > 0) return totalCount;

    const groupedCount = Array.isArray(ticket.grouped_ticket_data) ? ticket.grouped_ticket_data.length : 0;
    return groupedCount > 0 ? groupedCount : 1;
  };
  const pageActiveCount = visibleUserTickets.reduce((acc, t) => {
    return ['list', 'listed'].includes(normalizeStatusToken(t.rawStatus)) ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageSoldCount = visibleUserTickets.reduce((acc, t) => {
    return isCompletedSaleTicket(t) ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageDelistedCount = visibleUserTickets.reduce((acc, t) => {
    return ['delist', 'delisted', 'delistinprogress', 'delistrequested', 'return'].includes(
      normalizeStatusToken(t.rawStatus || t.status),
    ) ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageUnsoldCount = visibleUserTickets.reduce((acc, t) => {
    return normalizeStatusToken(t.rawStatus) === 'unsold' ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageVerifiedCount = visibleUserTickets.reduce((acc, t) => {
    return normalizeStatusToken(t.rawStatus) === 'verified' ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageToBeVerifiedCount = visibleUserTickets.reduce((acc, t) => {
    return normalizeStatusToken(t.rawStatus) === 'tobeverified' ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageInvalidCount = visibleUserTickets.reduce((acc, t) => {
    return normalizeStatusToken(t.rawStatus) === 'invalid' ? acc + getTicketQuantity(t) : acc;
  }, 0);
  const pageTotalTickets = visibleUserTickets.reduce((acc, t) => acc + getTicketQuantity(t), 0);
  const pageSoldRevenue = visibleUserTickets.reduce((sum, t) => isCompletedSaleTicket(t) ? sum + parseCurrency(t.soldPrice) : sum, 0);
  const pageListedRevenue = visibleUserTickets.reduce((sum, t) => ['list', 'listed'].includes(normalizeStatusToken(t.rawStatus)) ? sum + parseCurrency(t.price) : sum, 0);
  const activeCount = serverTicketCount('tab_listed') ?? pageActiveCount;
  const soldCount = serverTicketCount('tab_sold') ?? pageSoldCount;
  const delistedCount = serverTicketCount('tab_delisted') ?? pageDelistedCount;
  const unsoldCount = serverTicketCount('tab_unsold') ?? pageUnsoldCount;
  const verifiedCount = serverTicketCount('tab_verified') ?? pageVerifiedCount;
  const toBeVerifiedCount = serverTicketCount('tab_to_be_verified') ?? pageToBeVerifiedCount;
  const invalidCount = serverTicketCount('tab_invalid') ?? pageInvalidCount;
  const totalTickets = serverTicketCount('tab_all') ?? pageTotalTickets;
  const soldSum = ticketsData?.tab_sold?.aggregate?.sum?.tp_sold_amount;
  const listedSum = ticketsData?.tab_listed?.aggregate?.sum?.tp_list_price;
  const soldRevenue = soldSum == null ? pageSoldRevenue : Number(soldSum);
  const listedRevenue = listedSum == null ? pageListedRevenue : Number(listedSum);
 const userFeePercent = Number(currentUser?.userFee ?? 0);
let potentialRevenue = 0;
if (Number.isFinite(userFeePercent) && userFeePercent > 0) {
  const quickAsystFee = listedRevenue * (userFeePercent / 100);
  potentialRevenue = Math.round((listedRevenue - quickAsystFee) * 100) / 100;
} else {
  potentialRevenue = listedRevenue; // If no fee, payout is full listed revenue
}
  const paidOut = analytics.ua_paid_out ?? 0;
  const avgTicketPrice = soldCount > 0 ? soldRevenue / soldCount : 0;
    // Sell Through Rate should exclude delisted tickets and listed-only tickets
    // Required: Sell Through Rate = Sold / (Sold + Unsold)
    const sellThroughDenominator = soldCount + unsoldCount;
    const sellThroughRate = sellThroughDenominator > 0 ? (soldCount / sellThroughDenominator) * 100 : 0;
  // Calculate delist rate consistently with Org Analytics:
  // Delist rate = tickets returned (delisted/returned) ÷ tickets in any other status
  const otherTicketCount = Math.max(0, totalTickets - delistedCount);
  const delistRate = otherTicketCount > 0 ? Number(((delistedCount / otherTicketCount) * 100).toFixed(1)) : 0;
  
  const hearAboutUsBreakdown: Array<{ source: string; count: number; percentage: number }> = [];
  if (hearAboutUsData?.user && Array.isArray(hearAboutUsData.user)) {
    const sourceCount = new Map<string, number>();
    hearAboutUsData.user.forEach((user: any) => {
      const source = user.u_hear_about_us || 'Not Specified';
      sourceCount.set(source, (sourceCount.get(source) || 0) + 1);
    });
    const total = hearAboutUsData.user.length;
    hearAboutUsBreakdown.push(...Array.from(sourceCount.entries()).map(([source, count]) => ({
      source,
      count,
      percentage: total > 0 ? (count / total) * 100 : 0,
    })).sort((a, b) => b.count - a.count));
  }
  
  const preferredLeagueCategoriesList: LeagueCategoryPreference[] = Array.isArray(preferredLeagueCategoriesData?.league_categories) ? preferredLeagueCategoriesData.league_categories : [];
  const preferredTeamsById = new Map(preferredLeagueCategoriesList.map(team => [team.lc_id, team]));
  const selectedTeamsFromPreferences = preferredCategoryIds.map(lcId => preferredTeamsById.get(lcId)).filter(Boolean).map(team => ({
    id: team!.lc_id,
    abbreviation: (team!.lc_abbrev || '').trim() || (team!.lc_name || '').trim().slice(0, 3).toUpperCase(),
    name: (team!.lc_name || '').trim() || 'Unknown Team',
    color: (team!.lc_colour_code || '').trim() || '#475569',
    hasSoldTicket: teamsWithSoldStatus[team!.lc_id] || false,
    leagueId: (team!.l_id || '').trim(),
    leagueName: team!.l_id ? (leagueNameById.get(team!.l_id) || team!.lc_name || 'Unknown League') : team!.lc_name,
  }));
  const fallbackTeamPalette = ['#4c1d95', '#ea580c', '#0e7490', '#1d4ed8', '#be123c', '#166534', '#1f2937'];
  const getStableTeamUuid = (input: string) => {
    let hash = 0;
    for (let i = 0; i < input.length; i++) hash = ((hash << 5) - hash + input.charCodeAt(i)) | 0;
    const absHex = Math.abs(hash).toString(16).padStart(8, '0');
    const repeated = `${absHex}${absHex}${absHex}${absHex}`.slice(0, 32);
    const withVersion = `${repeated.slice(0, 12)}4${repeated.slice(13)}`;
    const withVariant = `${withVersion.slice(0, 16)}8${withVersion.slice(17)}`;
    return `${withVariant.slice(0, 8)}-${withVariant.slice(8, 12)}-${withVariant.slice(12, 16)}-${withVariant.slice(16, 20)}-${withVariant.slice(20, 32)}`;
  };
  const fallbackAssignedTeams = Array.isArray(effectiveUserRecord?.u_teams) ? effectiveUserRecord.u_teams.filter(Boolean) : [];
  const fallbackTeamsFromTickets = Array.from(new Set(currentTickets.flatMap(ticket => {
    const eventName = (ticket.event || '').split('•')[0]?.trim() || '';
    if (!eventName) return [];
    return eventName.split(/\s+vs\.?\s+/i).map(part => part.trim()).filter(Boolean);
  })));
  const selectedTeams: SelectedTeam[] = selectedTeamsFromPreferences.length > 0
    ? selectedTeamsFromPreferences
    : (fallbackAssignedTeams.length > 0 ? fallbackAssignedTeams : fallbackTeamsFromTickets).map((teamName: string, idx: number) => ({
        id: getStableTeamUuid(`${userId || 'unknown'}:${teamName}`),
        abbreviation: teamName.split(' ').filter(Boolean).map(p => p[0]).join('').toUpperCase().slice(0, 3) || 'TM',
        name: teamName, color: fallbackTeamPalette[idx % fallbackTeamPalette.length]
      }));

  useEffect(() => {
    if (!seatLevelTeam || !selectedTeams.some((team) => team.id === seatLevelTeam.id)) {
      setSeatLevelTeam(selectedTeams[0] || null);
    }
  }, [selectedTeams, seatLevelTeam]);

  const marketplaceMap = React.useMemo(() => {
    const map = new Map<string, { name: string; feePercent: number }>();
    marketplacesList.forEach(mp => {
      map.set(mp.id, { name: mp.name, feePercent: mp.vl_fee_percentage || 0 });
    });
    return map;
  }, [marketplacesList]);


const aggregateMarketplaceDataFinal = (): Array<{ marketplace: string; ticketsSold: number; revenue: number; qaProfit: number; percentage: number }> => {
  const mpMap = new Map<string, { count: number; revenue: number; qaProfit: number }>();
  const soldTickets = currentTickets.filter(isCompletedSaleTicket);
  soldTickets.forEach(ticket => {
    const soldAmount = parseCurrency(ticket.soldPrice);
    const listPrice = parseCurrency(ticket.price);
    const marketplace = ticket.marketplace && ticket.marketplace.trim() && ticket.marketplace !== 'Other'
      ? ticket.marketplace.trim()
      : 'Unknown';
    const ticketQaProfit = qaProfitByTicketPlacementId.get(ticket.tpId) ?? ticket.qaProfit ?? 0;

    const existing = mpMap.get(marketplace) || { count: 0, revenue: 0, qaProfit: 0 };
    existing.count += 1;
    existing.revenue += Math.max(0, soldAmount);
    existing.qaProfit += Math.max(0, ticketQaProfit);
    mpMap.set(marketplace, existing);
  });

  const totalRevenue = Array.from(mpMap.values()).reduce((sum, item) => sum + item.revenue, 0);
  
  return Array.from(mpMap.entries())
    .map(([marketplace, data]) => ({
      marketplace,
      ticketsSold: data.count,
      revenue: data.revenue,
      qaProfit: data.qaProfit,
      percentage: totalRevenue > 0 ? (data.revenue / totalRevenue) * 100 : 0,
    }))
    .sort((a, b) => b.revenue - a.revenue);
};
  const marketplaceDataFinal = useMemo(() => aggregateMarketplaceDataFinal(), [currentTickets, qaProfitByTicketPlacementId]);

const aggregateLeagueBreakdownFinal = (): Array<{ league: string; ticketsSold: number; revenue: number; percentage: number }> => {
  const leagueMap = new Map<string, { count: number; revenue: number }>();
  const soldTickets = currentTickets.filter(isCompletedSaleTicket);
  if (soldTickets.length === 0) return [];

  const teamToLeague = new Map<string, string>();
  selectedTeams.forEach(team => {
    if (team.name && team.leagueName) {
      teamToLeague.set(team.name.toLowerCase(), team.leagueName);
    }
    if (team.abbreviation && team.leagueName) {
      teamToLeague.set(team.abbreviation.toLowerCase(), team.leagueName);
    }
  });

  soldTickets.forEach(ticket => {
    const soldAmount = parseCurrency(ticket.soldPrice);
    if (soldAmount <= 0) return;

    let league: string | null = null;
    const eventLower = (ticket.event || '').toLowerCase();

    for (const [teamName, leagueName] of teamToLeague.entries()) {
      if (eventLower.includes(teamName)) {
        league = leagueName;
        break;
      }
    }

    if (!league) {
      const parts = eventLower.split(/\s+vs\.?\s+|•|\|/);
      for (const part of parts) {
        const trimmed = part.trim();
        if (teamToLeague.has(trimmed)) {
          league = teamToLeague.get(trimmed)!;
          break;
        }
      }
    }

    if (!league) {
      if (/nba|basketball/.test(eventLower)) league = 'NBA';
      else if (/nfl|football/.test(eventLower)) league = 'NFL';
      else if (/mlb|baseball/.test(eventLower)) league = 'MLB';
      else if (/nhl|hockey/.test(eventLower)) league = 'NHL';
      else if (/mls|soccer/.test(eventLower)) league = 'MLS';
      else if (/wnba|women'?s basketball/.test(eventLower)) league = 'WNBA';
      else if (/nwsl|women'?s soccer/.test(eventLower)) league = 'NWSL';
      else if (/college|ncaa/.test(eventLower)) {
        if (/basketball/.test(eventLower)) league = 'NCAA Basketball';
        else if (/football/.test(eventLower)) league = 'NCAA Football';
        else league = 'NCAA';
      }
      else if (/concert|live|music|tour/.test(eventLower)) league = 'Concerts';
      else if (/theater|broadway|musical|play/.test(eventLower)) league = 'Theater';
      else league = 'Other';
    }

    const existing = leagueMap.get(league) || { count: 0, revenue: 0 };
    existing.count += 1;
    existing.revenue += soldAmount;
    leagueMap.set(league, existing);
  });

  const totalRevenue = Array.from(leagueMap.values()).reduce((sum, item) => sum + item.revenue, 0);
  return Array.from(leagueMap.entries())
    .map(([league, data]) => ({
      league,
      ticketsSold: data.count,
      revenue: data.revenue,
      percentage: totalRevenue > 0 ? (data.revenue / totalRevenue) * 100 : 0,
    }))
    .sort((a, b) => b.revenue - a.revenue);
};
  const leagueBreakdownFinal = useMemo(() => aggregateLeagueBreakdownFinal(), [currentTickets, selectedTeams]);

  // ========== TIMING ANALYTICS CALCULATION (FRONTEND) ==========
  const calculateTimingAnalyticsFromTickets = useMemo(() => {
    const soldTickets = currentTickets.filter(isCompletedSaleTicket);
    const totalSold = soldTickets.length;
    if (totalSold === 0) {
      return {
        summary: { avgDaysBeforeSold: 0, medianDays: 0, avgDaysBeforeListed: 0, avgPriceChange: 0, basedOn: 'Based on 0 sales' },
        priceMovement: [],
        leagues: []
      };
    }
    const daysBeforeSoldList: number[] = [];
    const daysBeforeListedList: number[] = [];
    const priceChangeList: number[] = [];
    const timingBuckets: Record<string, {
      total: number;
      priceChangeSum: number;
      priceChangePercentSum: number;
      count: number;
    }> = {
      '3 Days Before Event': { total: 0, priceChangeSum: 0, priceChangePercentSum: 0, count: 0 },
      '7 Days Before Event': { total: 0, priceChangeSum: 0, priceChangePercentSum: 0, count: 0 },
      '1-2 Weeks Before Event': { total: 0, priceChangeSum: 0, priceChangePercentSum: 0, count: 0 },
      '2-4 Weeks Before Event': { total: 0, priceChangeSum: 0, priceChangePercentSum: 0, count: 0 },
      '>4 Weeks': { total: 0, priceChangeSum: 0, priceChangePercentSum: 0, count: 0 },
    };
    const leagueDataMap = new Map<string, { daysTotal: number; count: number; priceChangeTotal: number }>();

    const teamToLeague = new Map<string, string>();
    selectedTeams.forEach(team => {
      if (team.name && team.leagueName) {
        teamToLeague.set(team.name.toLowerCase(), team.leagueName);
      }
      if (team.abbreviation && team.leagueName) {
        teamToLeague.set(team.abbreviation.toLowerCase(), team.leagueName);
      }
    });

    soldTickets.forEach(ticket => {
      let eventDate = parseDateAnalytics(ticket.eventDateRaw);
      if (!eventDate && ticket.date) eventDate = parseDateAnalytics(ticket.date);
      const actionDate = parseDateAnalytics(ticket.updatedAt);
      if (!eventDate || !actionDate) return;
      const daysBefore = getDaysBetweenDates(actionDate, eventDate);
      if (daysBefore >= 0 && daysBefore <= 365) {
        daysBeforeSoldList.push(daysBefore);
        daysBeforeListedList.push(daysBefore);
      }
      const listPrice = parseCurrency(ticket.price);
      const soldPrice = parseCurrency(ticket.soldPrice);
      if (listPrice > 0 && soldPrice > 0 && daysBefore >= 0) {
        const priceChange = soldPrice - listPrice;
        const priceChangePercent = (priceChange / listPrice) * 100;
        priceChangeList.push(priceChange);
        let bucket = '';
        if (daysBefore <= 3) bucket = '3 Days Before Event';
        else if (daysBefore <= 7) bucket = '7 Days Before Event';
        else if (daysBefore <= 14) bucket = '1-2 Weeks Before Event';
        else if (daysBefore <= 28) bucket = '2-4 Weeks Before Event';
        else bucket = '>4 Weeks';
        if (timingBuckets[bucket]) {
          timingBuckets[bucket].total += 1;
          timingBuckets[bucket].priceChangeSum += priceChange;
          timingBuckets[bucket].priceChangePercentSum += priceChangePercent;
          timingBuckets[bucket].count += 1;
        }
        let leagueName: string = 'Other';
        const eventLower = (ticket.event || '').toLowerCase();
        for (const [teamName, lName] of teamToLeague.entries()) {
          if (eventLower.includes(teamName)) {
            leagueName = lName;
            break;
          }
        }
        if (leagueName === 'Other') {
          const parts = eventLower.split(/\s+vs\.?\s+|•|\|/);
          for (const part of parts) {
            const trimmed = part.trim();
            if (teamToLeague.has(trimmed)) {
              leagueName = teamToLeague.get(trimmed)!;
              break;
            }
          }
        }
        if (leagueName === 'Other') {
          if (/nba|basketball/.test(eventLower)) leagueName = 'NBA';
          else if (/nfl|football/.test(eventLower)) leagueName = 'NFL';
          else if (/mlb|baseball/.test(eventLower)) leagueName = 'MLB';
          else if (/nhl|hockey/.test(eventLower)) leagueName = 'NHL';
          else if (/mls|soccer/.test(eventLower)) leagueName = 'MLS';
          else if (/concert|live|music/.test(eventLower)) leagueName = 'Concerts';
          else if (/theater|broadway/.test(eventLower)) leagueName = 'Theater';
          else if (/ncaa|college/.test(eventLower)) leagueName = 'NCAA';
        }
        const existing = leagueDataMap.get(leagueName) || { daysTotal: 0, count: 0, priceChangeTotal: 0 };
        existing.daysTotal += daysBefore;
        existing.count += 1;
        existing.priceChangeTotal += priceChange;
        leagueDataMap.set(leagueName, existing);
      }
    });
    const avgDaysBeforeSold = daysBeforeSoldList.length ? daysBeforeSoldList.reduce((a,b)=>a+b,0)/daysBeforeSoldList.length : 0;
    const sortedDays = [...daysBeforeSoldList].sort((a,b)=>a-b);
    const medianDays = sortedDays.length ? sortedDays[Math.floor(sortedDays.length/2)] : 0;
    const avgDaysBeforeListed = daysBeforeListedList.length ? daysBeforeListedList.reduce((a,b)=>a+b,0)/daysBeforeListedList.length : 0;
    const avgPriceChange = priceChangeList.length ? priceChangeList.reduce((a,b)=>a+b,0)/priceChangeList.length : 0;
    const priceMovement = Object.entries(timingBuckets)
      .filter(([_, d]) => d.count > 0)
      .map(([timing, data]) => ({
        timing,
        total: data.total,
        avgPriceChange: data.priceChangeSum / data.count,
        avgPriceChangePercent: data.priceChangePercentSum / data.count,
      }))
      .sort((a,b) => {
        const order = ['3 Days Before Event','7 Days Before Event','1-2 Weeks Before Event','2-4 Weeks Before Event','>4 Weeks'];
        return order.indexOf(a.timing) - order.indexOf(b.timing);
      });
    const leagues = Array.from(leagueDataMap.entries())
      .map(([name, data]) => ({
        name,
        avgDays: data.daysTotal / data.count,
        sold: data.count,
        avgPriceChange: data.priceChangeTotal / data.count
      }))
      .sort((a,b) => b.sold - a.sold);
    return {
      summary: {
        avgDaysBeforeSold: Math.round(avgDaysBeforeSold * 10) / 10,
        medianDays: Math.round(medianDays * 10) / 10,
        avgDaysBeforeListed: Math.round(avgDaysBeforeListed * 10) / 10,
        avgPriceChange: Math.round(avgPriceChange * 100) / 100,
        basedOn: `Based on ${totalSold} sale${totalSold !== 1 ? 's' : ''}`
      },
      priceMovement,
      leagues
    };
  }, [currentTickets, selectedTeams]);

  const isValidTimingSummary = (summary: any): boolean => {
    if (!summary || typeof summary !== 'object') return false;
    const numericValues = [
      summary.avgDaysBeforeSold,
      summary.medianDays,
      summary.avgDaysBeforeListed,
      summary.avgPriceChange,
    ];
    const hasNumeric = numericValues.some((value) => Number.isFinite(value));
    const hasBasedOn = typeof summary.basedOn === 'string' && summary.basedOn.trim().length > 0;
    return hasNumeric || hasBasedOn;
  };

  const timingSummaryFinal = useMemo(() => {
    const backend = analytics?.ua_timing_data?.summary;
    if (isValidTimingSummary(backend)) return backend;
    return calculateTimingAnalyticsFromTickets.summary;
  }, [analytics, calculateTimingAnalyticsFromTickets]);

  const timingRowsFinal = useMemo(() => {
    const backendRows = analytics?.ua_timing_data?.priceMovement;
    if (backendRows && Array.isArray(backendRows) && backendRows.length) return backendRows;
    return calculateTimingAnalyticsFromTickets.priceMovement;
  }, [analytics, calculateTimingAnalyticsFromTickets]);

  const timingByLeagueFinal = useMemo(() => {
    const backendLeagues = analytics?.ua_timing_data?.leagues;
    if (backendLeagues && Array.isArray(backendLeagues) && backendLeagues.length) return backendLeagues;
    return calculateTimingAnalyticsFromTickets.leagues;
  }, [analytics, calculateTimingAnalyticsFromTickets]);

  const priceMovementCounters = useMemo(() => {
    const soldTickets = currentTickets.filter(isCompletedSaleTicket);
    let increased = 0, decreased = 0, unchanged = 0;
    
    soldTickets.forEach(ticket => {
      const listPrice = parseCurrency(ticket.price);
      const soldPrice = parseCurrency(ticket.soldPrice);
      if (listPrice > 0 && soldPrice > 0) {
        const priceChange = soldPrice - listPrice;
        if (priceChange > 0) increased++;
        else if (priceChange < 0) decreased++;
        else unchanged++;
      }
    });
    
    return { increased, decreased, unchanged };
  }, [currentTickets]);

  const teamEventToLeagueMap = React.useMemo(() => {
    const map = new Map<string, string>();
    const allTeams = Array.isArray(availableTeamsData?.league_categories) ? availableTeamsData.league_categories : [];
    
    allTeams.forEach((team: any) => {
      const teamName = (team.lc_name || '').toLowerCase().trim();
      const leagueId = team.l_id;
      const leagueName = leagueId ? (leagueNameById.get(leagueId) || team.lc_name || 'Unknown') : team.lc_name;
      
      if (teamName && leagueName) {
        map.set(teamName, leagueName);
        const abbrev = (team.lc_abbrev || '').toLowerCase().trim();
        if (abbrev) map.set(abbrev, leagueName);
      }
    });
    
    return map;
  }, [availableTeamsData, leagueNameById]);
const aggregateMarketplaceData = (): Array<{ marketplace: string; ticketsSold: number; revenue: number; percentage: number }> => {
  const mpDataMap = new Map<string, { count: number; revenue: number }>();
  const soldTickets = currentTickets.filter(isCompletedSaleTicket);
  
  if (soldTickets.length === 0) return [];
  
  let validMarketplaceCount = 0;
  let missingMarketplaceCount = 0;
  
  soldTickets.forEach(ticket => {
    const soldAmount = parseCurrency(ticket.soldPrice);
    // Only count if: has sold amount AND has real marketplace (not empty, not "Other")
    if (soldAmount > 0 && ticket.marketplace && ticket.marketplace.trim() !== '' && ticket.marketplace !== 'Other') {
      const marketplaceName = ticket.marketplace.trim();
      validMarketplaceCount++;
      
      const current = mpDataMap.get(marketplaceName) || { count: 0, revenue: 0 };
      mpDataMap.set(marketplaceName, {
        count: current.count + 1,
        revenue: current.revenue + soldAmount
      });
    } else if (soldAmount > 0) {
      missingMarketplaceCount++;
    }
  });
  
  console.log('📊 MARKETPLACE AGGREGATION REPORT (REAL DATA ONLY):', {
    totalSoldTickets: soldTickets.length,
    realMarketplacesWithData: validMarketplaceCount,
    ticketsWithoutMarketplaceData: missingMarketplaceCount,
    realMarketplacesFound: Array.from(mpDataMap.keys()),
    note: 'Only showing real marketplaces (not "Other" or empty values)'
  });
  
  // Calculate total revenue from ONLY real marketplace data
  const totalRevenue = Array.from(mpDataMap.values()).reduce((sum, item) => sum + item.revenue, 0);
  
  // Filter OUT "Other" and empty values - only return REAL marketplace data
  const realMarketplaceData = Array.from(mpDataMap.entries())
    .filter(([marketplace, _]) => marketplace && marketplace.trim() !== '' && marketplace !== 'Other')
    .map(([marketplace, data]) => ({
      marketplace,
      ticketsSold: data.count,
      revenue: data.revenue,
      percentage: totalRevenue > 0 ? (data.revenue / totalRevenue) * 100 : 0
    }))
    .sort((a, b) => b.revenue - a.revenue);
  
  return realMarketplaceData;
};

  const aggregateLeagueBreakdown = (): Array<{ league: string; ticketsSold: number; revenue: number; percentage: number }> => {
    const leagueDataMap = new Map<string, { count: number; revenue: number }>();
    const soldTickets = currentTickets.filter(isCompletedSaleTicket);
    
    if (soldTickets.length === 0) return [];
    
    let matchedByTeam = 0;
    let unmatchedTickets = 0;
    
    soldTickets.forEach(ticket => {
      const soldAmount = parseCurrency(ticket.soldPrice);
      if (soldAmount > 0 && ticket.event) {
        let leagueName = 'Other';
        
        const eventLower = ticket.event.toLowerCase().trim();
        
        if (teamEventToLeagueMap.has(eventLower)) {
          leagueName = teamEventToLeagueMap.get(eventLower) || 'Other';
          matchedByTeam++;
        } else {
          const eventParts = eventLower.split(/\s+vs\.?\s+|•/i);
          let foundMatch = false;
          for (const part of eventParts) {
            const trimmedPart = part.trim();
            if (teamEventToLeagueMap.has(trimmedPart)) {
              leagueName = teamEventToLeagueMap.get(trimmedPart) || 'Other';
              matchedByTeam++;
              foundMatch = true;
              break;
            }
          }
          
          if (!foundMatch) {
            if (eventLower.includes('nba')) leagueName = 'NBA';
            else if (eventLower.includes('nfl')) leagueName = 'NFL';
            else if (eventLower.includes('nhl')) leagueName = 'NHL';
            else if (eventLower.includes('mlb')) leagueName = 'MLB';
            else if (eventLower.includes('mls')) leagueName = 'MLS';
            else if (eventLower.includes('nwsl')) leagueName = 'NWSL';
            else if (eventLower.includes('wnba')) leagueName = 'WNBA';
            else if (eventLower.includes('college') || eventLower.includes('ncaa')) leagueName = 'College Sports';
            else {
              unmatchedTickets++;
            }
          }
        }
        
        const current = leagueDataMap.get(leagueName) || { count: 0, revenue: 0 };
        leagueDataMap.set(leagueName, {
          count: current.count + 1,
          revenue: current.revenue + soldAmount
        });
      }
    });
    
    console.log('🏆 LEAGUE AGGREGATION REPORT:', {
      totalSoldTickets: soldTickets.length,
      matchedByTeam: matchedByTeam,
      unmatchedTickets: unmatchedTickets,
      uniqueLeagues: leagueDataMap.size,
      leagueList: Array.from(leagueDataMap.keys())
    });
    
    const totalRevenue = Array.from(leagueDataMap.values()).reduce((sum, item) => sum + item.revenue, 0);
    
    return Array.from(leagueDataMap.entries())
      .map(([league, data]) => ({
        league,
        ticketsSold: data.count,
        revenue: data.revenue,
        percentage: totalRevenue > 0 ? (data.revenue / totalRevenue) * 100 : 0
      }))
      .sort((a, b) => b.revenue - a.revenue);
  };

  const marketplacePerformanceData = aggregateMarketplaceData();
  const leagueBreakdownData = aggregateLeagueBreakdown();
  
  (window as any).debugTicketData = () => {
    console.group('🔍 TICKET DATA DIAGNOSTIC REPORT - REAL MARKETPLACE DATA');
    console.log('📊 Current Tickets:', currentTickets.length);
    console.log('🏪 Known Marketplaces:', KNOWN_MARKETPLACES);
    
    const soldTickets = currentTickets.filter(isCompletedSaleTicket);
    console.log(`📦 Sold Tickets: ${soldTickets.length}`);
    
    if (soldTickets.length > 0) {
      console.group('Marketplace Data for Sold Tickets (REAL DATA ONLY):');
      const withMarketplace = soldTickets.filter(t => t.marketplace && t.marketplace.trim() !== '' && t.marketplace !== 'Other');
      const withoutMarketplace = soldTickets.filter(t => !t.marketplace || t.marketplace.trim() === '' || t.marketplace === 'Other');
      
      console.log(`  ✅ With Real Marketplace Data: ${withMarketplace.length}`);
      withMarketplace.forEach((t, idx) => {
        console.log(`    [${idx}] Marketplace: "${t.marketplace}" | Revenue: $${parseCurrency(t.soldPrice).toFixed(2)}`);
      });
      
      if (withoutMarketplace.length > 0) {
        console.log(`  ⚠️ Missing Marketplace Data: ${withoutMarketplace.length}`);
        withoutMarketplace.forEach((t, idx) => {
          console.log(`    [${idx}] TPId: ${t.tpId} | Marketplace: "${t.marketplace || 'EMPTY'}" | Event: ${t.event}`);
        });
      }
      
      console.groupEnd();
      
      console.group('Real Marketplace Aggregation:');
      marketplaceDataFinal.forEach(m => {
        console.log(`  ✅ ${m.marketplace}: ${m.ticketsSold} tickets | $${m.revenue.toFixed(2)} (${m.percentage.toFixed(1)}%)`);
      });
      if (marketplaceDataFinal.length === 0) {
        console.log('  ❌ NO REAL MARKETPLACE DATA - All sold tickets missing marketplace information');
      }
      console.groupEnd();
    }
    
    console.log('🛒 Marketplace Settings Available:', marketplacesList.length);
    console.groupEnd();
    
    return { soldTickets, realMarketplaceData: marketplaceDataFinal };
  };
  
  const marketplaceData = marketplacePerformanceData;
  const leagueBreakdown = leagueBreakdownData;
  const timingData = analytics.ua_timing_data || {};
  const timingSummary = timingData.summary || {};
  const timingRows = Array.isArray(timingData.priceMovement) ? timingData.priceMovement : [];
  const timingByLeague = Array.isArray(timingData.leagues) ? timingData.leagues : [];
  const statusFlags = Array.isArray(analytics.ua_status_flags) ? analytics.ua_status_flags : (analytics.ua_status_flags ? [analytics.ua_status_flags] : []);
  
  if (isUserLoading && !effectiveUserRecord) return <div className={styles.loadingContainer}><Loader size={40} className={styles.spinner} /><p>Loading user details...</p></div>;
  if (userError && !isGetUserByIdAllowlistError) return <div className={styles.errorContainer}><p>Error loading user: {userError.message}</p><button onClick={() => navigate('/users')} className={styles.backBtn}><ChevronLeft size={14} /> Back to Users</button></div>;
  if (isAffiliateAdmin && isAffiliateScopeResolved && !isAffiliateAllowedUser) return <div className={styles.errorContainer}><p>You can only view details for your assigned users.</p><button onClick={() => navigate('/users')} className={styles.backBtn}><ChevronLeft size={14} /> Back to Users</button></div>;
  if (!effectiveUserRecord || !currentUser) return <div className={styles.errorContainer}><p>User not found</p><button onClick={() => navigate('/users')} className={styles.backBtn}><ChevronLeft size={14} /> Back to Users</button></div>;
  
  return (
    <div className={styles.container}>
      {(isTicketTableBusy || vlProductionMapLoading) && (
        <div className={styles.vlBusyBanner} role="status" aria-live="polite">
          <div className={styles.vlBusySpinner} />
          <div className={styles.vlBusyBannerText}>
            <strong>
              {vlProductionMapLoading && !isTicketTableBusy
                ? vlProductionModalMode === 'add-pid'
                  ? 'Saving Production ID…'
                  : 'Submitting to Victory Live…'
                : ticketTableBusyMessage}
            </strong>
            <span>Please wait — this stays at the top until it finishes.</span>
          </div>
        </div>
      )}
      {typeof document !== 'undefined' &&
        createPortal(
          <>
            {wrongPidConfirm && (
              <div className={styles.modalOverlay}>
                <div className={styles.modalContent} onClick={(event) => event.stopPropagation()}>
                  <div className={styles.modalHeader}>
                    <h3>Wrong PID</h3>
                  </div>
                  <div className={styles.modalBody}>
                    <p>Do you want to delete this wrong PID ticket group?</p>
                  </div>
                  <div className={styles.modalFooter}>
                    <button
                      type="button"
                      className={styles.modalCancel}
                      disabled={wrongPidLoading}
                      onClick={() => setWrongPidConfirm(null)}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className={styles.modalConfirm}
                      disabled={wrongPidLoading}
                      onClick={() => void confirmWrongPid()}
                    >
                      {wrongPidLoading ? 'Removing…' : 'Yes'}
                    </button>
                  </div>
                </div>
              </div>
            )}
            {renderVlProductionMapModal()}
            {renderVlShareModal()}
            {renderConciergePriceModal()}
          </>,
          document.body,
        )}
      <div className={styles.header}>
        <div className={styles.logo} onClick={handleUserClick} style={{ cursor: 'pointer' }}><ChevronLeft size={14} /> Back</div>
        <div><button className={styles.deleteuser} onClick={() => setShowDeleteConfirm(true)}><Delete size={14} style={{ color: "#fff" }} /> Delete User</button></div>
      </div>
      <div className={styles.mainContent}>
          <div className={styles.pageHeader}>
          <div><p>Users Details</p><h2>{currentUser.name}</h2></div>
       
            <div className={styles.searchSection}>
                {activeTab !== 'teams' && activeTab !== 'profile' && activeTab !== 'analytics' && activeTab !== 'support-tickets' && (
              <div className={styles.searchWrapper}>
                <Search className={styles.searchIcon} size={18} />
                <input type="text" placeholder="Search by event, section, row, seat..." className={styles.searchInput} value={searchQuery} onChange={(e) => handleSearch(e.target.value)} />
              </div>
                   )}
              <div className={styles.iconGroup}><button className={styles.iconBtn} onClick={() => void handleRefresh()} disabled={isRefreshing} aria-label="Refresh user details"><RefreshRoundedIcon className={isRefreshing ? styles.spinner : undefined} /></button><button className={styles.iconBtn} onClick={() => setIsDarkMode(!isDarkMode)}>{isDarkMode ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}</button></div>
            </div>
     
        </div>
        
        <div className={styles.tabs}>
          <button className={activeTab === "profile" ? styles.activeTab : ""} onClick={() => handleActiveTabChange("profile")}>Profile</button>
          <button className={activeTab === "tickets" ? styles.activeTab : ""} onClick={() => handleActiveTabChange("tickets")}>Tickets ({totalTickets})</button>
          <button className={activeTab === "analytics" ? styles.activeTab : ""} onClick={() => handleActiveTabChange("analytics")}>Analytics</button>
          <button className={activeTab === "teams" ? styles.activeTab : ""} onClick={() => handleActiveTabChange("teams")}>Teams</button>
          <button className={activeTab === "support-tickets" ? styles.activeTab : ""} onClick={() => handleActiveTabChange("support-tickets")}>Support Tickets</button>
        </div>
        
         {activeTab === "profile" && (
          <>
            <div className={styles.profileRow}>
              <div className={styles.profileCol}>
                <div className={styles.card}>
                  <div className={styles.cardTitle} style={{ display: "flex", alignItems: "center", gap: "5px", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}><User size={16} /> User Information</div>
                    <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                      {isEditing ? (<button className={styles.cancelBtn} onClick={handleCancelEdit}><X size={14} /> Cancel</button>) : (<button className={styles.edituser} onClick={handleEditClick}><Edit size={14} /> Edit</button>)}
                    </div>
                  </div>
                  {isEditing && editFormData ? renderInlineEditForm() : (
                    <>
                      <div className={styles.userInfo}><div className={styles.avatar}>{currentUser.initials}</div><div><h3>{currentUser.name}</h3><div className={styles.badges}><span className={styles.userType}>{currentUser.type}</span><span className={styles.tier}>{currentUser.tier}</span></div></div></div>
                      <div className={styles.userFee}><span>User Fee</span><b>{currentUser.userFee}%</b></div>
                      <hr className={styles.divider} />
                      <div className={styles.userInfoDetails}>
                        <div className={styles.infoRow}><Briefcase size={14} className={styles.infoIcon} /><span className={styles.infoLabel}>Business:</span><span className={styles.infoValue}>{currentUser.business || "N/A"}</span></div>
                        <div className={`${styles.infoRow} ${styles.emailRow}`}><Mail size={14} className={styles.infoIcon} /><span className={`${styles.infoLabel} ${styles.emailLabel}`}>Email:</span><span className={`${styles.infoValue} ${styles.emailValue}`}>{currentUser.email || "N/A"}</span></div>
                        <div className={styles.infoRow}><Phone size={14} className={styles.infoIcon} /><span className={styles.infoLabel}>Phone:</span><span className={styles.infoValue}>{currentUser.phone || "N/A"}</span></div>
                        <div className={styles.infoRow}><User size={14} className={styles.infoIcon} /><span className={styles.infoLabel}>Sales Rep:</span><span className={styles.infoValue}>{repAffiliate.salesRep}</span></div>
                        <div className={styles.infoRow}><User size={14} className={styles.infoIcon} /><span className={styles.infoLabel}>Direct Affiliate:</span><span className={styles.infoValue}>{repAffiliate.directAffiliate}</span></div>
                        <div className={styles.infoRow}><User size={14} className={styles.infoIcon} /><span className={styles.infoLabel}>Indirect Affiliate:</span><span className={styles.infoValue}>{repAffiliate.indirectAffiliate}</span></div>
                        {hasAddressValues(currentUser) && (<><div className={styles.cardTitle} style={{ marginTop: "16px" }}><MapPinned size={16} /> Address</div>{currentUser.address1 && <p>{currentUser.address1}</p>}{currentUser.address2 && <p>{currentUser.address2}</p>}{currentUser.city && currentUser.state && currentUser.zip && (<p>{`${currentUser.city}, ${currentUser.state} ${currentUser.zip}`.trim()}</p>)}{currentUser.country && <p>{currentUser.country}</p>}</>)}
                        <div className={styles.cardTitle} style={{ marginTop: "16px" }}><Clock size={16} /> Last Active</div><p>{currentUser.lastActive}</p>
                        {currentUser.hearAboutUs && (<div style={{ marginTop: "16px", padding: "12px 14px", borderLeft: "4px solid #3b82f6", borderRadius: "4px", display: "flex", alignItems: "center", gap: "10px" }}><Lightbulb size={18} style={{ color: "#3b82f6", flexShrink: 0 }} /><div><div style={{ fontSize: "11px", fontWeight: "600", color: "#3b82f6", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "3px" }}>Source</div><div style={{ fontSize: "14px", fontWeight: "500",  color: "#f63b57", }}>{currentUser.hearAboutUs}</div></div></div>)}
                        <div className={styles.cardTitle} style={{ marginTop: "16px" }}><Award size={16} /> Ticketmaster Catalog</div>
                        <div className={styles.tierDisplay}><span className={styles.tier}>{currentUser.tier}</span><span className={styles.annualSales}>{currentUser.annualSales}</span></div>
                        <div className={styles.requirements}>{tierThresholds.map(({ label, threshold }) => (<span key={label} className={activeTier === label ? styles.requirementActive : undefined}>{label}: {threshold}</span>))}</div>
                        <hr className={styles.divider} />
                        {currentUser.assignedTeams && currentUser.assignedTeams.length > 0 && (<><h4 className={styles.teamsTitle}>Teams</h4><div className={styles.teams}>{currentUser.assignedTeams.map((team, i) => (<span key={i} className={styles.teamTag}>{team}</span>))}</div></>)}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className={styles.profileCol}>
                <div className={styles.card}>
                  <div className={styles.cardTitle}><TrendingUp size={16} /> Performance</div>
                  <>
                      <div className={styles.stats}>
                        <div className={`${styles.statBox} ${styles.blue}`}><b>{activeCount}</b><span>Active</span></div>
                        <div className={`${styles.statBox} ${styles.green}`}><b>{formatCurrency(potentialRevenue)}</b><span>Potential</span></div>
                        <div className={styles.statBox}><b>{soldCount}</b><span>Sold</span></div>
                        <div className={styles.statBox}><b>{formatCurrency(soldRevenue)}</b><span>Revenue</span></div>
                        <div className={`${styles.statBox} ${styles.orange}`}><b>{formatCurrency(typeof paidOut === "number" ? paidOut : 0)}</b><span>Paid Out</span></div>
                        <div className={`${styles.statBox} ${styles.purple}`}><b>{formatPercent(sellThroughRate)}</b><span>Sell-Through</span></div>
                      </div>
                      <hr className={styles.divider} />
                      <div className={styles.ticketStatsGrid}>
                        <div className={styles.ticketStatCard}><span className={styles.ticketStatValue}>{verifiedCount}</span><span className={styles.ticketStatLabel}>Verified</span></div>
                        <div className={styles.ticketStatCard}><span className={styles.ticketStatValue}>{toBeVerifiedCount}</span><span className={styles.ticketStatLabel}>To Be Verified</span></div>
                        <div className={styles.ticketStatCard}><span className={styles.ticketStatValue}>{delistedCount}</span><span className={styles.ticketStatLabel}>Delisted</span></div>
                        <div className={styles.ticketStatCard}><span className={styles.ticketStatValue}>{unsoldCount}</span><span className={styles.ticketStatLabel}>Unsold</span></div>
                        <div className={styles.ticketStatCard}><span className={styles.ticketStatValue}>{invalidCount}</span><span className={styles.ticketStatLabel}>Invalid</span></div>
                        <div className={`${styles.ticketStatCard} ${styles.highlightCard}`}><span className={styles.ticketStatValue}>{totalTickets}</span><span className={styles.ticketStatLabel}>Total Tickets</span></div>
                      </div>
                    </>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle}><CreditCard size={16} /> Payout Controls</div>
              {currentUser.payoutsVoided ? (
                <>
                  <div className={styles.payoutBoxWarning}><AlertTriangle size={20} color="#dc2626" /><div><b>Payouts are voided for this user</b><p>Tickets sold by this user will not generate payouts</p>{currentUser.voidReason && <p className={styles.voidReasonText}>Reason: {currentUser.voidReason}</p>}{currentUser.voidDate && <p className={styles.voidDateText}>Voided on: {new Date(currentUser.voidDate).toLocaleString()}</p>}</div></div>
                  <button className={styles.restoreBtn} onClick={handleRestorePayouts} disabled={restoreLoading}>{restoreLoading ? "Restoring..." : "Restore Payouts"}</button>
                </>
              ) : (
                <>
                  <div className={styles.payoutBox}><CheckCircle size={20} color="#10b981" /><div><b>Payouts are active for this user</b><p>Tickets sold will generate payouts normally</p></div></div>
                  <button className={styles.dangerBtn} onClick={() => setShowVoidPayoutsModal(true)}>Void Payouts</button>
                </>
              )}
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle} style={{ justifyContent: 'space-between', gap: '8px' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><DollarSign size={16} /> Payout Information</span>
                <span className={currentUser.payoutInfoIsComplete ? styles.active : styles.inactive}>
                  {currentUser.payoutInfoStatusText}
                </span>
              </div>
              <div className={styles.userInfoDetails}>
                <div className={styles.infoRow}>
                  <span className={styles.infoLabel}>Stripe Account ID:</span>
                  <span className={styles.infoValue}>{currentUser.payoutInfoAccountLabel}</span>
                </div>
                <div className={styles.infoRow}>
                  <span className={styles.infoLabel}>Payout Status:</span>
                  <span className={currentUser.payoutInfoIsComplete ? styles.active : styles.inactive}>
                    {currentUser.payoutInfoStatusText}
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.cardTitle} style={{ display: "flex", justifyContent: "space-between", gap: "5px", alignItems: "center" }}>
                <div style={{ display: "flex", gap: "5px", alignItems: "center" }}><Mail size={16} /> Email Communication</div>
                <span className={emailEnabledResolved ? styles.active : styles.inactive}>{emailEnabledResolved ? "Active" : "Disabled"}</span>
              </div>
              {emailEnabledResolved ? (<div className={styles.payoutBox}><CheckCircle size={20} color="#10b981" /><div><b>Emails are active for this user</b><p>This user receives email communications from QuickAsyst</p></div></div>) : (<div className={styles.payoutBoxWarning}><AlertTriangle size={20} color="#dc2626" /><div><b>Emails are disabled for this user</b><p>QuickAsyst will not send any emails to this user</p></div></div>)}
              <div className={styles.emailActions}>{emailEnabledResolved ? (<button className={styles.dangerBtn} onClick={handleToggleEmail} disabled={emailStatusLoading}>{emailStatusLoading ? "Updating..." : "Disable Emails"}</button>) : (<button className={styles.restoreBtn} onClick={handleToggleEmail} disabled={emailStatusLoading}>{emailStatusLoading ? "Updating..." : "Enable Emails"}</button>)}</div>
            </div>
            <div className={styles.notesRow}>
              <div className={styles.profileCol}><div className={styles.card}><div className={styles.cardTitle}><MessageCircle size={16} /> QA Notes</div>{renderNotesSection("qa", "QA Notes")}</div></div>
              <div className={styles.profileCol}>
                <div className={styles.card}><div className={styles.cardTitle}><FileText size={16} /> VL Notes</div>
               
                {renderSeatLevelNotes()}</div></div>
            </div>
          </>
        )}
{activeTab === "tickets" && (
  <div className={styles.ticketsSection}>
    <div className={styles.card}>
      <div className={styles.cardTitle} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <span><FileText size={16} /> Tickets by Status</span>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>

          {/* Date Filter Dropdown */}
          <div className={styles.dateFilterWrapper} style={{ position: 'relative' }}>
            <button
              className={`${styles.dateFilterBtn} ${dateFilter !== 'all' ? styles.dateFilterActive : ''}`}
              onClick={() => setShowDatePicker(!showDatePicker)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 14px',
                background: dateFilter !== 'all' ? '#3b82f6' : 'var(--input-bg)',
                color: dateFilter !== 'all' ? 'white' : 'var(--text)',
                border: '1px solid var(--border)',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '13px',
                transition: 'all 0.2s',
              }}
            >
              <Calendar size={16} />
              <span>{getDateFilterLabel()}</span>
              {dateFilter !== 'all' && (
                <X
                  size={14}
                  onClick={(e) => {
                    e.stopPropagation();
                    setDateFilter('all');
                    setCustomFromDate('');
                    setCustomToDate('');
                  }}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </button>

            {showDatePicker && (
              <div
                className={styles.dateFilterMenu}
                style={{
                  position: 'absolute',
                  top: 'calc(100% + 8px)',
                  right: '0',
                  background: 'var(--card-bg)',
                  border: '1px solid var(--border)',
                  borderRadius: '12px',
                  padding: '16px',
                  minWidth: '320px',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
                  zIndex: 100,
                  animation: 'fadeIn 0.2s ease-out',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {[
                    { value: 'all', label: 'All Dates' },
                    { value: 'today', label: 'Today' },
                    { value: 'yesterday', label: 'Yesterday' },
                    { value: 'thisWeek', label: 'This Week' },
                    { value: 'thisMonth', label: 'This Month' },
                  ].map((option) => (
                    <button
                      key={option.value}
                      className={`${styles.dateFilterOption} ${dateFilter === option.value ? styles.dateFilterOptionActive : ''}`}
                      onClick={() => {
                        setDateFilter(option.value as any);
                        setShowDatePicker(false);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        padding: '10px 14px',
                        borderRadius: '8px',
                        border: 'none',
                        background: dateFilter === option.value ? '#eff6ff' : 'transparent',
                        color: 'var(--text)',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: dateFilter === option.value ? '600' : '400',
                        transition: 'all 0.15s',
                        width: '100%',
                        textAlign: 'left',
                      }}
                    >
                      {dateFilter === option.value && <Check size={16} style={{ color: '#3b82f6' }} />}
                      <span>{option.label}</span>
                    </button>
                  ))}
                </div>

                <hr style={{ margin: '12px 0', border: 'none', borderTop: '1px solid var(--border)' }} />

                <div>
                  <div style={{ fontSize: '13px', fontWeight: '600', marginBottom: '8px' }}>Custom Range</div>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: '11px', color: 'var(--muted)', display: 'block', marginBottom: '4px' }}>From</label>
                      <input
                        type="date"
                        className={styles.dateInput}
                        value={customFromDate}
                        onChange={(e) => setCustomFromDate(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border: '1px solid var(--border)',
                          borderRadius: '6px',
                          fontSize: '13px',
                          background: 'var(--input-bg)',
                          color: 'var(--text)',
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={{ fontSize: '11px', color: 'var(--muted)', display: 'block', marginBottom: '4px' }}>To</label>
                      <input
                        type="date"
                        className={styles.dateInput}
                        value={customToDate}
                        onChange={(e) => setCustomToDate(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '8px 10px',
                          border: '1px solid var(--border)',
                          borderRadius: '6px',
                          fontSize: '13px',
                          background: 'var(--input-bg)',
                          color: 'var(--text)',
                        }}
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '8px', marginTop: '10px' }}>
                    <button
                      onClick={() => {
                        if (isCustomDateRangeValid()) {
                          setDateFilter('custom');
                          setShowDatePicker(false);
                        }
                      }}
                      disabled={!isCustomDateRangeValid()}
                      style={{
                        flex: 1,
                        padding: '8px 16px',
                        background: isCustomDateRangeValid() ? '#3b82f6' : '#e5e7eb',
                        color: isCustomDateRangeValid() ? 'white' : '#9ca3af',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: isCustomDateRangeValid() ? 'pointer' : 'default',
                        fontSize: '13px',
                        fontWeight: '500',
                      }}
                    >
                      Apply Range
                    </button>
                    <button
                      onClick={() => {
                        setCustomFromDate('');
                        setCustomToDate('');
                        setDateFilter('all');
                        setShowDatePicker(false);
                      }}
                      style={{
                        padding: '8px 16px',
                        background: 'transparent',
                        color: 'var(--text)',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '13px',
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <button
            className={styles.exportBtn}
            onClick={() => exportTicketsCsv(filteredTickets, activeFilterTab)}
            disabled={isTicketsLoading || filteredTickets.length === 0}
          >
            <Download size={14} /> Export CSV
          </button>
        </div>
      </div>

      {/* Date Filter Active Indicator */}
      {dateFilter !== 'all' && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            background: '#eff6ff',
            borderRadius: '6px',
            marginBottom: '12px',
            fontSize: '13px',
            color: '#1e40af',
          }}
        >
          <CalendarDays size={16} />
          <span>
            Showing tickets for <strong>{getDateFilterLabel()}</strong>{' '}
            ({ticketPageTotal} ticket{ticketPageTotal !== 1 ? 's' : ''})
          </span>
          <button
            onClick={() => {
              setDateFilter('all');
              setCustomFromDate('');
              setCustomToDate('');
            }}
            style={{
              marginLeft: 'auto',
              background: 'none',
              border: 'none',
              color: '#3b82f6',
              cursor: 'pointer',
              fontSize: '12px',
              fontWeight: '500',
              textDecoration: 'underline',
            }}
          >
            Clear Filter
          </button>
        </div>
      )}

        <>
          <div className={styles.ticketsHeader}>
            <div className={styles.filterTabs}>
              {ticketFilterTabs.map((tab) => (
                <button
                  key={tab}
                  type="button"
                  className={activeFilterTab === tab ? styles.filterTabActive : styles.filterTab}
                  onClick={() => setActiveFilterTab(tab)}
                >
                  {tab}
                  {getTabCount(tab) > 0 || tab === 'All' ? ` (${getTabCount(tab)})` : ''}
                </button>
              ))}
            </div>
          </div>

          <div className={styles.filterGroup}>
            <div className={styles.filterDropdownWrapper}>
              <button
                type="button"
                className={styles.filterStatusBtn}
                onClick={() => {
                  setShowFilterDropdown((open) => !open);
                  setShowBarcodeFilterDropdown(false);
                  setShowStripeAccountFilterDropdown(false);
                  setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                  setShowPricingMethodFilterDropdown(false);
                  setShowLastPricedFilterDropdown(false);
                }}
              >
                <Filter size={14} />
                {filterStatus === 'All' || filterStatus.startsWith('All ') ? 'Filter Status' : getUserStatusFilterOptions().find((option) => option.value === filterStatus)?.label || filterStatus}
                <ChevronDown size={14} />
              </button>
              {showFilterDropdown && (
                <div className={styles.filterDropdown}>
                  {getUserStatusFilterOptions().map((option) => (
                    <div
                      key={option.value}
                      className={`${styles.filterDropdownItem} ${filterStatus === option.value ? styles.filterDropdownItemActive : ''}`}
                      onClick={() => {
                        setFilterStatus(option.value);
                        if (activeFilterTab === 'Sold') {
                          setSoldSubFilter(soldSubFilterFromStatus(option.value));
                        }
                        setShowFilterDropdown(false);
                      }}
                    >
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {(activeFilterTab === 'Listed' || activeFilterTab === 'Sold') && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowBarcodeFilterDropdown((open) => !open);
                    setShowFilterDropdown(false);
                    setShowStripeAccountFilterDropdown(false);
                    setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                    setShowPricingMethodFilterDropdown(false);
                    setShowLastPricedFilterDropdown(false);
                  }}
                >
                  <ScanBarcode size={14} />
                  {barcodeFilter === 'attached' ? 'Attached' : barcodeFilter === 'missing' ? 'Missing' : barcodeFilter === 'none' ? 'No Barcode' : 'All barcodes'}
                  <ChevronDown size={14} />
                </button>
                {showBarcodeFilterDropdown && (
                  <div className={styles.filterDropdown}>
                    <div
                      className={`${styles.filterDropdownItem} ${barcodeFilter === 'all' ? styles.filterDropdownItemActive : ''}`}
                      onClick={() => { setBarcodeFilter('all'); setShowBarcodeFilterDropdown(false); }}
                    >
                      All barcodes
                    </div>
                    <div
                      className={`${styles.filterDropdownItem} ${barcodeFilter === 'attached' ? styles.filterDropdownItemActive : ''}`}
                      onClick={() => { setBarcodeFilter('attached'); setShowBarcodeFilterDropdown(false); }}
                    >
                      <span className={styles.filterDropdownItemInner}>
                        <CheckCircle size={14} className={styles.barcodeStatusOk} aria-hidden />
                        Attached
                      </span>
                    </div>
                    <div
                      className={`${styles.filterDropdownItem} ${barcodeFilter === 'missing' ? styles.filterDropdownItemActive : ''}`}
                      onClick={() => { setBarcodeFilter('missing'); setShowBarcodeFilterDropdown(false); }}
                    >
                      <span className={styles.filterDropdownItemInner}>
                        <AlertCircle size={14} className={styles.barcodeStatusMissing} aria-hidden />
                        Missing
                      </span>
                    </div>
                    <div
                      className={`${styles.filterDropdownItem} ${barcodeFilter === 'none' ? styles.filterDropdownItemActive : ''}`}
                      onClick={() => { setBarcodeFilter('none'); setShowBarcodeFilterDropdown(false); }}
                    >
                      <span className={styles.filterDropdownItemInner}>
                        <Ban size={14} className={styles.barcodeStatusNull} aria-hidden />
                        No Barcode
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeFilterTab === 'Sold' && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowStripeAccountFilterDropdown((open) => !open);
                    setShowFilterDropdown(false);
                    setShowBarcodeFilterDropdown(false);
                    setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                    setShowPricingMethodFilterDropdown(false);
                    setShowLastPricedFilterDropdown(false);
                  }}
                >
                  <DollarSign size={14} />
                  {STRIPE_ACCOUNT_FILTER_OPTIONS.find((option) => option.value === stripeAccountFilter)?.label || 'Stripe Account'}
                  <ChevronDown size={14} />
                </button>
                {showStripeAccountFilterDropdown && (
                  <div className={styles.filterDropdown}>
                    {STRIPE_ACCOUNT_FILTER_OPTIONS.map((option) => (
                      <div
                        key={option.value}
                        className={`${styles.filterDropdownItem} ${stripeAccountFilter === option.value ? styles.filterDropdownItemActive : ''}`}
                        onClick={() => {
                          setStripeAccountFilter(option.value);
                          setShowStripeAccountFilterDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeFilterTab === 'Listed' && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowVlShareFilterDropdown((open) => !open);
                    setShowFilterDropdown(false);
                    setShowBarcodeFilterDropdown(false);
                    setShowStripeAccountFilterDropdown(false);
                    setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                    setShowPricingMethodFilterDropdown(false);
                    setShowLastPricedFilterDropdown(false);
                  }}
                >
                  <Share2 size={14} />
                  {vlShareFilter === 'shared' ? 'Shared' : vlShareFilter === 'unshared' ? 'Unshared' : 'Share'}
                  <ChevronDown size={14} />
                </button>
                {showVlShareFilterDropdown && (
                  <div className={styles.filterDropdown}>
                    {([
                      { value: 'all', label: 'All' },
                      { value: 'shared', label: 'Shared' },
                      { value: 'unshared', label: 'Unshared' },
                    ] as const).map((option) => (
                      <div
                        key={option.value}
                        className={`${styles.filterDropdownItem} ${vlShareFilter === option.value ? styles.filterDropdownItemActive : ''}`}
                        onClick={() => {
                          setVlShareFilter(option.value);
                          setShowVlShareFilterDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeFilterTab === 'Listed' && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowPidStatusFilterDropdown((open) => !open);
                    setShowVlShareFilterDropdown(false);
                    setShowFilterDropdown(false);
                    setShowBarcodeFilterDropdown(false);
                    setShowStripeAccountFilterDropdown(false);
                    setShowPricingMethodFilterDropdown(false);
                    setShowLastPricedFilterDropdown(false);
                  }}
                >
                  {pidStatusFilter === 'available' ? 'PID Available' : pidStatusFilter === 'not_available' ? 'PID Not Available' : 'PID Status'}
                  <ChevronDown size={14} />
                </button>
                {showPidStatusFilterDropdown && (
                  <div className={styles.filterDropdown}>
                    {([
                      { value: 'all', label: 'All' },
                      { value: 'available', label: 'Available' },
                      { value: 'not_available', label: 'Not Available' },
                    ] as const).map((option) => (
                      <div
                        key={option.value}
                        className={`${styles.filterDropdownItem} ${pidStatusFilter === option.value ? styles.filterDropdownItemActive : ''}`}
                        onClick={() => {
                          setPidStatusFilter(option.value);
                          setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeFilterTab === 'Listed' && (
              <button
                type="button"
                className={`${styles.filterStatusBtn} ${styles.onHoldFilterBtn} ${onHoldFilter ? styles.onHoldFilterBtnActive : ''}`}
                onClick={() => setOnHoldFilter((prev) => !prev)}
              >
                On Hold
                {listedOnHoldCount > 0 && (
                  <span className={styles.onHoldCountBadge} aria-label={`${listedOnHoldCount} tickets on hold`}>
                    {listedOnHoldCount}
                  </span>
                )}
              </button>
            )}

            {activeFilterTab === 'Listed' && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowPricingMethodFilterDropdown((open) => !open);
                    setShowFilterDropdown(false);
                    setShowBarcodeFilterDropdown(false);
                    setShowStripeAccountFilterDropdown(false);
                    setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                    setShowLastPricedFilterDropdown(false);
                  }}
                >
                  {pricingMethodFilter === 'MANUAL'
                    ? 'Manual'
                    : pricingMethodFilter === 'FOLLOW_MARKET'
                      ? 'Follow the Market'
                      : pricingMethodFilter === 'NONE'
                        ? 'Nothing'
                        : 'Pricing Method'}
                  <ChevronDown size={14} />
                </button>
                {showPricingMethodFilterDropdown && (
                  <div className={styles.filterDropdown}>
                    {([
                      { value: 'all', label: 'All pricing methods' },
                      { value: 'MANUAL', label: 'Manual' },
                      { value: 'FOLLOW_MARKET', label: 'Follow the Market' },
                      { value: 'NONE', label: 'Nothing' },
                    ] as const).map((option) => (
                      <div
                        key={option.value}
                        className={`${styles.filterDropdownItem} ${pricingMethodFilter === option.value ? styles.filterDropdownItemActive : ''}`}
                        onClick={() => {
                          setPricingMethodFilter(option.value);
                          setShowPricingMethodFilterDropdown(false);
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeFilterTab === 'Listed' && (
              <div className={styles.filterDropdownWrapper}>
                <button
                  type="button"
                  className={styles.filterStatusBtn}
                  onClick={() => {
                    setShowLastPricedFilterDropdown((open) => !open);
                    setShowFilterDropdown(false);
                    setShowBarcodeFilterDropdown(false);
                    setShowStripeAccountFilterDropdown(false);
                    setShowPidStatusFilterDropdown(false);
                    setShowVlShareFilterDropdown(false);
                    setShowPricingMethodFilterDropdown(false);
                  }}
                >
                  <Calendar size={14} />
                  {(lastPricedFilter.length + (lastPricedFrom || lastPricedTo ? 1 : 0) + (lastPricedCustomRange ? 1 : 0)) > 0
                    ? `Last Priced (${lastPricedFilter.length + (lastPricedFrom || lastPricedTo ? 1 : 0) + (lastPricedCustomRange ? 1 : 0)})`
                    : 'Filter by Last Priced'}
                  <ChevronDown size={14} />
                </button>
                {showLastPricedFilterDropdown && (
                  <div className={`${styles.filterDropdown} ${styles.lastPricedDropdown}`}>
                    {LAST_PRICED_BUCKET_OPTIONS.map((option) => {
                      const checked = lastPricedFilter.includes(option.value);
                      return (
                        <div
                          key={option.value}
                          className={`${styles.filterDropdownItem} ${checked ? styles.filterDropdownItemActive : ''}`}
                          onClick={() => {
                            setLastPricedFilter((prev) =>
                              prev.includes(option.value)
                                ? prev.filter((value) => value !== option.value)
                                : [...prev, option.value],
                            );
                          }}
                        >
                          {option.label}
                        </div>
                      );
                    })}
                    <div className={styles.lastPricedRange}>
                      <div className={styles.lastPricedRangeOptionLabel}>Date & Time Range</div>
                      <label className={styles.lastPricedRangeField}>
                        <span>From</span>
                        <input
                          type="datetime-local"
                          value={lastPricedFrom}
                          onChange={(event) => setLastPricedFrom(event.target.value)}
                        />
                      </label>
                      <label className={styles.lastPricedRangeField}>
                        <span>To</span>
                        <input
                          type="datetime-local"
                          value={lastPricedTo}
                          onChange={(event) => setLastPricedTo(event.target.value)}
                        />
                      </label>
                      {lastPricedFrom && lastPricedTo && !getLastPricedRange(lastPricedFrom, lastPricedTo) && (
                        <div className={styles.lastPricedRangeError}>
                          From date and time must be before or equal to To date and time.
                        </div>
                      )}
                    </div>
                    <div className={styles.lastPricedCustomFilter}>
                      <label className={styles.lastPricedCustomUnit}>
                        <select
                          value={lastPricedCustomWindow}
                          aria-label="Last Priced window"
                          onChange={(event) => {
                            setLastPricedCustomWindow(event.target.value as 'within' | 'outside');
                            setLastPricedCustomError('');
                          }}
                        >
                          <option value="within">Within</option>
                          <option value="outside">Outside</option>
                        </select>
                      </label>
                      <label className={styles.lastPricedCustomUnit}>
                        <select
                          value={lastPricedCustomUnit}
                          aria-label="Last Priced time unit"
                          onChange={(event) => {
                            setLastPricedCustomUnit(event.target.value as 'Hours' | 'Minutes' | 'Days');
                            setLastPricedCustomError('');
                          }}
                        >
                          <option value="Hours">Hours</option>
                          <option value="Minutes">Minutes</option>
                          <option value="Days">Days</option>
                        </select>
                      </label>
                      <label className={styles.lastPricedCustomInput}>
                        <span>last</span>
                        <input
                          type="number"
                          min="0.01"
                          step="any"
                          inputMode="decimal"
                          value={lastPricedCustomValue}
                          aria-label="Last Priced duration"
                          aria-invalid={Boolean(lastPricedCustomError)}
                          aria-describedby={lastPricedCustomError ? 'userdetails-last-priced-custom-error' : undefined}
                          onChange={(event) => {
                            const value = event.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              setLastPricedCustomValue(value);
                              setLastPricedCustomError('');
                            }
                          }}
                        />
                      </label>
                      <button
                        type="button"
                        className={styles.lastPricedCustomApply}
                        onClick={applyLastPricedCustomFilter}
                      >
                        Filter
                      </button>
                      {lastPricedCustomError && (
                        <div
                          className={styles.lastPricedRangeError}
                          id="userdetails-last-priced-custom-error"
                          role="alert"
                        >
                          {lastPricedCustomError}
                        </div>
                      )}
                    </div>
                    {(lastPricedFilter.length > 0 || lastPricedFrom || lastPricedTo || lastPricedCustomRange || lastPricedCustomValue) && (
                      <button
                        type="button"
                        className={styles.lastPricedFilterClear}
                        onClick={clearLastPricedFilters}
                      >
                        <X size={14} /> Clear
                      </button>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>

          {(isTicketsLoading || tabSwitchLoading) ? (
            <div className={styles.loadingState} role="status" aria-live="polite">
              <div className={styles.ticketLoadSpinner} />
              <p>Loading tickets...</p>
            </div>
          ) : (
          <>
          {/* =================== BULK ACTIONS BAR =================== */}
          {bulkSelectedTicketIds.size > 0 && (
            <div className={styles.bulkActionsBar}>
              <div className={styles.bulkActionsLeft}>
                <div>
                  <strong>{bulkSelectedTicketIds.size}</strong>{' '}
                  ticket{bulkSelectedTicketIds.size > 1 ? 's' : ''} selected
                </div>
                {filteredTickets.filter((t) => bulkSelectedTicketIds.has(t.tpId)).length > 0 && (
                  <div style={{ marginLeft: 8 }}>
                    Event: {filteredTickets.find((t) => bulkSelectedTicketIds.has(t.tpId))?.event || 'N/A'}
                    {' • '}
                    Section: {filteredTickets.find((t) => bulkSelectedTicketIds.has(t.tpId))?.section || 'N/A'}
                    {' • '}
                    Row: {filteredTickets.find((t) => bulkSelectedTicketIds.has(t.tpId))?.row || 'N/A'}
                  </div>
                )}
                <button
                  type="button"
                  className={styles.clearSelectionBtn}
                  onClick={clearBulkSelection}
                  disabled={isTicketTableBusy}
                >
                  Clear Selection
                </button>
              </div>
              <div className={styles.bulkActionsRight}>
                <button
                  type="button"
                  className={styles.bulkChangePrice}
                  onClick={openBulkStatusModal}
                  disabled={isTicketTableBusy}
                >
                  Bulk Update Status
                </button>
                {areSelectedTicketsAllListed && (
                  <button
                    type="button"
                    className={styles.bulkChangePrice}
                    onClick={handleBulkChangePrice}
                    disabled={isTicketTableBusy}
                  >
                    <Edit size={14} /> Change Price
                  </button>
                )}
                {(() => {
                  const statuses = selectedTickets.map((t) => normalizeStatusValue(t.rawStatus || t.status));
                  const vlProgress = getVlProgressForUserTickets(selectedTickets);
                  const allHaveVlIds = selectedTickets.every((t) => Boolean(t.vlListingId || t.vlItemId));
                  const allToBeVerifiedOrVerified =
                    selectedTickets.length > 0 &&
                    statuses.every((s) => s === 'Verified' || s === 'ToBeVerified');
                  const allListed = selectedTickets.length > 0 && statuses.every((s) => s === 'List');
                  const canVlProgress =
                    (activeFilterTab === 'Verification' || activeFilterTab === 'All') &&
                    selectedTickets.length > 0 &&
                    vlProgress != null;
                  const canVlSyncOnVerification =
                    (activeFilterTab === 'Verification' || activeFilterTab === 'All') &&
                    allToBeVerifiedOrVerified;
                  const canVlSyncOnListed =
                    (activeFilterTab === 'Listed' || activeFilterTab === 'All') && allListed;
                  const canVlBarcodes =
                    (canVlSyncOnVerification || canVlSyncOnListed) && allHaveVlIds;
                  const allVerified =
                    selectedTickets.length > 0 &&
                    statuses.every((s) => s === 'Verified');
                  const allHaveMappedPid = selectedTickets.every((ticket) => {
                    const pid = String(getUserTicketVlProductionId(ticket) || '').trim();
                    return Boolean(pid && /^\d+$/.test(pid));
                  });
                  const canRemapProduction =
                    (activeFilterTab === 'Verification' || activeFilterTab === 'All') &&
                    allVerified &&
                    allHaveMappedPid;
                  const canAddPid =
                    (canVlSyncOnVerification || canVlSyncOnListed) &&
                    selectedTickets.length > 0;

                  return (
                    <>
                      {canVlProgress && vlProgress && (
                        <button
                          type="button"
                          className={styles.bulkMarkSold}
                          onClick={() => void handleVlProgressAction()}
                          disabled={isTicketTableBusy}
                          title={vlProgress.title}
                        >
                          {vlProgress.step === 'submit' && <ExternalLink size={14} />}
                          {vlProgress.step === 'share' && <Share2 size={14} />}
                          {' '}
                          {vlProgress.label}
                        </button>
                      )}
                      {canRemapProduction && (
                        <button
                          type="button"
                          className={styles.bulkChangePrice}
                          onClick={() => void handleOpenProductionSync(selectedTickets)}
                          disabled={isTicketTableBusy}
                          title="Overwrite the mapped Victory Live Production ID, then resubmit inventory"
                        >
                          <MapPinned size={14} /> Remap PID
                        </button>
                      )}
                      {canAddPid && (
                        <button
                          type="button"
                          className={styles.bulkChangePrice}
                          onClick={() => void handleOpenAddPid(selectedTickets)}
                          disabled={isTicketTableBusy}
                          title="Save Production ID for the whole ticket group in QuickAsyst only (does not update Victory Live)"
                        >
                          <MapPinned size={14} /> Add PID
                        </button>
                      )}
                      {(canVlSyncOnVerification || canVlSyncOnListed) && (
                        <button
                          type="button"
                          className={styles.bulkChangePrice}
                          onClick={() => openSyncFromVlScopeModal()}
                          disabled={isTicketTableBusy}
                          title="Choose what to sync from Victory Live (merge/split, barcode, price, notes, …)"
                        >
                          <RefreshCcw size={14} /> Sync from VL
                        </button>
                      )}
                      {canVlBarcodes && (
                        <button
                          type="button"
                          className={styles.bulkChangePrice}
                          onClick={() => void handleSyncBarcodes()}
                          disabled={
                            isTicketTableBusy ||
                            barcodeSyncSummary?.phase === 'crawling' ||
                            barcodeSyncSummary?.phase === 'verifying'
                          }
                          title="Start barcode crawl, wait for completion, then verify selected seats"
                        >
                          <ScanBarcode size={14} /> Sync Barcodes
                        </button>
                      )}
                      {(activeFilterTab === 'Listed' || activeFilterTab === 'All') && allListed && (
                        <button
                          type="button"
                          className={styles.bulkChangePrice}
                          onClick={() => void handleRefreshConciergePrices()}
                          disabled={isTicketTableBusy}
                          title="Pull current Victory Live list prices (Follow the Market / listing price) and show up/down changes"
                        >
                          <RefreshCcw size={14} /> Refresh VL Prices
                        </button>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          )}

          {/* =================== TABLE =================== */}
          <div className={`${styles.tableBusyWrap} ${isTicketTableBusy ? styles.tableBusyWrapActive : ''}`}>
            {isTicketTableBusy && (
              <div className={styles.tableBusyOverlay} role="status" aria-live="polite">
                <div className={styles.tableBusyOverlayInner}>
                  <div className={styles.vlBusySpinner} />
                  <p>{ticketTableBusyMessage}</p>
                </div>
              </div>
            )}
            <div className={styles.tableWrapper}>
              <table className={styles.ticketsTable}>
                <thead>
                  <tr>
                    <th className={`${styles.checkboxColumn} ${styles.stickyCheckbox}`}>
                      <input
                        type="checkbox"
                        className={styles.bulkSelectCheckbox}
                        checked={pageTickets.length > 0 && pageTickets.every((ticket) => bulkSelectedTicketIds.has(ticket.tpId))}
                        onChange={(e) => handleBulkSelectAllPage(e.target.checked)}
                      />
                    </th>
                    {renderTicketSortableHeader('Event', 'event', `${styles.thEvent} ${styles.stickyEvent}`)}
                    {renderTicketSortableHeader('Section', 'section', styles.thSection)}
                    {renderTicketSortableHeader('Row', 'row', styles.thRow)}
                    <th className={styles.thSeat}>Seats</th>
                    <th className={styles.thStatus}>Status</th>
                    {showMarketplaceColumn && (
                      <th className={styles.thMarketplace}>Marketplaces</th>
                    )}
                    {showSharedColumn && (
                      <th className={styles.thShared}>Shared</th>
                    )}
                    {showListPriceColumn && (
                      renderTicketSortableHeader('List Price', 'price', styles.thPrice)
                    )}
                    {activeFilterTab === 'Listed' && (
                      renderTicketSortableHeader('Last Priced', 'lastPriced', styles.thLastPriced)
                    )}
                    {showSoldPriceColumns && (
                      <>
                        {renderTicketSortableHeader('Sold Price', 'price', styles.thPrice)}
                        <th className={styles.thPrice}>Commission</th>
                      </>
                    )}
                    <th className={styles.thActions}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pagedDisplayRows.length > 0 ? (
                    pagedDisplayRows.map((row) => renderTicketTableRow(row))
                  ) : (
                    <tr>
                      <td colSpan={ticketTableColSpan} className={styles.noData}>
                        {searchQuery.trim() ? 'No tickets match your search' : 'No tickets found for this filter'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {groupedTicketTotal > 0 && (
            <div className={styles.ticketPagination}>
              <div className={styles.ticketPaginationLeft}>
                <span>
                  {groupedTicketTotal === 0
                    ? 'Showing 0 of 0 groups'
                    : `Showing ${ticketRangeStart} to ${ticketRangeEnd} of ${groupedTicketTotal} groups`}
                </span>
                <label className={styles.ticketPageSize}>
                  Groups per page:
                  <select
                    value={ticketPageSize}
                    onChange={(event) => setTicketPageSize(Number(event.target.value))}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </label>
              </div>
              <div className={styles.ticketPaginationRight}>
                <button
                  type="button"
                  onClick={() => setTicketPageOffset(Math.max(0, ticketPageOffset - ticketPageSize))}
                  disabled={ticketPageOffset === 0}
                >
                  <ChevronLeft size={16} /> Previous
                </button>
                <span>Page {ticketCurrentPage} of {ticketPageCount}</span>
                <button
                  type="button"
                  onClick={() => setTicketPageOffset(getNextGroupedPageOffset({
                    pageOffset: ticketPageOffset,
                    pageSize: ticketPageSize,
                    displayedRows: pagedDisplayRows.length,
                    groupsPerFullWindow: serverTicketPaging && !ticketSeatsFitOneFetch ? ticketGroupsPerFullWindow : null,
                  }))}
                  disabled={nextTicketPageDisabled}
                >
                  Next <ChevronRight size={16} />
                </button>
              </div>
            </div>
          )}
          </>
          )}
        </>
    </div>
  </div>
)}
        {/* Analytics Tab */}
        {activeTab === "analytics" && (
       <div className={styles.analyticsSection}>
  {analyticsLoading ? (
    <div className={styles.loadingSmall}><Loader size={20} className={styles.spinner} /><span>Loading analytics...</span></div>
  ) : (
    <>
      <div className={styles.card}>
        <div className={styles.cardHeader}><h3>Performance Analytics</h3></div>
        <div className={styles.analyticsCard}>
          <h4>Seller Status</h4>
          <div className={styles.statusBadges}>
            <span className={styles.statusLabel}>{analytics.ua_seller_status || currentUser.tier || 'No Status'}</span>
            <span className={styles.thresholdItem}>{analytics.ua_annual_sales_thresholds || 'Annual Sales Thresholds: VIP ($20k+) | Silver ($10k+) | Bronze ($5k+) | No Status (<$5k)'}</span>
          </div>
          <div className={styles.totalRevenue}><span className={styles.revenuLabel}>Total Revenue This Year</span><span className={styles.revenueValue}>{formatCurrency(analytics.ua_total_revenue_year ?? soldRevenue)}</span></div>
        </div>
          <div className={styles.metricsGrid}>
          <div className={styles.metricCard}><span className={styles.metricValue}>{analytics.ua_tickets_sold ?? soldCount}</span><span className={styles.metricLabel}>Tickets Sold</span></div>
          <div className={styles.metricCard}><span className={styles.metricValue}>{formatCurrency(analytics.ua_avg_ticket_price ?? avgTicketPrice)}</span><span className={styles.metricLabel}>Avg Ticket Price</span></div>
          <div className={styles.metricCard}><span className={styles.metricValue}>{formatPercent(delistRate)}</span><span className={styles.metricLabel}>Delist Rate</span></div>
          <div className={styles.metricCard}><span className={styles.metricValue}>{formatPercent(sellThroughRate)}</span><span className={styles.metricLabel}>Sell-Through</span></div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.statusFlagsSection}><h4>Status Flags</h4><div className={styles.flagsContainer}><CheckCircle size={24} color="#10b981" /><span className={styles.flagsText}>{statusFlags.length > 0 ? statusFlags.join(', ') : 'No flags'}</span></div></div>
      </div>
      <div className={styles.card}>
        <div className={styles.cardHeader}><h3>Marketplace Performance</h3></div>
        {marketplaceDataFinal.length > 0 ? (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table className={styles.priceMovementTable}>
                <thead><tr><th>MARKETPLACE</th><th>TICKETS SOLD</th><th>REVENUE GENERATED</th><th>QA PROFIT</th><th>% OF TOTAL</th></tr></thead>
                <tbody>
                  {marketplaceDataFinal.map((item, idx) => (
                    <tr key={idx}><td style={{ fontWeight: '500' }}>{item.marketplace}</td><td>{item.ticketsSold}</td><td style={{ fontWeight: '600', color: '#059669' }}>{formatCurrency(item.revenue)}</td><td style={{ fontWeight: '600', color: '#7c3aed' }}>{formatCurrency(item.qaProfit)}</td><td>{item.percentage.toFixed(1)}%</td></tr>
                  ))}
                  <tr style={{  fontWeight: '600' }}>
                    <td>TOTAL</td><td>{marketplaceDataFinal.reduce((sum, item) => sum + item.ticketsSold, 0)}</td>
                    <td style={{ color: '#059669' }}>{formatCurrency(marketplaceDataFinal.reduce((sum, item) => sum + item.revenue, 0))}</td>
                    <td style={{ color: '#7c3aed' }}>{formatCurrency(marketplaceDataFinal.reduce((sum, item) => sum + item.qaProfit, 0))}</td>
                    <td>100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        ) : (
          <div className={styles.emptyState}>
            <p>
              {soldCount === 0 
                ? '📦 No sold tickets yet. Mark tickets as sold to see marketplace performance.'
                : '⚠️ No real marketplace data available. Sold tickets are missing marketplace information. When marking tickets as sold, select the actual marketplace: AXS, Gametime, GoTickets, SeatGeek, StubHub, Ticket Evolution, Ticketmaster, TicketNetwork, TickPick, or Vivid Seats.'}
            </p>
          </div>
        )}
      </div>

      <div className={styles.card}>
        <div className={styles.cardHeader}><h3>League Breakdown</h3><div style={{ fontSize: '12px', color: '#6b7280', marginLeft: 'auto' }}>Based on ticket events & teams</div></div>
        {leagueBreakdownFinal.length > 0 ? (
          <>
            <div style={{ overflowX: 'auto' }}>
              <table className={styles.priceMovementTable}>
                <thead><tr><th>LEAGUE</th><th>TICKETS SOLD</th><th>REVENUE GENERATED</th><th>% OF TOTAL</th></tr></thead>
                <tbody>
                  {leagueBreakdownFinal.map((item, idx) => (
                    <tr key={idx}><td style={{ fontWeight: '500' }}>{item.league}</td><td>{item.ticketsSold}</td><td style={{ fontWeight: '600', color: '#059669' }}>{formatCurrency(item.revenue)}</td><td>{item.percentage.toFixed(1)}%</td></tr>
                  ))}
                  <tr style={{ fontWeight: '600' }}>
                    <td>TOTAL</td><td>{leagueBreakdownFinal.reduce((sum, item) => sum + item.ticketsSold, 0)}</td>
                    <td style={{ color: '#059669' }}>{formatCurrency(leagueBreakdownFinal.reduce((sum, item) => sum + item.revenue, 0))}</td><td>100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
        
          </>
        ) : (<div className={styles.emptyState}><p>No league data available. {soldCount === 0 ? 'Mark tickets as sold to see league breakdown.' : 'No leagues matched for sold tickets.'}</p></div>)}
      </div>

   {/* Timing & Pricing Intelligence */}
<div className={styles.card}>
  <div className={styles.cardHeader}>
    <div>
      <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
        <Clock size={20} />
        Timing & Pricing Intelligence
      </h3>
      <div className={styles.sellerBadge}>
        {timingSummaryFinal.basedOn?.includes('0 sales') ? 'Insufficient Data' : 'Very Early Seller'}
      </div>
      <div className={styles.basedOnText}>
        {timingSummaryFinal.basedOn || `Based on ${soldCount} sales`}
      </div>
    </div>
  </div>

  <div className={styles.timingMetricsGrid}>
    <div className={`${styles.timingMetric} ${styles.timingMetricBlue}`}>
      <div className={styles.timingValue}>{timingSummaryFinal.avgDaysBeforeSold ?? 0}</div>
      <div className={styles.timingLabel}>Avg Days Before Sold</div>
    </div>
    <div className={`${styles.timingMetric} ${styles.timingMetricGray}`}>
      <div className={styles.timingValue}>{timingSummaryFinal.medianDays ?? 0}</div>
      <div className={styles.timingLabel}>Median Days</div>
    </div>
    <div className={`${styles.timingMetric} ${styles.timingMetricGreen}`}>
      <div className={styles.timingValue}>{timingSummaryFinal.avgDaysBeforeListed ?? 0}</div>
      <div className={styles.timingLabel}>Avg Days Before Listed</div>
    </div>
    <div className={`${styles.timingMetric} ${styles.timingMetricTeal}`}>
      <div className={styles.timingValue}>
        {timingSummaryFinal.avgPriceChange >= 0 ? '+' : ''}
        {formatCurrency(timingSummaryFinal.avgPriceChange ?? 0)}
      </div>
      <div className={styles.timingLabel}>Avg Price Change</div>
    </div>
  </div>

  <div className={styles.priceMovementCountersRow}>
    <div className={styles.priceCounter}>
      <div className={`${styles.counterValue} ${styles.positive}`}>{priceMovementCounters.increased}</div>
      <div className={styles.counterLabel}>Price Increased</div>
    </div>
    <div className={styles.priceCounter}>
      <div className={`${styles.counterValue} ${styles.negative}`}>{priceMovementCounters.decreased}</div>
      <div className={styles.counterLabel}>Price Decreased</div>
    </div>
    <div className={styles.priceCounter}>
      <div className={`${styles.counterValue} ${styles.neutral}`}>{priceMovementCounters.unchanged}</div>
      <div className={styles.counterLabel}>Price Unchanged</div>
    </div>
  </div>

  {timingRowsFinal.length > 0 && (
    <div className={styles.saleTimingDistribution}>
      <div className={styles.distributionHeader}>
        <h4>Sale Timing Distribution</h4>
        <select 
          value={selectedLeagueFilter} 
          onChange={(e) => setSelectedLeagueFilter(e.target.value)}
          className={styles.leagueSelector}
        >
          <option value="all">All Leagues</option>
          {timingByLeagueFinal.map((league: any) => (
            <option key={league.name} value={league.name}>{league.name}</option>
          ))}
        </select>
      </div>
      <div className={styles.distributionBars}>
        {timingRowsFinal.map((bucket) => {
          const totalSold = soldCount || 1;
          const percent = (bucket.total / totalSold) * 100;
          return (
            <div key={bucket.timing} className={styles.distributionItem}>
              <div className={styles.distributionLabel}>
                <span>{bucket.timing}</span>
                <span>{bucket.total} ({percent.toFixed(0)}%)</span>
              </div>
              <div className={styles.barBackground}>
                <div className={styles.barFill} style={{ width: `${percent}%` }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  )}

  <hr className={styles.divider} />

  <div className={styles.priceMovementSection}>
    <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <DollarSign size={16} />
      Price Movement by Sale Timing
    </h4>
    <table className={styles.priceMovementTable}>
      <thead>
        <tr>
          <th>TIMING</th>
          <th>TOTAL</th>
          <th>AVG PRICE CHANGE</th>
          <th>AVG PRICE CHANGE %</th>
        </tr>
      </thead>
      <tbody>
        {timingRowsFinal.length > 0 ? (
          timingRowsFinal.map((row: any, idx: number) => (
            <tr key={idx}>
              <td>{row.timing || '-'}</td>
              <td>{row.total ?? 0}</td>
              <td className={(row.avgPriceChange || 0) >= 0 ? styles.positive : styles.negative}>
                {(row.avgPriceChange || 0) >= 0 ? '+' : ''}
                {formatCurrency(row.avgPriceChange || 0)}
              </td>
              <td className={(row.avgPriceChangePercent || 0) >= 0 ? styles.positive : styles.negative}>
                {(row.avgPriceChangePercent || 0) >= 0 ? '+' : ''}
                {formatPercent(row.avgPriceChangePercent || 0)}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={4} className={styles.noData}>No timing breakdown data</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>

  <hr className={styles.divider} />

  <div className={styles.timingByLeagueSection}>
    <h4>Timing by League</h4>
    {timingByLeagueFinal.length > 0 ? (
      <div className={styles.leagueCards}>
        {timingByLeagueFinal.map((league: any, idx: number) => (
          <div key={idx} className={styles.leagueCard}>
            <div className={styles.leagueCardHeader}>
              <span className={styles.leagueName}>{league.name}</span>
              <span className={styles.leagueSold}>{league.sold} sold</span>
            </div>
            <div className={styles.leagueStatsRow}>
              <div>
                <div className={styles.leagueStatLabel}>Avg Days to Sell</div>
                <div className={styles.leagueStatValue}>{(league.avgDays ?? 0).toFixed(1)} days</div>
              </div>
              <div>
                <div className={styles.leagueStatLabel}>Avg Price Change</div>
                <div className={`${styles.leagueStatValue} ${(league.avgPriceChange || 0) >= 0 ? styles.positive : styles.negative}`}>
                  {(league.avgPriceChange || 0) >= 0 ? '+' : ''}
                  {formatCurrency(league.avgPriceChange || 0)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    ) : (
      <p className={styles.noData}>No league timing data</p>
    )}
  </div>
</div>
    </>
  )}
</div>
        )}

        {/* Support Tickets Tab: this user's Victory Live support tickets and insights */}
        {activeTab === "support-tickets" && userId && (
          <div className={styles.analyticsSection}>
            <SupportTicketsPage userId={userId} />
          </div>
        )}

        {/* Teams Tab */}
        {activeTab === "teams" && (
          <div className={styles.analyticsSection}>
            <div className={styles.card}>
              <div className={styles.cardHeader}>
                <h3>Your Teams</h3>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center',marginTop: '12px' }}>
                  {selectedTeams.length > 0 && (
                    <div className={styles.searchWrapper} style={{ width: '300px' }}>
                      <Search className={styles.searchIcon} size={16} />
                      <input
                        type="text"
                        placeholder="Search teams..."
                        className={styles.searchInput}
                        value={teamSearchQuery}
                        onChange={(e) => setTeamSearchQuery(e.target.value)}
                        style={{ fontSize: '14px' }}
                      />
                    </div>
                  )}
                  <button
                    className={styles.addButton}
                    onClick={() => handleOpenAddTeamModal()}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '10px 20px',
                      background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600',
                      boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                 
                  >
                    <Plus size={18} strokeWidth={3} />
                    Add Team
                  </button>
                </div>
              </div>
              {userPreferenceLoading || preferredLeagueCategoriesLoading || teamsWithSoldLoading ? (
                <div className={styles.loadingSmall}><Loader size={20} className={styles.spinner} /><span>Loading teams...</span></div>
              ) : selectedTeams.length > 0 ? (
                <>
                  {getFilteredTeams().length > 0 ? (
                    <div className={styles.selectedTeamsGrid} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '16px', marginTop: '12px' }}>
                      {getFilteredTeams().map((team: SelectedTeam) => {
 const hasSoldTicket = localTickets.some(ticket => {
  const rawStatus = (ticket.rawStatus || ticket.status).toLowerCase();
  if (rawStatus !== 'sold') return false;
  const eventName = ticket.event.toLowerCase();
  return eventName.includes(team.name.toLowerCase()) || 
         eventName.includes(team.abbreviation.toLowerCase());
});
                        return (
                          <div
                            className={styles.selectedTeamCard}
                            key={team.id}
                            title={team.name}
                   
                            onMouseEnter={(e) => {
                              if (!hasSoldTicket) {
                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.12)';
                                e.currentTarget.style.borderColor = '#bfdbfe';
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                              e.currentTarget.style.borderColor = '#e5e7eb';
                            }}
                          >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                              <div style={{ flex: 1 , flexDirection: 'column', display: 'flex', alignItems: 'center', textAlign: 'center'}}>
                                <div
                                  className={styles.selectedTeamBadge}
                                  style={{ backgroundColor: team.color, color: getContrastTextColor(team.color), width: '44px', height: '44px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '700', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '8px', flexShrink: 0, overflow: 'hidden', textAlign: 'center', paddingTop: '0px' }}
                                >
                                  {team.abbreviation}
                                </div>
                                <div className={styles.selectedTeamName}   style={{
    fontSize: "15px",
    fontWeight: 600,
    width: "100%",
    maxWidth: "180px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "block",
  }}>
                                  <div>{team.name}</div>
                                  {team.leagueName && (
                                    <div style={{ fontSize: '11px', color: 'var(--muted)', fontWeight: '500' }}>
                                      ({team.leagueName})
                                    </div>
                                  )}
                                </div>
                              </div>
                              {hasSoldTicket && (
                                <div title="Tickets sold for this team - Cannot remove" className={styles.soldBadge}>
                                  <CheckCheck size={18} style={{ flexShrink: 0 }} />
                                  <span style={{ fontSize: '11px', fontWeight: '600' }}>Sold</span>
                                </div>
                              )}
                            </div>
                            <div style={{ display: 'flex', gap: '10px', paddingTop: '12px', borderTop: '1px solid #f3f4f6' }}>
                              <button
                                onClick={() => setSelectedTeamForSeats(team)}
                                className={styles.viewSeatsBtn}
                              >
                                View Seats
                              </button>
                              {!canEditPricing && (
                                <button
                                  onClick={() => handleRemoveTeam(team.id)}
                                  disabled={hasSoldTicket || removingTeamId === team.id}
                                  className={styles.removeTeamBtn}
                                  title={hasSoldTicket ? 'Cannot remove team with sold tickets' : 'Remove this team'}
                                >
                                  {removingTeamId === team.id ? <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> : <Trash2 size={16} />}
                                </button>
                              )}
                              {canEditPricing && (
                                <button
                                      onClick={() => handleAdminRemoveTeam(team.id)}
                                      disabled={hasSoldTicket || adminRemovingTeamId === team.id}
                                      className={styles.removeTeamBtn}
                                      title={hasSoldTicket ? 'Cannot remove team with sold tickets' : 'Remove team from user'}
                                    >
                                      {adminRemovingTeamId === team.id ? <Loader size={16} style={{ animation: 'spin 1s linear infinite' }} /> : <Trash2 size={16} />}
                                    </button>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className={styles.emptyState}><p>No teams match your search.</p></div>
                  )}
                </>
              ) : (
                <div className={styles.emptyState}><p>No teams assigned to this user. Click "Add Team" to assign teams.</p></div>
              )}
            </div>
          </div>
        )}

        {renderListedShareConfirmModal()}
        {renderListedDelistConfirmModal()}
        {renderSelfPricingPriceConfirmModal()}
        {renderNonVlStatusConfirmModal()}
        {renderListedMarketplaceEditModal()}
        {showDeleteConfirm && renderDeleteConfirm()}
        {showTicketDeleteConfirm && renderTicketDeleteConfirm()}
        {seatLevelNotePendingDeleteId && (
          <div className={styles.deleteConfirmOverlay}>
            <div
              className={`${styles.deleteConfirmContainer} ${styles.ticketDeleteContainer}`}
              role="dialog"
              aria-modal="true"
              aria-labelledby="seat-level-note-delete-title"
              onClick={(event) => event.stopPropagation()}
            >
              <div className={styles.ticketDeleteHeader}>
                <div className={styles.ticketDeleteHeaderLeft}>
                  <div className={styles.ticketDeleteIcon}><AlertTriangle color="#b91c1c" size={18} /></div>
                  <div className={styles.ticketDeleteTitleBlock}>
                    <div className={styles.ticketDeleteTitle} id="seat-level-note-delete-title">Delete Seat-Level Note</div>
                    <div className={styles.ticketDeleteSubtitle}>This action cannot be undone</div>
                  </div>
                </div>
                <button
                  type="button"
                  className={styles.ticketDeleteClose}
                  onClick={() => setSeatLevelNotePendingDeleteId(null)}
                  disabled={seatLevelNoteDeleteLoading}
                  aria-label="Close"
                >
                  <X size={18} />
                </button>
              </div>
              <div className={styles.ticketDeleteWarning}>
                <div>
                  <b>Are you sure you want to delete this seat-level note?</b>
                  <p style={{ margin: 0, marginTop: 6 }}>This note will be permanently removed.</p>
                </div>
              </div>
              <div className={styles.ticketDeleteActions}>
                <button
                  type="button"
                  className={styles.cancelBtn}
                  onClick={() => setSeatLevelNotePendingDeleteId(null)}
                  disabled={seatLevelNoteDeleteLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={styles.deleteConfirmBtn}
                  onClick={handleConfirmDeleteSeatLevelNote}
                  disabled={seatLevelNoteDeleteLoading}
                >
                  {seatLevelNoteDeleteLoading ? 'Deleting…' : 'Delete Note'}
                </button>
              </div>
            </div>
          </div>
        )}
        {renderVoidPayoutsModal()}
        {renderAddTeamModal()}
        {renderTeamSeatsModal()}
        {renderBulkStatusModal()}
        {renderChangeStatusModal()}
        {renderPricingMethodStatusModal()}
        {renderEditTicketModal()}
        {renderListedModal()}
        {renderSoldModal()}
        {renderPriceModal()}
        {renderBulkPriceModal()}
        {renderPriceChangeConfirmationModal()}
        {renderDelistEmailModal()}
        {canEditSoldCommission && showCommissionModal && selectedTicketForCommission && (
          <div
            className={styles.modalOverlay}
            onClick={() => {
              if (commissionOverrideLoading) return;
              setShowCommissionModal(false);
              setSelectedTicketForCommission(null);
              setCommissionOverrideInput('');
            }}
          >
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '440px' }}>
              <div className={styles.modalHeader}>
                <h3>
                  <DollarSign size={18} /> Edit Commission
                </h3>
                <button
                  type="button"
                  className={styles.modalClose}
                  onClick={() => {
                    if (commissionOverrideLoading) return;
                    setShowCommissionModal(false);
                    setSelectedTicketForCommission(null);
                    setCommissionOverrideInput('');
                  }}
                >
                  <X size={18} />
                </button>
              </div>
              <div className={styles.modalBody}>
                <p style={{ margin: '0 0 12px', color: 'var(--muted)' }}>
                  Override the sale-line commission for this ticket.
                </p>
                <label className={styles.fieldLabel} style={{ display: 'block', marginBottom: 8 }}>
                  Commission Amount
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={commissionOverrideInput}
                  onChange={(event) => setCommissionOverrideInput(event.target.value)}
                  disabled={commissionOverrideLoading}
                  style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: '1px solid var(--border)' }}
                />
              </div>
              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.modalCancel}
                  onClick={() => {
                    if (commissionOverrideLoading) return;
                    setShowCommissionModal(false);
                    setSelectedTicketForCommission(null);
                    setCommissionOverrideInput('');
                  }}
                  disabled={commissionOverrideLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={styles.modalConfirm}
                  onClick={async () => {
                    if (!canEditSoldCommission || !selectedTicketForCommission || commissionOverrideLoading) return;
                    const rawValue = commissionOverrideInput.trim();
                    if (!rawValue || !/^\d+(\.\d{1,2})?$/.test(rawValue)) {
                      showError('Enter a valid commission amount with up to 2 decimal places.');
                      return;
                    }
                    const amount = Number(rawValue);
                    if (!Number.isFinite(amount) || amount < 0) {
                      showError('Commission amount cannot be negative.');
                      return;
                    }
                    setCommissionOverrideLoading(true);
                    try {
                      const result = await updateTicketCommissionOverride({
                        variables: { tp_id: selectedTicketForCommission.tpId, commissionOverride: amount },
                      });
                      if (!result.data?.update_ticket_placement?.affected_rows) {
                        throw new Error('No ticket line was updated.');
                      }
                      setLocalTickets((prev) => prev.map((ticket) =>
                        ticket.tpId === selectedTicketForCommission.tpId
                          ? { ...ticket, tp_sales_rep_commission_override: amount }
                          : ticket,
                      ));
                      await Promise.all([
                        refetchTickets(),
                        refetchUserTicketMarketplaces(),
                      ]);
                      showSuccess('Commission amount updated successfully.');
                    } catch (error: any) {
                      showError(formatUserDetailsError(error, 'Failed to update commission amount.'));
                    } finally {
                      setCommissionOverrideLoading(false);
                      setShowCommissionModal(false);
                      setSelectedTicketForCommission(null);
                      setCommissionOverrideInput('');
                    }
                  }}
                  disabled={commissionOverrideLoading}
                >
                  {commissionOverrideLoading ? 'Saving…' : 'Save Commission'}
                </button>
              </div>
            </div>
          </div>
        )}
        {seatModeDialog.dialog}
        {showTicketViewModal && ticketForView && (
          <div
            className={styles.modalOverlay}
            onClick={() => {
              setShowTicketViewModal(false);
              setTicketForView(null);
            }}
          >
            <div
              className={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '600px' }}
            >
              <div className={styles.modalHeader}>
                <h3>
                  <Eye size={18} /> Ticket Details
                </h3>
                <button
                  type="button"
                  className={styles.modalClose}
                  onClick={() => {
                    setShowTicketViewModal(false);
                    setTicketForView(null);
                  }}
                >
                  <X size={18} />
                </button>
              </div>
              <div className={styles.modalBody}>
                <div className={styles.viewDetailsHero}>
                  <h4>{ticketForView.event || 'N/A'}</h4>
                  <p>
                    <MapPinned size={12} /> {ticketForView.venue || 'N/A'}
                  </p>
                  <p>
                    <Calendar size={12} /> {ticketForView.date || 'TBD'}
                    {ticketForView.eventTime ? ` • ${ticketForView.eventTime}` : ''}
                  </p>
                </div>
                <div className={styles.viewDetailsGrid}>
                  <div className={styles.detailSection}>
                    <h5>Ticket Details</h5>
                    <div>
                      <span>Section</span>
                      <span>{ticketForView.section || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Row</span>
                      <span>{ticketForView.row || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Seat Numbers</span>
                      <span>{ticketForView.seatNo || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Status</span>
                      <span className={styles.statusBadge}>
                        {getStatusLabel(ticketForView.rawStatus || ticketForView.status || '')}
                      </span>
                    </div>
                    <div>
                      <span>List Price</span>
                      <span>{displayPrice(ticketForView.price)}</span>
                    </div>
                    {getUserTicketVlProductionId(ticketForView) && (
                      <div>
                        <span>Production ID</span>
                        <span>{getUserTicketVlProductionId(ticketForView)}</span>
                      </div>
                    )}
                  </div>
                  <div className={styles.detailSection}>
                    <h5>Client Details</h5>
                    <div>
                      <span>Client Name</span>
                      <span>{currentUser?.name || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Client Email</span>
                      <span>{ticketForView.email || currentUser?.email || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Client Type</span>
                      <span>{getUserDetailCsvClientType() || 'N/A'}</span>
                    </div>
                    <div>
                      <span>Marketplace</span>
                      <span>{ticketForView.marketplace || '—'}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.modalCancel}
                  onClick={() => {
                    setShowTicketViewModal(false);
                    setTicketForView(null);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
        {showPriceLogsModal && ticketForPriceLogs && (
          <div
            className={styles.modalOverlay}
            onClick={() => {
              setShowPriceLogsModal(false);
              setTicketForPriceLogs(null);
              setPriceLogsTpIds([]);
            }}
          >
            <div
              className={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
              style={{ maxWidth: '960px', width: '95%' }}
            >
              <div className={styles.modalHeader}>
                <h3>
                  <History size={18} /> Price Change Logs
                </h3>
                <button
                  type="button"
                  className={styles.modalClose}
                  onClick={() => {
                    setShowPriceLogsModal(false);
                    setTicketForPriceLogs(null);
                    setPriceLogsTpIds([]);
                  }}
                >
                  <X size={18} />
                </button>
              </div>
              <div className={styles.modalBody}>
                <div className={styles.modalEventInfo} style={{ marginBottom: 12 }}>
                  <div className={styles.modalEventName}>{ticketForPriceLogs.event || 'N/A'}</div>
                  <div>
                    {[
                      ticketForPriceLogs.section && `Sec ${ticketForPriceLogs.section}`,
                      ticketForPriceLogs.row && `Row ${ticketForPriceLogs.row}`,
                      ticketForPriceLogs.seatNo && `Seat ${ticketForPriceLogs.seatNo}`,
                    ]
                      .filter(Boolean)
                      .join(' · ') || '—'}
                  </div>
                </div>
                <PriceChangeLogsPanel
                  tpIds={priceLogsTpIds}
                  compact
                  hideFilters
                  hideClientColumns
                />
              </div>
              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.modalCancel}
                  onClick={() => {
                    setShowPriceLogsModal(false);
                    setTicketForPriceLogs(null);
                    setPriceLogsTpIds([]);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}

        {showSyncFromVlScopeModal && (
          <SyncFromVlScopeModal
            open={showSyncFromVlScopeModal}
            confirming={syncFromVlConfirming}
            seatCount={syncFromVlScopeTpIds.length}
            onClose={() => {
              if (syncFromVlConfirming) return;
              setShowSyncFromVlScopeModal(false);
            }}
            onConfirm={(scope) => void handleSyncVlGroups(syncFromVlScopeTpIds, scope)}
          />
        )}
        {showBarcodeSyncConfirmModal && (
          <BarcodeSyncConfirmModal
            open={showBarcodeSyncConfirmModal}
            loadingRecommend={barcodeSyncRecommendLoading}
            confirming={barcodeSyncConfirming}
            recommendation={barcodeSyncRecommendation}
            error={barcodeSyncRecommendError}
            title="Sync Barcodes"
            onClose={() => {
              if (
                barcodeSyncConfirming ||
                barcodeSyncSummary?.phase === 'crawling' ||
                barcodeSyncSummary?.phase === 'verifying'
              ) return;
              setShowBarcodeSyncConfirmModal(false);
            }}
            onConfirm={confirmBarcodeSync}
          />
        )}
        <CheckBarcodesModal
          open={showCheckBarcodesModal}
          loading={checkBarcodesLoading}
          error={checkBarcodesError}
          result={checkBarcodesResult}
          onClose={() => {
            if (
              checkBarcodesLoading ||
              barcodeSyncSummary?.phase === 'crawling' ||
              barcodeSyncSummary?.phase === 'verifying'
            ) return;
            setShowCheckBarcodesModal(false);
          }}
        />
        {showBarcodeSyncSummaryModal && barcodeSyncSummary && (
          <div className={styles.modalOverlay}>
            <div
              className={styles.modalContent}
              style={{ maxWidth: '560px' }}
            >
              <div className={styles.modalHeader}>
                <div>
                  <h3>Barcode Sync Summary</h3>
                  <p>
                    {barcodeSyncSummary.phase === 'crawling' && 'Crawling in progress…'}
                    {barcodeSyncSummary.phase === 'verifying' && 'Crawl complete. Verifying selected seats…'}
                    {barcodeSyncSummary.phase === 'success' && 'Success: all selected seats have matching barcodes.'}
                    {barcodeSyncSummary.phase === 'failure' && 'Failure: one or more seats are missing/mismatched.'}
                  </p>
                </div>
                <button
                  type="button"
                  className={styles.modalClose}
                  onClick={() => setShowBarcodeSyncSummaryModal(false)}
                  disabled={barcodeSyncSummary.phase === 'crawling' || barcodeSyncSummary.phase === 'verifying'}
                >
                  <X size={18} />
                </button>
              </div>
              <div className={styles.modalBody}>
                {barcodeSyncSummary.crawlMessage && (
                  <div style={{ marginBottom: 10, fontSize: 13, color: '#6b7280' }}>
                    {barcodeSyncSummary.crawlMessage}
                  </div>
                )}
                <div className={styles.editField} style={{ gap: 8 }}>
                  {(barcodeSyncSummary.crawlResults || []).map((row) => (
                    <div key={row.accountId}>
                      <strong>{row.accountId}</strong>
                      {row.username ? ` - ${row.username}` : ''}
                      {row.marketplaceName ? ` (${row.marketplaceName})` : ''}
                      {': '}
                      {row.status === 'processing'
                        ? 'Processing'
                        : row.status === 'completed'
                          ? 'Completed'
                          : row.status === 'failed'
                            ? `Failed${row.message ? ` - ${row.message}` : ''}`
                            : 'Pending'}
                      {row.crawlStatus ? ` (${row.crawlStatus})` : ''}
                    </div>
                  ))}
                </div>
                {barcodeSyncSummary.verificationMessage && (
                  <div style={{ marginTop: 10, fontSize: 13, color: '#6b7280' }}>
                    {barcodeSyncSummary.verificationMessage}
                  </div>
                )}
                {barcodeSyncSummary.failures?.length ? (
                  <div style={{ marginTop: 10, fontSize: 13, color: '#991b1b' }}>
                    {barcodeSyncSummary.failures.slice(0, 12).map((row) => (
                      <div key={row}>- {row}</div>
                    ))}
                    {barcodeSyncSummary.failures.length > 12
                      ? <div>...and {barcodeSyncSummary.failures.length - 12} more</div>
                      : null}
                  </div>
                ) : null}
              </div>
              <div className={styles.modalFooter}>
                <button
                  type="button"
                  className={styles.modalConfirm}
                  onClick={() => setShowBarcodeSyncSummaryModal(false)}
                  disabled={barcodeSyncSummary.phase === 'crawling' || barcodeSyncSummary.phase === 'verifying'}
                >
                  {barcodeSyncSummary.phase === 'success' ? 'Done' : 'Close'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetailsPage;
